var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/p-retry/node_modules/retry/lib/retry_operation.js
var require_retry_operation = __commonJS({
  "../../node_modules/p-retry/node_modules/retry/lib/retry_operation.js"(exports, module) {
    "use strict";
    function RetryOperation(timeouts, options) {
      if (typeof options === "boolean") {
        options = { forever: options };
      }
      this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
      this._timeouts = timeouts;
      this._options = options || {};
      this._maxRetryTime = options && options.maxRetryTime || Infinity;
      this._fn = null;
      this._errors = [];
      this._attempts = 1;
      this._operationTimeout = null;
      this._operationTimeoutCb = null;
      this._timeout = null;
      this._operationStart = null;
      this._timer = null;
      if (this._options.forever) {
        this._cachedTimeouts = this._timeouts.slice(0);
      }
    }
    module.exports = RetryOperation;
    RetryOperation.prototype.reset = function() {
      this._attempts = 1;
      this._timeouts = this._originalTimeouts.slice(0);
    };
    RetryOperation.prototype.stop = function() {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      if (this._timer) {
        clearTimeout(this._timer);
      }
      this._timeouts = [];
      this._cachedTimeouts = null;
    };
    RetryOperation.prototype.retry = function(err) {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      if (!err) {
        return false;
      }
      var currentTime = (/* @__PURE__ */ new Date()).getTime();
      if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error("RetryOperation timeout occurred"));
        return false;
      }
      this._errors.push(err);
      var timeout = this._timeouts.shift();
      if (timeout === void 0) {
        if (this._cachedTimeouts) {
          this._errors.splice(0, this._errors.length - 1);
          timeout = this._cachedTimeouts.slice(-1);
        } else {
          return false;
        }
      }
      var self2 = this;
      this._timer = setTimeout(function() {
        self2._attempts++;
        if (self2._operationTimeoutCb) {
          self2._timeout = setTimeout(function() {
            self2._operationTimeoutCb(self2._attempts);
          }, self2._operationTimeout);
          if (self2._options.unref) {
            self2._timeout.unref();
          }
        }
        self2._fn(self2._attempts);
      }, timeout);
      if (this._options.unref) {
        this._timer.unref();
      }
      return true;
    };
    RetryOperation.prototype.attempt = function(fn, timeoutOps) {
      this._fn = fn;
      if (timeoutOps) {
        if (timeoutOps.timeout) {
          this._operationTimeout = timeoutOps.timeout;
        }
        if (timeoutOps.cb) {
          this._operationTimeoutCb = timeoutOps.cb;
        }
      }
      var self2 = this;
      if (this._operationTimeoutCb) {
        this._timeout = setTimeout(function() {
          self2._operationTimeoutCb();
        }, self2._operationTimeout);
      }
      this._operationStart = (/* @__PURE__ */ new Date()).getTime();
      this._fn(this._attempts);
    };
    RetryOperation.prototype.try = function(fn) {
      console.log("Using RetryOperation.try() is deprecated");
      this.attempt(fn);
    };
    RetryOperation.prototype.start = function(fn) {
      console.log("Using RetryOperation.start() is deprecated");
      this.attempt(fn);
    };
    RetryOperation.prototype.start = RetryOperation.prototype.try;
    RetryOperation.prototype.errors = function() {
      return this._errors;
    };
    RetryOperation.prototype.attempts = function() {
      return this._attempts;
    };
    RetryOperation.prototype.mainError = function() {
      if (this._errors.length === 0) {
        return null;
      }
      var counts = {};
      var mainError = null;
      var mainErrorCount = 0;
      for (var i4 = 0; i4 < this._errors.length; i4++) {
        var error = this._errors[i4];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
          mainError = error;
          mainErrorCount = count;
        }
      }
      return mainError;
    };
  }
});

// ../../node_modules/p-retry/node_modules/retry/lib/retry.js
var require_retry = __commonJS({
  "../../node_modules/p-retry/node_modules/retry/lib/retry.js"(exports) {
    "use strict";
    var RetryOperation = require_retry_operation();
    exports.operation = function(options) {
      var timeouts = exports.timeouts(options);
      return new RetryOperation(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
      });
    };
    exports.timeouts = function(options) {
      if (options instanceof Array) {
        return [].concat(options);
      }
      var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1 * 1e3,
        maxTimeout: Infinity,
        randomize: false
      };
      for (var key in options) {
        opts[key] = options[key];
      }
      if (opts.minTimeout > opts.maxTimeout) {
        throw new Error("minTimeout is greater than maxTimeout");
      }
      var timeouts = [];
      for (var i4 = 0; i4 < opts.retries; i4++) {
        timeouts.push(this.createTimeout(i4, opts));
      }
      if (options && options.forever && !timeouts.length) {
        timeouts.push(this.createTimeout(i4, opts));
      }
      timeouts.sort(function(a4, b3) {
        return a4 - b3;
      });
      return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
      var random = opts.randomize ? Math.random() + 1 : 1;
      var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
      timeout = Math.min(timeout, opts.maxTimeout);
      return timeout;
    };
    exports.wrap = function(obj, options, methods) {
      if (options instanceof Array) {
        methods = options;
        options = null;
      }
      if (!methods) {
        methods = [];
        for (var key in obj) {
          if (typeof obj[key] === "function") {
            methods.push(key);
          }
        }
      }
      for (var i4 = 0; i4 < methods.length; i4++) {
        var method = methods[i4];
        var original = obj[method];
        obj[method] = function retryWrapper(original2) {
          var op = exports.operation(options);
          var args = Array.prototype.slice.call(arguments, 1);
          var callback = args.pop();
          args.push(function(err) {
            if (op.retry(err)) {
              return;
            }
            if (err) {
              arguments[0] = op.mainError();
            }
            callback.apply(this, arguments);
          });
          op.attempt(function() {
            original2.apply(obj, args);
          });
        }.bind(obj, original);
        obj[method].options = options;
      }
    };
  }
});

// ../../node_modules/p-retry/node_modules/retry/index.js
var require_retry2 = __commonJS({
  "../../node_modules/p-retry/node_modules/retry/index.js"(exports, module) {
    "use strict";
    module.exports = require_retry();
  }
});

// ../../node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/lodash/isObject.js"(exports, module) {
    "use strict";
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject;
  }
});

// ../../node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    "use strict";
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});

// ../../node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/lodash/_root.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});

// ../../node_modules/lodash/now.js
var require_now = __commonJS({
  "../../node_modules/lodash/now.js"(exports, module) {
    "use strict";
    var root = require_root();
    var now = function() {
      return root.Date.now();
    };
    module.exports = now;
  }
});

// ../../node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "../../node_modules/lodash/_trimmedEndIndex.js"(exports, module) {
    "use strict";
    var reWhitespace = /\s/;
    function trimmedEndIndex(string10) {
      var index = string10.length;
      while (index-- && reWhitespace.test(string10.charAt(index))) {
      }
      return index;
    }
    module.exports = trimmedEndIndex;
  }
});

// ../../node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "../../node_modules/lodash/_baseTrim.js"(exports, module) {
    "use strict";
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string10) {
      return string10 ? string10.slice(0, trimmedEndIndex(string10) + 1).replace(reTrimStart, "") : string10;
    }
    module.exports = baseTrim;
  }
});

// ../../node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/lodash/_Symbol.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Symbol2 = root.Symbol;
    module.exports = Symbol2;
  }
});

// ../../node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/lodash/_getRawTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e4) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;
  }
});

// ../../node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/lodash/_objectToString.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString2(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString2;
  }
});

// ../../node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString2 = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString2(value);
    }
    module.exports = baseGetTag;
  }
});

// ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/lodash/isObjectLike.js"(exports, module) {
    "use strict";
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});

// ../../node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "../../node_modules/lodash/isSymbol.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module.exports = isSymbol;
  }
});

// ../../node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "../../node_modules/lodash/toNumber.js"(exports, module) {
    "use strict";
    var baseTrim = require_baseTrim();
    var isObject = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module.exports = toNumber;
  }
});

// ../../node_modules/lodash/debounce.js
var require_debounce = __commonJS({
  "../../node_modules/lodash/debounce.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    var now = require_now();
    var toNumber = require_toNumber();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce6(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module.exports = debounce6;
  }
});

// ../../node_modules/lodash/throttle.js
var require_throttle = __commonJS({
  "../../node_modules/lodash/throttle.js"(exports, module) {
    "use strict";
    var debounce6 = require_debounce();
    var isObject = require_isObject();
    var FUNC_ERROR_TEXT = "Expected a function";
    function throttle3(func, wait, options) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      return debounce6(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    module.exports = throttle3;
  }
});

// ../../node_modules/namespace-emitter/index.js
var require_namespace_emitter = __commonJS({
  "../../node_modules/namespace-emitter/index.js"(exports, module) {
    "use strict";
    module.exports = function createNamespaceEmitter() {
      var emitter = {};
      var _fns = emitter._fns = {};
      emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) {
          emitAll(event, toEmit, [arg1, arg2, arg3, arg4, arg5, arg6]);
        }
      };
      emitter.on = function on(event, fn) {
        if (!_fns[event]) {
          _fns[event] = [];
        }
        _fns[event].push(fn);
      };
      emitter.once = function once(event, fn) {
        function one() {
          fn.apply(this, arguments);
          emitter.off(event, one);
        }
        this.on(event, one);
      };
      emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
          var fns = this._fns[event];
          var i4 = 0;
          var l4 = fns ? fns.length : 0;
          for (i4; i4 < l4; i4++) {
            if (fns[i4] !== fn) {
              keep.push(fns[i4]);
            }
          }
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
      };
      function getListeners(e4) {
        var out = _fns[e4] ? _fns[e4] : [];
        var idx = e4.indexOf(":");
        var args = idx === -1 ? [e4] : [e4.substring(0, idx), e4.substring(idx + 1)];
        var keys = Object.keys(_fns);
        var i4 = 0;
        var l4 = keys.length;
        for (i4; i4 < l4; i4++) {
          var key = keys[i4];
          if (key === "*") {
            out = out.concat(_fns[key]);
          }
          if (args.length === 2 && args[0] === key) {
            out = out.concat(_fns[key]);
            break;
          }
        }
        return out;
      }
      function emitAll(e4, fns, args) {
        var i4 = 0;
        var l4 = fns.length;
        for (i4; i4 < l4; i4++) {
          if (!fns[i4])
            break;
          fns[i4].event = e4;
          fns[i4].apply(fns[i4], args);
        }
      }
      return emitter;
    };
  }
});

// ../../node_modules/@transloadit/prettier-bytes/dist/prettierBytes.js
var require_prettierBytes = __commonJS({
  "../../node_modules/@transloadit/prettier-bytes/dist/prettierBytes.js"(exports, module) {
    "use strict";
    module.exports = function prettierBytes4(num) {
      if (typeof num !== "number" || Number.isNaN(num)) {
        throw new TypeError(`Expected a number, got ${typeof num}`);
      }
      const neg = num < 0;
      const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      if (neg) {
        num = -num;
      }
      if (num < 1) {
        return `${(neg ? "-" : "") + num} B`;
      }
      const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
      num = Number(num / 1024 ** exponent);
      const unit = units[exponent];
      if (num >= 10 || num % 1 === 0) {
        return `${(neg ? "-" : "") + num.toFixed(0)} ${unit}`;
      }
      return `${(neg ? "-" : "") + num.toFixed(1)} ${unit}`;
    };
  }
});

// ../../node_modules/wildcard/index.js
var require_wildcard = __commonJS({
  "../../node_modules/wildcard/index.js"(exports, module) {
    "use strict";
    function WildcardMatcher(text, separator2) {
      this.text = text = text || "";
      this.hasWild = ~text.indexOf("*");
      this.separator = separator2;
      this.parts = text.split(separator2);
    }
    WildcardMatcher.prototype.match = function(input) {
      var matches = true;
      var parts = this.parts;
      var ii;
      var partsCount = parts.length;
      var testParts;
      if (typeof input == "string" || input instanceof String) {
        if (!this.hasWild && this.text != input) {
          matches = false;
        } else {
          testParts = (input || "").split(this.separator);
          for (ii = 0; matches && ii < partsCount; ii++) {
            if (parts[ii] === "*") {
              continue;
            } else if (ii < testParts.length) {
              matches = parts[ii] === testParts[ii];
            } else {
              matches = false;
            }
          }
          matches = matches && testParts;
        }
      } else if (typeof input.splice == "function") {
        matches = [];
        for (ii = input.length; ii--; ) {
          if (this.match(input[ii])) {
            matches[matches.length] = input[ii];
          }
        }
      } else if (typeof input == "object") {
        matches = {};
        for (var key in input) {
          if (this.match(key)) {
            matches[key] = input[key];
          }
        }
      }
      return matches;
    };
    module.exports = function(text, test, separator2) {
      var matcher = new WildcardMatcher(text, separator2 || /[\/\.]/);
      if (typeof test != "undefined") {
        return matcher.match(test);
      }
      return matcher;
    };
  }
});

// ../../node_modules/mime-match/index.js
var require_mime_match = __commonJS({
  "../../node_modules/mime-match/index.js"(exports, module) {
    "use strict";
    var wildcard = require_wildcard();
    var reMimePartSplit = /[\/\+\.]/;
    module.exports = function(target, pattern) {
      function test(pattern2) {
        var result = wildcard(pattern2, target, reMimePartSplit);
        return result && result.length >= 2;
      }
      return pattern ? test(pattern.split(";")[0]) : test;
    };
  }
});

// ../../node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    var b3 = "function" === typeof Symbol && Symbol.for;
    var c4 = b3 ? Symbol.for("react.element") : 60103;
    var d4 = b3 ? Symbol.for("react.portal") : 60106;
    var e4 = b3 ? Symbol.for("react.fragment") : 60107;
    var f4 = b3 ? Symbol.for("react.strict_mode") : 60108;
    var g3 = b3 ? Symbol.for("react.profiler") : 60114;
    var h10 = b3 ? Symbol.for("react.provider") : 60109;
    var k4 = b3 ? Symbol.for("react.context") : 60110;
    var l4 = b3 ? Symbol.for("react.async_mode") : 60111;
    var m4 = b3 ? Symbol.for("react.concurrent_mode") : 60111;
    var n3 = b3 ? Symbol.for("react.forward_ref") : 60112;
    var p4 = b3 ? Symbol.for("react.suspense") : 60113;
    var q4 = b3 ? Symbol.for("react.suspense_list") : 60120;
    var r4 = b3 ? Symbol.for("react.memo") : 60115;
    var t4 = b3 ? Symbol.for("react.lazy") : 60116;
    var v4 = b3 ? Symbol.for("react.block") : 60121;
    var w4 = b3 ? Symbol.for("react.fundamental") : 60117;
    var x4 = b3 ? Symbol.for("react.responder") : 60118;
    var y4 = b3 ? Symbol.for("react.scope") : 60119;
    function z4(a4) {
      if ("object" === typeof a4 && null !== a4) {
        var u4 = a4.$$typeof;
        switch (u4) {
          case c4:
            switch (a4 = a4.type, a4) {
              case l4:
              case m4:
              case e4:
              case g3:
              case f4:
              case p4:
                return a4;
              default:
                switch (a4 = a4 && a4.$$typeof, a4) {
                  case k4:
                  case n3:
                  case t4:
                  case r4:
                  case h10:
                    return a4;
                  default:
                    return u4;
                }
            }
          case d4:
            return u4;
        }
      }
    }
    function A3(a4) {
      return z4(a4) === m4;
    }
    exports.AsyncMode = l4;
    exports.ConcurrentMode = m4;
    exports.ContextConsumer = k4;
    exports.ContextProvider = h10;
    exports.Element = c4;
    exports.ForwardRef = n3;
    exports.Fragment = e4;
    exports.Lazy = t4;
    exports.Memo = r4;
    exports.Portal = d4;
    exports.Profiler = g3;
    exports.StrictMode = f4;
    exports.Suspense = p4;
    exports.isAsyncMode = function(a4) {
      return A3(a4) || z4(a4) === l4;
    };
    exports.isConcurrentMode = A3;
    exports.isContextConsumer = function(a4) {
      return z4(a4) === k4;
    };
    exports.isContextProvider = function(a4) {
      return z4(a4) === h10;
    };
    exports.isElement = function(a4) {
      return "object" === typeof a4 && null !== a4 && a4.$$typeof === c4;
    };
    exports.isForwardRef = function(a4) {
      return z4(a4) === n3;
    };
    exports.isFragment = function(a4) {
      return z4(a4) === e4;
    };
    exports.isLazy = function(a4) {
      return z4(a4) === t4;
    };
    exports.isMemo = function(a4) {
      return z4(a4) === r4;
    };
    exports.isPortal = function(a4) {
      return z4(a4) === d4;
    };
    exports.isProfiler = function(a4) {
      return z4(a4) === g3;
    };
    exports.isStrictMode = function(a4) {
      return z4(a4) === f4;
    };
    exports.isSuspense = function(a4) {
      return z4(a4) === p4;
    };
    exports.isValidElementType = function(a4) {
      return "string" === typeof a4 || "function" === typeof a4 || a4 === e4 || a4 === m4 || a4 === g3 || a4 === f4 || a4 === p4 || a4 === q4 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === t4 || a4.$$typeof === r4 || a4.$$typeof === h10 || a4.$$typeof === k4 || a4.$$typeof === n3 || a4.$$typeof === w4 || a4.$$typeof === x4 || a4.$$typeof === y4 || a4.$$typeof === v4);
    };
    exports.typeOf = z4;
  }
});

// ../../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object10) {
          if (typeof object10 === "object" && object10 !== null) {
            var $$typeof = object10.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object10.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment10 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense25 = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object10) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object10) || typeOf(object10) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object10) {
          return typeOf(object10) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object10) {
          return typeOf(object10) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object10) {
          return typeOf(object10) === REACT_PROVIDER_TYPE;
        }
        function isElement(object10) {
          return typeof object10 === "object" && object10 !== null && object10.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object10) {
          return typeOf(object10) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object10) {
          return typeOf(object10) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object10) {
          return typeOf(object10) === REACT_LAZY_TYPE;
        }
        function isMemo(object10) {
          return typeOf(object10) === REACT_MEMO_TYPE;
        }
        function isPortal(object10) {
          return typeOf(object10) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object10) {
          return typeOf(object10) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object10) {
          return typeOf(object10) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object10) {
          return typeOf(object10) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment10;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense25;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (process.env.NODE_ENV === "production") {
      module.exports = require_react_is_production_min();
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i4 = 0; i4 < 10; i4++) {
          test2["_" + String.fromCharCode(i4)] = i4;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n3) {
          return test2[n3];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s4 = 1; s4 < arguments.length; s4++) {
        from = Object(arguments[s4]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i4 = 0; i4 < symbols.length; i4++) {
            if (propIsEnumerable.call(from, symbols[i4])) {
              to[symbols[i4]] = from[symbols[i4]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    "use strict";
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has2 = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x4) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has2;
    function checkPropTypes(typeSpecs, values, location2, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has2(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location2 + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign2 = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has2 = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x4) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement3, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x4, y4) {
        if (x4 === y4) {
          return x4 !== 0 || 1 / x4 === 1 / y4;
        } else {
          return x4 !== x4 && y4 !== y4;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location2, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location2, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i4 = 0; i4 < propValue.length; i4++) {
            var error = typeChecker(propValue, i4, componentName, location2, propFullName + "[" + i4 + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!isValidElement3(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          for (var i4 = 0; i4 < expectedValues.length; i4++) {
            if (is(propValue, expectedValues[i4])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has2(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i4 = 0; i4 < arrayOfTypeCheckers.length; i4++) {
          var checker = arrayOfTypeCheckers[i4];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i4 + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var expectedTypes = [];
          for (var i5 = 0; i5 < arrayOfTypeCheckers.length; i5++) {
            var checker2 = arrayOfTypeCheckers[i5];
            var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location2, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign2({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has2(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement3(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "../../node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function() {
      function shim(props, propName, componentName, location2, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/classnames/index.js"(exports, module) {
    "use strict";
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      function classNames19() {
        var classes = "";
        for (var i4 = 0; i4 < arguments.length; i4++) {
          var arg = arguments[i4];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames19.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (typeof module !== "undefined" && module.exports) {
        classNames19.default = classNames19;
        module.exports = classNames19;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames19;
        });
      } else {
        window.classNames = classNames19;
      }
    })();
  }
});

// ../../node_modules/eventemitter3/index.js
var require_eventemitter3 = __commonJS({
  "../../node_modules/eventemitter3/index.js"(exports, module) {
    "use strict";
    var has2 = Object.prototype.hasOwnProperty;
    var prefix = "~";
    function Events() {
    }
    if (Object.create) {
      Events.prototype = /* @__PURE__ */ Object.create(null);
      if (!new Events().__proto__)
        prefix = false;
    }
    function EE(fn, context, once) {
      this.fn = fn;
      this.context = context;
      this.once = once || false;
    }
    function addListener(emitter, event, fn, context, once) {
      if (typeof fn !== "function") {
        throw new TypeError("The listener must be a function");
      }
      var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
      if (!emitter._events[evt])
        emitter._events[evt] = listener, emitter._eventsCount++;
      else if (!emitter._events[evt].fn)
        emitter._events[evt].push(listener);
      else
        emitter._events[evt] = [emitter._events[evt], listener];
      return emitter;
    }
    function clearEvent(emitter, evt) {
      if (--emitter._eventsCount === 0)
        emitter._events = new Events();
      else
        delete emitter._events[evt];
    }
    function EventEmitter2() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    EventEmitter2.prototype.eventNames = function eventNames() {
      var names = [], events, name;
      if (this._eventsCount === 0)
        return names;
      for (name in events = this._events) {
        if (has2.call(events, name))
          names.push(prefix ? name.slice(1) : name);
      }
      if (Object.getOwnPropertySymbols) {
        return names.concat(Object.getOwnPropertySymbols(events));
      }
      return names;
    };
    EventEmitter2.prototype.listeners = function listeners(event) {
      var evt = prefix ? prefix + event : event, handlers = this._events[evt];
      if (!handlers)
        return [];
      if (handlers.fn)
        return [handlers.fn];
      for (var i4 = 0, l4 = handlers.length, ee4 = new Array(l4); i4 < l4; i4++) {
        ee4[i4] = handlers[i4].fn;
      }
      return ee4;
    };
    EventEmitter2.prototype.listenerCount = function listenerCount(event) {
      var evt = prefix ? prefix + event : event, listeners = this._events[evt];
      if (!listeners)
        return 0;
      if (listeners.fn)
        return 1;
      return listeners.length;
    };
    EventEmitter2.prototype.emit = function emit(event, a1, a22, a32, a4, a5) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt])
        return false;
      var listeners = this._events[evt], len = arguments.length, args, i4;
      if (listeners.fn) {
        if (listeners.once)
          this.removeListener(event, listeners.fn, void 0, true);
        switch (len) {
          case 1:
            return listeners.fn.call(listeners.context), true;
          case 2:
            return listeners.fn.call(listeners.context, a1), true;
          case 3:
            return listeners.fn.call(listeners.context, a1, a22), true;
          case 4:
            return listeners.fn.call(listeners.context, a1, a22, a32), true;
          case 5:
            return listeners.fn.call(listeners.context, a1, a22, a32, a4), true;
          case 6:
            return listeners.fn.call(listeners.context, a1, a22, a32, a4, a5), true;
        }
        for (i4 = 1, args = new Array(len - 1); i4 < len; i4++) {
          args[i4 - 1] = arguments[i4];
        }
        listeners.fn.apply(listeners.context, args);
      } else {
        var length = listeners.length, j4;
        for (i4 = 0; i4 < length; i4++) {
          if (listeners[i4].once)
            this.removeListener(event, listeners[i4].fn, void 0, true);
          switch (len) {
            case 1:
              listeners[i4].fn.call(listeners[i4].context);
              break;
            case 2:
              listeners[i4].fn.call(listeners[i4].context, a1);
              break;
            case 3:
              listeners[i4].fn.call(listeners[i4].context, a1, a22);
              break;
            case 4:
              listeners[i4].fn.call(listeners[i4].context, a1, a22, a32);
              break;
            default:
              if (!args)
                for (j4 = 1, args = new Array(len - 1); j4 < len; j4++) {
                  args[j4 - 1] = arguments[j4];
                }
              listeners[i4].fn.apply(listeners[i4].context, args);
          }
        }
      }
      return true;
    };
    EventEmitter2.prototype.on = function on(event, fn, context) {
      return addListener(this, event, fn, context, false);
    };
    EventEmitter2.prototype.once = function once(event, fn, context) {
      return addListener(this, event, fn, context, true);
    };
    EventEmitter2.prototype.removeListener = function removeListener(event, fn, context, once) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt])
        return this;
      if (!fn) {
        clearEvent(this, evt);
        return this;
      }
      var listeners = this._events[evt];
      if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
          clearEvent(this, evt);
        }
      } else {
        for (var i4 = 0, events = [], length = listeners.length; i4 < length; i4++) {
          if (listeners[i4].fn !== fn || once && !listeners[i4].once || context && listeners[i4].context !== context) {
            events.push(listeners[i4]);
          }
        }
        if (events.length)
          this._events[evt] = events.length === 1 ? events[0] : events;
        else
          clearEvent(this, evt);
      }
      return this;
    };
    EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
      if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt])
          clearEvent(this, evt);
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
      return this;
    };
    EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
    EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
    EventEmitter2.prefixed = prefix;
    EventEmitter2.EventEmitter = EventEmitter2;
    if ("undefined" !== typeof module) {
      module.exports = EventEmitter2;
    }
  }
});

// ../../node_modules/is-shallow-equal/index.js
var require_is_shallow_equal = __commonJS({
  "../../node_modules/is-shallow-equal/index.js"(exports, module) {
    "use strict";
    module.exports = function isShallowEqual(a4, b3) {
      if (a4 === b3)
        return true;
      for (var i4 in a4)
        if (!(i4 in b3))
          return false;
      for (var i4 in b3)
        if (a4[i4] !== b3[i4])
          return false;
      return true;
    };
  }
});

// src/components/accounts/EmployerCreateContainer.tsx
import { useCallback as useCallback2 } from "react";
import * as zod from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  createClientMutationId,
  useSetUserErrorCodes,
  useUserErrorCode
} from "shared-lib";
import {
  ActionContainer,
  ErrorField,
  FormErrorCode,
  FormErrorCodes,
  FormInputRow,
  FormTextAreaInput,
  InputField,
  SwitchInput
} from "shared-ui";
import { IdentityUserSearchBoxInput } from "app-core";

// src/mutations/__generated__/UseEmployerLogoUploadMutation.graphql.ts
var node = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payload",
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerLogoUploadMutation",
      "selections": [
        {
          "alias": "uploadUrl",
          "args": v1,
          "concreteType": "AccountsEmployerGetPreSignedLogoUrlPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerGetPreSignedLogoUrl",
          "plural": false,
          "selections": [
            v22,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerLogoUploadMutation",
      "selections": [
        {
          "alias": "uploadUrl",
          "args": v1,
          "concreteType": "AccountsEmployerGetPreSignedLogoUrlPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerGetPreSignedLogoUrl",
          "plural": false,
          "selections": [
            v22,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "3ba37b3e4fd27825d8734cd4ef159703",
      "id": null,
      "metadata": {},
      "name": "UseEmployerLogoUploadMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerLogoUploadMutation(\n  $input: AccountsEmployerGetPreSignedLogoUrlInput!\n) {\n  uploadUrl: accountsEmployerGetPreSignedLogoUrl(input: $input) {\n    payload\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node.hash = "5e158145e22abc2e0c75facc1ce138ef";
var UseEmployerLogoUploadMutation_graphql_default = node;

// src/mutations/UseEmployerLogoUpload.ts
import { useAsyncMutation } from "shared-lib";
var mutationDef = UseEmployerLogoUploadMutation_graphql_default;
function useEmployerLogoUpload() {
  const [commit, isBusy] = useAsyncMutation(mutationDef);
  return [commit, isBusy];
}
var UseEmployerLogoUploadGraphQL = mutationDef;

// src/mutations/__generated__/UseEmployerActivateMutation.graphql.ts
var node2 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerActivateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerActivatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerActivate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerActivateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerActivatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerActivate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f313cb4cff2c6256503c2dad5e49a46f",
      "id": null,
      "metadata": {},
      "name": "UseEmployerActivateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerActivateMutation(\n  $input: AccountsEmployerActivateInput!\n) {\n  data: accountsEmployerActivate(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node2.hash = "f0f0b174bc0a02602251aae882e69473";
var UseEmployerActivateMutation_graphql_default = node2;

// src/mutations/UseEmployerActivate.ts
import { useAsyncMutation as useAsyncMutation2 } from "shared-lib";
var mutationDef2 = UseEmployerActivateMutation_graphql_default;
function useEmployerActivate() {
  const [commit, isBusy] = useAsyncMutation2(mutationDef2);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerApproveMutation.graphql.ts
var node3 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerApproveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerApprovePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerApprove",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerApproveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerApprovePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerApprove",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "051a2c4702add1f3810c8c7aff000c9c",
      "id": null,
      "metadata": {},
      "name": "UseEmployerApproveMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerApproveMutation(\n  $input: AccountsEmployerApproveInput!\n) {\n  data: accountsEmployerApprove(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node3.hash = "d9a9d46af974217d2cfbaeef8d8f40fe";
var UseEmployerApproveMutation_graphql_default = node3;

// src/mutations/UseEmployerApprove.ts
import { useAsyncMutation as useAsyncMutation3 } from "shared-lib";
var mutationDef3 = UseEmployerApproveMutation_graphql_default;
function useEmployerApprove() {
  const [commit, isBusy] = useAsyncMutation3(mutationDef3);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerCreateMutation.graphql.ts
var node4 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4a9e99321fb7bd793464bcbdce683357",
      "id": null,
      "metadata": {},
      "name": "UseEmployerCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerCreateMutation(\n  $input: AccountsEmployerCreateInput!\n) {\n  data: accountsEmployerCreate(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node4.hash = "1cf86c0983439fc0ac6791c0efd82be4";
var UseEmployerCreateMutation_graphql_default = node4;

// src/mutations/UseEmployerCreate.ts
import { useAsyncMutation as useAsyncMutation4 } from "shared-lib";
var mutationDef4 = UseEmployerCreateMutation_graphql_default;
function useEmployerCreate() {
  const [commit, isBusy] = useAsyncMutation4(mutationDef4);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerDeactivateMutation.graphql.ts
var node5 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerDeactivateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerDeactivatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerDeactivate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerDeactivateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerDeactivatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerDeactivate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f0be501663e85260ae793d3d35333565",
      "id": null,
      "metadata": {},
      "name": "UseEmployerDeactivateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerDeactivateMutation(\n  $input: AccountsEmployerDeactivateInput!\n) {\n  data: accountsEmployerDeactivate(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node5.hash = "a9a6c871fbe375b6cc7af901ce222219";
var UseEmployerDeactivateMutation_graphql_default = node5;

// src/mutations/UseEmployerDeactivate.ts
import { useAsyncMutation as useAsyncMutation5 } from "shared-lib";
var mutationDef5 = UseEmployerDeactivateMutation_graphql_default;
function useEmployerDeactivate() {
  const [commit, isBusy] = useAsyncMutation5(mutationDef5);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerEmailsSendingAddressChangeMutation.graphql.ts
var node6 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerSendingConfig",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmployerSendingConfig",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailProvider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailProviderConfig",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerEmailsSendingAddressChangeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "NotificationsEmployerEmailsSendingAddressChangePayload",
          "kind": "LinkedField",
          "name": "notificationsEmployerEmailsSendingAddressChange",
          "plural": false,
          "selections": [
            v22,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerEmailsSendingAddressChangeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "NotificationsEmployerEmailsSendingAddressChangePayload",
          "kind": "LinkedField",
          "name": "notificationsEmployerEmailsSendingAddressChange",
          "plural": false,
          "selections": [
            v22,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dc152f5bc1d86888c84f56a595db04cc",
      "id": null,
      "metadata": {},
      "name": "UseEmployerEmailsSendingAddressChangeMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerEmailsSendingAddressChangeMutation(\n  $input: NotificationsEmployerEmailsSendingAddressChangeInput!\n) {\n  data: notificationsEmployerEmailsSendingAddressChange(input: $input) {\n    payload {\n      node {\n        id\n        employerId\n        updatedAt\n        email\n        emailProvider\n        isVerified\n        emailProviderConfig\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node6.hash = "a9ea7461cfd50aacaee33b6d40b20a4c";
var UseEmployerEmailsSendingAddressChangeMutation_graphql_default = node6;

// src/mutations/UseEmployerEmailsSendingAddressChange.ts
import { useAsyncMutation as useAsyncMutation6 } from "shared-lib";
var mutationDef6 = UseEmployerEmailsSendingAddressChangeMutation_graphql_default;
function useEmployerEmailsSendingAddressChange() {
  const [commit, isBusy] = useAsyncMutation6(
    mutationDef6
  );
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerSetIsTestAccountMutation.graphql.ts
var node7 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerSetIsTestAccountMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerSetIsTestAccountPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerSetIsTestAccount",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerSetIsTestAccountMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerSetIsTestAccountPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerSetIsTestAccount",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "89e66901fd0875acae7d9a843954c283",
      "id": null,
      "metadata": {},
      "name": "UseEmployerSetIsTestAccountMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerSetIsTestAccountMutation(\n  $input: AccountsEmployerSetIsTestAccountInput!\n) {\n  data: accountsEmployerSetIsTestAccount(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node7.hash = "c0414a711518612b0bafadf0deeedc1d";
var UseEmployerSetIsTestAccountMutation_graphql_default = node7;

// src/mutations/UseEmployerSetIsTestAccount.ts
import { useAsyncMutation as useAsyncMutation7 } from "shared-lib";
var mutationDef7 = UseEmployerSetIsTestAccountMutation_graphql_default;
function useEmployerSetIsTestAccount() {
  const [commit, isBusy] = useAsyncMutation7(mutationDef7);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerTogglePhoneNumberVisibilityMutation.graphql.ts
var node8 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerTogglePhoneNumberVisibilityMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerTogglePhoneNumberVisibilityPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerTogglePhoneNumberVisibility",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerTogglePhoneNumberVisibilityMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerTogglePhoneNumberVisibilityPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerTogglePhoneNumberVisibility",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c0c122e23d8fdab784362d2eb98c8666",
      "id": null,
      "metadata": {},
      "name": "UseEmployerTogglePhoneNumberVisibilityMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerTogglePhoneNumberVisibilityMutation(\n  $input: AccountsEmployerTogglePhoneNumberVisibilityInput!\n) {\n  data: accountsEmployerTogglePhoneNumberVisibility(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node8.hash = "edd96d5aa2b3daf0f0f620b9a8ecf79d";
var UseEmployerTogglePhoneNumberVisibilityMutation_graphql_default = node8;

// src/mutations/UseEmployerTogglePhoneNumberVisibility.ts
import { useAsyncMutation as useAsyncMutation8 } from "shared-lib";
var mutationDef8 = UseEmployerTogglePhoneNumberVisibilityMutation_graphql_default;
function useEmployerSetPhoneNumberVisibility() {
  const [commit, isBusy] = useAsyncMutation8(
    mutationDef8
  );
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUpdateCanonicalCompanyMutation.graphql.ts
var node9 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUpdateCanonicalCompanyMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerChangeCanonicalCompanyPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerChangeCanonicalCompany",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUpdateCanonicalCompanyMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerChangeCanonicalCompanyPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerChangeCanonicalCompany",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0de0ad520b6faac254b21d8e29ba1b40",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUpdateCanonicalCompanyMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUpdateCanonicalCompanyMutation(\n  $input: AccountsEmployerChangeCanonicalCompanyInput!\n) {\n  data: accountsEmployerChangeCanonicalCompany(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node9.hash = "2b04d793571b5eeb5bb16b5aa384bbdb";
var UseEmployerUpdateCanonicalCompanyMutation_graphql_default = node9;

// src/mutations/UseEmployerUpdateCanonicalCompany.ts
import { useAsyncMutation as useAsyncMutation9 } from "shared-lib";
var mutationDef9 = UseEmployerUpdateCanonicalCompanyMutation_graphql_default;
function useEmployerChangeCanonicalCompany() {
  const [commit, isBusy] = useAsyncMutation9(mutationDef9);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUpdateDetailsMutation.graphql.ts
var node10 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUpdateDetailsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateDetailsPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateDetails",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUpdateDetailsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateDetailsPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateDetails",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "67e68cac459ef2a844a2891548e5a41b",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUpdateDetailsMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUpdateDetailsMutation(\n  $input: AccountsEmployerUpdateDetailsInput!\n) {\n  data: accountsEmployerUpdateDetails(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node10.hash = "ba8eaadc21cf2f782cec5f813f50fc19";
var UseEmployerUpdateDetailsMutation_graphql_default = node10;

// src/mutations/UseEmployerUpdateDetails.ts
import { useAsyncMutation as useAsyncMutation10 } from "shared-lib";
var mutationDef10 = UseEmployerUpdateDetailsMutation_graphql_default;
function useEmployerUpdateDetails() {
  const [commit, isBusy] = useAsyncMutation10(mutationDef10);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserEnableMutation.graphql.ts
var node11 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v22,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployerUserGroup",
            "kind": "LinkedField",
            "name": "userGroups",
            "plural": true,
            "selections": [
              v22,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAdminGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDefault",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserEnableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserEnablePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserEnable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserEnableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserEnablePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserEnable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "39b53e65641834ded37b099caa960991",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserEnableMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserEnableMutation(\n  $input: AccountsEmployerUserEnableInput!\n) {\n  data: accountsEmployerUserEnable(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        isTest\n        isDeleted\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node11.hash = "01611e818536a110576c8c5b088f6c9b";
var UseEmployerUserEnableMutation_graphql_default = node11;

// src/mutations/UseEmployerUserEnable.ts
import { useAsyncMutation as useAsyncMutation11 } from "shared-lib";
var mutationDef11 = UseEmployerUserEnableMutation_graphql_default;
function useEmployerUserEnable() {
  const [commit, isBusy] = useAsyncMutation11(mutationDef11);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserDisableMutation.graphql.ts
var node12 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v22,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployerUserGroup",
            "kind": "LinkedField",
            "name": "userGroups",
            "plural": true,
            "selections": [
              v22,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAdminGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDefault",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserDisableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserDisablePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserDisable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserDisableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserDisablePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserDisable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0a38fa61ef276f34585c90d996d111e2",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserDisableMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserDisableMutation(\n  $input: AccountsEmployerUserDisableInput!\n) {\n  data: accountsEmployerUserDisable(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        isTest\n        isDeleted\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node12.hash = "64805e83f9fad11d262c5dba6bbda1e7";
var UseEmployerUserDisableMutation_graphql_default = node12;

// src/mutations/UseEmployerUserDisable.ts
import { useAsyncMutation as useAsyncMutation12 } from "shared-lib";
var mutationDef12 = UseEmployerUserDisableMutation_graphql_default;
function useEmployerUserDisable() {
  const [commit, isBusy] = useAsyncMutation12(mutationDef12);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserEmailUpdateMutation.graphql.ts
var node13 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserEmailUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangeEmailPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangeEmail",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserEmailUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangeEmailPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangeEmail",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "98d97e729b39265a61fb1681b2eeac17",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserEmailUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserEmailUpdateMutation(\n  $input: AccountsEmployerUserChangeEmailInput!\n) {\n  data: accountsEmployerUserChangeEmail(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node13.hash = "23b0e9141999544df99eb88cacefe5b3";
var UseEmployerUserEmailUpdateMutation_graphql_default = node13;

// src/mutations/UseEmployerUserEmailUpdate.ts
import { useAsyncMutation as useAsyncMutation13 } from "shared-lib";
var mutationDef13 = UseEmployerUserEmailUpdateMutation_graphql_default;
function useEmployerUserEmailUpdate() {
  const [commit, isBusy] = useAsyncMutation13(mutationDef13);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserCreateMutation.graphql.ts
var node14 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v22,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployerUserGroup",
            "kind": "LinkedField",
            "name": "userGroups",
            "plural": true,
            "selections": [
              v22,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAdminGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDefault",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserCreate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserCreate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "082df230bfbaac4bd4e2aafa05c0b0fc",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserCreateMutation(\n  $input: AccountsEmployerUserCreateInput!\n) {\n  data: accountsEmployerUserCreate(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        isTest\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node14.hash = "8d8f3c473a13fb8981ce292d950c90bc";
var UseEmployerUserCreateMutation_graphql_default = node14;

// src/mutations/UseEmployerUserCreate.ts
import { useAsyncMutation as useAsyncMutation14 } from "shared-lib";
var mutationDef14 = UseEmployerUserCreateMutation_graphql_default;
function useEmployerUserCreate() {
  const [commit, isBusy] = useAsyncMutation14(mutationDef14);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserGroupCreateMutation.graphql.ts
var node15 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v22 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUserGroup",
    "kind": "LinkedField",
    "name": "employerUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserGroupCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v22,
          "concreteType": "AccountsEmployerUserGroupCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserGroupCreate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseEmployerUserGroupCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v22,
          "concreteType": "AccountsEmployerUserGroupCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserGroupCreate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "appendEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "employerUserGroup",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9dbaa3256cba8e67a7d6288977e55ffe",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserGroupCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserGroupCreateMutation(\n  $input: AccountsEmployerUserGroupCreateInput!\n) {\n  data: accountsEmployerUserGroupCreate(input: $input) {\n    employerUserGroup {\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        description\n        employerId\n        isDefault\n        isAdminGroup\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node15.hash = "acba05c81c5d068ecf745778a12ef875";
var UseEmployerUserGroupCreateMutation_graphql_default = node15;

// src/mutations/UseEmployerUserGroupCreate.ts
import { useAsyncMutation as useAsyncMutation15 } from "shared-lib";
var mutationDef15 = UseEmployerUserGroupCreateMutation_graphql_default;
function useEmployerUserGroupCreate() {
  const [commit, isBusy] = useAsyncMutation15(mutationDef15);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserGroupUpdateMutation.graphql.ts
var node16 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUserGroup",
    "kind": "LinkedField",
    "name": "employerUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserGroupUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserGroupUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserGroupUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserGroupUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserGroupUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserGroupUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "75890fa9e7f22ded09c0f30235bb9ded",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserGroupUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserGroupUpdateMutation(\n  $input: AccountsEmployerUserGroupUpdateInput!\n) {\n  data: accountsEmployerUserGroupUpdate(input: $input) {\n    employerUserGroup {\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        description\n        employerId\n        isDefault\n        isAdminGroup\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node16.hash = "ea2ac3defaf27f8992a707c84f5fa363";
var UseEmployerUserGroupUpdateMutation_graphql_default = node16;

// src/mutations/UseEmployerUserGroupUpdate.ts
import { useAsyncMutation as useAsyncMutation16 } from "shared-lib";
var mutationDef16 = UseEmployerUserGroupUpdateMutation_graphql_default;
function useEmployerUserGroupUpdate() {
  const [commit, isBusy] = useAsyncMutation16(mutationDef16);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserUpdateMutation.graphql.ts
var node17 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v10 = {
    "kind": "InlineFragment",
    "selections": [
      v9,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v22,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EmployerUserDetailsEditor_user"
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v22,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isTest",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDeleted",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v22,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "abeef04c344b2a9e96709a64bf473316",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserUpdateMutation(\n  $input: AccountsEmployerUserUpdateInput!\n) {\n  data: accountsEmployerUserUpdate(input: $input) {\n    employerUser {\n      node {\n        id\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        ...EmployerUserDetailsEditor_user\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node17.hash = "56fe10d213c3d70a49a543ee6f6f605e";
var UseEmployerUserUpdateMutation_graphql_default = node17;

// src/mutations/UseEmployerUserUpdate.ts
import { useAsyncMutation as useAsyncMutation17 } from "shared-lib";
var mutationDef17 = UseEmployerUserUpdateMutation_graphql_default;
function useEmployerUserUpdate() {
  const [commit, isBusy] = useAsyncMutation17(mutationDef17);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserJoinGroupMutation.graphql.ts
var node18 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v10 = {
    "kind": "InlineFragment",
    "selections": [
      v9,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserJoinGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserJoinGroupPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserJoinGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v22,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EmployerUserDetailsEditor_user"
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserJoinGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserJoinGroupPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserJoinGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v22,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isTest",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDeleted",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v22,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "77c569981d5983a55d091d573763ce88",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserJoinGroupMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserJoinGroupMutation(\n  $input: AccountsEmployerUserJoinGroupInput!\n) {\n  data: accountsEmployerUserJoinGroup(input: $input) {\n    employerUser {\n      node {\n        id\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        ...EmployerUserDetailsEditor_user\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node18.hash = "b6507bbc63ddc866fbcb113cb6af8085";
var UseEmployerUserJoinGroupMutation_graphql_default = node18;

// src/mutations/UseEmployerUserJoinGroup.ts
import { useAsyncMutation as useAsyncMutation18 } from "shared-lib";
var mutationDef18 = UseEmployerUserJoinGroupMutation_graphql_default;
function useEmployerUserJoinGroup() {
  const [commit, isBusy] = useAsyncMutation18(mutationDef18);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserLeaveGroupMutation.graphql.ts
var node19 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v10 = {
    "kind": "InlineFragment",
    "selections": [
      v9,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserLeaveGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserLeaveGroupPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserLeaveGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v22,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EmployerUserDetailsEditor_user"
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserLeaveGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserLeaveGroupPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserLeaveGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v22,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isTest",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDeleted",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v22,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "20a43fc1823b91129ae06b74eb5b71b8",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserLeaveGroupMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserLeaveGroupMutation(\n  $input: AccountsEmployerUserLeaveGroupInput!\n) {\n  data: accountsEmployerUserLeaveGroup(input: $input) {\n    employerUser {\n      node {\n        id\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        ...EmployerUserDetailsEditor_user\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node19.hash = "fcf19a3cf40b56013434fe28996a00f9";
var UseEmployerUserLeaveGroupMutation_graphql_default = node19;

// src/mutations/UseEmployerUserLeaveGroup.ts
import { useAsyncMutation as useAsyncMutation19 } from "shared-lib";
var mutationDef19 = UseEmployerUserLeaveGroupMutation_graphql_default;
function useEmployerUserLeaveGroup() {
  const [commit, isBusy] = useAsyncMutation19(mutationDef19);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerUserPasswordUpdateMutation.graphql.ts
var node20 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserPasswordUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangePasswordPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangePassword",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserPasswordUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangePasswordPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangePassword",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a50c493c446f7854c2cec60645d548db",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserPasswordUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserPasswordUpdateMutation(\n  $input: AccountsEmployerUserChangePasswordInput!\n) {\n  data: accountsEmployerUserChangePassword(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node20.hash = "37e33008b2e5f5a31298f95097f59818";
var UseEmployerUserPasswordUpdateMutation_graphql_default = node20;

// src/mutations/UseEmployerUserPasswordUpdate.ts
import { useAsyncMutation as useAsyncMutation20 } from "shared-lib";
var mutationDef20 = UseEmployerUserPasswordUpdateMutation_graphql_default;
function useEmployerUserPasswordUpdate() {
  const [commit, isBusy] = useAsyncMutation20(mutationDef20);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerLocationCreateMutation.graphql.ts
var node21 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfOfficeLocation",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmployerOfficeLocation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OfficeLocationAddress",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "county",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerLocationCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerOfficeAddLocationPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerOfficeAddLocation",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerLocationCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerOfficeAddLocationPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerOfficeAddLocation",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fedbd9c0c00b887ee75965f682842d1f",
      "id": null,
      "metadata": {},
      "name": "UseEmployerLocationCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerLocationCreateMutation(\n  $input: AccountsEmployerOfficeAddLocationInput!\n) {\n  data: accountsEmployerOfficeAddLocation(input: $input) {\n    employer {\n      node {\n        id\n        name\n        code\n        updatedAt\n        createdAt\n        address {\n          line1\n          line2\n          city\n          county\n          country\n          postCode\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node21.hash = "c50bf28acaf2fab1369292cda3bb03d3";
var UseEmployerLocationCreateMutation_graphql_default = node21;

// src/mutations/UseEmployerLocationCreate.ts
import { useAsyncMutation as useAsyncMutation21 } from "shared-lib";
var mutationDef21 = UseEmployerLocationCreateMutation_graphql_default;
function useEmployerLocationCreate() {
  const [commit, isBusy] = useAsyncMutation21(mutationDef21);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerLocationUpdateMutation.graphql.ts
var node22 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfOfficeLocation",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmployerOfficeLocation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v22,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OfficeLocationAddress",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "county",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v22,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerLocationUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerOfficeUpdateLocationPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerOfficeUpdateLocation",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerLocationUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerOfficeUpdateLocationPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerOfficeUpdateLocation",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fc5bc9462d41046c73d9eb9b4d79daa3",
      "id": null,
      "metadata": {},
      "name": "UseEmployerLocationUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerLocationUpdateMutation(\n  $input: AccountsEmployerOfficeUpdateLocationInput!\n) {\n  data: accountsEmployerOfficeUpdateLocation(input: $input) {\n    employer {\n      node {\n        id\n        name\n        code\n        updatedAt\n        createdAt\n        address {\n          line1\n          line2\n          city\n          county\n          country\n          postCode\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node22.hash = "e1b6b608c10589b4e16dcd066ca436e5";
var UseEmployerLocationUpdateMutation_graphql_default = node22;

// src/mutations/UseEmployerLocationUpdate.ts
import { useAsyncMutation as useAsyncMutation22 } from "shared-lib";
var mutationDef22 = UseEmployerLocationUpdateMutation_graphql_default;
function useEmployerLocationUpdate() {
  const [commit, isBusy] = useAsyncMutation22(mutationDef22);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerNameUpdateMutation.graphql.ts
var node23 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerNameUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateNamePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateName",
          "plural": false,
          "selections": [
            v22,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerNameUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateNamePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateName",
          "plural": false,
          "selections": [
            v22,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e431eb7fda9d88da70b53c1f461d46d6",
      "id": null,
      "metadata": {},
      "name": "UseEmployerNameUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerNameUpdateMutation(\n  $input: AccountsEmployerUpdateNameInput!\n) {\n  data: accountsEmployerUpdateName(input: $input) {\n    payload {\n      node {\n        id\n        employerId\n        name\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node23.hash = "d478483a5397c544033137ecf3bc27f5";
var UseEmployerNameUpdateMutation_graphql_default = node23;

// src/mutations/UseEmployerNameUpdate.ts
import { useAsyncMutation as useAsyncMutation23 } from "shared-lib";
var mutationDef23 = UseEmployerNameUpdateMutation_graphql_default;
function useEmployerNameUpdateMutation() {
  const [commit, isBusy] = useAsyncMutation23(mutationDef23);
  return [commit, isBusy];
}

// src/mutations/__generated__/UseEmployerLocationRemoveMutation.graphql.ts
var node24 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": "data",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "AccountsEmployerOfficeRemoveLocationPayload",
      "kind": "LinkedField",
      "name": "accountsEmployerOfficeRemoveLocation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfOfficeLocation",
          "kind": "LinkedField",
          "name": "location",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmployerOfficeLocation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OfficeLocationAddress",
                  "kind": "LinkedField",
                  "name": "address",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "line1",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "line2",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "city",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "county",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "country",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "postCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerLocationRemoveMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerLocationRemoveMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "551d1939240adfd20f6616661f214ea5",
      "id": null,
      "metadata": {},
      "name": "UseEmployerLocationRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerLocationRemoveMutation(\n  $input: AccountsEmployerOfficeRemoveLocationInput!\n) {\n  data: accountsEmployerOfficeRemoveLocation(input: $input) {\n    location {\n      node {\n        id\n        name\n        code\n        updatedAt\n        createdAt\n        address {\n          line1\n          line2\n          city\n          county\n          country\n          postCode\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node24.hash = "5cdf7dff72747718939c293a153965b9";
var UseEmployerLocationRemoveMutation_graphql_default = node24;

// src/mutations/UseEmployerLocationRemove.ts
import { useAsyncMutation as useAsyncMutation24 } from "shared-lib";
var mutationDef24 = UseEmployerLocationRemoveMutation_graphql_default;
function UseEmployerLocationRemove() {
  const [commit, isBusy] = useAsyncMutation24(mutationDef24);
  return [commit, isBusy];
}

// src/lib/error-codes.ts
var EmployerAccountsErrorCodes = class {
};
EmployerAccountsErrorCodes.USER_EMAIL_IS_IN_USE = "ACCOUNTS_EMPLOYER_USER_EMAIL_IS_IN_USE";

// src/components/accounts/__generated__/EmployerSearchBoxInputQuery.graphql.ts
var node25 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v22 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    v1
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerSearchBoxInputQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "EmployerSearchBox_employers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerSearchBoxInputQuery",
      "selections": [
        {
          "alias": "list",
          "args": v22,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v22,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerSearchBox_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "ac8a5cbc098d56a7c66d362cc46f25e1",
      "id": null,
      "metadata": {},
      "name": "EmployerSearchBoxInputQuery",
      "operationKind": "query",
      "text": "query EmployerSearchBoxInputQuery(\n  $where: EmployerFilter!\n) {\n  ...EmployerSearchBox_employers_3FC4Qo\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployerSearchBox_employers_3FC4Qo on Query {\n  list: accountsEmployers(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        employerId\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node25.hash = "6ad398480d562519083ad193715692da";
var EmployerSearchBoxInputQuery_graphql_default = node25;

// src/components/accounts/EmployerSearchBoxInput.tsx
import { Controller } from "react-hook-form";
import { useLazyLoadQuery } from "react-relay";

// src/components/accounts/__generated__/EmployerSearchBoxPaginationQuery.graphql.ts
var node26 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v22 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v22,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    v32
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerSearchBoxPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v22,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "EmployerSearchBox_employers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerSearchBoxPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerSearchBox_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "ee91ee3f76f5c44f8507ae7a55b44ada",
      "id": null,
      "metadata": {},
      "name": "EmployerSearchBoxPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerSearchBoxPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: EmployerFilter\n) {\n  ...EmployerSearchBox_employers_3sueo6\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployerSearchBox_employers_3sueo6 on Query {\n  list: accountsEmployers(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        employerId\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node26.hash = "dab80b742b9e0488f33ebba23921f835";
var EmployerSearchBoxPaginationQuery_graphql_default = node26;

// src/components/accounts/__generated__/EmployerSearchBox_employers.graphql.ts
var node27 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerSearchBoxPaginationQuery_graphql_default
      }
    },
    "name": "EmployerSearchBox_employers",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountsEmployersConnection",
        "kind": "LinkedField",
        "name": "__EmployerSearchBox_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Employer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "webSite",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerRow_account"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node27.hash = "dab80b742b9e0488f33ebba23921f835";
var EmployerSearchBox_employers_graphql_default = node27;

// src/components/accounts/EmployerSearchBox.tsx
import {
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";
import { usePaginationFragment } from "react-relay";
import { debounce } from "lodash-es";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { Combobox } from "@headlessui/react";
import { classNames } from "shared-ui";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var fragment = EmployerSearchBox_employers_graphql_default;
var EmployerSearchBox = ({
  onSelected,
  employers,
  defaultValue,
  showLabel,
  placeholder
}) => {
  const [selected, setSelected] = useState(
    defaultValue ?? null
  );
  const [searchTerm, setSearchTerm] = useState("");
  const onQueryChangeHandler = useMemo(
    () => debounce((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [selected]
  );
  const { data, refetch } = usePaginationFragment(fragment, employers);
  const where = { isDeleted: { eq: false } };
  if (searchTerm) {
    where.and = [
      { name: { startsWith: searchTerm } },
      { isDeleted: { eq: false } }
    ];
  } else {
    where.and = [{ isDeleted: { eq: false } }];
  }
  useEffect(() => {
    refetch({ first: 10, where }, { fetchPolicy: "store-or-network" });
  }, [searchTerm]);
  const { list } = data;
  const rows = (list?.edges ?? []).map((edge) => edge.node);
  return /* @__PURE__ */ jsxs(Combobox, { as: "div", value: selected, onChange: onSetSelected, children: [
    showLabel && /* @__PURE__ */ jsx(Combobox.Label, { className: "block text-sm font-medium text-gray-700", children: "Employer" }),
    /* @__PURE__ */ jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ jsx(
        Combobox.Input,
        {
          "aria-label": placeholder || "Search Employers",
          placeholder: placeholder || "Search Employers",
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result) {
              return result.name;
            }
            return "";
          },
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx(
        Combobox.Button,
        {
          "aria-label": "Employer Search Box",
          className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
          children: /* @__PURE__ */ jsx(
            ChevronUpDownIcon,
            {
              className: "h-5 w-5 text-gray-600",
              "aria-hidden": "true"
            }
          )
        }
      ),
      rows.length > 0 && /* @__PURE__ */ jsx(Combobox.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx(
        Combobox.Option,
        {
          value: result,
          className: ({ active }) => classNames(
            "relative cursor-default select-none py-2 pl-3 pr-9",
            active ? "bg-info-600 text-white" : "text-gray-900"
          ),
          children: ({ active, selected: selected2 }) => /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("div", { className: "flex", children: /* @__PURE__ */ jsx(
              "span",
              {
                className: classNames(
                  "truncate",
                  selected2 ? "font-semibold" : ""
                ),
                children: result.name
              }
            ) }),
            selected2 && /* @__PURE__ */ jsx(
              "span",
              {
                className: classNames(
                  "absolute inset-y-0 right-0 flex items-center pr-4",
                  active ? "bg-info-600 text-white" : "text-info-600"
                ),
                children: /* @__PURE__ */ jsx(CheckIcon, { className: "h-5 w-5", "aria-hidden": "true" })
              }
            )
          ] })
        },
        result.id
      )) })
    ] })
  ] });
};

// src/components/accounts/EmployerSearchBoxInput.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var graphqlQuery = EmployerSearchBoxInputQuery_graphql_default;
var EmployerSearchBoxInput = ({
  name,
  control,
  defaultValue,
  showLabel
}) => {
  const where = { isDeleted: { eq: false } };
  const query = useLazyLoadQuery(
    graphqlQuery,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx2(
    Controller,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange } }) => /* @__PURE__ */ jsx2(
        EmployerSearchBox,
        {
          onSelected: (result) => {
            onControllerChange(result);
          },
          employers: query,
          defaultValue,
          showLabel
        }
      )
    }
  );
};

// src/components/accounts/EmployerCreateContainer.tsx
import { Fragment as Fragment2, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var formSchema = zod.object({
  account: zod.object({
    employerId: zod.string(),
    name: zod.string()
  }).optional().nullable(),
  identity: zod.object({
    identityUserId: zod.string(),
    email: zod.string()
  }).optional().nullable(),
  name: zod.string().min(3, { message: "Employer name is required" }),
  adminFirstName: zod.string().min(1, { message: "Firstname is required" }),
  adminLastName: zod.string().min(1, { message: "Lastname is required" }),
  adminUserEmail: zod.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  }),
  notes: zod.string().nullable(),
  isTest: zod.boolean(),
  useExistingAccount: zod.boolean(),
  useExistingIdentity: zod.boolean()
});
var EmployerCreateContainer = ({ onCreate, onCancel }) => {
  const defaultValues = {
    account: null,
    identity: null,
    name: "DemoCo EP1899",
    adminFirstName: "mick",
    adminLastName: "Del",
    adminUserEmail: "mick@elevatedirect.com",
    notes: "DemoCo EP1899",
    isTest: true,
    useExistingAccount: true,
    useExistingIdentity: true
  };
  const setErrorCode = useSetUserErrorCodes();
  const { register, handleSubmit, watch, formState, control } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode();
  const [createEmployer, isCreatingEmployer] = useEmployerCreate();
  const onSave = useCallback2(
    async (form) => {
      setErrorCode(null);
      if (!form.name || !form.adminFirstName || !form.adminLastName || !form.adminUserEmail) {
        return;
      }
      let identityUserContext = {
        create: true
      };
      if (form.useExistingIdentity) {
        identityUserContext = {
          identityId: form.identity?.identityUserId
        };
      }
      const input = {
        clientMutationId: createClientMutationId(),
        name: form.name,
        adminFirstName: form.adminFirstName,
        adminLastName: form.adminLastName,
        adminUserEmail: form.adminUserEmail,
        isTest: form.isTest,
        notes: form.notes || "",
        copyFromEmployerId: form.account?.employerId,
        identityUserContext
      };
      const response = await createEmployer({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.employer?.node) {
        onCreate(response.data.employer.node);
      }
    },
    [createEmployer]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  const useExistingAccount = watch("useExistingAccount");
  const useExistingIdentity = watch("useExistingIdentity");
  let errorDisplay = /* @__PURE__ */ jsx3(FormErrorCodes, {});
  if (userErrorCode && userErrorCode === EmployerAccountsErrorCodes.USER_EMAIL_IS_IN_USE) {
    errorDisplay = /* @__PURE__ */ jsx3(FormErrorCode, { message: "Email is already in use" });
  }
  return /* @__PURE__ */ jsxs2("div", { className: "m-4 flex flex-col items-center justify-center", children: [
    errorDisplay,
    /* @__PURE__ */ jsx3("form", { onSubmit, children: /* @__PURE__ */ jsxs2(
      ActionContainer,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        isDisabled: isCreatingEmployer,
        titleTop: `Create Employer`,
        children: [
          /* @__PURE__ */ jsxs2(
            FormInputRow,
            {
              name: "useExistingAccount",
              title: "Use Existing Account *",
              children: [
                /* @__PURE__ */ jsx3(
                  SwitchInput,
                  {
                    control,
                    name: "useExistingAccount",
                    defaultChecked: false,
                    label: "Use Existing Account"
                  }
                ),
                /* @__PURE__ */ jsx3(ErrorField, { field: errors.useExistingAccount })
              ]
            }
          ),
          useExistingAccount && /* @__PURE__ */ jsxs2(Fragment2, { children: [
            /* @__PURE__ */ jsx3("div", { className: "flex items-center", children: /* @__PURE__ */ jsx3("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs2("div", { className: "border bg-white p-4", children: [
              /* @__PURE__ */ jsx3("p", { children: "This will copy the company details, canonical company etc to the new account" }),
              /* @__PURE__ */ jsx3("p", { children: "It will copy all existing user groups, but will not copy any existing users." }),
              /* @__PURE__ */ jsx3("p", { children: "It will also not copy the company logo" })
            ] }) }) }),
            /* @__PURE__ */ jsxs2(FormInputRow, { name: "account", title: "Employer *", children: [
              /* @__PURE__ */ jsx3(EmployerSearchBoxInput, { control, name: "account" }),
              /* @__PURE__ */ jsx3(ErrorField, { field: errors.account })
            ] })
          ] }),
          /* @__PURE__ */ jsxs2(FormInputRow, { name: "name", title: "Name *", children: [
            /* @__PURE__ */ jsx3(
              InputField,
              {
                "aria-label": "Employer Name",
                register,
                name: "name",
                required: true,
                placeholder: "Employer Name"
              }
            ),
            /* @__PURE__ */ jsx3(ErrorField, { field: errors.name })
          ] }),
          /* @__PURE__ */ jsxs2(FormInputRow, { name: "isTest", title: "Test Account *", children: [
            /* @__PURE__ */ jsx3(
              SwitchInput,
              {
                control,
                name: "isTest",
                defaultChecked: false,
                label: "Is Test Account"
              }
            ),
            /* @__PURE__ */ jsx3(ErrorField, { field: errors.isTest })
          ] }),
          /* @__PURE__ */ jsxs2(FormInputRow, { name: "adminFirstName", title: "First Name *", children: [
            /* @__PURE__ */ jsx3(
              InputField,
              {
                "aria-label": "Admin User First Name",
                register,
                name: "adminFirstName",
                required: true,
                placeholder: "Admin User First Name"
              }
            ),
            /* @__PURE__ */ jsx3(ErrorField, { field: errors.adminFirstName })
          ] }),
          /* @__PURE__ */ jsxs2(FormInputRow, { name: "adminLastName", title: "Last Name *", children: [
            /* @__PURE__ */ jsx3(
              InputField,
              {
                register,
                name: "adminLastName",
                required: true,
                placeholder: "Admin User Last Name",
                "aria-label": "Admin User Last Name"
              }
            ),
            /* @__PURE__ */ jsx3(ErrorField, { field: errors.adminLastName })
          ] }),
          /* @__PURE__ */ jsxs2(FormInputRow, { name: "adminUserEmail", title: "Email *", children: [
            /* @__PURE__ */ jsx3(
              InputField,
              {
                "aria-label": "Admin User Email",
                register,
                name: "adminUserEmail",
                required: true,
                placeholder: "Admin User Email"
              }
            ),
            /* @__PURE__ */ jsx3(ErrorField, { field: errors.adminUserEmail })
          ] }),
          /* @__PURE__ */ jsxs2(FormInputRow, { name: "notes", title: "Notes *", children: [
            /* @__PURE__ */ jsx3(
              FormTextAreaInput,
              {
                "aria-label": "Notes",
                rows: 6,
                register,
                name: "notes",
                required: false,
                placeholder: "Notes"
              }
            ),
            /* @__PURE__ */ jsx3(ErrorField, { field: errors.notes })
          ] }),
          /* @__PURE__ */ jsxs2(FormInputRow, { name: "useExistingIdentity", title: "Use Existing User *", children: [
            /* @__PURE__ */ jsx3(
              SwitchInput,
              {
                control,
                name: "useExistingIdentity",
                defaultChecked: false,
                label: "Use Existing User"
              }
            ),
            /* @__PURE__ */ jsx3(ErrorField, { field: errors.useExistingIdentity })
          ] }),
          useExistingIdentity && /* @__PURE__ */ jsxs2(Fragment2, { children: [
            /* @__PURE__ */ jsx3("div", { className: "flex items-center", children: /* @__PURE__ */ jsx3("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsx3("div", { className: "border bg-white p-4", children: /* @__PURE__ */ jsx3("p", { children: "This will use an existing User Account" }) }) }) }),
            /* @__PURE__ */ jsxs2(FormInputRow, { name: "identity", title: "User *", children: [
              /* @__PURE__ */ jsx3(IdentityUserSearchBoxInput, { control, name: "identity" }),
              /* @__PURE__ */ jsx3(ErrorField, { field: errors.identity })
            ] })
          ] })
        ]
      }
    ) })
  ] });
};

// src/components/accounts/__generated__/EmployerDetailsQuery.graphql.ts
var node28 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerDetailsQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerById",
          "plural": false,
          "selections": [
            v22,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerDetailsViewFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerDetailsEditFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerLogoUploadFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerDetailsQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerById",
          "plural": false,
          "selections": [
            v22,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "details",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "industry",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webSite",
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c26d752d3692f9b1e94d27d73bae92d4",
      "id": null,
      "metadata": {},
      "name": "EmployerDetailsQuery",
      "operationKind": "query",
      "text": "query EmployerDetailsQuery(\n  $id: UUID!\n) {\n  employer: accountsEmployerById(id: $id) {\n    id\n    ...EmployerDetailsViewFragment\n    ...EmployerDetailsEditFragment\n    ...EmployerLogoUploadFragment\n  }\n}\n\nfragment EmployerDetailsEditFragment on Employer {\n  name\n  logoUrl\n  details\n  industry\n  webSite\n}\n\nfragment EmployerDetailsViewFragment on Employer {\n  id\n  name\n  logoUrl\n  details\n  industry\n  webSite\n}\n\nfragment EmployerLogoUploadFragment on Employer {\n  id\n  name\n  logoUrl\n  details\n  industry\n  webSite\n}\n"
    }
  };
}();
node28.hash = "ada224dad184f1d4c49ee3e51f4cf441";
var EmployerDetailsQuery_graphql_default = node28;

// src/components/accounts/EmployerDetails.tsx
import { Suspense } from "react";
import {
  loadQuery,
  usePreloadedQuery
} from "react-relay";
import { useRouteLoaderData } from "react-router-dom";
import { resolveEmployerId } from "app-core";
import { useLogger as useLogger2, useToggle } from "shared-lib";
import { EdSkeleton, ErrorContainer } from "shared-ui";

// src/components/accounts/__generated__/EmployerDetailsEditFragment.graphql.ts
var node29 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerDetailsEditFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "details",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webSite",
      "storageKey": null
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node29.hash = "c36376f062ed27f69cab26d963732f47";
var EmployerDetailsEditFragment_graphql_default = node29;

// src/components/accounts/__generated__/EmployerDetailsEditIndustriesAllQuery.graphql.ts
var node30 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "Industry",
      "kind": "LinkedField",
      "name": "industriesAll",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerDetailsEditIndustriesAllQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "EmployerDetailsEditIndustriesAllQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "10f66389aca005959f7704930143335b",
      "id": null,
      "metadata": {},
      "name": "EmployerDetailsEditIndustriesAllQuery",
      "operationKind": "query",
      "text": "query EmployerDetailsEditIndustriesAllQuery {\n  industriesAll {\n    id\n    name\n  }\n}\n"
    }
  };
}();
node30.hash = "71c9a3cf5e6436f1261fa73f78c39bf1";
var EmployerDetailsEditIndustriesAllQuery_graphql_default = node30;

// src/components/accounts/EmployerDetailsEdit.tsx
import { useCallback as useCallback3, useState as useState2 } from "react";
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod";
import { useForm as useForm2 } from "react-hook-form";
import { useFragment, useLazyLoadQuery as useLazyLoadQuery2 } from "react-relay";
import * as zod2 from "zod";
import { createClientMutationId as createClientMutationId2, useUserErrorCode as useUserErrorCode2 } from "shared-lib";
import {
  ActionContainer as ActionContainer2,
  AlertMessage,
  ErrorField as ErrorField2,
  FormInput,
  FormInputRow as FormInputRow2,
  SelectMenu
} from "shared-ui";

// src/mutations/__generated__/UseEmployerDetailsUpdateMutation.graphql.ts
var node31 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "details",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "webSite",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerDetailsUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateDetailsPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateDetails",
          "plural": false,
          "selections": [
            v22,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerDetailsUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateDetailsPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateDetails",
          "plural": false,
          "selections": [
            v22,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0f243e5b24bdf9c041cb3c23109a60c8",
      "id": null,
      "metadata": {},
      "name": "UseEmployerDetailsUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerDetailsUpdateMutation(\n  $input: AccountsEmployerUpdateDetailsInput!\n) {\n  data: accountsEmployerUpdateDetails(input: $input) {\n    employer {\n      node {\n        id\n        name\n        logoUrl\n        details\n        industry\n        webSite\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node31.hash = "9b67f1c9c30557c9fa2c8d5a715dce64";
var UseEmployerDetailsUpdateMutation_graphql_default = node31;

// src/mutations/UseEmployerDetailsUpdateMutation.ts
import { useAsyncMutation as useAsyncMutation25 } from "shared-lib";
var mutationDef25 = UseEmployerDetailsUpdateMutation_graphql_default;
function useEmployerDetailsUpdate() {
  const [commit, isBusy] = useAsyncMutation25(mutationDef25);
  return [commit, isBusy];
}

// src/components/accounts/EmployerDetailsEdit.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var fragmentDef = EmployerDetailsEditFragment_graphql_default;
var queryDef = EmployerDetailsEditIndustriesAllQuery_graphql_default;
var formSchema2 = zod2.object({
  name: zod2.string().min(1, "name is required"),
  webSite: zod2.string().url(),
  industry: zod2.string(),
  details: zod2.string(),
  logoUrl: zod2.string()
});
var EmployerDetailsEdit = ({
  employerId,
  employerFragmentRef,
  onCancel,
  onDone
}) => {
  const [update, isUpdating] = useEmployerDetailsUpdate();
  const [updateName, isUpdatingName] = useEmployerNameUpdateMutation();
  const industryList = useLazyLoadQuery2(
    queryDef,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  const data = useFragment(
    fragmentDef,
    employerFragmentRef
  );
  const employerIndustry = data?.industry && industryList?.industriesAll?.find((obj) => obj?.name === data?.industry);
  const errorCode = useUserErrorCode2();
  const defaultValues = {
    name: data?.name || "",
    webSite: data?.webSite || "",
    industry: data?.industry || "",
    details: data?.details || "",
    logoUrl: data?.logoUrl || ""
  };
  const { register, handleSubmit, formState, setValue } = useForm2({
    resolver: zodResolver2(formSchema2),
    defaultValues
  });
  const [industry, setIndustry] = useState2(
    employerIndustry || null
  );
  const { errors, isDirty } = formState;
  const onSetField = useCallback3(
    (item) => {
      setIndustry(item);
      setValue("industry", item.name);
    },
    [setValue, setIndustry]
  );
  const onSave = useCallback3(
    async (form) => {
      if (!form.name) {
        return;
      }
      const updateDetailsInput = {
        industry: form.industry || "",
        website: form.webSite || "",
        clientMutationId: createClientMutationId2(),
        details: form.details || "",
        employerId,
        headOfficeAddress: "",
        logoUrl: form.logoUrl || ""
      };
      const updateNameInput = {
        name: form.name,
        clientMutationId: createClientMutationId2(),
        employerId
      };
      try {
        const detailsResponse = await update({ input: updateDetailsInput });
        const nameResponse = await updateName({ input: updateNameInput });
        if (detailsResponse?.data && nameResponse.data) {
          onDone();
        }
      } catch (error) {
        console.error("Error occurred during mutations", error);
      }
    },
    [update, onDone, updateName, employerId]
  );
  return /* @__PURE__ */ jsx4("div", { className: "flex flex-1 bg-gray-100 lg:mx-5", children: /* @__PURE__ */ jsx4("div", { className: "flex w-full justify-between p-4", children: /* @__PURE__ */ jsxs3(
    ActionContainer2,
    {
      onSubmit: handleSubmit(onSave),
      onCancel,
      showCancel: true,
      isSaving: isUpdating || isUpdatingName,
      isDirty,
      children: [
        errorCode && /* @__PURE__ */ jsx4(AlertMessage, { message: "An error has occurred" }),
        /* @__PURE__ */ jsxs3(FormInputRow2, { name: "name", title: "Name *", children: [
          /* @__PURE__ */ jsx4(
            FormInput,
            {
              "aria-label": "name",
              type: "text",
              name: "name",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx4(ErrorField2, { field: errors.name })
        ] }),
        /* @__PURE__ */ jsxs3(FormInputRow2, { name: "industry", title: "Industry", children: [
          /* @__PURE__ */ jsx4(
            SelectMenu,
            {
              items: industryList?.industriesAll,
              onChange: onSetField,
              value: industry
            }
          ),
          /* @__PURE__ */ jsx4(ErrorField2, { field: errors.industry })
        ] }),
        /* @__PURE__ */ jsxs3(FormInputRow2, { name: "webSite", title: "webSite", children: [
          /* @__PURE__ */ jsx4(
            FormInput,
            {
              "aria-label": "website",
              type: "text",
              name: "webSite",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx4(ErrorField2, { field: errors.webSite })
        ] }),
        /* @__PURE__ */ jsxs3(FormInputRow2, { name: "details", title: "details", children: [
          /* @__PURE__ */ jsx4(
            FormInput,
            {
              "aria-label": "details",
              type: "text",
              name: "details",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx4(ErrorField2, { field: errors.details })
        ] })
      ]
    }
  ) }) });
};

// src/components/accounts/__generated__/EmployerDetailsViewFragment.graphql.ts
var node32 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerDetailsViewFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "details",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webSite",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node32.hash = "208deb7e4f719099c91efa52c46a4c52";
var EmployerDetailsViewFragment_graphql_default = node32;

// src/components/accounts/EmployerDetailsView.tsx
import { useFragment as useFragment2 } from "react-relay";
import { PencilIcon } from "@heroicons/react/24/outline";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var fragmentDef2 = EmployerDetailsViewFragment_graphql_default;
var EmployerDetailsView = ({ employer, onEdit }) => {
  const data = useFragment2(
    fragmentDef2,
    employer
  );
  return /* @__PURE__ */ jsx5("div", { className: "mx-5 flex flex-1 bg-gray-100 p-4", children: /* @__PURE__ */ jsxs4("div", { className: "flex h-fit w-full justify-between rounded-lg bg-white px-6 py-5 xl:border", children: [
    /* @__PURE__ */ jsxs4("div", { className: "flex flex-col gap-4", children: [
      /* @__PURE__ */ jsxs4("div", { children: [
        /* @__PURE__ */ jsx5("div", { className: "text-gray-600", children: "Name:" }),
        data.name
      ] }),
      /* @__PURE__ */ jsxs4("div", { children: [
        /* @__PURE__ */ jsx5("div", { className: "text-gray-600", children: "Industry:" }),
        data.industry
      ] }),
      /* @__PURE__ */ jsxs4("div", { children: [
        /* @__PURE__ */ jsx5("div", { className: "text-gray-600", children: "WebSite:" }),
        data.webSite
      ] }),
      /* @__PURE__ */ jsxs4("div", { children: [
        /* @__PURE__ */ jsx5("div", { className: "text-gray-600", children: "Description:" }),
        data.details
      ] })
    ] }),
    /* @__PURE__ */ jsx5(
      "div",
      {
        className: "text-primary-400 cursor-pointer pb-5 pl-5",
        onClick: onEdit,
        children: /* @__PURE__ */ jsx5(PencilIcon, { className: "h-6 w-6" })
      }
    )
  ] }) });
};
var EmployerLogoView = ({ employer, onEdit }) => {
  const data = useFragment2(
    fragmentDef2,
    employer
  );
  return /* @__PURE__ */ jsx5("div", { className: "mx-5 flex flex-1 bg-gray-100 p-4", children: /* @__PURE__ */ jsxs4("div", { className: "flex h-fit w-full justify-between rounded-lg bg-white px-6 py-5 xl:border", children: [
    /* @__PURE__ */ jsx5("div", { className: "flex flex-col gap-4", children: /* @__PURE__ */ jsxs4("div", { children: [
      /* @__PURE__ */ jsx5("div", { className: "text-gray-600", children: "Logo:" }),
      data.logoUrl ? /* @__PURE__ */ jsx5("img", { src: data.logoUrl, alt: "logo" }) : "No logo"
    ] }) }),
    /* @__PURE__ */ jsx5(
      "div",
      {
        className: "text-primary-400 cursor-pointer pb-5 pl-5",
        onClick: onEdit,
        children: /* @__PURE__ */ jsx5(PencilIcon, { className: "h-6 w-6" })
      }
    )
  ] }) });
};

// src/components/accounts/__generated__/EmployerLogoUploadFragment.graphql.ts
var node33 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerLogoUploadFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "details",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webSite",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node33.hash = "5bfa614db7843d0448f50db3766ec256";
var EmployerLogoUploadFragment_graphql_default = node33;

// src/components/accounts/EmployerLogoUpload.tsx
import { useCallback as useCallback4, useState as useState3 } from "react";
import { XCircleIcon } from "@heroicons/react/20/solid";

// ../../node_modules/@uppy/utils/lib/Translator.js
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
function insertReplacement(source, rx, replacement) {
  const newParts = [];
  source.forEach((chunk) => {
    if (typeof chunk !== "string") {
      return newParts.push(chunk);
    }
    return rx[Symbol.split](chunk).forEach((raw, i4, list) => {
      if (raw !== "") {
        newParts.push(raw);
      }
      if (i4 < list.length - 1) {
        newParts.push(replacement);
      }
    });
  });
  return newParts;
}
function interpolate(phrase, options) {
  const dollarRegex = /\$/g;
  const dollarBillsYall = "$$$$";
  let interpolated = [phrase];
  if (options == null)
    return interpolated;
  for (const arg of Object.keys(options)) {
    if (arg !== "_") {
      let replacement = options[arg];
      if (typeof replacement === "string") {
        replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
      }
      interpolated = insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, "g"), replacement);
    }
  }
  return interpolated;
}
var defaultOnMissingKey = (key) => {
  throw new Error(`missing string: ${key}`);
};
var _onMissingKey = /* @__PURE__ */ _classPrivateFieldLooseKey("onMissingKey");
var _apply = /* @__PURE__ */ _classPrivateFieldLooseKey("apply");
var Translator = class {
  constructor(locales, _temp) {
    let {
      onMissingKey = defaultOnMissingKey
    } = _temp === void 0 ? {} : _temp;
    Object.defineProperty(this, _apply, {
      value: _apply2
    });
    Object.defineProperty(this, _onMissingKey, {
      writable: true,
      value: void 0
    });
    this.locale = {
      strings: {},
      pluralize(n3) {
        if (n3 === 1) {
          return 0;
        }
        return 1;
      }
    };
    if (Array.isArray(locales)) {
      locales.forEach(_classPrivateFieldLooseBase(this, _apply)[_apply], this);
    } else {
      _classPrivateFieldLooseBase(this, _apply)[_apply](locales);
    }
    _classPrivateFieldLooseBase(this, _onMissingKey)[_onMissingKey] = onMissingKey;
  }
  /**
   * Public translate method
   *
   * @param key
   * @param options with values that will be used later to replace placeholders in string
   * @returns string translated (and interpolated)
   */
  translate(key, options) {
    return this.translateArray(key, options).join("");
  }
  /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @returns The translated and interpolated parts, in order.
   */
  translateArray(key, options) {
    let string10 = this.locale.strings[key];
    if (string10 == null) {
      _classPrivateFieldLooseBase(this, _onMissingKey)[_onMissingKey](key);
      string10 = key;
    }
    const hasPluralForms = typeof string10 === "object";
    if (hasPluralForms) {
      if (options && typeof options.smart_count !== "undefined") {
        const plural = this.locale.pluralize(options.smart_count);
        return interpolate(string10[plural], options);
      }
      throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
    }
    if (typeof string10 !== "string") {
      throw new Error(`string was not a string`);
    }
    return interpolate(string10, options);
  }
};
function _apply2(locale2) {
  if (!(locale2 != null && locale2.strings)) {
    return;
  }
  const prevLocale = this.locale;
  Object.assign(this.locale, {
    strings: {
      ...prevLocale.strings,
      ...locale2.strings
    },
    pluralize: locale2.pluralize || prevLocale.pluralize
  });
}

// ../../node_modules/@uppy/core/lib/BasePlugin.js
var BasePlugin = class {
  constructor(uppy2, opts) {
    this.uppy = uppy2;
    this.opts = opts != null ? opts : {};
  }
  getPluginState() {
    const {
      plugins: plugins2
    } = this.uppy.getState();
    return (plugins2 == null ? void 0 : plugins2[this.id]) || {};
  }
  setPluginState(update) {
    const {
      plugins: plugins2
    } = this.uppy.getState();
    this.uppy.setState({
      plugins: {
        ...plugins2,
        [this.id]: {
          ...plugins2[this.id],
          ...update
        }
      }
    });
  }
  setOptions(newOpts) {
    this.opts = {
      ...this.opts,
      ...newOpts
    };
    this.setPluginState(void 0);
    this.i18nInit();
  }
  i18nInit() {
    const translator = new Translator([this.defaultLocale, this.uppy.locale, this.opts.locale]);
    this.i18n = translator.translate.bind(translator);
    this.i18nArray = translator.translateArray.bind(translator);
    this.setPluginState(void 0);
  }
  /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addTarget(plugin) {
    throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
  }
  install() {
  }
  uninstall() {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  update(state) {
  }
  // Called after every state update, after everything's mounted. Debounced.
  afterUpdate() {
  }
};

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/UserFacingApiError.js
var UserFacingApiError = class extends Error {
  constructor() {
    super(...arguments);
    this.name = "UserFacingApiError";
  }
};
var UserFacingApiError_default = UserFacingApiError;

// ../../node_modules/p-retry/index.js
var import_retry = __toESM(require_retry2(), 1);

// ../../node_modules/is-network-error/index.js
var objectToString = Object.prototype.toString;
var isError = (value) => objectToString.call(value) === "[object Error]";
var errorMessages = /* @__PURE__ */ new Set([
  "network error",
  // Chrome
  "Failed to fetch",
  // Chrome
  "NetworkError when attempting to fetch resource.",
  // Firefox
  "The Internet connection appears to be offline.",
  // Safari 16
  "Load failed",
  // Safari 17+
  "Network request failed",
  // `cross-fetch`
  "fetch failed"
  // Undici (Node.js)
]);
function isNetworkError(error) {
  const isValid = error && isError(error) && error.name === "TypeError" && typeof error.message === "string";
  if (!isValid) {
    return false;
  }
  if (error.message === "Load failed") {
    return error.stack === void 0;
  }
  return errorMessages.has(error.message);
}

// ../../node_modules/p-retry/index.js
var AbortError = class extends Error {
  constructor(message) {
    super();
    if (message instanceof Error) {
      this.originalError = message;
      ({ message } = message);
    } else {
      this.originalError = new Error(message);
      this.originalError.stack = this.stack;
    }
    this.name = "AbortError";
    this.message = message;
  }
};
var decorateErrorWithCounts = (error, attemptNumber, options) => {
  const retriesLeft = options.retries - (attemptNumber - 1);
  error.attemptNumber = attemptNumber;
  error.retriesLeft = retriesLeft;
  return error;
};
async function pRetry(input, options) {
  return new Promise((resolve, reject) => {
    options = {
      onFailedAttempt() {
      },
      retries: 10,
      shouldRetry: () => true,
      ...options
    };
    const operation = import_retry.default.operation(options);
    const abortHandler = () => {
      operation.stop();
      reject(options.signal?.reason);
    };
    if (options.signal && !options.signal.aborted) {
      options.signal.addEventListener("abort", abortHandler, { once: true });
    }
    const cleanUp = () => {
      options.signal?.removeEventListener("abort", abortHandler);
      operation.stop();
    };
    operation.attempt(async (attemptNumber) => {
      try {
        const result = await input(attemptNumber);
        cleanUp();
        resolve(result);
      } catch (error) {
        try {
          if (!(error instanceof Error)) {
            throw new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`);
          }
          if (error instanceof AbortError) {
            throw error.originalError;
          }
          if (error instanceof TypeError && !isNetworkError(error)) {
            throw error;
          }
          decorateErrorWithCounts(error, attemptNumber, options);
          if (!await options.shouldRetry(error)) {
            operation.stop();
            reject(error);
          }
          await options.onFailedAttempt(error);
          if (!operation.retry(error)) {
            throw operation.mainError();
          }
        } catch (finalError) {
          decorateErrorWithCounts(finalError, attemptNumber, options);
          cleanUp();
          reject(finalError);
        }
      }
    });
  });
}

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/NetworkError.js
var NetworkError = class extends Error {
  constructor(error, xhr) {
    if (xhr === void 0) {
      xhr = null;
    }
    super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
    this.cause = error;
    this.isNetworkError = true;
    this.request = xhr;
  }
};
var NetworkError_default = NetworkError;

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/fetchWithNetworkError.js
function fetchWithNetworkError() {
  return fetch(...arguments).catch((err) => {
    if (err.name === "AbortError") {
      throw err;
    } else {
      throw new NetworkError_default(err);
    }
  });
}

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/hasProperty.js
function has(object10, key) {
  return Object.prototype.hasOwnProperty.call(object10, key);
}

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/ErrorWithCause.js
var ErrorWithCause = class extends Error {
  constructor(message, options) {
    super(message);
    this.cause = options == null ? void 0 : options.cause;
    if (this.cause && has(this.cause, "isNetworkError")) {
      this.isNetworkError = this.cause.isNetworkError;
    } else {
      this.isNetworkError = false;
    }
  }
};
var ErrorWithCause_default = ErrorWithCause;

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/emitSocketProgress.js
var import_throttle = __toESM(require_throttle(), 1);
function emitSocketProgress(uploader, progressData, file) {
  const {
    progress,
    bytesUploaded,
    bytesTotal
  } = progressData;
  if (progress) {
    uploader.uppy.log(`Upload progress: ${progress}`);
    uploader.uppy.emit("upload-progress", file, {
      // @ts-expect-error todo remove in next major
      uploader,
      bytesUploaded,
      bytesTotal
    });
  }
}
var emitSocketProgress_default = (0, import_throttle.default)(emitSocketProgress, 300, {
  leading: true,
  trailing: true
});

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/getSocketHost.js
function getSocketHost(url) {
  var _regex$exec;
  const regex = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i;
  const host = (_regex$exec = regex.exec(url)) == null ? void 0 : _regex$exec[1];
  const socketProtocol = /^http:\/\//i.test(url) ? "ws" : "wss";
  return `${socketProtocol}://${host}`;
}

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/companion-client/lib/AuthError.js
var AuthError = class extends Error {
  constructor() {
    super("Authorization required");
    this.name = "AuthError";
    this.isAuthError = true;
  }
};
var AuthError_default = AuthError;

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/companion-client/lib/RequestClient.js
var _Symbol$for;
function _classPrivateFieldLooseBase2(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id2 = 0;
function _classPrivateFieldLooseKey2(name) {
  return "__private_" + id2++ + "_" + name;
}
var packageJson = {
  "version": "3.7.4"
};
function stripSlash(url) {
  return url.replace(/\/$/, "");
}
var retryCount = 10;
var socketActivityTimeoutMs = 5 * 60 * 1e3;
var authErrorStatusCode = 401;
var HttpError = class extends Error {
  constructor(_ref) {
    let {
      statusCode,
      message
    } = _ref;
    super(message);
    this.name = "HttpError";
    this.statusCode = statusCode;
  }
};
async function handleJSONResponse(res) {
  if (res.status === authErrorStatusCode) {
    throw new AuthError_default();
  }
  if (res.ok) {
    return res.json();
  }
  let errMsg = `Failed request with status: ${res.status}. ${res.statusText}`;
  let errData;
  try {
    errData = await res.json();
    if (errData.message)
      errMsg = `${errMsg} message: ${errData.message}`;
    if (errData.requestId)
      errMsg = `${errMsg} request-Id: ${errData.requestId}`;
  } catch (cause) {
    throw new Error(errMsg, {
      cause
    });
  }
  if (res.status >= 400 && res.status <= 499 && errData.message) {
    throw new UserFacingApiError_default(errData.message);
  }
  throw new HttpError({
    statusCode: res.status,
    message: errMsg
  });
}
var _companionHeaders = /* @__PURE__ */ _classPrivateFieldLooseKey2("companionHeaders");
var _getUrl = /* @__PURE__ */ _classPrivateFieldLooseKey2("getUrl");
var _requestSocketToken = /* @__PURE__ */ _classPrivateFieldLooseKey2("requestSocketToken");
var _awaitRemoteFileUpload = /* @__PURE__ */ _classPrivateFieldLooseKey2("awaitRemoteFileUpload");
_Symbol$for = Symbol.for("uppy test: getCompanionHeaders");
var RequestClient = class {
  constructor(uppy2, opts) {
    Object.defineProperty(this, _awaitRemoteFileUpload, {
      value: _awaitRemoteFileUpload2
    });
    Object.defineProperty(this, _getUrl, {
      value: _getUrl2
    });
    Object.defineProperty(this, _companionHeaders, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requestSocketToken, {
      writable: true,
      value: async (_ref2) => {
        var _file$remote;
        let {
          file,
          postBody,
          signal
        } = _ref2;
        if (((_file$remote = file.remote) == null ? void 0 : _file$remote.url) == null) {
          throw new Error("Cannot connect to an undefined URL");
        }
        const res = await this.post(file.remote.url, {
          ...file.remote.body,
          ...postBody
        }, {
          signal
        });
        return res.token;
      }
    });
    this.uppy = uppy2;
    this.opts = opts;
    this.onReceiveResponse = this.onReceiveResponse.bind(this);
    _classPrivateFieldLooseBase2(this, _companionHeaders)[_companionHeaders] = opts == null ? void 0 : opts.companionHeaders;
  }
  setCompanionHeaders(headers) {
    _classPrivateFieldLooseBase2(this, _companionHeaders)[_companionHeaders] = headers;
  }
  [_Symbol$for]() {
    return _classPrivateFieldLooseBase2(this, _companionHeaders)[_companionHeaders];
  }
  get hostname() {
    const {
      companion
    } = this.uppy.getState();
    const host = this.opts.companionUrl;
    return stripSlash(companion && companion[host] ? companion[host] : host);
  }
  async headers(emptyBody) {
    if (emptyBody === void 0) {
      emptyBody = false;
    }
    const defaultHeaders = {
      Accept: "application/json",
      ...emptyBody ? void 0 : {
        // Passing those headers on requests with no data forces browsers to first make a preflight request.
        "Content-Type": "application/json"
      }
    };
    return {
      ...defaultHeaders,
      ..._classPrivateFieldLooseBase2(this, _companionHeaders)[_companionHeaders]
    };
  }
  onReceiveResponse(res) {
    const {
      headers
    } = res;
    const state = this.uppy.getState();
    const companion = state.companion || {};
    const host = this.opts.companionUrl;
    if (headers.has("i-am") && headers.get("i-am") !== companion[host]) {
      this.uppy.setState({
        companion: {
          ...companion,
          [host]: headers.get("i-am")
        }
      });
    }
  }
  async request(_ref3) {
    let {
      path,
      method = "GET",
      data,
      skipPostResponse,
      signal
    } = _ref3;
    try {
      const headers = await this.headers(!data);
      const response = await fetchWithNetworkError(_classPrivateFieldLooseBase2(this, _getUrl)[_getUrl](path), {
        method,
        signal,
        headers,
        credentials: this.opts.companionCookiesRule || "same-origin",
        body: data ? JSON.stringify(data) : null
      });
      if (!skipPostResponse)
        this.onReceiveResponse(response);
      return await handleJSONResponse(response);
    } catch (err) {
      if (err.isAuthError || err.name === "UserFacingApiError" || err.name === "AbortError")
        throw err;
      throw new ErrorWithCause_default(`Could not ${method} ${_classPrivateFieldLooseBase2(this, _getUrl)[_getUrl](path)}`, {
        cause: err
      });
    }
  }
  async get(path, options) {
    if (typeof options === "boolean")
      options = {
        skipPostResponse: options
      };
    return this.request({
      ...options,
      path
    });
  }
  async post(path, data, options) {
    if (typeof options === "boolean")
      options = {
        skipPostResponse: options
      };
    return this.request({
      ...options,
      path,
      method: "POST",
      data
    });
  }
  async delete(path, data, options) {
    if (typeof options === "boolean")
      options = {
        skipPostResponse: options
      };
    return this.request({
      ...options,
      path,
      method: "DELETE",
      data
    });
  }
  /**
   * Remote uploading consists of two steps:
   * 1. #requestSocketToken which starts the download/upload in companion and returns a unique token for the upload.
   * Then companion will halt the upload until:
   * 2. #awaitRemoteFileUpload is called, which will open/ensure a websocket connection towards companion, with the
   * previously generated token provided. It returns a promise that will resolve/reject once the file has finished
   * uploading or is otherwise done (failed, canceled)
   */
  async uploadRemoteFile(file, reqBody, options) {
    var _this = this;
    try {
      const {
        signal,
        getQueue
      } = options || {};
      return await pRetry(async () => {
        var _this$uppy$getFile;
        const existingServerToken = (_this$uppy$getFile = this.uppy.getFile(file.id)) == null ? void 0 : _this$uppy$getFile.serverToken;
        if (existingServerToken != null) {
          this.uppy.log(`Connecting to exiting websocket ${existingServerToken}`);
          return _classPrivateFieldLooseBase2(this, _awaitRemoteFileUpload)[_awaitRemoteFileUpload]({
            file,
            queue: getQueue(),
            signal
          });
        }
        const queueRequestSocketToken = getQueue().wrapPromiseFunction(async function() {
          try {
            return await _classPrivateFieldLooseBase2(_this, _requestSocketToken)[_requestSocketToken](...arguments);
          } catch (outerErr) {
            if (outerErr.isAuthError)
              throw new AbortError(outerErr);
            if (outerErr.cause == null)
              throw outerErr;
            const err = outerErr.cause;
            const isRetryableHttpError = () => [408, 409, 429, 418, 423].includes(err.statusCode) || err.statusCode >= 500 && err.statusCode <= 599 && ![501, 505].includes(err.statusCode);
            if (err.name === "HttpError" && !isRetryableHttpError())
              throw new AbortError(err);
            throw err;
          }
        }, {
          priority: -1
        });
        const serverToken = await queueRequestSocketToken({
          file,
          postBody: reqBody,
          signal
        }).abortOn(signal);
        if (!this.uppy.getFile(file.id))
          return void 0;
        this.uppy.setFileState(file.id, {
          serverToken
        });
        return _classPrivateFieldLooseBase2(this, _awaitRemoteFileUpload)[_awaitRemoteFileUpload]({
          file: this.uppy.getFile(file.id),
          // re-fetching file because it might have changed in the meantime
          queue: getQueue(),
          signal
        });
      }, {
        retries: retryCount,
        signal,
        onFailedAttempt: (err) => this.uppy.log(`Retrying upload due to: ${err.message}`, "warning")
      });
    } catch (err) {
      if (err.name === "AbortError") {
        return void 0;
      }
      this.uppy.emit("upload-error", file, err);
      throw err;
    }
  }
};
function _getUrl2(url) {
  if (/^(https?:|)\/\//.test(url)) {
    return url;
  }
  return `${this.hostname}/${url}`;
}
async function _awaitRemoteFileUpload2(_ref4) {
  let {
    file,
    queue,
    signal
  } = _ref4;
  let removeEventHandlers;
  const {
    capabilities
  } = this.uppy.getState();
  try {
    return await new Promise((resolve, reject) => {
      const token = file.serverToken;
      const host = getSocketHost(file.remote.companionUrl);
      let socket;
      let socketAbortController;
      let activityTimeout;
      let {
        isPaused
      } = file;
      const socketSend = (action, payload) => {
        if (socket == null || socket.readyState !== socket.OPEN) {
          var _socket2;
          this.uppy.log(`Cannot send "${action}" to socket ${file.id} because the socket state was ${String((_socket2 = socket) == null ? void 0 : _socket2.readyState)}`, "warning");
          return;
        }
        socket.send(JSON.stringify({
          action,
          payload: payload != null ? payload : {}
        }));
      };
      function sendState() {
        if (!capabilities.resumableUploads)
          return;
        if (isPaused)
          socketSend("pause");
        else
          socketSend("resume");
      }
      const createWebsocket = async () => {
        if (socketAbortController)
          socketAbortController.abort();
        socketAbortController = new AbortController();
        const onFatalError = (err) => {
          var _socketAbortControlle;
          this.uppy.setFileState(file.id, {
            serverToken: null
          });
          (_socketAbortControlle = socketAbortController) == null || _socketAbortControlle.abort == null || _socketAbortControlle.abort();
          reject(err);
        };
        function resetActivityTimeout() {
          clearTimeout(activityTimeout);
          if (isPaused)
            return;
          activityTimeout = setTimeout(() => onFatalError(new Error("Timeout waiting for message from Companion socket")), socketActivityTimeoutMs);
        }
        try {
          await queue.wrapPromiseFunction(async () => {
            const reconnectWebsocket = async () => (
              // eslint-disable-next-line promise/param-names
              new Promise((_4, rejectSocket) => {
                socket = new WebSocket(`${host}/api/${token}`);
                resetActivityTimeout();
                socket.addEventListener("close", () => {
                  socket = void 0;
                  rejectSocket(new Error("Socket closed unexpectedly"));
                });
                socket.addEventListener("error", (error) => {
                  var _socket2;
                  this.uppy.log(`Companion socket error ${JSON.stringify(error)}, closing socket`, "warning");
                  (_socket2 = socket) == null || _socket2.close();
                });
                socket.addEventListener("open", () => {
                  sendState();
                });
                socket.addEventListener("message", (e4) => {
                  resetActivityTimeout();
                  try {
                    const {
                      action,
                      payload
                    } = JSON.parse(e4.data);
                    switch (action) {
                      case "progress": {
                        emitSocketProgress_default(this, payload, this.uppy.getFile(file.id));
                        break;
                      }
                      case "success": {
                        var _payload$response, _payload$response$sta, _payload$response2, _socketAbortControlle2;
                        const text = (_payload$response = payload.response) == null ? void 0 : _payload$response.responseText;
                        this.uppy.emit("upload-success", this.uppy.getFile(file.id), {
                          uploadURL: payload.url,
                          status: (_payload$response$sta = (_payload$response2 = payload.response) == null ? void 0 : _payload$response2.status) != null ? _payload$response$sta : 200,
                          body: text ? JSON.parse(text) : void 0
                        });
                        (_socketAbortControlle2 = socketAbortController) == null || _socketAbortControlle2.abort == null || _socketAbortControlle2.abort();
                        resolve();
                        break;
                      }
                      case "error": {
                        const {
                          message
                        } = payload.error;
                        throw Object.assign(new Error(message), {
                          cause: payload.error
                        });
                      }
                      default:
                        this.uppy.log(`Companion socket unknown action ${action}`, "warning");
                    }
                  } catch (err) {
                    onFatalError(err);
                  }
                });
                const closeSocket = () => {
                  this.uppy.log(`Closing socket ${file.id}`, "info");
                  clearTimeout(activityTimeout);
                  if (socket)
                    socket.close();
                  socket = void 0;
                };
                socketAbortController.signal.addEventListener("abort", () => {
                  closeSocket();
                });
              })
            );
            await pRetry(reconnectWebsocket, {
              retries: retryCount,
              signal: socketAbortController.signal,
              onFailedAttempt: () => {
                if (socketAbortController.signal.aborted)
                  return;
                this.uppy.log(`Retrying websocket ${file.id}`, "info");
              }
            });
          })().abortOn(socketAbortController.signal);
        } catch (err) {
          if (socketAbortController.signal.aborted)
            return;
          onFatalError(err);
        }
      };
      const pause = (newPausedState) => {
        if (!capabilities.resumableUploads)
          return;
        isPaused = newPausedState;
        if (socket)
          sendState();
        if (newPausedState) {
          var _socketAbortControlle3;
          (_socketAbortControlle3 = socketAbortController) == null || _socketAbortControlle3.abort == null || _socketAbortControlle3.abort();
        } else {
          createWebsocket();
        }
      };
      const onFileRemove = (targetFile) => {
        var _socketAbortControlle4;
        if (!capabilities.individualCancellation)
          return;
        if (targetFile.id !== file.id)
          return;
        socketSend("cancel");
        (_socketAbortControlle4 = socketAbortController) == null || _socketAbortControlle4.abort == null || _socketAbortControlle4.abort();
        this.uppy.log(`upload ${file.id} was removed`, "info");
        resolve();
      };
      const onCancelAll = (_ref5) => {
        var _socketAbortControlle5;
        let {
          reason
        } = _ref5;
        if (reason === "user") {
          socketSend("cancel");
        }
        (_socketAbortControlle5 = socketAbortController) == null || _socketAbortControlle5.abort == null || _socketAbortControlle5.abort();
        this.uppy.log(`upload ${file.id} was canceled`, "info");
        resolve();
      };
      const onFilePausedChange = (targetFileId, newPausedState) => {
        if (targetFileId !== file.id)
          return;
        pause(newPausedState);
      };
      const onPauseAll = () => pause(true);
      const onResumeAll = () => pause(false);
      this.uppy.on("file-removed", onFileRemove);
      this.uppy.on("cancel-all", onCancelAll);
      this.uppy.on("upload-pause", onFilePausedChange);
      this.uppy.on("pause-all", onPauseAll);
      this.uppy.on("resume-all", onResumeAll);
      removeEventHandlers = () => {
        this.uppy.off("file-removed", onFileRemove);
        this.uppy.off("cancel-all", onCancelAll);
        this.uppy.off("upload-pause", onFilePausedChange);
        this.uppy.off("pause-all", onPauseAll);
        this.uppy.off("resume-all", onResumeAll);
      };
      signal.addEventListener("abort", () => {
        var _socketAbortControlle6;
        (_socketAbortControlle6 = socketAbortController) == null || _socketAbortControlle6.abort();
      });
      createWebsocket();
    });
  } finally {
    removeEventHandlers == null || removeEventHandlers();
  }
}
RequestClient.VERSION = packageJson.version;

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/companion-client/lib/Socket.js
var import_namespace_emitter = __toESM(require_namespace_emitter(), 1);
var _Symbol$for2;
var _Symbol$for22;
function _classPrivateFieldLooseBase3(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id3 = 0;
function _classPrivateFieldLooseKey3(name) {
  return "__private_" + id3++ + "_" + name;
}
var _queued = /* @__PURE__ */ _classPrivateFieldLooseKey3("queued");
var _emitter = /* @__PURE__ */ _classPrivateFieldLooseKey3("emitter");
var _isOpen = /* @__PURE__ */ _classPrivateFieldLooseKey3("isOpen");
var _socket = /* @__PURE__ */ _classPrivateFieldLooseKey3("socket");
var _handleMessage = /* @__PURE__ */ _classPrivateFieldLooseKey3("handleMessage");
_Symbol$for2 = Symbol.for("uppy test: getSocket");
_Symbol$for22 = Symbol.for("uppy test: getQueued");
var UppySocket = class {
  constructor(opts) {
    Object.defineProperty(this, _queued, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _emitter, {
      writable: true,
      value: (0, import_namespace_emitter.default)()
    });
    Object.defineProperty(this, _isOpen, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _socket, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _handleMessage, {
      writable: true,
      value: (e4) => {
        try {
          const message = JSON.parse(e4.data);
          this.emit(message.action, message.payload);
        } catch (err) {
          console.log(err);
        }
      }
    });
    this.opts = opts;
    if (!opts || opts.autoOpen !== false) {
      this.open();
    }
  }
  get isOpen() {
    return _classPrivateFieldLooseBase3(this, _isOpen)[_isOpen];
  }
  [_Symbol$for2]() {
    return _classPrivateFieldLooseBase3(this, _socket)[_socket];
  }
  [_Symbol$for22]() {
    return _classPrivateFieldLooseBase3(this, _queued)[_queued];
  }
  open() {
    if (_classPrivateFieldLooseBase3(this, _socket)[_socket] != null)
      return;
    _classPrivateFieldLooseBase3(this, _socket)[_socket] = new WebSocket(this.opts.target);
    _classPrivateFieldLooseBase3(this, _socket)[_socket].onopen = () => {
      _classPrivateFieldLooseBase3(this, _isOpen)[_isOpen] = true;
      while (_classPrivateFieldLooseBase3(this, _queued)[_queued].length > 0 && _classPrivateFieldLooseBase3(this, _isOpen)[_isOpen]) {
        const first = _classPrivateFieldLooseBase3(this, _queued)[_queued].shift();
        this.send(first.action, first.payload);
      }
    };
    _classPrivateFieldLooseBase3(this, _socket)[_socket].onclose = () => {
      _classPrivateFieldLooseBase3(this, _isOpen)[_isOpen] = false;
      _classPrivateFieldLooseBase3(this, _socket)[_socket] = null;
    };
    _classPrivateFieldLooseBase3(this, _socket)[_socket].onmessage = _classPrivateFieldLooseBase3(this, _handleMessage)[_handleMessage];
  }
  close() {
    var _classPrivateFieldLoo;
    (_classPrivateFieldLoo = _classPrivateFieldLooseBase3(this, _socket)[_socket]) == null || _classPrivateFieldLoo.close();
  }
  send(action, payload) {
    if (!_classPrivateFieldLooseBase3(this, _isOpen)[_isOpen]) {
      _classPrivateFieldLooseBase3(this, _queued)[_queued].push({
        action,
        payload
      });
      return;
    }
    _classPrivateFieldLooseBase3(this, _socket)[_socket].send(JSON.stringify({
      action,
      payload
    }));
  }
  on(action, handler) {
    _classPrivateFieldLooseBase3(this, _emitter)[_emitter].on(action, handler);
  }
  emit(action, payload) {
    _classPrivateFieldLooseBase3(this, _emitter)[_emitter].emit(action, payload);
  }
  once(action, handler) {
    _classPrivateFieldLooseBase3(this, _emitter)[_emitter].once(action, handler);
  }
};

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/EventManager.js
function _classPrivateFieldLooseBase4(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id4 = 0;
function _classPrivateFieldLooseKey4(name) {
  return "__private_" + id4++ + "_" + name;
}
var _uppy = /* @__PURE__ */ _classPrivateFieldLooseKey4("uppy");
var _events = /* @__PURE__ */ _classPrivateFieldLooseKey4("events");
var EventManager = class {
  constructor(uppy2) {
    Object.defineProperty(this, _uppy, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _events, {
      writable: true,
      value: []
    });
    _classPrivateFieldLooseBase4(this, _uppy)[_uppy] = uppy2;
  }
  on(event, fn) {
    _classPrivateFieldLooseBase4(this, _events)[_events].push([event, fn]);
    return _classPrivateFieldLooseBase4(this, _uppy)[_uppy].on(event, fn);
  }
  remove() {
    for (const [event, fn] of _classPrivateFieldLooseBase4(this, _events)[_events].splice(0)) {
      _classPrivateFieldLooseBase4(this, _uppy)[_uppy].off(event, fn);
    }
  }
  onFilePause(fileID, cb) {
    this.on("upload-pause", (targetFileID, isPaused) => {
      if (fileID === targetFileID) {
        cb(isPaused);
      }
    });
  }
  onFileRemove(fileID, cb) {
    this.on("file-removed", (file) => {
      if (fileID === file.id)
        cb(file.id);
    });
  }
  onPause(fileID, cb) {
    this.on("upload-pause", (targetFileID, isPaused) => {
      if (fileID === targetFileID) {
        cb(isPaused);
      }
    });
  }
  onRetry(fileID, cb) {
    this.on("upload-retry", (targetFileID) => {
      if (fileID === targetFileID) {
        cb();
      }
    });
  }
  onRetryAll(fileID, cb) {
    this.on("retry-all", () => {
      if (!_classPrivateFieldLooseBase4(this, _uppy)[_uppy].getFile(fileID))
        return;
      cb();
    });
  }
  onPauseAll(fileID, cb) {
    this.on("pause-all", () => {
      if (!_classPrivateFieldLooseBase4(this, _uppy)[_uppy].getFile(fileID))
        return;
      cb();
    });
  }
  onCancelAll(fileID, eventHandler) {
    var _this = this;
    this.on("cancel-all", function() {
      if (!_classPrivateFieldLooseBase4(_this, _uppy)[_uppy].getFile(fileID))
        return;
      eventHandler(...arguments);
    });
  }
  onResumeAll(fileID, cb) {
    this.on("resume-all", () => {
      if (!_classPrivateFieldLooseBase4(this, _uppy)[_uppy].getFile(fileID))
        return;
      cb();
    });
  }
};

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/RateLimitedQueue.js
function _classPrivateFieldLooseBase5(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id5 = 0;
function _classPrivateFieldLooseKey5(name) {
  return "__private_" + id5++ + "_" + name;
}
function createCancelError(cause) {
  return new Error("Cancelled", {
    cause
  });
}
function abortOn(signal) {
  if (signal != null) {
    var _this$then;
    const abortPromise = () => this.abort(signal.reason);
    signal.addEventListener("abort", abortPromise, {
      once: true
    });
    const removeAbortListener = () => {
      signal.removeEventListener("abort", abortPromise);
    };
    (_this$then = this.then) == null || _this$then.call(this, removeAbortListener, removeAbortListener);
  }
  return this;
}
var _activeRequests = /* @__PURE__ */ _classPrivateFieldLooseKey5("activeRequests");
var _queuedHandlers = /* @__PURE__ */ _classPrivateFieldLooseKey5("queuedHandlers");
var _paused = /* @__PURE__ */ _classPrivateFieldLooseKey5("paused");
var _pauseTimer = /* @__PURE__ */ _classPrivateFieldLooseKey5("pauseTimer");
var _downLimit = /* @__PURE__ */ _classPrivateFieldLooseKey5("downLimit");
var _upperLimit = /* @__PURE__ */ _classPrivateFieldLooseKey5("upperLimit");
var _rateLimitingTimer = /* @__PURE__ */ _classPrivateFieldLooseKey5("rateLimitingTimer");
var _call = /* @__PURE__ */ _classPrivateFieldLooseKey5("call");
var _queueNext = /* @__PURE__ */ _classPrivateFieldLooseKey5("queueNext");
var _next = /* @__PURE__ */ _classPrivateFieldLooseKey5("next");
var _queue = /* @__PURE__ */ _classPrivateFieldLooseKey5("queue");
var _dequeue = /* @__PURE__ */ _classPrivateFieldLooseKey5("dequeue");
var _resume = /* @__PURE__ */ _classPrivateFieldLooseKey5("resume");
var _increaseLimit = /* @__PURE__ */ _classPrivateFieldLooseKey5("increaseLimit");
var RateLimitedQueue = class {
  constructor(limit) {
    Object.defineProperty(this, _dequeue, {
      value: _dequeue2
    });
    Object.defineProperty(this, _queue, {
      value: _queue2
    });
    Object.defineProperty(this, _next, {
      value: _next2
    });
    Object.defineProperty(this, _queueNext, {
      value: _queueNext2
    });
    Object.defineProperty(this, _call, {
      value: _call2
    });
    Object.defineProperty(this, _activeRequests, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _queuedHandlers, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _paused, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _pauseTimer, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _downLimit, {
      writable: true,
      value: 1
    });
    Object.defineProperty(this, _upperLimit, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _rateLimitingTimer, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _resume, {
      writable: true,
      value: () => this.resume()
    });
    Object.defineProperty(this, _increaseLimit, {
      writable: true,
      value: () => {
        if (_classPrivateFieldLooseBase5(this, _paused)[_paused]) {
          _classPrivateFieldLooseBase5(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase5(this, _increaseLimit)[_increaseLimit], 0);
          return;
        }
        _classPrivateFieldLooseBase5(this, _downLimit)[_downLimit] = this.limit;
        this.limit = Math.ceil((_classPrivateFieldLooseBase5(this, _upperLimit)[_upperLimit] + _classPrivateFieldLooseBase5(this, _downLimit)[_downLimit]) / 2);
        for (let i4 = _classPrivateFieldLooseBase5(this, _downLimit)[_downLimit]; i4 <= this.limit; i4++) {
          _classPrivateFieldLooseBase5(this, _queueNext)[_queueNext]();
        }
        if (_classPrivateFieldLooseBase5(this, _upperLimit)[_upperLimit] - _classPrivateFieldLooseBase5(this, _downLimit)[_downLimit] > 3) {
          _classPrivateFieldLooseBase5(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase5(this, _increaseLimit)[_increaseLimit], 2e3);
        } else {
          _classPrivateFieldLooseBase5(this, _downLimit)[_downLimit] = Math.floor(_classPrivateFieldLooseBase5(this, _downLimit)[_downLimit] / 2);
        }
      }
    });
    if (typeof limit !== "number" || limit === 0) {
      this.limit = Infinity;
    } else {
      this.limit = limit;
    }
  }
  run(fn, queueOptions) {
    if (!_classPrivateFieldLooseBase5(this, _paused)[_paused] && _classPrivateFieldLooseBase5(this, _activeRequests)[_activeRequests] < this.limit) {
      return _classPrivateFieldLooseBase5(this, _call)[_call](fn);
    }
    return _classPrivateFieldLooseBase5(this, _queue)[_queue](fn, queueOptions);
  }
  wrapSyncFunction(fn, queueOptions) {
    var _this = this;
    return function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const queuedRequest = _this.run(() => {
        fn(...args);
        queueMicrotask(() => queuedRequest.done());
        return () => {
        };
      }, queueOptions);
      return {
        abortOn,
        abort() {
          queuedRequest.abort();
        }
      };
    };
  }
  wrapPromiseFunction(fn, queueOptions) {
    var _this2 = this;
    return function() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      let queuedRequest;
      const outerPromise = new Promise((resolve, reject) => {
        queuedRequest = _this2.run(() => {
          let cancelError;
          let innerPromise;
          try {
            innerPromise = Promise.resolve(fn(...args));
          } catch (err) {
            innerPromise = Promise.reject(err);
          }
          innerPromise.then((result) => {
            if (cancelError) {
              reject(cancelError);
            } else {
              queuedRequest.done();
              resolve(result);
            }
          }, (err) => {
            if (cancelError) {
              reject(cancelError);
            } else {
              queuedRequest.done();
              reject(err);
            }
          });
          return (cause) => {
            cancelError = createCancelError(cause);
          };
        }, queueOptions);
      });
      outerPromise.abort = (cause) => {
        queuedRequest.abort(cause);
      };
      outerPromise.abortOn = abortOn;
      return outerPromise;
    };
  }
  resume() {
    _classPrivateFieldLooseBase5(this, _paused)[_paused] = false;
    clearTimeout(_classPrivateFieldLooseBase5(this, _pauseTimer)[_pauseTimer]);
    for (let i4 = 0; i4 < this.limit; i4++) {
      _classPrivateFieldLooseBase5(this, _queueNext)[_queueNext]();
    }
  }
  /**
   * Freezes the queue for a while or indefinitely.
   *
   * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
   *                                    If omitted, the queue won't resume automatically.
   */
  pause(duration2) {
    if (duration2 === void 0) {
      duration2 = null;
    }
    _classPrivateFieldLooseBase5(this, _paused)[_paused] = true;
    clearTimeout(_classPrivateFieldLooseBase5(this, _pauseTimer)[_pauseTimer]);
    if (duration2 != null) {
      _classPrivateFieldLooseBase5(this, _pauseTimer)[_pauseTimer] = setTimeout(_classPrivateFieldLooseBase5(this, _resume)[_resume], duration2);
    }
  }
  /**
   * Pauses the queue for a duration, and lower the limit of concurrent requests
   * when the queue resumes. When the queue resumes, it tries to progressively
   * increase the limit in `this.#increaseLimit` until another call is made to
   * `this.rateLimit`.
   * Call this function when using the RateLimitedQueue for network requests and
   * the remote server responds with 429 HTTP code.
   *
   * @param {number} duration in milliseconds.
   */
  rateLimit(duration2) {
    clearTimeout(_classPrivateFieldLooseBase5(this, _rateLimitingTimer)[_rateLimitingTimer]);
    this.pause(duration2);
    if (this.limit > 1 && Number.isFinite(this.limit)) {
      _classPrivateFieldLooseBase5(this, _upperLimit)[_upperLimit] = this.limit - 1;
      this.limit = _classPrivateFieldLooseBase5(this, _downLimit)[_downLimit];
      _classPrivateFieldLooseBase5(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase5(this, _increaseLimit)[_increaseLimit], duration2);
    }
  }
  get isPaused() {
    return _classPrivateFieldLooseBase5(this, _paused)[_paused];
  }
};
function _call2(fn) {
  _classPrivateFieldLooseBase5(this, _activeRequests)[_activeRequests] += 1;
  let done = false;
  let cancelActive;
  try {
    cancelActive = fn();
  } catch (err) {
    _classPrivateFieldLooseBase5(this, _activeRequests)[_activeRequests] -= 1;
    throw err;
  }
  return {
    abort: (cause) => {
      if (done)
        return;
      done = true;
      _classPrivateFieldLooseBase5(this, _activeRequests)[_activeRequests] -= 1;
      cancelActive == null || cancelActive(cause);
      _classPrivateFieldLooseBase5(this, _queueNext)[_queueNext]();
    },
    done: () => {
      if (done)
        return;
      done = true;
      _classPrivateFieldLooseBase5(this, _activeRequests)[_activeRequests] -= 1;
      _classPrivateFieldLooseBase5(this, _queueNext)[_queueNext]();
    }
  };
}
function _queueNext2() {
  queueMicrotask(() => _classPrivateFieldLooseBase5(this, _next)[_next]());
}
function _next2() {
  if (_classPrivateFieldLooseBase5(this, _paused)[_paused] || _classPrivateFieldLooseBase5(this, _activeRequests)[_activeRequests] >= this.limit) {
    return;
  }
  if (_classPrivateFieldLooseBase5(this, _queuedHandlers)[_queuedHandlers].length === 0) {
    return;
  }
  const next = _classPrivateFieldLooseBase5(this, _queuedHandlers)[_queuedHandlers].shift();
  const handler = _classPrivateFieldLooseBase5(this, _call)[_call](next.fn);
  next.abort = handler.abort;
  next.done = handler.done;
}
function _queue2(fn, options) {
  if (options === void 0) {
    options = {};
  }
  const handler = {
    fn,
    priority: options.priority || 0,
    abort: () => {
      _classPrivateFieldLooseBase5(this, _dequeue)[_dequeue](handler);
    },
    done: () => {
      throw new Error("Cannot mark a queued request as done: this indicates a bug");
    }
  };
  const index = _classPrivateFieldLooseBase5(this, _queuedHandlers)[_queuedHandlers].findIndex((other) => {
    return handler.priority > other.priority;
  });
  if (index === -1) {
    _classPrivateFieldLooseBase5(this, _queuedHandlers)[_queuedHandlers].push(handler);
  } else {
    _classPrivateFieldLooseBase5(this, _queuedHandlers)[_queuedHandlers].splice(index, 0, handler);
  }
  return handler;
}
function _dequeue2(handler) {
  const index = _classPrivateFieldLooseBase5(this, _queuedHandlers)[_queuedHandlers].indexOf(handler);
  if (index !== -1) {
    _classPrivateFieldLooseBase5(this, _queuedHandlers)[_queuedHandlers].splice(index, 1);
  }
}
var internalRateLimitedQueue = Symbol("__queue");

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/fileFilters.js
function filterNonFailedFiles(files) {
  const hasError = (file) => "error" in file && !!file.error;
  return files.filter((file) => !hasError(file));
}
function filterFilesToEmitUploadStarted(files) {
  return files.filter((file) => {
    var _file$progress;
    return !((_file$progress = file.progress) != null && _file$progress.uploadStarted) || !file.isRestored;
  });
}

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/AbortController.js
var {
  AbortController: AbortController2
} = globalThis;
var {
  AbortSignal
} = globalThis;
var createAbortError = function(message, options) {
  if (message === void 0) {
    message = "Aborted";
  }
  const err = new DOMException(message, "AbortError");
  if (options != null && has(options, "cause")) {
    Object.defineProperty(err, "cause", {
      // @ts-expect-error TS is drunk
      __proto__: null,
      configurable: true,
      writable: true,
      value: options.cause
    });
  }
  return err;
};

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/aws-s3-multipart/lib/MultipartUploader.js
function _classPrivateFieldLooseBase6(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id6 = 0;
function _classPrivateFieldLooseKey6(name) {
  return "__private_" + id6++ + "_" + name;
}
var MB = 1024 * 1024;
var defaultOptions = {
  getChunkSize(file) {
    return Math.ceil(file.size / 1e4);
  },
  onProgress() {
  },
  onPartComplete() {
  },
  onSuccess() {
  },
  onError(err) {
    throw err;
  }
};
function ensureInt(value) {
  if (typeof value === "string") {
    return parseInt(value, 10);
  }
  if (typeof value === "number") {
    return value;
  }
  throw new TypeError("Expected a number");
}
var pausingUploadReason = Symbol("pausing upload, not an actual error");
var _abortController = /* @__PURE__ */ _classPrivateFieldLooseKey6("abortController");
var _chunks = /* @__PURE__ */ _classPrivateFieldLooseKey6("chunks");
var _chunkState = /* @__PURE__ */ _classPrivateFieldLooseKey6("chunkState");
var _data = /* @__PURE__ */ _classPrivateFieldLooseKey6("data");
var _file = /* @__PURE__ */ _classPrivateFieldLooseKey6("file");
var _uploadHasStarted = /* @__PURE__ */ _classPrivateFieldLooseKey6("uploadHasStarted");
var _onError = /* @__PURE__ */ _classPrivateFieldLooseKey6("onError");
var _onSuccess = /* @__PURE__ */ _classPrivateFieldLooseKey6("onSuccess");
var _shouldUseMultipart = /* @__PURE__ */ _classPrivateFieldLooseKey6("shouldUseMultipart");
var _isRestoring = /* @__PURE__ */ _classPrivateFieldLooseKey6("isRestoring");
var _onReject = /* @__PURE__ */ _classPrivateFieldLooseKey6("onReject");
var _maxMultipartParts = /* @__PURE__ */ _classPrivateFieldLooseKey6("maxMultipartParts");
var _minPartSize = /* @__PURE__ */ _classPrivateFieldLooseKey6("minPartSize");
var _initChunks = /* @__PURE__ */ _classPrivateFieldLooseKey6("initChunks");
var _createUpload = /* @__PURE__ */ _classPrivateFieldLooseKey6("createUpload");
var _resumeUpload = /* @__PURE__ */ _classPrivateFieldLooseKey6("resumeUpload");
var _onPartProgress = /* @__PURE__ */ _classPrivateFieldLooseKey6("onPartProgress");
var _onPartComplete = /* @__PURE__ */ _classPrivateFieldLooseKey6("onPartComplete");
var _abortUpload = /* @__PURE__ */ _classPrivateFieldLooseKey6("abortUpload");
var MultipartUploader = class {
  constructor(data, options) {
    var _this$options, _this$options$getChun;
    Object.defineProperty(this, _abortUpload, {
      value: _abortUpload2
    });
    Object.defineProperty(this, _resumeUpload, {
      value: _resumeUpload2
    });
    Object.defineProperty(this, _createUpload, {
      value: _createUpload2
    });
    Object.defineProperty(this, _initChunks, {
      value: _initChunks2
    });
    Object.defineProperty(this, _abortController, {
      writable: true,
      value: new AbortController2()
    });
    Object.defineProperty(this, _chunks, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _chunkState, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _data, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _file, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploadHasStarted, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _onError, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onSuccess, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _shouldUseMultipart, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _isRestoring, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onReject, {
      writable: true,
      value: (err) => (err == null ? void 0 : err.cause) === pausingUploadReason ? null : _classPrivateFieldLooseBase6(this, _onError)[_onError](err)
    });
    Object.defineProperty(this, _maxMultipartParts, {
      writable: true,
      value: 1e4
    });
    Object.defineProperty(this, _minPartSize, {
      writable: true,
      value: 5 * MB
    });
    Object.defineProperty(this, _onPartProgress, {
      writable: true,
      value: (index) => (ev) => {
        if (!ev.lengthComputable)
          return;
        _classPrivateFieldLooseBase6(this, _chunkState)[_chunkState][index].uploaded = ensureInt(ev.loaded);
        const totalUploaded = _classPrivateFieldLooseBase6(this, _chunkState)[_chunkState].reduce((n3, c4) => n3 + c4.uploaded, 0);
        this.options.onProgress(totalUploaded, _classPrivateFieldLooseBase6(this, _data)[_data].size);
      }
    });
    Object.defineProperty(this, _onPartComplete, {
      writable: true,
      value: (index) => (etag) => {
        _classPrivateFieldLooseBase6(this, _chunks)[_chunks][index] = null;
        _classPrivateFieldLooseBase6(this, _chunkState)[_chunkState][index].etag = etag;
        _classPrivateFieldLooseBase6(this, _chunkState)[_chunkState][index].done = true;
        const part = {
          PartNumber: index + 1,
          ETag: etag
        };
        this.options.onPartComplete(part);
      }
    });
    this.options = {
      ...defaultOptions,
      ...options
    };
    (_this$options$getChun = (_this$options = this.options).getChunkSize) != null ? _this$options$getChun : _this$options.getChunkSize = defaultOptions.getChunkSize;
    _classPrivateFieldLooseBase6(this, _data)[_data] = data;
    _classPrivateFieldLooseBase6(this, _file)[_file] = options.file;
    _classPrivateFieldLooseBase6(this, _onSuccess)[_onSuccess] = this.options.onSuccess;
    _classPrivateFieldLooseBase6(this, _onError)[_onError] = this.options.onError;
    _classPrivateFieldLooseBase6(this, _shouldUseMultipart)[_shouldUseMultipart] = this.options.shouldUseMultipart;
    _classPrivateFieldLooseBase6(this, _isRestoring)[_isRestoring] = options.uploadId && options.key;
    _classPrivateFieldLooseBase6(this, _initChunks)[_initChunks]();
  }
  start() {
    if (_classPrivateFieldLooseBase6(this, _uploadHasStarted)[_uploadHasStarted]) {
      if (!_classPrivateFieldLooseBase6(this, _abortController)[_abortController].signal.aborted)
        _classPrivateFieldLooseBase6(this, _abortController)[_abortController].abort(pausingUploadReason);
      _classPrivateFieldLooseBase6(this, _abortController)[_abortController] = new AbortController2();
      _classPrivateFieldLooseBase6(this, _resumeUpload)[_resumeUpload]();
    } else if (_classPrivateFieldLooseBase6(this, _isRestoring)[_isRestoring]) {
      this.options.companionComm.restoreUploadFile(_classPrivateFieldLooseBase6(this, _file)[_file], {
        uploadId: this.options.uploadId,
        key: this.options.key
      });
      _classPrivateFieldLooseBase6(this, _resumeUpload)[_resumeUpload]();
    } else {
      _classPrivateFieldLooseBase6(this, _createUpload)[_createUpload]();
    }
  }
  pause() {
    _classPrivateFieldLooseBase6(this, _abortController)[_abortController].abort(pausingUploadReason);
    _classPrivateFieldLooseBase6(this, _abortController)[_abortController] = new AbortController2();
  }
  abort(opts) {
    var _opts;
    if (opts === void 0) {
      opts = void 0;
    }
    if ((_opts = opts) != null && _opts.really)
      _classPrivateFieldLooseBase6(this, _abortUpload)[_abortUpload]();
    else
      this.pause();
  }
  // TODO: remove this in the next major
  get chunkState() {
    return _classPrivateFieldLooseBase6(this, _chunkState)[_chunkState];
  }
};
function _initChunks2() {
  const fileSize = _classPrivateFieldLooseBase6(this, _data)[_data].size;
  const shouldUseMultipart = typeof _classPrivateFieldLooseBase6(this, _shouldUseMultipart)[_shouldUseMultipart] === "function" ? _classPrivateFieldLooseBase6(this, _shouldUseMultipart)[_shouldUseMultipart](_classPrivateFieldLooseBase6(this, _file)[_file]) : Boolean(_classPrivateFieldLooseBase6(this, _shouldUseMultipart)[_shouldUseMultipart]);
  if (shouldUseMultipart && fileSize > _classPrivateFieldLooseBase6(this, _minPartSize)[_minPartSize]) {
    let chunkSize = Math.max(this.options.getChunkSize(_classPrivateFieldLooseBase6(this, _data)[_data]), _classPrivateFieldLooseBase6(this, _minPartSize)[_minPartSize]);
    let arraySize = Math.floor(fileSize / chunkSize);
    if (arraySize > _classPrivateFieldLooseBase6(this, _maxMultipartParts)[_maxMultipartParts]) {
      arraySize = _classPrivateFieldLooseBase6(this, _maxMultipartParts)[_maxMultipartParts];
      chunkSize = fileSize / _classPrivateFieldLooseBase6(this, _maxMultipartParts)[_maxMultipartParts];
    }
    _classPrivateFieldLooseBase6(this, _chunks)[_chunks] = Array(arraySize);
    for (let offset = 0, j4 = 0; offset < fileSize; offset += chunkSize, j4++) {
      const end = Math.min(fileSize, offset + chunkSize);
      const getData = () => {
        const i22 = offset;
        return _classPrivateFieldLooseBase6(this, _data)[_data].slice(i22, end);
      };
      _classPrivateFieldLooseBase6(this, _chunks)[_chunks][j4] = {
        getData,
        onProgress: _classPrivateFieldLooseBase6(this, _onPartProgress)[_onPartProgress](j4),
        onComplete: _classPrivateFieldLooseBase6(this, _onPartComplete)[_onPartComplete](j4),
        shouldUseMultipart
      };
      if (_classPrivateFieldLooseBase6(this, _isRestoring)[_isRestoring]) {
        const size = offset + chunkSize > fileSize ? fileSize - offset : chunkSize;
        _classPrivateFieldLooseBase6(this, _chunks)[_chunks][j4].setAsUploaded = () => {
          _classPrivateFieldLooseBase6(this, _chunks)[_chunks][j4] = null;
          _classPrivateFieldLooseBase6(this, _chunkState)[_chunkState][j4].uploaded = size;
        };
      }
    }
  } else {
    _classPrivateFieldLooseBase6(this, _chunks)[_chunks] = [{
      getData: () => _classPrivateFieldLooseBase6(this, _data)[_data],
      onProgress: _classPrivateFieldLooseBase6(this, _onPartProgress)[_onPartProgress](0),
      onComplete: _classPrivateFieldLooseBase6(this, _onPartComplete)[_onPartComplete](0),
      shouldUseMultipart
    }];
  }
  _classPrivateFieldLooseBase6(this, _chunkState)[_chunkState] = _classPrivateFieldLooseBase6(this, _chunks)[_chunks].map(() => ({
    uploaded: 0
  }));
}
function _createUpload2() {
  this.options.companionComm.uploadFile(_classPrivateFieldLooseBase6(this, _file)[_file], _classPrivateFieldLooseBase6(this, _chunks)[_chunks], _classPrivateFieldLooseBase6(this, _abortController)[_abortController].signal).then(_classPrivateFieldLooseBase6(this, _onSuccess)[_onSuccess], _classPrivateFieldLooseBase6(this, _onReject)[_onReject]);
  _classPrivateFieldLooseBase6(this, _uploadHasStarted)[_uploadHasStarted] = true;
}
function _resumeUpload2() {
  this.options.companionComm.resumeUploadFile(_classPrivateFieldLooseBase6(this, _file)[_file], _classPrivateFieldLooseBase6(this, _chunks)[_chunks], _classPrivateFieldLooseBase6(this, _abortController)[_abortController].signal).then(_classPrivateFieldLooseBase6(this, _onSuccess)[_onSuccess], _classPrivateFieldLooseBase6(this, _onReject)[_onReject]);
}
function _abortUpload2() {
  _classPrivateFieldLooseBase6(this, _abortController)[_abortController].abort();
  this.options.companionComm.abortFileUpload(_classPrivateFieldLooseBase6(this, _file)[_file]).catch((err) => this.options.log(err));
}
var MultipartUploader_default = MultipartUploader;

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/aws-s3-multipart/lib/createSignedURL.js
function createCanonicalRequest(_ref) {
  let {
    method = "PUT",
    CanonicalUri = "/",
    CanonicalQueryString = "",
    SignedHeaders,
    HashedPayload
  } = _ref;
  const headerKeys = Object.keys(SignedHeaders).map((k4) => k4.toLowerCase()).sort();
  return [method, CanonicalUri, CanonicalQueryString, ...headerKeys.map((k4) => `${k4}:${SignedHeaders[k4]}`), "", headerKeys.join(";"), HashedPayload].join("\n");
}
var ec = new TextEncoder();
var algorithm = {
  name: "HMAC",
  hash: "SHA-256"
};
async function digest(data) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.digest(algorithm.hash, ec.encode(data));
}
async function generateHmacKey(secret) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.importKey("raw", typeof secret === "string" ? ec.encode(secret) : secret, algorithm, false, ["sign"]);
}
function arrayBufferToHexString(arrayBuffer) {
  const byteArray = new Uint8Array(arrayBuffer);
  let hexString = "";
  for (let i4 = 0; i4 < byteArray.length; i4++) {
    hexString += byteArray[i4].toString(16).padStart(2, "0");
  }
  return hexString;
}
async function hash(key, data) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.sign(algorithm, await generateHmacKey(key), ec.encode(data));
}
async function createSignedURL(_ref2) {
  let {
    accountKey,
    accountSecret,
    sessionToken,
    bucketName,
    Key,
    Region,
    expires,
    uploadId,
    partNumber
  } = _ref2;
  const Service = "s3";
  const host = `${bucketName}.${Service}.${Region}.amazonaws.com`;
  const CanonicalUri = `/${encodeURI(Key)}`;
  const payload = "UNSIGNED-PAYLOAD";
  const requestDateTime = (/* @__PURE__ */ new Date()).toISOString().replace(/[-:]|\.\d+/g, "");
  const date = requestDateTime.slice(0, 8);
  const scope = `${date}/${Region}/${Service}/aws4_request`;
  const url = new URL(`https://${host}${CanonicalUri}`);
  url.searchParams.set("X-Amz-Algorithm", "AWS4-HMAC-SHA256");
  url.searchParams.set("X-Amz-Content-Sha256", payload);
  url.searchParams.set("X-Amz-Credential", `${accountKey}/${scope}`);
  url.searchParams.set("X-Amz-Date", requestDateTime);
  url.searchParams.set("X-Amz-Expires", expires);
  url.searchParams.set("X-Amz-Security-Token", sessionToken);
  url.searchParams.set("X-Amz-SignedHeaders", "host");
  if (partNumber)
    url.searchParams.set("partNumber", partNumber);
  if (uploadId)
    url.searchParams.set("uploadId", uploadId);
  url.searchParams.set("x-id", partNumber && uploadId ? "UploadPart" : "PutObject");
  const canonical = createCanonicalRequest({
    CanonicalUri,
    CanonicalQueryString: url.search.slice(1),
    SignedHeaders: {
      host
    },
    HashedPayload: payload
  });
  const hashedCanonical = arrayBufferToHexString(await digest(canonical));
  const stringToSign = [
    `AWS4-HMAC-SHA256`,
    // The algorithm used to create the hash of the canonical request.
    requestDateTime,
    // The date and time used in the credential scope.
    scope,
    // The credential scope. This restricts the resulting signature to the specified Region and service.
    hashedCanonical
    // The hash of the canonical request.
  ].join("\n");
  const kDate = await hash(`AWS4${accountSecret}`, date);
  const kRegion = await hash(kDate, Region);
  const kService = await hash(kRegion, Service);
  const kSigning = await hash(kService, "aws4_request");
  const signature = arrayBufferToHexString(await hash(kSigning, stringToSign));
  url.searchParams.set("X-Amz-Signature", signature);
  return url;
}

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/aws-s3-multipart/lib/index.js
var _Symbol$for3;
function _classPrivateFieldLooseBase7(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id7 = 0;
function _classPrivateFieldLooseKey7(name) {
  return "__private_" + id7++ + "_" + name;
}
var packageJson2 = {
  "version": "3.10.2"
};
function assertServerError(res) {
  if (res && res.error) {
    const error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }
  return res;
}
function removeMetadataFromURL(urlString) {
  const urlObject = new URL(urlString);
  urlObject.search = "";
  urlObject.hash = "";
  return urlObject.href;
}
function getExpiry(credentials) {
  const expirationDate = credentials.Expiration;
  if (expirationDate) {
    const timeUntilExpiry = Math.floor((new Date(expirationDate) - Date.now()) / 1e3);
    if (timeUntilExpiry > 9) {
      return timeUntilExpiry;
    }
  }
  return void 0;
}
function getAllowedMetadata(_ref) {
  let {
    meta,
    allowedMetaFields,
    querify = false
  } = _ref;
  const metaFields2 = allowedMetaFields != null ? allowedMetaFields : Object.keys(meta);
  if (!meta)
    return {};
  return Object.fromEntries(metaFields2.filter((key) => meta[key] != null).map((key) => {
    const realKey = querify ? `metadata[${key}]` : key;
    const value = String(meta[key]);
    return [realKey, value];
  }));
}
function throwIfAborted(signal) {
  if (signal != null && signal.aborted) {
    throw createAbortError("The operation was aborted", {
      cause: signal.reason
    });
  }
}
var _abortMultipartUpload = /* @__PURE__ */ _classPrivateFieldLooseKey7("abortMultipartUpload");
var _cache = /* @__PURE__ */ _classPrivateFieldLooseKey7("cache");
var _createMultipartUpload = /* @__PURE__ */ _classPrivateFieldLooseKey7("createMultipartUpload");
var _fetchSignature = /* @__PURE__ */ _classPrivateFieldLooseKey7("fetchSignature");
var _getUploadParameters = /* @__PURE__ */ _classPrivateFieldLooseKey7("getUploadParameters");
var _listParts = /* @__PURE__ */ _classPrivateFieldLooseKey7("listParts");
var _previousRetryDelay = /* @__PURE__ */ _classPrivateFieldLooseKey7("previousRetryDelay");
var _requests = /* @__PURE__ */ _classPrivateFieldLooseKey7("requests");
var _retryDelays = /* @__PURE__ */ _classPrivateFieldLooseKey7("retryDelays");
var _sendCompletionRequest = /* @__PURE__ */ _classPrivateFieldLooseKey7("sendCompletionRequest");
var _setS3MultipartState = /* @__PURE__ */ _classPrivateFieldLooseKey7("setS3MultipartState");
var _uploadPartBytes = /* @__PURE__ */ _classPrivateFieldLooseKey7("uploadPartBytes");
var _getFile = /* @__PURE__ */ _classPrivateFieldLooseKey7("getFile");
var _shouldRetry = /* @__PURE__ */ _classPrivateFieldLooseKey7("shouldRetry");
var _nonMultipartUpload = /* @__PURE__ */ _classPrivateFieldLooseKey7("nonMultipartUpload");
var HTTPCommunicationQueue = class {
  constructor(_requests22, options, setS3MultipartState, getFile) {
    Object.defineProperty(this, _nonMultipartUpload, {
      value: _nonMultipartUpload2
    });
    Object.defineProperty(this, _shouldRetry, {
      value: _shouldRetry2
    });
    Object.defineProperty(this, _abortMultipartUpload, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cache, {
      writable: true,
      value: /* @__PURE__ */ new WeakMap()
    });
    Object.defineProperty(this, _createMultipartUpload, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _fetchSignature, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _getUploadParameters, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _listParts, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousRetryDelay, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requests, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _retryDelays, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _sendCompletionRequest, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setS3MultipartState, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploadPartBytes, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _getFile, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase7(this, _requests)[_requests] = _requests22;
    _classPrivateFieldLooseBase7(this, _setS3MultipartState)[_setS3MultipartState] = setS3MultipartState;
    _classPrivateFieldLooseBase7(this, _getFile)[_getFile] = getFile;
    this.setOptions(options);
  }
  setOptions(options) {
    const requests = _classPrivateFieldLooseBase7(this, _requests)[_requests];
    if ("abortMultipartUpload" in options) {
      _classPrivateFieldLooseBase7(this, _abortMultipartUpload)[_abortMultipartUpload] = requests.wrapPromiseFunction(options.abortMultipartUpload, {
        priority: 1
      });
    }
    if ("createMultipartUpload" in options) {
      _classPrivateFieldLooseBase7(this, _createMultipartUpload)[_createMultipartUpload] = requests.wrapPromiseFunction(options.createMultipartUpload, {
        priority: -1
      });
    }
    if ("signPart" in options) {
      _classPrivateFieldLooseBase7(this, _fetchSignature)[_fetchSignature] = requests.wrapPromiseFunction(options.signPart);
    }
    if ("listParts" in options) {
      _classPrivateFieldLooseBase7(this, _listParts)[_listParts] = requests.wrapPromiseFunction(options.listParts);
    }
    if ("completeMultipartUpload" in options) {
      _classPrivateFieldLooseBase7(this, _sendCompletionRequest)[_sendCompletionRequest] = requests.wrapPromiseFunction(options.completeMultipartUpload, {
        priority: 1
      });
    }
    if ("retryDelays" in options) {
      var _options$retryDelays;
      _classPrivateFieldLooseBase7(this, _retryDelays)[_retryDelays] = (_options$retryDelays = options.retryDelays) != null ? _options$retryDelays : [];
    }
    if ("uploadPartBytes" in options) {
      _classPrivateFieldLooseBase7(this, _uploadPartBytes)[_uploadPartBytes] = requests.wrapPromiseFunction(options.uploadPartBytes, {
        priority: Infinity
      });
    }
    if ("getUploadParameters" in options) {
      _classPrivateFieldLooseBase7(this, _getUploadParameters)[_getUploadParameters] = requests.wrapPromiseFunction(options.getUploadParameters);
    }
  }
  async getUploadId(file, signal) {
    let cachedResult;
    while ((cachedResult = _classPrivateFieldLooseBase7(this, _cache)[_cache].get(file.data)) != null) {
      try {
        return await cachedResult;
      } catch {
      }
    }
    const promise = _classPrivateFieldLooseBase7(this, _createMultipartUpload)[_createMultipartUpload](_classPrivateFieldLooseBase7(this, _getFile)[_getFile](file), signal);
    const abortPromise = () => {
      promise.abort(signal.reason);
      _classPrivateFieldLooseBase7(this, _cache)[_cache].delete(file.data);
    };
    signal.addEventListener("abort", abortPromise, {
      once: true
    });
    _classPrivateFieldLooseBase7(this, _cache)[_cache].set(file.data, promise);
    promise.then(async (result) => {
      signal.removeEventListener("abort", abortPromise);
      _classPrivateFieldLooseBase7(this, _setS3MultipartState)[_setS3MultipartState](file, result);
      _classPrivateFieldLooseBase7(this, _cache)[_cache].set(file.data, result);
    }, () => {
      signal.removeEventListener("abort", abortPromise);
      _classPrivateFieldLooseBase7(this, _cache)[_cache].delete(file.data);
    });
    return promise;
  }
  async abortFileUpload(file) {
    const result = _classPrivateFieldLooseBase7(this, _cache)[_cache].get(file.data);
    if (result == null) {
      return;
    }
    _classPrivateFieldLooseBase7(this, _cache)[_cache].delete(file.data);
    _classPrivateFieldLooseBase7(this, _setS3MultipartState)[_setS3MultipartState](file, /* @__PURE__ */ Object.create(null));
    let awaitedResult;
    try {
      awaitedResult = await result;
    } catch {
      return;
    }
    await _classPrivateFieldLooseBase7(this, _abortMultipartUpload)[_abortMultipartUpload](_classPrivateFieldLooseBase7(this, _getFile)[_getFile](file), awaitedResult);
  }
  /**
   * @param {import("@uppy/core").UppyFile} file
   * @param {import("../types/chunk").Chunk[]} chunks
   * @param {AbortSignal} signal
   * @returns {Promise<void>}
   */
  async uploadFile(file, chunks2, signal) {
    throwIfAborted(signal);
    if (chunks2.length === 1 && !chunks2[0].shouldUseMultipart) {
      return _classPrivateFieldLooseBase7(this, _nonMultipartUpload)[_nonMultipartUpload](file, chunks2[0], signal);
    }
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    throwIfAborted(signal);
    try {
      const parts = await Promise.all(chunks2.map((chunk, i4) => this.uploadChunk(file, i4 + 1, chunk, signal)));
      throwIfAborted(signal);
      return await _classPrivateFieldLooseBase7(this, _sendCompletionRequest)[_sendCompletionRequest](_classPrivateFieldLooseBase7(this, _getFile)[_getFile](file), {
        key,
        uploadId,
        parts,
        signal
      }, signal).abortOn(signal);
    } catch (err) {
      if ((err == null ? void 0 : err.cause) !== pausingUploadReason && (err == null ? void 0 : err.name) !== "AbortError") {
        this.abortFileUpload(file);
      }
      throw err;
    }
  }
  restoreUploadFile(file, uploadIdAndKey) {
    _classPrivateFieldLooseBase7(this, _cache)[_cache].set(file.data, uploadIdAndKey);
  }
  async resumeUploadFile(file, chunks2, signal) {
    throwIfAborted(signal);
    if (chunks2.length === 1 && chunks2[0] != null && !chunks2[0].shouldUseMultipart) {
      return _classPrivateFieldLooseBase7(this, _nonMultipartUpload)[_nonMultipartUpload](file, chunks2[0], signal);
    }
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    throwIfAborted(signal);
    const alreadyUploadedParts = await _classPrivateFieldLooseBase7(this, _listParts)[_listParts](_classPrivateFieldLooseBase7(this, _getFile)[_getFile](file), {
      uploadId,
      key,
      signal
    }, signal).abortOn(signal);
    throwIfAborted(signal);
    const parts = await Promise.all(chunks2.map((chunk, i4) => {
      const partNumber = i4 + 1;
      const alreadyUploadedInfo = alreadyUploadedParts.find((_ref2) => {
        let {
          PartNumber
        } = _ref2;
        return PartNumber === partNumber;
      });
      if (alreadyUploadedInfo == null) {
        return this.uploadChunk(file, partNumber, chunk, signal);
      }
      chunk == null || chunk.setAsUploaded == null || chunk.setAsUploaded();
      return {
        PartNumber: partNumber,
        ETag: alreadyUploadedInfo.ETag
      };
    }));
    throwIfAborted(signal);
    return _classPrivateFieldLooseBase7(this, _sendCompletionRequest)[_sendCompletionRequest](_classPrivateFieldLooseBase7(this, _getFile)[_getFile](file), {
      key,
      uploadId,
      parts,
      signal
    }, signal).abortOn(signal);
  }
  /**
   *
   * @param {import("@uppy/core").UppyFile} file
   * @param {number} partNumber
   * @param {import("../types/chunk").Chunk} chunk
   * @param {AbortSignal} signal
   * @returns {Promise<object>}
   */
  async uploadChunk(file, partNumber, chunk, signal) {
    throwIfAborted(signal);
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    const signatureRetryIterator = _classPrivateFieldLooseBase7(this, _retryDelays)[_retryDelays].values();
    const chunkRetryIterator = _classPrivateFieldLooseBase7(this, _retryDelays)[_retryDelays].values();
    const shouldRetrySignature = () => {
      const next = signatureRetryIterator.next();
      if (next == null || next.done) {
        return null;
      }
      return next.value;
    };
    for (; ; ) {
      throwIfAborted(signal);
      const chunkData = chunk.getData();
      const {
        onProgress,
        onComplete
      } = chunk;
      let signature;
      try {
        signature = await _classPrivateFieldLooseBase7(this, _fetchSignature)[_fetchSignature](_classPrivateFieldLooseBase7(this, _getFile)[_getFile](file), {
          uploadId,
          key,
          partNumber,
          body: chunkData,
          signal
        }).abortOn(signal);
      } catch (err) {
        const timeout = shouldRetrySignature();
        if (timeout == null || signal.aborted) {
          throw err;
        }
        await new Promise((resolve) => setTimeout(resolve, timeout));
        continue;
      }
      throwIfAborted(signal);
      try {
        return {
          PartNumber: partNumber,
          ...await _classPrivateFieldLooseBase7(this, _uploadPartBytes)[_uploadPartBytes]({
            signature,
            body: chunkData,
            size: chunkData.size,
            onProgress,
            onComplete,
            signal
          }).abortOn(signal)
        };
      } catch (err) {
        if (!await _classPrivateFieldLooseBase7(this, _shouldRetry)[_shouldRetry](err, chunkRetryIterator))
          throw err;
      }
    }
  }
};
async function _shouldRetry2(err, retryDelayIterator) {
  var _err$source;
  const requests = _classPrivateFieldLooseBase7(this, _requests)[_requests];
  const status = err == null || (_err$source = err.source) == null ? void 0 : _err$source.status;
  if (status == null) {
    return false;
  }
  if (status === 403 && err.message === "Request has expired") {
    if (!requests.isPaused) {
      if (requests.limit === 1 || _classPrivateFieldLooseBase7(this, _previousRetryDelay)[_previousRetryDelay] == null) {
        const next = retryDelayIterator.next();
        if (next == null || next.done) {
          return false;
        }
        _classPrivateFieldLooseBase7(this, _previousRetryDelay)[_previousRetryDelay] = next.value;
      }
      requests.rateLimit(0);
      await new Promise((resolve) => setTimeout(resolve, _classPrivateFieldLooseBase7(this, _previousRetryDelay)[_previousRetryDelay]));
    }
  } else if (status === 429) {
    if (!requests.isPaused) {
      const next = retryDelayIterator.next();
      if (next == null || next.done) {
        return false;
      }
      requests.rateLimit(next.value);
    }
  } else if (status > 400 && status < 500 && status !== 409) {
    return false;
  } else if (typeof navigator !== "undefined" && navigator.onLine === false) {
    if (!requests.isPaused) {
      requests.pause();
      window.addEventListener("online", () => {
        requests.resume();
      }, {
        once: true
      });
    }
  } else {
    const next = retryDelayIterator.next();
    if (next == null || next.done) {
      return false;
    }
    await new Promise((resolve) => setTimeout(resolve, next.value));
  }
  return true;
}
async function _nonMultipartUpload2(file, chunk, signal) {
  const {
    method = "POST",
    url,
    fields,
    headers
  } = await _classPrivateFieldLooseBase7(this, _getUploadParameters)[_getUploadParameters](_classPrivateFieldLooseBase7(this, _getFile)[_getFile](file), {
    signal
  }).abortOn(signal);
  let body;
  const data = chunk.getData();
  if (method.toUpperCase() === "POST") {
    const formData = new FormData();
    Object.entries(fields).forEach((_ref10) => {
      let [key, value] = _ref10;
      return formData.set(key, value);
    });
    formData.set("file", data);
    body = formData;
  } else {
    body = data;
  }
  const {
    onProgress,
    onComplete
  } = chunk;
  const result = await _classPrivateFieldLooseBase7(this, _uploadPartBytes)[_uploadPartBytes]({
    signature: {
      url,
      headers,
      method
    },
    body,
    size: data.size,
    onProgress,
    onComplete,
    signal
  }).abortOn(signal);
  return "location" in result ? result : {
    location: removeMetadataFromURL(url),
    ...result
  };
}
var _companionCommunicationQueue = /* @__PURE__ */ _classPrivateFieldLooseKey7("companionCommunicationQueue");
var _client = /* @__PURE__ */ _classPrivateFieldLooseKey7("client");
var _cachedTemporaryCredentials = /* @__PURE__ */ _classPrivateFieldLooseKey7("cachedTemporaryCredentials");
var _getTemporarySecurityCredentials = /* @__PURE__ */ _classPrivateFieldLooseKey7("getTemporarySecurityCredentials");
var _setS3MultipartState2 = /* @__PURE__ */ _classPrivateFieldLooseKey7("setS3MultipartState");
var _getFile2 = /* @__PURE__ */ _classPrivateFieldLooseKey7("getFile");
var _uploadLocalFile = /* @__PURE__ */ _classPrivateFieldLooseKey7("uploadLocalFile");
var _getCompanionClientArgs = /* @__PURE__ */ _classPrivateFieldLooseKey7("getCompanionClientArgs");
var _upload = /* @__PURE__ */ _classPrivateFieldLooseKey7("upload");
var _setCompanionHeaders = /* @__PURE__ */ _classPrivateFieldLooseKey7("setCompanionHeaders");
var _setResumableUploadsCapability = /* @__PURE__ */ _classPrivateFieldLooseKey7("setResumableUploadsCapability");
var _resetResumableCapability = /* @__PURE__ */ _classPrivateFieldLooseKey7("resetResumableCapability");
_Symbol$for3 = Symbol.for("uppy test: getClient");
var AwsS3Multipart = class _AwsS3Multipart extends BasePlugin {
  constructor(uppy2, opts) {
    var _this$opts$rateLimite;
    super(uppy2, opts);
    Object.defineProperty(this, _getCompanionClientArgs, {
      value: _getCompanionClientArgs2
    });
    Object.defineProperty(this, _uploadLocalFile, {
      value: _uploadLocalFile2
    });
    Object.defineProperty(this, _getTemporarySecurityCredentials, {
      value: _getTemporarySecurityCredentials2
    });
    Object.defineProperty(this, _companionCommunicationQueue, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _client, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cachedTemporaryCredentials, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setS3MultipartState2, {
      writable: true,
      value: (file, _ref3) => {
        let {
          key,
          uploadId
        } = _ref3;
        const cFile = this.uppy.getFile(file.id);
        if (cFile == null) {
          return;
        }
        this.uppy.setFileState(file.id, {
          s3Multipart: {
            ...cFile.s3Multipart,
            key,
            uploadId
          }
        });
      }
    });
    Object.defineProperty(this, _getFile2, {
      writable: true,
      value: (file) => {
        return this.uppy.getFile(file.id) || file;
      }
    });
    Object.defineProperty(this, _upload, {
      writable: true,
      value: async (fileIDs) => {
        if (fileIDs.length === 0)
          return void 0;
        const files = this.uppy.getFilesByIds(fileIDs);
        const filesFiltered = filterNonFailedFiles(files);
        const filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
        this.uppy.emit("upload-start", filesToEmit);
        const promises = filesFiltered.map((file) => {
          if (file.isRemote) {
            const getQueue = () => this.requests;
            _classPrivateFieldLooseBase7(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](false);
            const controller = new AbortController();
            const removedHandler = (removedFile) => {
              if (removedFile.id === file.id)
                controller.abort();
            };
            this.uppy.on("file-removed", removedHandler);
            const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, _classPrivateFieldLooseBase7(this, _getCompanionClientArgs)[_getCompanionClientArgs](file), {
              signal: controller.signal,
              getQueue
            });
            this.requests.wrapSyncFunction(() => {
              this.uppy.off("file-removed", removedHandler);
            }, {
              priority: -1
            })();
            return uploadPromise;
          }
          return _classPrivateFieldLooseBase7(this, _uploadLocalFile)[_uploadLocalFile](file);
        });
        const upload = await Promise.all(promises);
        _classPrivateFieldLooseBase7(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](true);
        return upload;
      }
    });
    Object.defineProperty(this, _setCompanionHeaders, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase7(this, _client)[_client].setCompanionHeaders(this.opts.companionHeaders);
      }
    });
    Object.defineProperty(this, _setResumableUploadsCapability, {
      writable: true,
      value: (boolean5) => {
        const {
          capabilities
        } = this.uppy.getState();
        this.uppy.setState({
          capabilities: {
            ...capabilities,
            resumableUploads: boolean5
          }
        });
      }
    });
    Object.defineProperty(this, _resetResumableCapability, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase7(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](true);
      }
    });
    this.type = "uploader";
    this.id = this.opts.id || "AwsS3Multipart";
    this.title = "AWS S3 Multipart";
    _classPrivateFieldLooseBase7(this, _client)[_client] = new RequestClient(uppy2, opts);
    const defaultOptions11 = {
      // TODO: null here means “include all”, [] means include none.
      // This is inconsistent with @uppy/aws-s3 and @uppy/transloadit
      allowedMetaFields: null,
      limit: 6,
      shouldUseMultipart: (file) => file.size !== 0,
      // TODO: Switch default to:
      // eslint-disable-next-line no-bitwise
      // shouldUseMultipart: (file) => file.size >> 10 >> 10 > 100,
      retryDelays: [0, 1e3, 3e3, 5e3],
      createMultipartUpload: this.createMultipartUpload.bind(this),
      listParts: this.listParts.bind(this),
      abortMultipartUpload: this.abortMultipartUpload.bind(this),
      completeMultipartUpload: this.completeMultipartUpload.bind(this),
      getTemporarySecurityCredentials: false,
      signPart: opts != null && opts.getTemporarySecurityCredentials ? this.createSignedURL.bind(this) : this.signPart.bind(this),
      uploadPartBytes: _AwsS3Multipart.uploadPartBytes,
      getUploadParameters: opts != null && opts.getTemporarySecurityCredentials ? this.createSignedURL.bind(this) : this.getUploadParameters.bind(this),
      companionHeaders: {}
    };
    this.opts = {
      ...defaultOptions11,
      ...opts
    };
    if ((opts == null ? void 0 : opts.prepareUploadParts) != null && opts.signPart == null) {
      this.opts.signPart = async (file, _ref4) => {
        let {
          uploadId,
          key,
          partNumber,
          body,
          signal
        } = _ref4;
        const {
          presignedUrls,
          headers
        } = await opts.prepareUploadParts(file, {
          uploadId,
          key,
          parts: [{
            number: partNumber,
            chunk: body
          }],
          signal
        });
        return {
          url: presignedUrls == null ? void 0 : presignedUrls[partNumber],
          headers: headers == null ? void 0 : headers[partNumber]
        };
      };
    }
    this.requests = (_this$opts$rateLimite = this.opts.rateLimitedQueue) != null ? _this$opts$rateLimite : new RateLimitedQueue(this.opts.limit);
    _classPrivateFieldLooseBase7(this, _companionCommunicationQueue)[_companionCommunicationQueue] = new HTTPCommunicationQueue(this.requests, this.opts, _classPrivateFieldLooseBase7(this, _setS3MultipartState2)[_setS3MultipartState2], _classPrivateFieldLooseBase7(this, _getFile2)[_getFile2]);
    this.uploaders = /* @__PURE__ */ Object.create(null);
    this.uploaderEvents = /* @__PURE__ */ Object.create(null);
    this.uploaderSockets = /* @__PURE__ */ Object.create(null);
  }
  [_Symbol$for3]() {
    return _classPrivateFieldLooseBase7(this, _client)[_client];
  }
  setOptions(newOptions) {
    _classPrivateFieldLooseBase7(this, _companionCommunicationQueue)[_companionCommunicationQueue].setOptions(newOptions);
    super.setOptions(newOptions);
    _classPrivateFieldLooseBase7(this, _setCompanionHeaders)[_setCompanionHeaders]();
  }
  /**
   * Clean up all references for a file's upload: the MultipartUploader instance,
   * any events related to the file, and the Companion WebSocket connection.
   *
   * Set `opts.abort` to tell S3 that the multipart upload is cancelled and must be removed.
   * This should be done when the user cancels the upload, not when the upload is completed or errored.
   */
  resetUploaderReferences(fileID, opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (this.uploaders[fileID]) {
      this.uploaders[fileID].abort({
        really: opts.abort || false
      });
      this.uploaders[fileID] = null;
    }
    if (this.uploaderEvents[fileID]) {
      this.uploaderEvents[fileID].remove();
      this.uploaderEvents[fileID] = null;
    }
    if (this.uploaderSockets[fileID]) {
      this.uploaderSockets[fileID].close();
      this.uploaderSockets[fileID] = null;
    }
  }
  // TODO: make this a private method in the next major
  assertHost(method) {
    if (!this.opts.companionUrl) {
      throw new Error(`Expected a \`companionUrl\` option containing a Companion address, or if you are not using Companion, a custom \`${method}\` implementation.`);
    }
  }
  createMultipartUpload(file, signal) {
    this.assertHost("createMultipartUpload");
    throwIfAborted(signal);
    const metadata = getAllowedMetadata({
      meta: file.meta,
      allowedMetaFields: this.opts.allowedMetaFields
    });
    return _classPrivateFieldLooseBase7(this, _client)[_client].post("s3/multipart", {
      filename: file.name,
      type: file.type,
      metadata
    }, {
      signal
    }).then(assertServerError);
  }
  listParts(file, _ref5, signal) {
    let {
      key,
      uploadId
    } = _ref5;
    this.assertHost("listParts");
    throwIfAborted(signal);
    const filename = encodeURIComponent(key);
    return _classPrivateFieldLooseBase7(this, _client)[_client].get(`s3/multipart/${uploadId}?key=${filename}`, {
      signal
    }).then(assertServerError);
  }
  completeMultipartUpload(file, _ref6, signal) {
    let {
      key,
      uploadId,
      parts
    } = _ref6;
    this.assertHost("completeMultipartUpload");
    throwIfAborted(signal);
    const filename = encodeURIComponent(key);
    const uploadIdEnc = encodeURIComponent(uploadId);
    return _classPrivateFieldLooseBase7(this, _client)[_client].post(`s3/multipart/${uploadIdEnc}/complete?key=${filename}`, {
      parts
    }, {
      signal
    }).then(assertServerError);
  }
  async createSignedURL(file, options) {
    const data = await _classPrivateFieldLooseBase7(this, _getTemporarySecurityCredentials)[_getTemporarySecurityCredentials](options);
    const expires = getExpiry(data.credentials) || 604800;
    const {
      uploadId,
      key,
      partNumber,
      signal
    } = options;
    return {
      method: "PUT",
      expires,
      fields: {},
      url: `${await createSignedURL({
        accountKey: data.credentials.AccessKeyId,
        accountSecret: data.credentials.SecretAccessKey,
        sessionToken: data.credentials.SessionToken,
        expires,
        bucketName: data.bucket,
        Region: data.region,
        Key: key != null ? key : `${crypto.randomUUID()}-${file.name}`,
        uploadId,
        partNumber,
        signal
      })}`,
      // Provide content type header required by S3
      headers: {
        "Content-Type": file.type
      }
    };
  }
  signPart(file, _ref7) {
    let {
      uploadId,
      key,
      partNumber,
      signal
    } = _ref7;
    this.assertHost("signPart");
    throwIfAborted(signal);
    if (uploadId == null || key == null || partNumber == null) {
      throw new Error("Cannot sign without a key, an uploadId, and a partNumber");
    }
    const filename = encodeURIComponent(key);
    return _classPrivateFieldLooseBase7(this, _client)[_client].get(`s3/multipart/${uploadId}/${partNumber}?key=${filename}`, {
      signal
    }).then(assertServerError);
  }
  abortMultipartUpload(file, _ref8, signal) {
    let {
      key,
      uploadId
    } = _ref8;
    this.assertHost("abortMultipartUpload");
    const filename = encodeURIComponent(key);
    const uploadIdEnc = encodeURIComponent(uploadId);
    return _classPrivateFieldLooseBase7(this, _client)[_client].delete(`s3/multipart/${uploadIdEnc}?key=${filename}`, void 0, {
      signal
    }).then(assertServerError);
  }
  getUploadParameters(file, options) {
    const {
      meta
    } = file;
    const {
      type,
      name: filename
    } = meta;
    const metadata = getAllowedMetadata({
      meta,
      allowedMetaFields: this.opts.allowedMetaFields,
      querify: true
    });
    const query = new URLSearchParams({
      filename,
      type,
      ...metadata
    });
    return _classPrivateFieldLooseBase7(this, _client)[_client].get(`s3/params?${query}`, options);
  }
  static async uploadPartBytes(_ref9) {
    let {
      signature: {
        url,
        expires,
        headers,
        method = "PUT"
      },
      body,
      size = body.size,
      onProgress,
      onComplete,
      signal
    } = _ref9;
    throwIfAborted(signal);
    if (url == null) {
      throw new Error("Cannot upload to an undefined URL");
    }
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      if (headers) {
        Object.keys(headers).forEach((key) => {
          xhr.setRequestHeader(key, headers[key]);
        });
      }
      xhr.responseType = "text";
      if (typeof expires === "number") {
        xhr.timeout = expires * 1e3;
      }
      function onabort() {
        xhr.abort();
      }
      function cleanup() {
        signal.removeEventListener("abort", onabort);
      }
      signal.addEventListener("abort", onabort);
      xhr.upload.addEventListener("progress", (ev) => {
        onProgress(ev);
      });
      xhr.addEventListener("abort", () => {
        cleanup();
        reject(createAbortError());
      });
      xhr.addEventListener("timeout", () => {
        cleanup();
        const error = new Error("Request has expired");
        error.source = {
          status: 403
        };
        reject(error);
      });
      xhr.addEventListener("load", (ev) => {
        cleanup();
        if (ev.target.status === 403 && ev.target.responseText.includes("<Message>Request has expired</Message>")) {
          const error = new Error("Request has expired");
          error.source = ev.target;
          reject(error);
          return;
        }
        if (ev.target.status < 200 || ev.target.status >= 300) {
          const error = new Error("Non 2xx");
          error.source = ev.target;
          reject(error);
          return;
        }
        onProgress == null || onProgress({
          loaded: size,
          lengthComputable: true
        });
        const etag = ev.target.getResponseHeader("ETag");
        const location2 = ev.target.getResponseHeader("Location");
        if (method.toUpperCase() === "POST" && location2 === null) {
          console.warn("AwsS3/Multipart: Could not read the Location header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions.");
        }
        if (etag === null) {
          reject(new Error("AwsS3/Multipart: Could not read the ETag header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions."));
          return;
        }
        onComplete == null || onComplete(etag);
        resolve({
          ETag: etag,
          ...location2 ? {
            location: location2
          } : void 0
        });
      });
      xhr.addEventListener("error", (ev) => {
        cleanup();
        const error = new Error("Unknown error");
        error.source = ev.target;
        reject(error);
      });
      xhr.send(body);
    });
  }
  install() {
    _classPrivateFieldLooseBase7(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](true);
    this.uppy.addPreProcessor(_classPrivateFieldLooseBase7(this, _setCompanionHeaders)[_setCompanionHeaders]);
    this.uppy.addUploader(_classPrivateFieldLooseBase7(this, _upload)[_upload]);
    this.uppy.on("cancel-all", _classPrivateFieldLooseBase7(this, _resetResumableCapability)[_resetResumableCapability]);
  }
  uninstall() {
    this.uppy.removePreProcessor(_classPrivateFieldLooseBase7(this, _setCompanionHeaders)[_setCompanionHeaders]);
    this.uppy.removeUploader(_classPrivateFieldLooseBase7(this, _upload)[_upload]);
    this.uppy.off("cancel-all", _classPrivateFieldLooseBase7(this, _resetResumableCapability)[_resetResumableCapability]);
  }
};
async function _getTemporarySecurityCredentials2(options) {
  throwIfAborted(options == null ? void 0 : options.signal);
  if (_classPrivateFieldLooseBase7(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] == null) {
    if (this.opts.getTemporarySecurityCredentials === true) {
      this.assertHost("getTemporarySecurityCredentials");
      _classPrivateFieldLooseBase7(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = _classPrivateFieldLooseBase7(this, _client)[_client].get("s3/sts", null, options).then(assertServerError);
    } else {
      _classPrivateFieldLooseBase7(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = this.opts.getTemporarySecurityCredentials(options);
    }
    _classPrivateFieldLooseBase7(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = await _classPrivateFieldLooseBase7(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials];
    setTimeout(() => {
      _classPrivateFieldLooseBase7(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = null;
    }, (getExpiry(_classPrivateFieldLooseBase7(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials].credentials) || 0) * 500);
  }
  return _classPrivateFieldLooseBase7(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials];
}
function _uploadLocalFile2(file) {
  var _this = this;
  return new Promise((resolve, reject) => {
    const onProgress = (bytesUploaded, bytesTotal) => {
      this.uppy.emit("upload-progress", this.uppy.getFile(file.id), {
        uploader: this,
        bytesUploaded,
        bytesTotal
      });
    };
    const onError = (err) => {
      this.uppy.log(err);
      this.uppy.emit("upload-error", file, err);
      this.resetUploaderReferences(file.id);
      reject(err);
    };
    const onSuccess = (result) => {
      const uploadResp = {
        body: {
          ...result
        },
        uploadURL: result.location
      };
      this.resetUploaderReferences(file.id);
      this.uppy.emit("upload-success", _classPrivateFieldLooseBase7(this, _getFile2)[_getFile2](file), uploadResp);
      if (result.location) {
        this.uppy.log(`Download ${file.name} from ${result.location}`);
      }
      resolve();
    };
    const onPartComplete = (part) => {
      this.uppy.emit("s3-multipart:part-uploaded", _classPrivateFieldLooseBase7(this, _getFile2)[_getFile2](file), part);
    };
    const upload = new MultipartUploader_default(file.data, {
      // .bind to pass the file object to each handler.
      companionComm: _classPrivateFieldLooseBase7(this, _companionCommunicationQueue)[_companionCommunicationQueue],
      log: function() {
        return _this.uppy.log(...arguments);
      },
      getChunkSize: this.opts.getChunkSize ? this.opts.getChunkSize.bind(this) : null,
      onProgress,
      onError,
      onSuccess,
      onPartComplete,
      file,
      shouldUseMultipart: this.opts.shouldUseMultipart,
      ...file.s3Multipart
    });
    this.uploaders[file.id] = upload;
    const eventManager = new EventManager(this.uppy);
    this.uploaderEvents[file.id] = eventManager;
    eventManager.onFileRemove(file.id, (removed) => {
      upload.abort();
      this.resetUploaderReferences(file.id, {
        abort: true
      });
      resolve(`upload ${removed.id} was removed`);
    });
    eventManager.onCancelAll(file.id, function(_temp) {
      let {
        reason
      } = _temp === void 0 ? {} : _temp;
      if (reason === "user") {
        upload.abort();
        _this.resetUploaderReferences(file.id, {
          abort: true
        });
      }
      resolve(`upload ${file.id} was canceled`);
    });
    eventManager.onFilePause(file.id, (isPaused) => {
      if (isPaused) {
        upload.pause();
      } else {
        upload.start();
      }
    });
    eventManager.onPauseAll(file.id, () => {
      upload.pause();
    });
    eventManager.onResumeAll(file.id, () => {
      upload.start();
    });
    upload.start();
  });
}
function _getCompanionClientArgs2(file) {
  return {
    ...file.remote.body,
    protocol: "s3-multipart",
    size: file.data.size,
    metadata: file.meta
  };
}
AwsS3Multipart.VERSION = packageJson2.version;

// ../../node_modules/nanoid/non-secure/index.js
var urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var nanoid = (size = 21) => {
  let id18 = "";
  let i4 = size;
  while (i4--) {
    id18 += urlAlphabet[Math.random() * 64 | 0];
  }
  return id18;
};

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/ProgressTimeout.js
function _classPrivateFieldLooseBase8(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id8 = 0;
function _classPrivateFieldLooseKey8(name) {
  return "__private_" + id8++ + "_" + name;
}
var _aliveTimer = /* @__PURE__ */ _classPrivateFieldLooseKey8("aliveTimer");
var _isDone = /* @__PURE__ */ _classPrivateFieldLooseKey8("isDone");
var _onTimedOut = /* @__PURE__ */ _classPrivateFieldLooseKey8("onTimedOut");
var _timeout = /* @__PURE__ */ _classPrivateFieldLooseKey8("timeout");
var ProgressTimeout = class {
  constructor(timeout, timeoutHandler) {
    Object.defineProperty(this, _aliveTimer, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _isDone, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _onTimedOut, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _timeout, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase8(this, _timeout)[_timeout] = timeout;
    _classPrivateFieldLooseBase8(this, _onTimedOut)[_onTimedOut] = timeoutHandler;
  }
  progress() {
    if (_classPrivateFieldLooseBase8(this, _isDone)[_isDone])
      return;
    if (_classPrivateFieldLooseBase8(this, _timeout)[_timeout] > 0) {
      clearTimeout(_classPrivateFieldLooseBase8(this, _aliveTimer)[_aliveTimer]);
      _classPrivateFieldLooseBase8(this, _aliveTimer)[_aliveTimer] = setTimeout(_classPrivateFieldLooseBase8(this, _onTimedOut)[_onTimedOut], _classPrivateFieldLooseBase8(this, _timeout)[_timeout]);
    }
  }
  done() {
    if (!_classPrivateFieldLooseBase8(this, _isDone)[_isDone]) {
      clearTimeout(_classPrivateFieldLooseBase8(this, _aliveTimer)[_aliveTimer]);
      _classPrivateFieldLooseBase8(this, _aliveTimer)[_aliveTimer] = void 0;
      _classPrivateFieldLooseBase8(this, _isDone)[_isDone] = true;
    }
  }
};
var ProgressTimeout_default = ProgressTimeout;

// ../../node_modules/@uppy/aws-s3/node_modules/@uppy/utils/lib/isNetworkError.js
function isNetworkError2(xhr) {
  if (!xhr) {
    return false;
  }
  return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
var isNetworkError_default = isNetworkError2;

// ../../node_modules/@uppy/aws-s3/lib/MiniXHRUpload.js
function _classPrivateFieldLooseBase9(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id9 = 0;
function _classPrivateFieldLooseKey9(name) {
  return "__private_" + id9++ + "_" + name;
}
function buildResponseError(xhr, error) {
  if (isNetworkError_default(xhr))
    return new NetworkError_default(error, xhr);
  const err = new ErrorWithCause_default("Upload error", {
    cause: error
  });
  err.request = xhr;
  return err;
}
function setTypeInBlob(file) {
  const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}
function addMetadata(formData, meta, opts) {
  const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(meta);
  allowedMetaFields.forEach((item) => {
    formData.append(item, meta[item]);
  });
}
function createFormDataUpload(file, opts) {
  const formPost = new FormData();
  addMetadata(formPost, file.meta, opts);
  const dataWithUpdatedType = setTypeInBlob(file);
  if (file.name) {
    formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
  } else {
    formPost.append(opts.fieldName, dataWithUpdatedType);
  }
  return formPost;
}
var createBareUpload = (file) => file.data;
var _addEventHandlerForFile = /* @__PURE__ */ _classPrivateFieldLooseKey9("addEventHandlerForFile");
var _addEventHandlerIfFileStillExists = /* @__PURE__ */ _classPrivateFieldLooseKey9("addEventHandlerIfFileStillExists");
var MiniXHRUpload = class {
  constructor(uppy2, opts) {
    Object.defineProperty(this, _addEventHandlerIfFileStillExists, {
      value: _addEventHandlerIfFileStillExists2
    });
    Object.defineProperty(this, _addEventHandlerForFile, {
      value: _addEventHandlerForFile2
    });
    this.uppy = uppy2;
    this.opts = {
      validateStatus(status) {
        return status >= 200 && status < 300;
      },
      ...opts
    };
    this.requests = opts[internalRateLimitedQueue];
    this.uploaderEvents = /* @__PURE__ */ Object.create(null);
    this.i18n = opts.i18n;
  }
  getOptions(file) {
    var _file$xhrUpload;
    const {
      uppy: uppy2
    } = this;
    const overrides = uppy2.getState().xhrUpload;
    const opts = {
      ...this.opts,
      ...overrides || {},
      ...file.xhrUpload || {},
      headers: {
        ...this.opts.headers,
        ...overrides == null ? void 0 : overrides.headers,
        ...(_file$xhrUpload = file.xhrUpload) == null ? void 0 : _file$xhrUpload.headers
      }
    };
    return opts;
  }
  uploadLocalFile(file) {
    const opts = this.getOptions(file);
    return new Promise((resolve, reject) => {
      const data = opts.formData ? createFormDataUpload(file, opts) : createBareUpload(file, opts);
      const xhr = new XMLHttpRequest();
      this.uploaderEvents[file.id] = new EventManager(this.uppy);
      const timer = new ProgressTimeout_default(opts.timeout, () => {
        xhr.abort();
        queuedRequest.done();
        const error = new Error(this.i18n("timedOut", {
          seconds: Math.ceil(opts.timeout / 1e3)
        }));
        this.uppy.emit("upload-error", file, error);
        reject(error);
      });
      const id18 = nanoid();
      xhr.upload.addEventListener("loadstart", () => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} started`);
      });
      xhr.upload.addEventListener("progress", (ev) => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} progress: ${ev.loaded} / ${ev.total}`);
        timer.progress();
        if (ev.lengthComputable) {
          this.uppy.emit("upload-progress", this.uppy.getFile(file.id), {
            uploader: this,
            bytesUploaded: ev.loaded,
            bytesTotal: ev.total
          });
        }
      });
      xhr.addEventListener("load", (ev) => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} finished`);
        timer.done();
        queuedRequest.done();
        if (this.uploaderEvents[file.id]) {
          this.uploaderEvents[file.id].remove();
          this.uploaderEvents[file.id] = null;
        }
        if (opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
          const body2 = opts.getResponseData(xhr.responseText, xhr);
          const uploadURL = body2[opts.responseUrlFieldName];
          const uploadResp = {
            status: ev.target.status,
            body: body2,
            uploadURL
          };
          this.uppy.emit("upload-success", this.uppy.getFile(file.id), uploadResp);
          if (uploadURL) {
            this.uppy.log(`Download ${file.name} from ${uploadURL}`);
          }
          return resolve(file);
        }
        const body = opts.getResponseData(xhr.responseText, xhr);
        const error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
        const response = {
          status: ev.target.status,
          body
        };
        this.uppy.emit("upload-error", file, error, response);
        return reject(error);
      });
      xhr.addEventListener("error", () => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} errored`);
        timer.done();
        queuedRequest.done();
        if (this.uploaderEvents[file.id]) {
          this.uploaderEvents[file.id].remove();
          this.uploaderEvents[file.id] = null;
        }
        const error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
        this.uppy.emit("upload-error", file, error);
        return reject(error);
      });
      xhr.open(opts.method.toUpperCase(), opts.endpoint, true);
      xhr.withCredentials = Boolean(opts.withCredentials);
      if (opts.responseType !== "") {
        xhr.responseType = opts.responseType;
      }
      Object.keys(opts.headers).forEach((header) => {
        xhr.setRequestHeader(header, opts.headers[header]);
      });
      const queuedRequest = this.requests.run(() => {
        xhr.send(data);
        return () => {
          timer.done();
          xhr.abort();
        };
      }, {
        priority: 1
      });
      _classPrivateFieldLooseBase9(this, _addEventHandlerForFile)[_addEventHandlerForFile]("file-removed", file.id, () => {
        queuedRequest.abort();
        reject(new Error("File removed"));
      });
      _classPrivateFieldLooseBase9(this, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]("cancel-all", file.id, function(_temp) {
        let {
          reason
        } = _temp === void 0 ? {} : _temp;
        if (reason === "user") {
          queuedRequest.abort();
        }
        reject(new Error("Upload cancelled"));
      });
    });
  }
};
function _addEventHandlerForFile2(eventName, fileID, eventHandler) {
  this.uploaderEvents[fileID].on(eventName, (fileOrID) => {
    var _fileOrID$id;
    const id18 = (_fileOrID$id = fileOrID == null ? void 0 : fileOrID.id) != null ? _fileOrID$id : fileOrID;
    if (fileID === id18)
      eventHandler();
  });
}
function _addEventHandlerIfFileStillExists2(eventName, fileID, eventHandler) {
  var _this = this;
  this.uploaderEvents[fileID].on(eventName, function() {
    if (_this.uppy.getFile(fileID))
      eventHandler(...arguments);
  });
}

// ../../node_modules/@uppy/aws-s3/lib/isXml.js
function removeMimeParameters(mimeType) {
  return mimeType.replace(/;.*$/, "");
}
function isXml(content, xhr) {
  const rawContentType = xhr.headers ? xhr.headers["content-type"] : xhr.getResponseHeader("Content-Type");
  if (typeof rawContentType === "string") {
    const contentType = removeMimeParameters(rawContentType).toLowerCase();
    if (contentType === "application/xml" || contentType === "text/xml") {
      return true;
    }
    if (contentType === "text/html" && /^<\?xml /.test(content)) {
      return true;
    }
  }
  return false;
}
var isXml_default = isXml;

// ../../node_modules/@uppy/aws-s3/lib/locale.js
var locale_default = {
  strings: {
    timedOut: "Upload stalled for %{seconds} seconds, aborting."
  }
};

// ../../node_modules/@uppy/aws-s3/lib/index.js
var _Symbol$for4;
function _classPrivateFieldLooseBase10(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id10 = 0;
function _classPrivateFieldLooseKey10(name) {
  return "__private_" + id10++ + "_" + name;
}
var packageJson3 = {
  "version": "3.6.2"
};
function resolveUrl(origin, link) {
  if (!origin && !link.startsWith("https://") && !link.startsWith("http://")) {
    link = `https://${link}`;
  }
  return new URL(link, origin || void 0).toString();
}
function getXmlValue(source, tagName) {
  const start = source.indexOf(`<${tagName}>`);
  const end = source.indexOf(`</${tagName}>`, start);
  return start !== -1 && end !== -1 ? source.slice(start + tagName.length + 2, end) : "";
}
function assertServerError2(res) {
  if (res && res.error) {
    const error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }
  return res;
}
function validateParameters(file, params) {
  const valid = params != null && typeof params.url === "string" && (typeof params.fields === "object" || params.fields == null);
  if (!valid) {
    const err = new TypeError(`AwsS3: got incorrect result from 'getUploadParameters()' for file '${file.name}', expected an object '{ url, method, fields, headers }' but got '${JSON.stringify(params)}' instead.
See https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.`);
    throw err;
  }
  const methodIsValid = params.method == null || /^p(u|os)t$/i.test(params.method);
  if (!methodIsValid) {
    const err = new TypeError(`AwsS3: got incorrect method from 'getUploadParameters()' for file '${file.name}', expected  'PUT' or 'POST' but got '${params.method}' instead.
See https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.`);
    throw err;
  }
}
function defaultGetResponseError(content, xhr) {
  if (!isXml_default(content, xhr)) {
    return void 0;
  }
  const error = getXmlValue(content, "Message");
  return new Error(error);
}
var warnedSuccessActionStatus = false;
var _client2 = /* @__PURE__ */ _classPrivateFieldLooseKey10("client");
var _requests2 = /* @__PURE__ */ _classPrivateFieldLooseKey10("requests");
var _uploader = /* @__PURE__ */ _classPrivateFieldLooseKey10("uploader");
var _handleUpload = /* @__PURE__ */ _classPrivateFieldLooseKey10("handleUpload");
var _setCompanionHeaders2 = /* @__PURE__ */ _classPrivateFieldLooseKey10("setCompanionHeaders");
var _getCompanionClientArgs3 = /* @__PURE__ */ _classPrivateFieldLooseKey10("getCompanionClientArgs");
_Symbol$for4 = Symbol.for("uppy test: getClient");
var AwsS3 = class extends BasePlugin {
  constructor(uppy2, _opts) {
    if ((_opts == null ? void 0 : _opts.shouldUseMultipart) != null) {
      return new AwsS3Multipart(uppy2, _opts);
    }
    super(uppy2, _opts);
    Object.defineProperty(this, _client2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requests2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploader, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _handleUpload, {
      writable: true,
      value: async (fileIDs) => {
        const paramsPromises = /* @__PURE__ */ Object.create(null);
        function onremove(file) {
          var _paramsPromises$id;
          const {
            id: id18
          } = file;
          (_paramsPromises$id = paramsPromises[id18]) == null || _paramsPromises$id.abort();
        }
        this.uppy.on("file-removed", onremove);
        const files = this.uppy.getFilesByIds(fileIDs);
        const filesFiltered = filterNonFailedFiles(files);
        const filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
        this.uppy.emit("upload-start", filesToEmit);
        const getUploadParameters = _classPrivateFieldLooseBase10(this, _requests2)[_requests2].wrapPromiseFunction((file) => {
          return this.opts.getUploadParameters(file);
        });
        const numberOfFiles = fileIDs.length;
        return Promise.allSettled(fileIDs.map((id18, index) => {
          paramsPromises[id18] = getUploadParameters(this.uppy.getFile(id18));
          return paramsPromises[id18].then((params) => {
            delete paramsPromises[id18];
            const file = this.uppy.getFile(id18);
            validateParameters(file, params);
            const {
              method = "POST",
              url,
              fields,
              headers
            } = params;
            const xhrOpts = {
              method,
              formData: method.toUpperCase() === "POST",
              endpoint: url,
              allowedMetaFields: fields ? Object.keys(fields) : []
            };
            if (headers) {
              xhrOpts.headers = headers;
            }
            this.uppy.setFileState(file.id, {
              meta: {
                ...file.meta,
                ...fields
              },
              xhrUpload: xhrOpts
            });
            return this.uploadFile(file.id, index, numberOfFiles);
          }).catch((error) => {
            delete paramsPromises[id18];
            const file = this.uppy.getFile(id18);
            this.uppy.emit("upload-error", file, error);
            return Promise.reject(error);
          });
        })).finally(() => {
          this.uppy.off("file-removed", onremove);
        });
      }
    });
    Object.defineProperty(this, _setCompanionHeaders2, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase10(this, _client2)[_client2].setCompanionHeaders(this.opts.companionHeaders);
        return Promise.resolve();
      }
    });
    Object.defineProperty(this, _getCompanionClientArgs3, {
      writable: true,
      value: (file) => {
        const opts = _classPrivateFieldLooseBase10(this, _uploader)[_uploader].getOptions(file);
        const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(file.meta);
        return {
          ...file.remote.body,
          protocol: "multipart",
          endpoint: opts.endpoint,
          size: file.data.size,
          fieldname: opts.fieldName,
          metadata: Object.fromEntries(allowedMetaFields.map((name) => [name, file.meta[name]])),
          httpMethod: opts.method,
          useFormData: opts.formData,
          headers: typeof opts.headers === "function" ? opts.headers(file) : opts.headers
        };
      }
    });
    this.type = "uploader";
    this.id = this.opts.id || "AwsS3";
    this.title = "AWS S3";
    this.defaultLocale = locale_default;
    const defaultOptions11 = {
      timeout: 30 * 1e3,
      limit: 0,
      allowedMetaFields: [],
      // have to opt in
      getUploadParameters: this.getUploadParameters.bind(this),
      shouldUseMultipart: false,
      companionHeaders: {}
    };
    this.opts = {
      ...defaultOptions11,
      ..._opts
    };
    if ((_opts == null ? void 0 : _opts.allowedMetaFields) === void 0 && "metaFields" in this.opts) {
      throw new Error("The `metaFields` option has been renamed to `allowedMetaFields`.");
    }
    this.i18nInit();
    _classPrivateFieldLooseBase10(this, _client2)[_client2] = new RequestClient(uppy2, _opts);
    _classPrivateFieldLooseBase10(this, _requests2)[_requests2] = new RateLimitedQueue(this.opts.limit);
  }
  [_Symbol$for4]() {
    return _classPrivateFieldLooseBase10(this, _client2)[_client2];
  }
  // TODO: remove getter and setter for #client on the next major release
  get client() {
    return _classPrivateFieldLooseBase10(this, _client2)[_client2];
  }
  set client(client) {
    _classPrivateFieldLooseBase10(this, _client2)[_client2] = client;
  }
  getUploadParameters(file) {
    if (!this.opts.companionUrl) {
      throw new Error("Expected a `companionUrl` option containing a Companion address.");
    }
    const filename = file.meta.name;
    const {
      type
    } = file.meta;
    const metadata = Object.fromEntries(this.opts.allowedMetaFields.filter((key) => file.meta[key] != null).map((key) => [`metadata[${key}]`, file.meta[key].toString()]));
    const query = new URLSearchParams({
      filename,
      type,
      ...metadata
    });
    return _classPrivateFieldLooseBase10(this, _client2)[_client2].get(`s3/params?${query}`).then(assertServerError2);
  }
  uploadFile(id18, current, total) {
    const file = this.uppy.getFile(id18);
    this.uppy.log(`uploading ${current} of ${total}`);
    if (file.error)
      throw new Error(file.error);
    if (file.isRemote) {
      const getQueue = () => _classPrivateFieldLooseBase10(this, _requests2)[_requests2];
      const controller = new AbortController();
      const removedHandler = (removedFile) => {
        if (removedFile.id === file.id)
          controller.abort();
      };
      this.uppy.on("file-removed", removedHandler);
      const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, _classPrivateFieldLooseBase10(this, _getCompanionClientArgs3)[_getCompanionClientArgs3](file), {
        signal: controller.signal,
        getQueue
      });
      _classPrivateFieldLooseBase10(this, _requests2)[_requests2].wrapSyncFunction(() => {
        this.uppy.off("file-removed", removedHandler);
      }, {
        priority: -1
      })();
      return uploadPromise;
    }
    return _classPrivateFieldLooseBase10(this, _uploader)[_uploader].uploadLocalFile(file, current, total);
  }
  install() {
    const {
      uppy: uppy2
    } = this;
    uppy2.addPreProcessor(_classPrivateFieldLooseBase10(this, _setCompanionHeaders2)[_setCompanionHeaders2]);
    uppy2.addUploader(_classPrivateFieldLooseBase10(this, _handleUpload)[_handleUpload]);
    function defaultGetResponseData(content, xhr) {
      const opts = this;
      if (!isXml_default(content, xhr)) {
        if (opts.method.toUpperCase() === "POST") {
          if (!warnedSuccessActionStatus) {
            uppy2.log("[AwsS3] No response data found, make sure to set the success_action_status AWS SDK option to 201. See https://uppy.io/docs/aws-s3/#POST-Uploads", "warning");
            warnedSuccessActionStatus = true;
          }
          return {
            location: null
          };
        }
        if (!xhr.responseURL) {
          return {
            location: null
          };
        }
        return {
          location: xhr.responseURL.replace(/\?.*$/, "")
        };
      }
      return {
        // Some S3 alternatives do not reply with an absolute URL.
        // Eg DigitalOcean Spaces uses /$bucketName/xyz
        location: resolveUrl(xhr.responseURL, getXmlValue(content, "Location")),
        bucket: getXmlValue(content, "Bucket"),
        key: getXmlValue(content, "Key"),
        etag: getXmlValue(content, "ETag")
      };
    }
    const xhrOptions = {
      fieldName: "file",
      responseUrlFieldName: "location",
      timeout: this.opts.timeout,
      // Share the rate limiting queue with XHRUpload.
      [internalRateLimitedQueue]: _classPrivateFieldLooseBase10(this, _requests2)[_requests2],
      responseType: "text",
      getResponseData: this.opts.getResponseData || defaultGetResponseData,
      getResponseError: defaultGetResponseError
    };
    xhrOptions.i18n = this.i18n;
    _classPrivateFieldLooseBase10(this, _uploader)[_uploader] = new MiniXHRUpload(uppy2, xhrOptions);
  }
  uninstall() {
    this.uppy.removePreProcessor(_classPrivateFieldLooseBase10(this, _setCompanionHeaders2)[_setCompanionHeaders2]);
    this.uppy.removeUploader(_classPrivateFieldLooseBase10(this, _handleUpload)[_handleUpload]);
  }
};
AwsS3.VERSION = packageJson3.version;

// ../../node_modules/@uppy/core/lib/Uppy.js
var import_namespace_emitter2 = __toESM(require_namespace_emitter(), 1);
var import_throttle2 = __toESM(require_throttle(), 1);

// ../../node_modules/@uppy/store-default/lib/index.js
function _classPrivateFieldLooseBase11(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id11 = 0;
function _classPrivateFieldLooseKey11(name) {
  return "__private_" + id11++ + "_" + name;
}
var packageJson4 = {
  "version": "3.2.2"
};
var _callbacks = /* @__PURE__ */ _classPrivateFieldLooseKey11("callbacks");
var _publish = /* @__PURE__ */ _classPrivateFieldLooseKey11("publish");
var DefaultStore = class {
  constructor() {
    Object.defineProperty(this, _publish, {
      value: _publish2
    });
    this.state = {};
    Object.defineProperty(this, _callbacks, {
      writable: true,
      value: /* @__PURE__ */ new Set()
    });
  }
  getState() {
    return this.state;
  }
  setState(patch) {
    const prevState = {
      ...this.state
    };
    const nextState = {
      ...this.state,
      ...patch
    };
    this.state = nextState;
    _classPrivateFieldLooseBase11(this, _publish)[_publish](prevState, nextState, patch);
  }
  subscribe(listener) {
    _classPrivateFieldLooseBase11(this, _callbacks)[_callbacks].add(listener);
    return () => {
      _classPrivateFieldLooseBase11(this, _callbacks)[_callbacks].delete(listener);
    };
  }
};
function _publish2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  _classPrivateFieldLooseBase11(this, _callbacks)[_callbacks].forEach((listener) => {
    listener(...args);
  });
}
DefaultStore.VERSION = packageJson4.version;
var lib_default = DefaultStore;

// ../../node_modules/@uppy/utils/lib/getFileNameAndExtension.js
function getFileNameAndExtension(fullFileName) {
  const lastDot = fullFileName.lastIndexOf(".");
  if (lastDot === -1 || lastDot === fullFileName.length - 1) {
    return {
      name: fullFileName,
      extension: void 0
    };
  }
  return {
    name: fullFileName.slice(0, lastDot),
    extension: fullFileName.slice(lastDot + 1)
  };
}

// ../../node_modules/@uppy/utils/lib/mimeTypes.js
var mimeTypes_default = {
  __proto__: null,
  md: "text/markdown",
  markdown: "text/markdown",
  mp4: "video/mp4",
  mp3: "audio/mp3",
  svg: "image/svg+xml",
  jpg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  gif: "image/gif",
  heic: "image/heic",
  heif: "image/heif",
  yaml: "text/yaml",
  yml: "text/yaml",
  csv: "text/csv",
  tsv: "text/tab-separated-values",
  tab: "text/tab-separated-values",
  avi: "video/x-msvideo",
  mks: "video/x-matroska",
  mkv: "video/x-matroska",
  mov: "video/quicktime",
  dicom: "application/dicom",
  doc: "application/msword",
  docm: "application/vnd.ms-word.document.macroenabled.12",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  dot: "application/msword",
  dotm: "application/vnd.ms-word.template.macroenabled.12",
  dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  xla: "application/vnd.ms-excel",
  xlam: "application/vnd.ms-excel.addin.macroenabled.12",
  xlc: "application/vnd.ms-excel",
  xlf: "application/x-xliff+xml",
  xlm: "application/vnd.ms-excel",
  xls: "application/vnd.ms-excel",
  xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
  xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xlt: "application/vnd.ms-excel",
  xltm: "application/vnd.ms-excel.template.macroenabled.12",
  xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  xlw: "application/vnd.ms-excel",
  txt: "text/plain",
  text: "text/plain",
  conf: "text/plain",
  log: "text/plain",
  pdf: "application/pdf",
  zip: "application/zip",
  "7z": "application/x-7z-compressed",
  rar: "application/x-rar-compressed",
  tar: "application/x-tar",
  gz: "application/gzip",
  dmg: "application/x-apple-diskimage"
};

// ../../node_modules/@uppy/utils/lib/getFileType.js
function getFileType(file) {
  var _getFileNameAndExtens;
  if (file.type)
    return file.type;
  const fileExtension = file.name ? (_getFileNameAndExtens = getFileNameAndExtension(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
  if (fileExtension && fileExtension in mimeTypes_default) {
    return mimeTypes_default[fileExtension];
  }
  return "application/octet-stream";
}

// ../../node_modules/@uppy/utils/lib/generateFileID.js
function encodeCharacter(character) {
  return character.charCodeAt(0).toString(32);
}
function encodeFilename(name) {
  let suffix = "";
  return name.replace(/[^A-Z0-9]/gi, (character) => {
    suffix += `-${encodeCharacter(character)}`;
    return "/";
  }) + suffix;
}
function generateFileID(file) {
  let id18 = "uppy";
  if (typeof file.name === "string") {
    id18 += `-${encodeFilename(file.name.toLowerCase())}`;
  }
  if (file.type !== void 0) {
    id18 += `-${file.type}`;
  }
  if (file.meta && typeof file.meta.relativePath === "string") {
    id18 += `-${encodeFilename(file.meta.relativePath.toLowerCase())}`;
  }
  if (file.data.size !== void 0) {
    id18 += `-${file.data.size}`;
  }
  if (file.data.lastModified !== void 0) {
    id18 += `-${file.data.lastModified}`;
  }
  return id18;
}
function hasFileStableId(file) {
  if (!file.isRemote || !file.remote)
    return false;
  const stableIdProviders = /* @__PURE__ */ new Set(["box", "dropbox", "drive", "facebook", "unsplash"]);
  return stableIdProviders.has(file.remote.provider);
}
function getSafeFileId(file) {
  if (hasFileStableId(file))
    return file.id;
  const fileType = getFileType(file);
  return generateFileID({
    ...file,
    type: fileType
  });
}

// ../../node_modules/@uppy/core/lib/supportsUploadProgress.js
function supportsUploadProgress(userAgent) {
  if (userAgent == null && typeof navigator !== "undefined") {
    userAgent = navigator.userAgent;
  }
  if (!userAgent)
    return true;
  const m4 = /Edge\/(\d+\.\d+)/.exec(userAgent);
  if (!m4)
    return true;
  const edgeVersion = m4[1];
  const version = edgeVersion.split(".", 2);
  const major = parseInt(version[0], 10);
  const minor = parseInt(version[1], 10);
  if (major < 15 || major === 15 && minor < 15063) {
    return true;
  }
  if (major > 18 || major === 18 && minor >= 18218) {
    return true;
  }
  return false;
}

// ../../node_modules/@uppy/core/lib/getFileName.js
function getFileName(fileType, fileDescriptor) {
  if (fileDescriptor.name) {
    return fileDescriptor.name;
  }
  if (fileType.split("/")[0] === "image") {
    return `${fileType.split("/")[0]}.${fileType.split("/")[1]}`;
  }
  return "noname";
}

// ../../node_modules/@uppy/utils/lib/getTimeStamp.js
function pad(number) {
  return number < 10 ? `0${number}` : number.toString();
}
function getTimeStamp() {
  const date = /* @__PURE__ */ new Date();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  return `${hours}:${minutes}:${seconds}`;
}

// ../../node_modules/@uppy/core/lib/loggers.js
var justErrorsLogger = {
  debug: () => {
  },
  warn: () => {
  },
  error: function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return console.error(`[Uppy] [${getTimeStamp()}]`, ...args);
  }
};
var debugLogger = {
  debug: function() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return console.debug(`[Uppy] [${getTimeStamp()}]`, ...args);
  },
  warn: function() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return console.warn(`[Uppy] [${getTimeStamp()}]`, ...args);
  },
  error: function() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return console.error(`[Uppy] [${getTimeStamp()}]`, ...args);
  }
};

// ../../node_modules/@uppy/core/lib/Restricter.js
var import_prettier_bytes = __toESM(require_prettierBytes(), 1);
var import_mime_match = __toESM(require_mime_match(), 1);
var defaultOptions2 = {
  maxFileSize: null,
  minFileSize: null,
  maxTotalFileSize: null,
  maxNumberOfFiles: null,
  minNumberOfFiles: null,
  allowedFileTypes: null,
  requiredMetaFields: []
};
var RestrictionError = class extends Error {
  constructor(message, opts) {
    var _opts$isUserFacing;
    super(message);
    this.isRestriction = true;
    this.isUserFacing = (_opts$isUserFacing = opts == null ? void 0 : opts.isUserFacing) != null ? _opts$isUserFacing : true;
    if (opts != null && opts.file) {
      this.file = opts.file;
    }
  }
};
var Restricter = class {
  constructor(getOpts, i18n) {
    this.i18n = i18n;
    this.getOpts = () => {
      var _opts$restrictions;
      const opts = getOpts();
      if (((_opts$restrictions = opts.restrictions) == null ? void 0 : _opts$restrictions.allowedFileTypes) != null && !Array.isArray(opts.restrictions.allowedFileTypes)) {
        throw new TypeError("`restrictions.allowedFileTypes` must be an array");
      }
      return opts;
    };
  }
  // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
  validateAggregateRestrictions(existingFiles, addingFiles) {
    const {
      maxTotalFileSize,
      maxNumberOfFiles
    } = this.getOpts().restrictions;
    if (maxNumberOfFiles) {
      const nonGhostFiles = existingFiles.filter((f4) => !f4.isGhost);
      if (nonGhostFiles.length + addingFiles.length > maxNumberOfFiles) {
        throw new RestrictionError(`${this.i18n("youCanOnlyUploadX", {
          smart_count: maxNumberOfFiles
        })}`);
      }
    }
    if (maxTotalFileSize) {
      let totalFilesSize = existingFiles.reduce((total, f4) => {
        var _f$size;
        return total + ((_f$size = f4.size) != null ? _f$size : 0);
      }, 0);
      for (const addingFile of addingFiles) {
        if (addingFile.size != null) {
          totalFilesSize += addingFile.size;
          if (totalFilesSize > maxTotalFileSize) {
            throw new RestrictionError(this.i18n("exceedsSize", {
              size: (0, import_prettier_bytes.default)(maxTotalFileSize),
              file: addingFile.name
            }));
          }
        }
      }
    }
  }
  validateSingleFile(file) {
    const {
      maxFileSize,
      minFileSize,
      allowedFileTypes
    } = this.getOpts().restrictions;
    if (allowedFileTypes) {
      const isCorrectFileType = allowedFileTypes.some((type) => {
        if (type.includes("/")) {
          if (!file.type)
            return false;
          return (0, import_mime_match.default)(file.type.replace(/;.*?$/, ""), type);
        }
        if (type[0] === "." && file.extension) {
          return file.extension.toLowerCase() === type.slice(1).toLowerCase();
        }
        return false;
      });
      if (!isCorrectFileType) {
        const allowedFileTypesString = allowedFileTypes.join(", ");
        throw new RestrictionError(this.i18n("youCanOnlyUploadFileTypes", {
          types: allowedFileTypesString
        }), {
          file
        });
      }
    }
    if (maxFileSize && file.size != null && file.size > maxFileSize) {
      throw new RestrictionError(this.i18n("exceedsSize", {
        size: (0, import_prettier_bytes.default)(maxFileSize),
        file: file.name
      }), {
        file
      });
    }
    if (minFileSize && file.size != null && file.size < minFileSize) {
      throw new RestrictionError(this.i18n("inferiorSize", {
        size: (0, import_prettier_bytes.default)(minFileSize)
      }), {
        file
      });
    }
  }
  validate(existingFiles, addingFiles) {
    addingFiles.forEach((addingFile) => {
      this.validateSingleFile(addingFile);
    });
    this.validateAggregateRestrictions(existingFiles, addingFiles);
  }
  validateMinNumberOfFiles(files) {
    const {
      minNumberOfFiles
    } = this.getOpts().restrictions;
    if (minNumberOfFiles && Object.keys(files).length < minNumberOfFiles) {
      throw new RestrictionError(this.i18n("youHaveToAtLeastSelectX", {
        smart_count: minNumberOfFiles
      }));
    }
  }
  getMissingRequiredMetaFields(file) {
    const error = new RestrictionError(this.i18n("missingRequiredMetaFieldOnFile", {
      fileName: file.name
    }));
    const {
      requiredMetaFields
    } = this.getOpts().restrictions;
    const missingFields = [];
    for (const field of requiredMetaFields) {
      if (!Object.hasOwn(file.meta, field) || file.meta[field] === "") {
        missingFields.push(field);
      }
    }
    return {
      missingFields,
      error
    };
  }
};

// ../../node_modules/@uppy/core/lib/locale.js
var locale_default2 = {
  strings: {
    addBulkFilesFailed: {
      0: "Failed to add %{smart_count} file due to an internal error",
      1: "Failed to add %{smart_count} files due to internal errors"
    },
    youCanOnlyUploadX: {
      0: "You can only upload %{smart_count} file",
      1: "You can only upload %{smart_count} files"
    },
    youHaveToAtLeastSelectX: {
      0: "You have to select at least %{smart_count} file",
      1: "You have to select at least %{smart_count} files"
    },
    exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
    missingRequiredMetaField: "Missing required meta fields",
    missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
    inferiorSize: "This file is smaller than the allowed size of %{size}",
    youCanOnlyUploadFileTypes: "You can only upload: %{types}",
    noMoreFilesAllowed: "Cannot add more files",
    noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
    companionError: "Connection with Companion failed",
    authAborted: "Authentication aborted",
    companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
    failedToUpload: "Failed to upload %{file}",
    noInternetConnection: "No Internet connection",
    connectedToInternet: "Connected to the Internet",
    // Strings for remote providers
    noFilesFound: "You have no files or folders here",
    noSearchResults: "Unfortunately, there are no results for this search",
    selectX: {
      0: "Select %{smart_count}",
      1: "Select %{smart_count}"
    },
    allFilesFromFolderNamed: "All files from folder %{name}",
    openFolderNamed: "Open folder %{name}",
    cancel: "Cancel",
    logOut: "Log out",
    filter: "Filter",
    resetFilter: "Reset filter",
    loading: "Loading...",
    loadedXFiles: "Loaded %{numFiles} files",
    authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
    authenticateWith: "Connect to %{pluginName}",
    signInWithGoogle: "Sign in with Google",
    searchImages: "Search for images",
    enterTextToSearch: "Enter text to search for images",
    search: "Search",
    resetSearch: "Reset search",
    emptyFolderAdded: "No files were added from empty folder",
    addedNumFiles: "Added %{numFiles} file(s)",
    folderAlreadyAdded: 'The folder "%{folder}" was already added',
    folderAdded: {
      0: "Added %{smart_count} file from %{folder}",
      1: "Added %{smart_count} files from %{folder}"
    },
    additionalRestrictionsFailed: "%{count} additional restrictions were not fulfilled"
  }
};

// ../../node_modules/@uppy/core/lib/Uppy.js
var _Symbol$for5;
var _Symbol$for23;
function _classPrivateFieldLooseBase12(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id12 = 0;
function _classPrivateFieldLooseKey12(name) {
  return "__private_" + id12++ + "_" + name;
}
var packageJson5 = {
  "version": "3.10.1"
};
var defaultUploadState = {
  totalProgress: 0,
  allowNewUpload: true,
  error: null,
  recoveredState: null
};
var _plugins = /* @__PURE__ */ _classPrivateFieldLooseKey12("plugins");
var _restricter = /* @__PURE__ */ _classPrivateFieldLooseKey12("restricter");
var _storeUnsubscribe = /* @__PURE__ */ _classPrivateFieldLooseKey12("storeUnsubscribe");
var _emitter2 = /* @__PURE__ */ _classPrivateFieldLooseKey12("emitter");
var _preProcessors = /* @__PURE__ */ _classPrivateFieldLooseKey12("preProcessors");
var _uploaders = /* @__PURE__ */ _classPrivateFieldLooseKey12("uploaders");
var _postProcessors = /* @__PURE__ */ _classPrivateFieldLooseKey12("postProcessors");
var _informAndEmit = /* @__PURE__ */ _classPrivateFieldLooseKey12("informAndEmit");
var _checkRequiredMetaFieldsOnFile = /* @__PURE__ */ _classPrivateFieldLooseKey12("checkRequiredMetaFieldsOnFile");
var _checkRequiredMetaFields = /* @__PURE__ */ _classPrivateFieldLooseKey12("checkRequiredMetaFields");
var _assertNewUploadAllowed = /* @__PURE__ */ _classPrivateFieldLooseKey12("assertNewUploadAllowed");
var _transformFile = /* @__PURE__ */ _classPrivateFieldLooseKey12("transformFile");
var _startIfAutoProceed = /* @__PURE__ */ _classPrivateFieldLooseKey12("startIfAutoProceed");
var _checkAndUpdateFileState = /* @__PURE__ */ _classPrivateFieldLooseKey12("checkAndUpdateFileState");
var _addListeners = /* @__PURE__ */ _classPrivateFieldLooseKey12("addListeners");
var _updateOnlineStatus = /* @__PURE__ */ _classPrivateFieldLooseKey12("updateOnlineStatus");
var _requestClientById = /* @__PURE__ */ _classPrivateFieldLooseKey12("requestClientById");
var _createUpload3 = /* @__PURE__ */ _classPrivateFieldLooseKey12("createUpload");
var _getUpload = /* @__PURE__ */ _classPrivateFieldLooseKey12("getUpload");
var _removeUpload = /* @__PURE__ */ _classPrivateFieldLooseKey12("removeUpload");
var _runUpload = /* @__PURE__ */ _classPrivateFieldLooseKey12("runUpload");
_Symbol$for5 = Symbol.for("uppy test: getPlugins");
_Symbol$for23 = Symbol.for("uppy test: createUpload");
var Uppy = class _Uppy {
  /**
   * Instantiate Uppy
   */
  constructor(_opts) {
    Object.defineProperty(this, _runUpload, {
      value: _runUpload2
    });
    Object.defineProperty(this, _removeUpload, {
      value: _removeUpload2
    });
    Object.defineProperty(this, _getUpload, {
      value: _getUpload2
    });
    Object.defineProperty(this, _createUpload3, {
      value: _createUpload22
    });
    Object.defineProperty(this, _addListeners, {
      value: _addListeners2
    });
    Object.defineProperty(this, _checkAndUpdateFileState, {
      value: _checkAndUpdateFileState2
    });
    Object.defineProperty(this, _startIfAutoProceed, {
      value: _startIfAutoProceed2
    });
    Object.defineProperty(this, _transformFile, {
      value: _transformFile2
    });
    Object.defineProperty(this, _assertNewUploadAllowed, {
      value: _assertNewUploadAllowed2
    });
    Object.defineProperty(this, _checkRequiredMetaFields, {
      value: _checkRequiredMetaFields2
    });
    Object.defineProperty(this, _checkRequiredMetaFieldsOnFile, {
      value: _checkRequiredMetaFieldsOnFile2
    });
    Object.defineProperty(this, _informAndEmit, {
      value: _informAndEmit2
    });
    Object.defineProperty(this, _plugins, {
      writable: true,
      value: /* @__PURE__ */ Object.create(null)
    });
    Object.defineProperty(this, _restricter, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _storeUnsubscribe, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _emitter2, {
      writable: true,
      value: (0, import_namespace_emitter2.default)()
    });
    Object.defineProperty(this, _preProcessors, {
      writable: true,
      value: /* @__PURE__ */ new Set()
    });
    Object.defineProperty(this, _uploaders, {
      writable: true,
      value: /* @__PURE__ */ new Set()
    });
    Object.defineProperty(this, _postProcessors, {
      writable: true,
      value: /* @__PURE__ */ new Set()
    });
    this.scheduledAutoProceed = null;
    this.wasOffline = false;
    this.calculateProgress = (0, import_throttle2.default)((file, data) => {
      const fileInState = this.getFile(file == null ? void 0 : file.id);
      if (file == null || !fileInState) {
        this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
        return;
      }
      if (fileInState.progress.percentage === 100) {
        this.log(`Not setting progress for a file that has been already uploaded: ${file.id}`);
        return;
      }
      const canHavePercentage = Number.isFinite(data.bytesTotal) && data.bytesTotal > 0;
      this.setFileState(file.id, {
        progress: {
          ...fileInState.progress,
          bytesUploaded: data.bytesUploaded,
          bytesTotal: data.bytesTotal,
          percentage: canHavePercentage ? Math.round(data.bytesUploaded / data.bytesTotal * 100) : 0
        }
      });
      this.calculateTotalProgress();
    }, 500, {
      leading: true,
      trailing: true
    });
    Object.defineProperty(this, _updateOnlineStatus, {
      writable: true,
      value: this.updateOnlineStatus.bind(this)
    });
    Object.defineProperty(this, _requestClientById, {
      writable: true,
      value: /* @__PURE__ */ new Map()
    });
    this.defaultLocale = locale_default2;
    const defaultOptions11 = {
      id: "uppy",
      autoProceed: false,
      allowMultipleUploadBatches: true,
      debug: false,
      restrictions: defaultOptions2,
      meta: {},
      onBeforeFileAdded: (file, files) => !Object.hasOwn(files, file.id),
      onBeforeUpload: (files) => files,
      store: new lib_default(),
      logger: justErrorsLogger,
      infoTimeout: 5e3
    };
    const merged = {
      ...defaultOptions11,
      ..._opts
    };
    this.opts = {
      ...merged,
      restrictions: {
        ...defaultOptions11.restrictions,
        ..._opts && _opts.restrictions
      }
    };
    if (_opts && _opts.logger && _opts.debug) {
      this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning");
    } else if (_opts && _opts.debug) {
      this.opts.logger = debugLogger;
    }
    this.log(`Using Core v${_Uppy.VERSION}`);
    this.i18nInit();
    this.store = this.opts.store;
    this.setState({
      ...defaultUploadState,
      plugins: {},
      files: {},
      currentUploads: {},
      capabilities: {
        uploadProgress: supportsUploadProgress(),
        individualCancellation: true,
        resumableUploads: false
      },
      meta: {
        ...this.opts.meta
      },
      info: []
    });
    _classPrivateFieldLooseBase12(this, _restricter)[_restricter] = new Restricter(() => this.opts, this.i18n);
    _classPrivateFieldLooseBase12(this, _storeUnsubscribe)[_storeUnsubscribe] = this.store.subscribe(
      // eslint-disable-next-line
      // @ts-ignore Store is incorrectly typed
      (prevState, nextState, patch) => {
        this.emit("state-update", prevState, nextState, patch);
        this.updateAll(nextState);
      }
    );
    if (this.opts.debug && typeof window !== "undefined") {
      window[this.opts.id] = this;
    }
    _classPrivateFieldLooseBase12(this, _addListeners)[_addListeners]();
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    _classPrivateFieldLooseBase12(this, _emitter2)[_emitter2].emit(event, ...args);
  }
  on(event, callback) {
    _classPrivateFieldLooseBase12(this, _emitter2)[_emitter2].on(event, callback);
    return this;
  }
  once(event, callback) {
    _classPrivateFieldLooseBase12(this, _emitter2)[_emitter2].once(event, callback);
    return this;
  }
  off(event, callback) {
    _classPrivateFieldLooseBase12(this, _emitter2)[_emitter2].off(event, callback);
    return this;
  }
  /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */
  updateAll(state) {
    this.iteratePlugins((plugin) => {
      plugin.update(state);
    });
  }
  /**
   * Updates state with a patch
   */
  setState(patch) {
    this.store.setState(patch);
  }
  /**
   * Returns current state.
   */
  getState() {
    return this.store.getState();
  }
  patchFilesState(filesWithNewState) {
    const existingFilesState = this.getState().files;
    this.setState({
      files: {
        ...existingFilesState,
        ...Object.fromEntries(Object.entries(filesWithNewState).map((_ref) => {
          let [fileID, newFileState] = _ref;
          return [fileID, {
            ...existingFilesState[fileID],
            ...newFileState
          }];
        }))
      }
    });
  }
  /**
   * Shorthand to set state for a specific file.
   */
  setFileState(fileID, state) {
    if (!this.getState().files[fileID]) {
      throw new Error(`Can\u2019t set state for ${fileID} (the file could have been removed)`);
    }
    this.patchFilesState({
      [fileID]: state
    });
  }
  i18nInit() {
    const onMissingKey = (key) => this.log(`Missing i18n string: ${key}`, "error");
    const translator = new Translator([this.defaultLocale, this.opts.locale], {
      onMissingKey
    });
    this.i18n = translator.translate.bind(translator);
    this.i18nArray = translator.translateArray.bind(translator);
    this.locale = translator.locale;
  }
  setOptions(newOpts) {
    this.opts = {
      ...this.opts,
      ...newOpts,
      restrictions: {
        ...this.opts.restrictions,
        ...newOpts == null ? void 0 : newOpts.restrictions
      }
    };
    if (newOpts.meta) {
      this.setMeta(newOpts.meta);
    }
    this.i18nInit();
    if (newOpts.locale) {
      this.iteratePlugins((plugin) => {
        plugin.setOptions(newOpts);
      });
    }
    this.setState(void 0);
  }
  // todo next major: remove
  resetProgress() {
    const defaultProgress = {
      percentage: 0,
      bytesUploaded: 0,
      uploadComplete: false,
      uploadStarted: null
    };
    const files = {
      ...this.getState().files
    };
    const updatedFiles = {};
    Object.keys(files).forEach((fileID) => {
      updatedFiles[fileID] = {
        ...files[fileID],
        progress: {
          ...files[fileID].progress,
          ...defaultProgress
        }
      };
    });
    this.setState({
      files: updatedFiles,
      ...defaultUploadState
    });
    this.emit("reset-progress");
  }
  // @todo next major: rename to `clear()`, make it also cancel ongoing uploads
  // or throw and say you need to cancel manually
  clearUploadedFiles() {
    this.setState({
      ...defaultUploadState,
      files: {}
    });
  }
  addPreProcessor(fn) {
    _classPrivateFieldLooseBase12(this, _preProcessors)[_preProcessors].add(fn);
  }
  removePreProcessor(fn) {
    return _classPrivateFieldLooseBase12(this, _preProcessors)[_preProcessors].delete(fn);
  }
  addPostProcessor(fn) {
    _classPrivateFieldLooseBase12(this, _postProcessors)[_postProcessors].add(fn);
  }
  removePostProcessor(fn) {
    return _classPrivateFieldLooseBase12(this, _postProcessors)[_postProcessors].delete(fn);
  }
  addUploader(fn) {
    _classPrivateFieldLooseBase12(this, _uploaders)[_uploaders].add(fn);
  }
  removeUploader(fn) {
    return _classPrivateFieldLooseBase12(this, _uploaders)[_uploaders].delete(fn);
  }
  setMeta(data) {
    const updatedMeta = {
      ...this.getState().meta,
      ...data
    };
    const updatedFiles = {
      ...this.getState().files
    };
    Object.keys(updatedFiles).forEach((fileID) => {
      updatedFiles[fileID] = {
        ...updatedFiles[fileID],
        meta: {
          ...updatedFiles[fileID].meta,
          ...data
        }
      };
    });
    this.log("Adding metadata:");
    this.log(data);
    this.setState({
      meta: updatedMeta,
      files: updatedFiles
    });
  }
  setFileMeta(fileID, data) {
    const updatedFiles = {
      ...this.getState().files
    };
    if (!updatedFiles[fileID]) {
      this.log("Was trying to set metadata for a file that has been removed: ", fileID);
      return;
    }
    const newMeta = {
      ...updatedFiles[fileID].meta,
      ...data
    };
    updatedFiles[fileID] = {
      ...updatedFiles[fileID],
      meta: newMeta
    };
    this.setState({
      files: updatedFiles
    });
  }
  /**
   * Get a file object.
   */
  getFile(fileID) {
    return this.getState().files[fileID];
  }
  /**
   * Get all files in an array.
   */
  getFiles() {
    const {
      files
    } = this.getState();
    return Object.values(files);
  }
  getFilesByIds(ids) {
    return ids.map((id18) => this.getFile(id18));
  }
  // TODO: remove or refactor this method. It's very inefficient
  getObjectOfFilesPerState() {
    const {
      files: filesObject,
      totalProgress,
      error
    } = this.getState();
    const files = Object.values(filesObject);
    const inProgressFiles = files.filter((_ref2) => {
      let {
        progress
      } = _ref2;
      return !progress.uploadComplete && progress.uploadStarted;
    });
    const newFiles = files.filter((file) => !file.progress.uploadStarted);
    const startedFiles = files.filter((file) => file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess);
    const uploadStartedFiles = files.filter((file) => file.progress.uploadStarted);
    const pausedFiles = files.filter((file) => file.isPaused);
    const completeFiles = files.filter((file) => file.progress.uploadComplete);
    const erroredFiles = files.filter((file) => file.error);
    const inProgressNotPausedFiles = inProgressFiles.filter((file) => !file.isPaused);
    const processingFiles = files.filter((file) => file.progress.preprocess || file.progress.postprocess);
    return {
      newFiles,
      startedFiles,
      uploadStartedFiles,
      pausedFiles,
      completeFiles,
      erroredFiles,
      inProgressFiles,
      inProgressNotPausedFiles,
      processingFiles,
      isUploadStarted: uploadStartedFiles.length > 0,
      isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
      isAllErrored: !!error && erroredFiles.length === files.length,
      isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
      isUploadInProgress: inProgressFiles.length > 0,
      isSomeGhost: files.some((file) => file.isGhost)
    };
  }
  validateRestrictions(file, files) {
    if (files === void 0) {
      files = this.getFiles();
    }
    try {
      _classPrivateFieldLooseBase12(this, _restricter)[_restricter].validate(files, [file]);
    } catch (err) {
      return err;
    }
    return null;
  }
  checkIfFileAlreadyExists(fileID) {
    const {
      files
    } = this.getState();
    if (files[fileID] && !files[fileID].isGhost) {
      return true;
    }
    return false;
  }
  /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   */
  addFile(file) {
    _classPrivateFieldLooseBase12(this, _assertNewUploadAllowed)[_assertNewUploadAllowed](file);
    const {
      nextFilesState,
      validFilesToAdd,
      errors
    } = _classPrivateFieldLooseBase12(this, _checkAndUpdateFileState)[_checkAndUpdateFileState]([file]);
    const restrictionErrors = errors.filter((error) => error.isRestriction);
    _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit](restrictionErrors);
    if (errors.length > 0)
      throw errors[0];
    this.setState({
      files: nextFilesState
    });
    const [firstValidFileToAdd] = validFilesToAdd;
    this.emit("file-added", firstValidFileToAdd);
    this.emit("files-added", validFilesToAdd);
    this.log(`Added file: ${firstValidFileToAdd.name}, ${firstValidFileToAdd.id}, mime type: ${firstValidFileToAdd.type}`);
    _classPrivateFieldLooseBase12(this, _startIfAutoProceed)[_startIfAutoProceed]();
    return firstValidFileToAdd.id;
  }
  /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */
  addFiles(fileDescriptors) {
    _classPrivateFieldLooseBase12(this, _assertNewUploadAllowed)[_assertNewUploadAllowed]();
    const {
      nextFilesState,
      validFilesToAdd,
      errors
    } = _classPrivateFieldLooseBase12(this, _checkAndUpdateFileState)[_checkAndUpdateFileState](fileDescriptors);
    const restrictionErrors = errors.filter((error) => error.isRestriction);
    _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit](restrictionErrors);
    const nonRestrictionErrors = errors.filter((error) => !error.isRestriction);
    if (nonRestrictionErrors.length > 0) {
      let message = "Multiple errors occurred while adding files:\n";
      nonRestrictionErrors.forEach((subError) => {
        message += `
 * ${subError.message}`;
      });
      this.info({
        message: this.i18n("addBulkFilesFailed", {
          smart_count: nonRestrictionErrors.length
        }),
        details: message
      }, "error", this.opts.infoTimeout);
      if (typeof AggregateError === "function") {
        throw new AggregateError(nonRestrictionErrors, message);
      } else {
        const err = new Error(message);
        err.errors = nonRestrictionErrors;
        throw err;
      }
    }
    this.setState({
      files: nextFilesState
    });
    validFilesToAdd.forEach((file) => {
      this.emit("file-added", file);
    });
    this.emit("files-added", validFilesToAdd);
    if (validFilesToAdd.length > 5) {
      this.log(`Added batch of ${validFilesToAdd.length} files`);
    } else {
      Object.values(validFilesToAdd).forEach((file) => {
        this.log(`Added file: ${file.name}
 id: ${file.id}
 type: ${file.type}`);
      });
    }
    if (validFilesToAdd.length > 0) {
      _classPrivateFieldLooseBase12(this, _startIfAutoProceed)[_startIfAutoProceed]();
    }
  }
  removeFiles(fileIDs, reason) {
    const {
      files,
      currentUploads
    } = this.getState();
    const updatedFiles = {
      ...files
    };
    const updatedUploads = {
      ...currentUploads
    };
    const removedFiles = /* @__PURE__ */ Object.create(null);
    fileIDs.forEach((fileID) => {
      if (files[fileID]) {
        removedFiles[fileID] = files[fileID];
        delete updatedFiles[fileID];
      }
    });
    function fileIsNotRemoved(uploadFileID) {
      return removedFiles[uploadFileID] === void 0;
    }
    Object.keys(updatedUploads).forEach((uploadID) => {
      const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved);
      if (newFileIDs.length === 0) {
        delete updatedUploads[uploadID];
        return;
      }
      const {
        capabilities
      } = this.getState();
      if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) {
        throw new Error("individualCancellation is disabled");
      }
      updatedUploads[uploadID] = {
        ...currentUploads[uploadID],
        fileIDs: newFileIDs
      };
    });
    const stateUpdate = {
      currentUploads: updatedUploads,
      files: updatedFiles
    };
    if (Object.keys(updatedFiles).length === 0) {
      stateUpdate.allowNewUpload = true;
      stateUpdate.error = null;
      stateUpdate.recoveredState = null;
    }
    this.setState(stateUpdate);
    this.calculateTotalProgress();
    const removedFileIDs = Object.keys(removedFiles);
    removedFileIDs.forEach((fileID) => {
      this.emit("file-removed", removedFiles[fileID], reason);
    });
    if (removedFileIDs.length > 5) {
      this.log(`Removed ${removedFileIDs.length} files`);
    } else {
      this.log(`Removed files: ${removedFileIDs.join(", ")}`);
    }
  }
  removeFile(fileID, reason) {
    this.removeFiles([fileID], reason);
  }
  pauseResume(fileID) {
    if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).progress.uploadComplete) {
      return void 0;
    }
    const wasPaused = this.getFile(fileID).isPaused || false;
    const isPaused = !wasPaused;
    this.setFileState(fileID, {
      isPaused
    });
    this.emit("upload-pause", fileID, isPaused);
    return isPaused;
  }
  pauseAll() {
    const updatedFiles = {
      ...this.getState().files
    };
    const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file) => {
      return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
    });
    inProgressUpdatedFiles.forEach((file) => {
      const updatedFile = {
        ...updatedFiles[file],
        isPaused: true
      };
      updatedFiles[file] = updatedFile;
    });
    this.setState({
      files: updatedFiles
    });
    this.emit("pause-all");
  }
  resumeAll() {
    const updatedFiles = {
      ...this.getState().files
    };
    const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file) => {
      return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
    });
    inProgressUpdatedFiles.forEach((file) => {
      const updatedFile = {
        ...updatedFiles[file],
        isPaused: false,
        error: null
      };
      updatedFiles[file] = updatedFile;
    });
    this.setState({
      files: updatedFiles
    });
    this.emit("resume-all");
  }
  retryAll() {
    const updatedFiles = {
      ...this.getState().files
    };
    const filesToRetry = Object.keys(updatedFiles).filter((file) => {
      return updatedFiles[file].error;
    });
    filesToRetry.forEach((file) => {
      const updatedFile = {
        ...updatedFiles[file],
        isPaused: false,
        error: null
      };
      updatedFiles[file] = updatedFile;
    });
    this.setState({
      files: updatedFiles,
      error: null
    });
    this.emit("retry-all", filesToRetry);
    if (filesToRetry.length === 0) {
      return Promise.resolve({
        successful: [],
        failed: []
      });
    }
    const uploadID = _classPrivateFieldLooseBase12(this, _createUpload3)[_createUpload3](filesToRetry, {
      forceAllowNewUpload: true
      // create new upload even if allowNewUpload: false
    });
    return _classPrivateFieldLooseBase12(this, _runUpload)[_runUpload](uploadID);
  }
  cancelAll(_temp) {
    let {
      reason = "user"
    } = _temp === void 0 ? {} : _temp;
    this.emit("cancel-all", {
      reason
    });
    if (reason === "user") {
      const {
        files
      } = this.getState();
      const fileIDs = Object.keys(files);
      if (fileIDs.length) {
        this.removeFiles(fileIDs, "cancel-all");
      }
      this.setState(defaultUploadState);
    }
  }
  retryUpload(fileID) {
    this.setFileState(fileID, {
      error: null,
      isPaused: false
    });
    this.emit("upload-retry", fileID);
    const uploadID = _classPrivateFieldLooseBase12(this, _createUpload3)[_createUpload3]([fileID], {
      forceAllowNewUpload: true
      // create new upload even if allowNewUpload: false
    });
    return _classPrivateFieldLooseBase12(this, _runUpload)[_runUpload](uploadID);
  }
  logout() {
    this.iteratePlugins((plugin) => {
      var _provider;
      ;
      (_provider = plugin.provider) == null || _provider.logout == null || _provider.logout();
    });
  }
  calculateTotalProgress() {
    const files = this.getFiles();
    const inProgress = files.filter((file) => {
      return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
    });
    if (inProgress.length === 0) {
      this.emit("progress", 0);
      this.setState({
        totalProgress: 0
      });
      return;
    }
    const sizedFiles = inProgress.filter((file) => file.progress.bytesTotal != null);
    const unsizedFiles = inProgress.filter((file) => file.progress.bytesTotal == null);
    if (sizedFiles.length === 0) {
      const progressMax = inProgress.length * 100;
      const currentProgress = unsizedFiles.reduce((acc, file) => {
        return acc + file.progress.percentage;
      }, 0);
      const totalProgress2 = Math.round(currentProgress / progressMax * 100);
      this.setState({
        totalProgress: totalProgress2
      });
      return;
    }
    let totalSize = sizedFiles.reduce((acc, file) => {
      var _file$progress$bytesT;
      return acc + ((_file$progress$bytesT = file.progress.bytesTotal) != null ? _file$progress$bytesT : 0);
    }, 0);
    const averageSize = totalSize / sizedFiles.length;
    totalSize += averageSize * unsizedFiles.length;
    let uploadedSize = 0;
    sizedFiles.forEach((file) => {
      uploadedSize += file.progress.bytesUploaded;
    });
    unsizedFiles.forEach((file) => {
      uploadedSize += averageSize * (file.progress.percentage || 0) / 100;
    });
    let totalProgress = totalSize === 0 ? 0 : Math.round(uploadedSize / totalSize * 100);
    if (totalProgress > 100) {
      totalProgress = 100;
    }
    this.setState({
      totalProgress
    });
    this.emit("progress", totalProgress);
  }
  updateOnlineStatus() {
    var _window$navigator$onL;
    const online = (_window$navigator$onL = window.navigator.onLine) != null ? _window$navigator$onL : true;
    if (!online) {
      this.emit("is-offline");
      this.info(this.i18n("noInternetConnection"), "error", 0);
      this.wasOffline = true;
    } else {
      this.emit("is-online");
      if (this.wasOffline) {
        this.emit("back-online");
        this.info(this.i18n("connectedToInternet"), "success", 3e3);
        this.wasOffline = false;
      }
    }
  }
  getID() {
    return this.opts.id;
  }
  /**
   * Registers a plugin with Core.
   */
  use(Plugin, opts) {
    if (typeof Plugin !== "function") {
      const msg = `Expected a plugin class, but got ${Plugin === null ? "null" : typeof Plugin}. Please verify that the plugin was imported and spelled correctly.`;
      throw new TypeError(msg);
    }
    const plugin = new Plugin(this, opts);
    const pluginId = plugin.id;
    if (!pluginId) {
      throw new Error("Your plugin must have an id");
    }
    if (!plugin.type) {
      throw new Error("Your plugin must have a type");
    }
    const existsPluginAlready = this.getPlugin(pluginId);
    if (existsPluginAlready) {
      const msg = `Already found a plugin named '${existsPluginAlready.id}'. Tried to use: '${pluginId}'.
Uppy plugins must have unique \`id\` options. See https://uppy.io/docs/plugins/#id.`;
      throw new Error(msg);
    }
    if (Plugin.VERSION) {
      this.log(`Using ${pluginId} v${Plugin.VERSION}`);
    }
    if (plugin.type in _classPrivateFieldLooseBase12(this, _plugins)[_plugins]) {
      _classPrivateFieldLooseBase12(this, _plugins)[_plugins][plugin.type].push(plugin);
    } else {
      _classPrivateFieldLooseBase12(this, _plugins)[_plugins][plugin.type] = [plugin];
    }
    plugin.install();
    this.emit("plugin-added", plugin);
    return this;
  }
  /**
   * Find one Plugin by name.
   */
  getPlugin(id18) {
    for (const plugins2 of Object.values(_classPrivateFieldLooseBase12(this, _plugins)[_plugins])) {
      const foundPlugin = plugins2.find((plugin) => plugin.id === id18);
      if (foundPlugin != null)
        return foundPlugin;
    }
    return void 0;
  }
  [_Symbol$for5](type) {
    return _classPrivateFieldLooseBase12(this, _plugins)[_plugins][type];
  }
  /**
   * Iterate through all `use`d plugins.
   *
   */
  iteratePlugins(method) {
    Object.values(_classPrivateFieldLooseBase12(this, _plugins)[_plugins]).flat(1).forEach(method);
  }
  /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */
  removePlugin(instance) {
    this.log(`Removing plugin ${instance.id}`);
    this.emit("plugin-remove", instance);
    if (instance.uninstall) {
      instance.uninstall();
    }
    const list = _classPrivateFieldLooseBase12(this, _plugins)[_plugins][instance.type];
    const index = list.findIndex((item) => item.id === instance.id);
    if (index !== -1) {
      list.splice(index, 1);
    }
    const state = this.getState();
    const updatedState = {
      plugins: {
        ...state.plugins,
        [instance.id]: void 0
      }
    };
    this.setState(updatedState);
  }
  /**
   * Uninstall all plugins and close down this Uppy instance.
   */
  // @todo next major: rename to `destroy`.
  // Cancel local uploads, cancel remote uploads, DON'T cancel assemblies
  // document that if you do want to cancel assemblies, you need to call smth manually.
  // Potentially remove reason, as it’s confusing, just come up with a default behaviour.
  close(_temp2) {
    let {
      reason
    } = _temp2 === void 0 ? {} : _temp2;
    this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
    this.cancelAll({
      reason
    });
    _classPrivateFieldLooseBase12(this, _storeUnsubscribe)[_storeUnsubscribe]();
    this.iteratePlugins((plugin) => {
      this.removePlugin(plugin);
    });
    if (typeof window !== "undefined" && window.removeEventListener) {
      window.removeEventListener("online", _classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus]);
      window.removeEventListener("offline", _classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus]);
    }
  }
  hideInfo() {
    const {
      info
    } = this.getState();
    this.setState({
      info: info.slice(1)
    });
    this.emit("info-hidden");
  }
  /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   */
  info(message, type, duration2) {
    if (type === void 0) {
      type = "info";
    }
    if (duration2 === void 0) {
      duration2 = 3e3;
    }
    const isComplexMessage = typeof message === "object";
    this.setState({
      info: [...this.getState().info, {
        type,
        message: isComplexMessage ? message.message : message,
        details: isComplexMessage ? message.details : null
      }]
    });
    setTimeout(() => this.hideInfo(), duration2);
    this.emit("info-visible");
  }
  /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   */
  log(message, type) {
    const {
      logger
    } = this.opts;
    switch (type) {
      case "error":
        logger.error(message);
        break;
      case "warning":
        logger.warn(message);
        break;
      default:
        logger.debug(message);
        break;
    }
  }
  registerRequestClient(id18, client) {
    _classPrivateFieldLooseBase12(this, _requestClientById)[_requestClientById].set(id18, client);
  }
  /** @protected */
  getRequestClientForFile(file) {
    if (!file.remote)
      throw new Error(`Tried to get RequestClient for a non-remote file ${file.id}`);
    const requestClient = _classPrivateFieldLooseBase12(this, _requestClientById)[_requestClientById].get(file.remote.requestClientId);
    if (requestClient == null)
      throw new Error(`requestClientId "${file.remote.requestClientId}" not registered for file "${file.id}"`);
    return requestClient;
  }
  /**
   * Restore an upload by its ID.
   */
  restore(uploadID) {
    this.log(`Core: attempting to restore upload "${uploadID}"`);
    if (!this.getState().currentUploads[uploadID]) {
      _classPrivateFieldLooseBase12(this, _removeUpload)[_removeUpload](uploadID);
      return Promise.reject(new Error("Nonexistent upload"));
    }
    return _classPrivateFieldLooseBase12(this, _runUpload)[_runUpload](uploadID);
  }
  [_Symbol$for23]() {
    return _classPrivateFieldLooseBase12(this, _createUpload3)[_createUpload3](...arguments);
  }
  /**
   * Add data to an upload's result object.
   */
  addResultData(uploadID, data) {
    if (!_classPrivateFieldLooseBase12(this, _getUpload)[_getUpload](uploadID)) {
      this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
      return;
    }
    const {
      currentUploads
    } = this.getState();
    const currentUpload = {
      ...currentUploads[uploadID],
      result: {
        ...currentUploads[uploadID].result,
        ...data
      }
    };
    this.setState({
      currentUploads: {
        ...currentUploads,
        [uploadID]: currentUpload
      }
    });
  }
  /**
   * Start an upload for all the files that are not currently being uploaded.
   */
  upload() {
    var _classPrivateFieldLoo;
    if (!((_classPrivateFieldLoo = _classPrivateFieldLooseBase12(this, _plugins)[_plugins]["uploader"]) != null && _classPrivateFieldLoo.length)) {
      this.log("No uploader type plugins are used", "warning");
    }
    let {
      files
    } = this.getState();
    const onBeforeUploadResult = this.opts.onBeforeUpload(files);
    if (onBeforeUploadResult === false) {
      return Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false"));
    }
    if (onBeforeUploadResult && typeof onBeforeUploadResult === "object") {
      files = onBeforeUploadResult;
      this.setState({
        files
      });
    }
    return Promise.resolve().then(() => _classPrivateFieldLooseBase12(this, _restricter)[_restricter].validateMinNumberOfFiles(files)).catch((err) => {
      _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit]([err]);
      throw err;
    }).then(() => {
      if (!_classPrivateFieldLooseBase12(this, _checkRequiredMetaFields)[_checkRequiredMetaFields](files)) {
        throw new RestrictionError(this.i18n("missingRequiredMetaField"));
      }
    }).catch((err) => {
      throw err;
    }).then(() => {
      const {
        currentUploads
      } = this.getState();
      const currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr) => curr.fileIDs);
      const waitingFileIDs = [];
      Object.keys(files).forEach((fileID) => {
        const file = this.getFile(fileID);
        if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) {
          waitingFileIDs.push(file.id);
        }
      });
      const uploadID = _classPrivateFieldLooseBase12(this, _createUpload3)[_createUpload3](waitingFileIDs);
      return _classPrivateFieldLooseBase12(this, _runUpload)[_runUpload](uploadID);
    }).catch((err) => {
      this.emit("error", err);
      this.log(err, "error");
      throw err;
    });
  }
};
function _informAndEmit2(errors) {
  for (const error of errors) {
    if (error.isRestriction) {
      this.emit("restriction-failed", error.file, error);
    } else {
      this.emit("error", error, error.file);
    }
    this.log(error, "warning");
  }
  const userFacingErrors = errors.filter((error) => error.isUserFacing);
  const maxNumToShow = 4;
  const firstErrors = userFacingErrors.slice(0, maxNumToShow);
  const additionalErrors = userFacingErrors.slice(maxNumToShow);
  firstErrors.forEach((_ref3) => {
    let {
      message,
      details = ""
    } = _ref3;
    this.info({
      message,
      details
    }, "error", this.opts.infoTimeout);
  });
  if (additionalErrors.length > 0) {
    this.info({
      message: this.i18n("additionalRestrictionsFailed", {
        count: additionalErrors.length
      })
    });
  }
}
function _checkRequiredMetaFieldsOnFile2(file) {
  const {
    missingFields,
    error
  } = _classPrivateFieldLooseBase12(this, _restricter)[_restricter].getMissingRequiredMetaFields(file);
  if (missingFields.length > 0) {
    this.setFileState(file.id, {
      missingRequiredMetaFields: missingFields
    });
    this.log(error.message);
    this.emit("restriction-failed", file, error);
    return false;
  }
  return true;
}
function _checkRequiredMetaFields2(files) {
  let success = true;
  for (const file of Object.values(files)) {
    if (!_classPrivateFieldLooseBase12(this, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file)) {
      success = false;
    }
  }
  return success;
}
function _assertNewUploadAllowed2(file) {
  const {
    allowNewUpload
  } = this.getState();
  if (allowNewUpload === false) {
    const error = new RestrictionError(this.i18n("noMoreFilesAllowed"), {
      file
    });
    _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit]([error]);
    throw error;
  }
}
function _transformFile2(fileDescriptorOrFile) {
  const file = fileDescriptorOrFile instanceof File ? {
    name: fileDescriptorOrFile.name,
    type: fileDescriptorOrFile.type,
    size: fileDescriptorOrFile.size,
    data: fileDescriptorOrFile
  } : fileDescriptorOrFile;
  const fileType = getFileType(file);
  const fileName = getFileName(fileType, file);
  const fileExtension = getFileNameAndExtension(fileName).extension;
  const id18 = getSafeFileId(file);
  const meta = file.meta || {};
  meta.name = fileName;
  meta.type = fileType;
  const size = Number.isFinite(file.data.size) ? file.data.size : null;
  return {
    source: file.source || "",
    id: id18,
    name: fileName,
    extension: fileExtension || "",
    meta: {
      ...this.getState().meta,
      ...meta
    },
    type: fileType,
    data: file.data,
    progress: {
      percentage: 0,
      bytesUploaded: 0,
      bytesTotal: size,
      uploadComplete: false,
      uploadStarted: null
    },
    size,
    isGhost: false,
    isRemote: file.isRemote || false,
    // TODO: this should not be a string
    // @ts-expect-error wrong
    remote: file.remote || "",
    preview: file.preview
  };
}
function _startIfAutoProceed2() {
  if (this.opts.autoProceed && !this.scheduledAutoProceed) {
    this.scheduledAutoProceed = setTimeout(() => {
      this.scheduledAutoProceed = null;
      this.upload().catch((err) => {
        if (!err.isRestriction) {
          this.log(err.stack || err.message || err);
        }
      });
    }, 4);
  }
}
function _checkAndUpdateFileState2(filesToAdd) {
  const {
    files: existingFiles
  } = this.getState();
  const nextFilesState = {
    ...existingFiles
  };
  const validFilesToAdd = [];
  const errors = [];
  for (const fileToAdd of filesToAdd) {
    try {
      var _existingFiles$newFil;
      let newFile = _classPrivateFieldLooseBase12(this, _transformFile)[_transformFile](fileToAdd);
      const isGhost = (_existingFiles$newFil = existingFiles[newFile.id]) == null ? void 0 : _existingFiles$newFil.isGhost;
      if (isGhost) {
        const existingFileState = existingFiles[newFile.id];
        newFile = {
          ...existingFileState,
          isGhost: false,
          data: fileToAdd.data
        };
        this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
      }
      const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);
      if (!onBeforeFileAddedResult && this.checkIfFileAlreadyExists(newFile.id)) {
        throw new RestrictionError(this.i18n("noDuplicates", {
          fileName: newFile.name
        }), {
          file: fileToAdd
        });
      }
      if (onBeforeFileAddedResult === false && !isGhost) {
        throw new RestrictionError("Cannot add the file because onBeforeFileAdded returned false.", {
          isUserFacing: false,
          file: fileToAdd
        });
      } else if (typeof onBeforeFileAddedResult === "object" && onBeforeFileAddedResult !== null) {
        newFile = onBeforeFileAddedResult;
      }
      _classPrivateFieldLooseBase12(this, _restricter)[_restricter].validateSingleFile(newFile);
      nextFilesState[newFile.id] = newFile;
      validFilesToAdd.push(newFile);
    } catch (err) {
      errors.push(err);
    }
  }
  try {
    _classPrivateFieldLooseBase12(this, _restricter)[_restricter].validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
  } catch (err) {
    errors.push(err);
    return {
      nextFilesState: existingFiles,
      validFilesToAdd: [],
      errors
    };
  }
  return {
    nextFilesState,
    validFilesToAdd,
    errors
  };
}
function _addListeners2() {
  const errorHandler = (error, file, response) => {
    let errorMsg = error.message || "Unknown error";
    if (error.details) {
      errorMsg += ` ${error.details}`;
    }
    this.setState({
      error: errorMsg
    });
    if (file != null && file.id in this.getState().files) {
      this.setFileState(file.id, {
        error: errorMsg,
        response
      });
    }
  };
  this.on("error", errorHandler);
  this.on("upload-error", (file, error, response) => {
    errorHandler(error, file, response);
    if (typeof error === "object" && error.message) {
      var _file$name;
      this.log(error.message, "error");
      const newError = new Error(this.i18n("failedToUpload", {
        file: (_file$name = file == null ? void 0 : file.name) != null ? _file$name : ""
      }));
      newError.isUserFacing = true;
      newError.details = error.message;
      if (error.details) {
        newError.details += ` ${error.details}`;
      }
      _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit]([newError]);
    } else {
      _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit]([error]);
    }
  });
  let uploadStalledWarningRecentlyEmitted = null;
  this.on("upload-stalled", (error, files) => {
    const {
      message
    } = error;
    const details = files.map((file) => file.meta.name).join(", ");
    if (!uploadStalledWarningRecentlyEmitted) {
      this.info({
        message,
        details
      }, "warning", this.opts.infoTimeout);
      uploadStalledWarningRecentlyEmitted = setTimeout(() => {
        uploadStalledWarningRecentlyEmitted = null;
      }, this.opts.infoTimeout);
    }
    this.log(`${message} ${details}`.trim(), "warning");
  });
  this.on("upload", () => {
    this.setState({
      error: null
    });
  });
  const onUploadStarted = (files) => {
    const filesFiltered = files.filter((file) => {
      const exists = file != null && this.getFile(file.id);
      if (!exists)
        this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return exists;
    });
    const filesState = Object.fromEntries(filesFiltered.map((file) => [file.id, {
      progress: {
        uploadStarted: Date.now(),
        uploadComplete: false,
        percentage: 0,
        bytesUploaded: 0,
        bytesTotal: file.size
      }
    }]));
    this.patchFilesState(filesState);
  };
  this.on("upload-start", (files) => {
    files.forEach((file) => {
      this.emit("upload-started", file);
    });
    onUploadStarted(files);
  });
  this.on("upload-progress", this.calculateProgress);
  this.on("upload-success", (file, uploadResp) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    const currentProgress = this.getFile(file.id).progress;
    this.setFileState(file.id, {
      progress: {
        ...currentProgress,
        postprocess: _classPrivateFieldLooseBase12(this, _postProcessors)[_postProcessors].size > 0 ? {
          mode: "indeterminate"
        } : void 0,
        uploadComplete: true,
        percentage: 100,
        bytesUploaded: currentProgress.bytesTotal
      },
      response: uploadResp,
      uploadURL: uploadResp.uploadURL,
      isPaused: false
    });
    if (file.size == null) {
      this.setFileState(file.id, {
        size: uploadResp.bytesUploaded || currentProgress.bytesTotal
      });
    }
    this.calculateTotalProgress();
  });
  this.on("preprocess-progress", (file, progress) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    this.setFileState(file.id, {
      progress: {
        ...this.getFile(file.id).progress,
        preprocess: progress
      }
    });
  });
  this.on("preprocess-complete", (file) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    const files = {
      ...this.getState().files
    };
    files[file.id] = {
      ...files[file.id],
      progress: {
        ...files[file.id].progress
      }
    };
    delete files[file.id].progress.preprocess;
    this.setState({
      files
    });
  });
  this.on("postprocess-progress", (file, progress) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    this.setFileState(file.id, {
      progress: {
        ...this.getState().files[file.id].progress,
        postprocess: progress
      }
    });
  });
  this.on("postprocess-complete", (file) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    const files = {
      ...this.getState().files
    };
    files[file.id] = {
      ...files[file.id],
      progress: {
        ...files[file.id].progress
      }
    };
    delete files[file.id].progress.postprocess;
    this.setState({
      files
    });
  });
  this.on("restored", () => {
    this.calculateTotalProgress();
  });
  this.on("dashboard:file-edit-complete", (file) => {
    if (file) {
      _classPrivateFieldLooseBase12(this, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file);
    }
  });
  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("online", _classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus]);
    window.addEventListener("offline", _classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus]);
    setTimeout(_classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus], 3e3);
  }
}
function _createUpload22(fileIDs, opts) {
  if (opts === void 0) {
    opts = {};
  }
  const {
    forceAllowNewUpload = false
  } = opts;
  const {
    allowNewUpload,
    currentUploads
  } = this.getState();
  if (!allowNewUpload && !forceAllowNewUpload) {
    throw new Error("Cannot create a new upload: already uploading.");
  }
  const uploadID = nanoid();
  this.emit("upload", {
    id: uploadID,
    fileIDs
  });
  this.setState({
    allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
    currentUploads: {
      ...currentUploads,
      [uploadID]: {
        fileIDs,
        step: 0,
        result: {}
      }
    }
  });
  return uploadID;
}
function _getUpload2(uploadID) {
  const {
    currentUploads
  } = this.getState();
  return currentUploads[uploadID];
}
function _removeUpload2(uploadID) {
  const currentUploads = {
    ...this.getState().currentUploads
  };
  delete currentUploads[uploadID];
  this.setState({
    currentUploads
  });
}
async function _runUpload2(uploadID) {
  const getCurrentUpload = () => {
    const {
      currentUploads
    } = this.getState();
    return currentUploads[uploadID];
  };
  let currentUpload = getCurrentUpload();
  const steps = [..._classPrivateFieldLooseBase12(this, _preProcessors)[_preProcessors], ..._classPrivateFieldLooseBase12(this, _uploaders)[_uploaders], ..._classPrivateFieldLooseBase12(this, _postProcessors)[_postProcessors]];
  try {
    for (let step = currentUpload.step || 0; step < steps.length; step++) {
      if (!currentUpload) {
        break;
      }
      const fn = steps[step];
      this.setState({
        currentUploads: {
          ...this.getState().currentUploads,
          [uploadID]: {
            ...currentUpload,
            step
          }
        }
      });
      const {
        fileIDs
      } = currentUpload;
      await fn(fileIDs, uploadID);
      currentUpload = getCurrentUpload();
    }
  } catch (err) {
    _classPrivateFieldLooseBase12(this, _removeUpload)[_removeUpload](uploadID);
    throw err;
  }
  if (currentUpload) {
    currentUpload.fileIDs.forEach((fileID) => {
      const file = this.getFile(fileID);
      if (file && file.progress.postprocess) {
        this.emit("postprocess-complete", file);
      }
    });
    const files = currentUpload.fileIDs.map((fileID) => this.getFile(fileID));
    const successful = files.filter((file) => !file.error);
    const failed = files.filter((file) => file.error);
    this.addResultData(uploadID, {
      successful,
      failed,
      uploadID
    });
    currentUpload = getCurrentUpload();
  }
  let result;
  if (currentUpload) {
    result = currentUpload.result;
    this.emit("complete", result);
    _classPrivateFieldLooseBase12(this, _removeUpload)[_removeUpload](uploadID);
  }
  if (result == null) {
    this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
  }
  return result;
}
Uppy.VERSION = packageJson5.version;
var Uppy_default = Uppy;

// ../../node_modules/preact/dist/preact.mjs
var n;
var l;
var u;
var t;
var i;
var o;
var r;
var f;
var e;
var c = {};
var s = [];
var a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
var h = Array.isArray;
function v(n3, l4) {
  for (var u4 in l4)
    n3[u4] = l4[u4];
  return n3;
}
function p(n3) {
  var l4 = n3.parentNode;
  l4 && l4.removeChild(n3);
}
function y(l4, u4, t4) {
  var i4, o4, r4, f4 = {};
  for (r4 in u4)
    "key" == r4 ? i4 = u4[r4] : "ref" == r4 ? o4 = u4[r4] : f4[r4] = u4[r4];
  if (arguments.length > 2 && (f4.children = arguments.length > 3 ? n.call(arguments, 2) : t4), "function" == typeof l4 && null != l4.defaultProps)
    for (r4 in l4.defaultProps)
      void 0 === f4[r4] && (f4[r4] = l4.defaultProps[r4]);
  return d(l4, f4, i4, o4, null);
}
function d(n3, t4, i4, o4, r4) {
  var f4 = { type: n3, props: t4, key: i4, ref: o4, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: null == r4 ? ++u : r4, __i: -1, __u: 0 };
  return null == r4 && null != l.vnode && l.vnode(f4), f4;
}
function _() {
  return { current: null };
}
function g(n3) {
  return n3.children;
}
function b(n3, l4) {
  this.props = n3, this.context = l4;
}
function m(n3, l4) {
  if (null == l4)
    return n3.__ ? m(n3.__, n3.__i + 1) : null;
  for (var u4; l4 < n3.__k.length; l4++)
    if (null != (u4 = n3.__k[l4]) && null != u4.__e)
      return u4.__e;
  return "function" == typeof n3.type ? m(n3) : null;
}
function w(n3, u4, t4) {
  var i4, o4 = n3.__v, r4 = o4.__e, f4 = n3.__P;
  if (f4)
    return (i4 = v({}, o4)).__v = o4.__v + 1, l.vnode && l.vnode(i4), M(f4, i4, o4, n3.__n, void 0 !== f4.ownerSVGElement, 32 & o4.__u ? [r4] : null, u4, null == r4 ? m(o4) : r4, !!(32 & o4.__u), t4), i4.__v = o4.__v, i4.__.__k[i4.__i] = i4, i4.__d = void 0, i4.__e != r4 && k(i4), i4;
}
function k(n3) {
  var l4, u4;
  if (null != (n3 = n3.__) && null != n3.__c) {
    for (n3.__e = n3.__c.base = null, l4 = 0; l4 < n3.__k.length; l4++)
      if (null != (u4 = n3.__k[l4]) && null != u4.__e) {
        n3.__e = n3.__c.base = u4.__e;
        break;
      }
    return k(n3);
  }
}
function x(n3) {
  (!n3.__d && (n3.__d = true) && i.push(n3) && !C.__r++ || o !== l.debounceRendering) && ((o = l.debounceRendering) || r)(C);
}
function C() {
  var n3, u4, t4, o4 = [], r4 = [];
  for (i.sort(f); n3 = i.shift(); )
    n3.__d && (t4 = i.length, u4 = w(n3, o4, r4) || u4, 0 === t4 || i.length > t4 ? (j(o4, u4, r4), r4.length = o4.length = 0, u4 = void 0, i.sort(f)) : u4 && l.__c && l.__c(u4, s));
  u4 && j(o4, u4, r4), C.__r = 0;
}
function P(n3, l4, u4, t4, i4, o4, r4, f4, e4, a4, h10) {
  var v4, p4, y4, d4, _4, g3 = t4 && t4.__k || s, b3 = l4.length;
  for (u4.__d = e4, S(u4, l4, g3), e4 = u4.__d, v4 = 0; v4 < b3; v4++)
    null != (y4 = u4.__k[v4]) && "boolean" != typeof y4 && "function" != typeof y4 && (p4 = -1 === y4.__i ? c : g3[y4.__i] || c, y4.__i = v4, M(n3, y4, p4, i4, o4, r4, f4, e4, a4, h10), d4 = y4.__e, y4.ref && p4.ref != y4.ref && (p4.ref && N(p4.ref, null, y4), h10.push(y4.ref, y4.__c || d4, y4)), null == _4 && null != d4 && (_4 = d4), 65536 & y4.__u || p4.__k === y4.__k ? e4 = $(y4, e4, n3) : "function" == typeof y4.type && void 0 !== y4.__d ? e4 = y4.__d : d4 && (e4 = d4.nextSibling), y4.__d = void 0, y4.__u &= -196609);
  u4.__d = e4, u4.__e = _4;
}
function S(n3, l4, u4) {
  var t4, i4, o4, r4, f4, e4 = l4.length, c4 = u4.length, s4 = c4, a4 = 0;
  for (n3.__k = [], t4 = 0; t4 < e4; t4++)
    r4 = t4 + a4, null != (i4 = n3.__k[t4] = null == (i4 = l4[t4]) || "boolean" == typeof i4 || "function" == typeof i4 ? null : "string" == typeof i4 || "number" == typeof i4 || "bigint" == typeof i4 || i4.constructor == String ? d(null, i4, null, null, null) : h(i4) ? d(g, { children: i4 }, null, null, null) : void 0 === i4.constructor && i4.__b > 0 ? d(i4.type, i4.props, i4.key, i4.ref ? i4.ref : null, i4.__v) : i4) ? (i4.__ = n3, i4.__b = n3.__b + 1, f4 = I(i4, u4, r4, s4), i4.__i = f4, o4 = null, -1 !== f4 && (s4--, (o4 = u4[f4]) && (o4.__u |= 131072)), null == o4 || null === o4.__v ? (-1 == f4 && a4--, "function" != typeof i4.type && (i4.__u |= 65536)) : f4 !== r4 && (f4 === r4 + 1 ? a4++ : f4 > r4 ? s4 > e4 - r4 ? a4 += f4 - r4 : a4-- : f4 < r4 ? f4 == r4 - 1 && (a4 = f4 - r4) : a4 = 0, f4 !== t4 + a4 && (i4.__u |= 65536))) : (o4 = u4[r4]) && null == o4.key && o4.__e && 0 == (131072 & o4.__u) && (o4.__e == n3.__d && (n3.__d = m(o4)), O(o4, o4, false), u4[r4] = null, s4--);
  if (s4)
    for (t4 = 0; t4 < c4; t4++)
      null != (o4 = u4[t4]) && 0 == (131072 & o4.__u) && (o4.__e == n3.__d && (n3.__d = m(o4)), O(o4, o4));
}
function $(n3, l4, u4) {
  var t4, i4;
  if ("function" == typeof n3.type) {
    for (t4 = n3.__k, i4 = 0; t4 && i4 < t4.length; i4++)
      t4[i4] && (t4[i4].__ = n3, l4 = $(t4[i4], l4, u4));
    return l4;
  }
  n3.__e != l4 && (u4.insertBefore(n3.__e, l4 || null), l4 = n3.__e);
  do {
    l4 = l4 && l4.nextSibling;
  } while (null != l4 && 8 === l4.nodeType);
  return l4;
}
function H(n3, l4) {
  return l4 = l4 || [], null == n3 || "boolean" == typeof n3 || (h(n3) ? n3.some(function(n4) {
    H(n4, l4);
  }) : l4.push(n3)), l4;
}
function I(n3, l4, u4, t4) {
  var i4 = n3.key, o4 = n3.type, r4 = u4 - 1, f4 = u4 + 1, e4 = l4[u4];
  if (null === e4 || e4 && i4 == e4.key && o4 === e4.type && 0 == (131072 & e4.__u))
    return u4;
  if (t4 > (null != e4 && 0 == (131072 & e4.__u) ? 1 : 0))
    for (; r4 >= 0 || f4 < l4.length; ) {
      if (r4 >= 0) {
        if ((e4 = l4[r4]) && 0 == (131072 & e4.__u) && i4 == e4.key && o4 === e4.type)
          return r4;
        r4--;
      }
      if (f4 < l4.length) {
        if ((e4 = l4[f4]) && 0 == (131072 & e4.__u) && i4 == e4.key && o4 === e4.type)
          return f4;
        f4++;
      }
    }
  return -1;
}
function T(n3, l4, u4) {
  "-" === l4[0] ? n3.setProperty(l4, null == u4 ? "" : u4) : n3[l4] = null == u4 ? "" : "number" != typeof u4 || a.test(l4) ? u4 : u4 + "px";
}
function A(n3, l4, u4, t4, i4) {
  var o4;
  n:
    if ("style" === l4)
      if ("string" == typeof u4)
        n3.style.cssText = u4;
      else {
        if ("string" == typeof t4 && (n3.style.cssText = t4 = ""), t4)
          for (l4 in t4)
            u4 && l4 in u4 || T(n3.style, l4, "");
        if (u4)
          for (l4 in u4)
            t4 && u4[l4] === t4[l4] || T(n3.style, l4, u4[l4]);
      }
    else if ("o" === l4[0] && "n" === l4[1])
      o4 = l4 !== (l4 = l4.replace(/(PointerCapture)$|Capture$/i, "$1")), l4 = l4.toLowerCase() in n3 ? l4.toLowerCase().slice(2) : l4.slice(2), n3.l || (n3.l = {}), n3.l[l4 + o4] = u4, u4 ? t4 ? u4.u = t4.u : (u4.u = Date.now(), n3.addEventListener(l4, o4 ? L : D, o4)) : n3.removeEventListener(l4, o4 ? L : D, o4);
    else {
      if (i4)
        l4 = l4.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" !== l4 && "height" !== l4 && "href" !== l4 && "list" !== l4 && "form" !== l4 && "tabIndex" !== l4 && "download" !== l4 && "rowSpan" !== l4 && "colSpan" !== l4 && "role" !== l4 && l4 in n3)
        try {
          n3[l4] = null == u4 ? "" : u4;
          break n;
        } catch (n4) {
        }
      "function" == typeof u4 || (null == u4 || false === u4 && "-" !== l4[4] ? n3.removeAttribute(l4) : n3.setAttribute(l4, u4));
    }
}
function D(n3) {
  if (this.l) {
    var u4 = this.l[n3.type + false];
    if (n3.t) {
      if (n3.t <= u4.u)
        return;
    } else
      n3.t = Date.now();
    return u4(l.event ? l.event(n3) : n3);
  }
}
function L(n3) {
  if (this.l)
    return this.l[n3.type + true](l.event ? l.event(n3) : n3);
}
function M(n3, u4, t4, i4, o4, r4, f4, e4, c4, s4) {
  var a4, p4, y4, d4, _4, m4, w4, k4, x4, C4, S3, $3, H3, I3, T3, A3 = u4.type;
  if (void 0 !== u4.constructor)
    return null;
  128 & t4.__u && (c4 = !!(32 & t4.__u), r4 = [e4 = u4.__e = t4.__e]), (a4 = l.__b) && a4(u4);
  n:
    if ("function" == typeof A3)
      try {
        if (k4 = u4.props, x4 = (a4 = A3.contextType) && i4[a4.__c], C4 = a4 ? x4 ? x4.props.value : a4.__ : i4, t4.__c ? w4 = (p4 = u4.__c = t4.__c).__ = p4.__E : ("prototype" in A3 && A3.prototype.render ? u4.__c = p4 = new A3(k4, C4) : (u4.__c = p4 = new b(k4, C4), p4.constructor = A3, p4.render = q), x4 && x4.sub(p4), p4.props = k4, p4.state || (p4.state = {}), p4.context = C4, p4.__n = i4, y4 = p4.__d = true, p4.__h = [], p4._sb = []), null == p4.__s && (p4.__s = p4.state), null != A3.getDerivedStateFromProps && (p4.__s == p4.state && (p4.__s = v({}, p4.__s)), v(p4.__s, A3.getDerivedStateFromProps(k4, p4.__s))), d4 = p4.props, _4 = p4.state, p4.__v = u4, y4)
          null == A3.getDerivedStateFromProps && null != p4.componentWillMount && p4.componentWillMount(), null != p4.componentDidMount && p4.__h.push(p4.componentDidMount);
        else {
          if (null == A3.getDerivedStateFromProps && k4 !== d4 && null != p4.componentWillReceiveProps && p4.componentWillReceiveProps(k4, C4), !p4.__e && (null != p4.shouldComponentUpdate && false === p4.shouldComponentUpdate(k4, p4.__s, C4) || u4.__v === t4.__v)) {
            for (u4.__v !== t4.__v && (p4.props = k4, p4.state = p4.__s, p4.__d = false), u4.__e = t4.__e, u4.__k = t4.__k, u4.__k.forEach(function(n4) {
              n4 && (n4.__ = u4);
            }), S3 = 0; S3 < p4._sb.length; S3++)
              p4.__h.push(p4._sb[S3]);
            p4._sb = [], p4.__h.length && f4.push(p4);
            break n;
          }
          null != p4.componentWillUpdate && p4.componentWillUpdate(k4, p4.__s, C4), null != p4.componentDidUpdate && p4.__h.push(function() {
            p4.componentDidUpdate(d4, _4, m4);
          });
        }
        if (p4.context = C4, p4.props = k4, p4.__P = n3, p4.__e = false, $3 = l.__r, H3 = 0, "prototype" in A3 && A3.prototype.render) {
          for (p4.state = p4.__s, p4.__d = false, $3 && $3(u4), a4 = p4.render(p4.props, p4.state, p4.context), I3 = 0; I3 < p4._sb.length; I3++)
            p4.__h.push(p4._sb[I3]);
          p4._sb = [];
        } else
          do {
            p4.__d = false, $3 && $3(u4), a4 = p4.render(p4.props, p4.state, p4.context), p4.state = p4.__s;
          } while (p4.__d && ++H3 < 25);
        p4.state = p4.__s, null != p4.getChildContext && (i4 = v(v({}, i4), p4.getChildContext())), y4 || null == p4.getSnapshotBeforeUpdate || (m4 = p4.getSnapshotBeforeUpdate(d4, _4)), P(n3, h(T3 = null != a4 && a4.type === g && null == a4.key ? a4.props.children : a4) ? T3 : [T3], u4, t4, i4, o4, r4, f4, e4, c4, s4), p4.base = u4.__e, u4.__u &= -161, p4.__h.length && f4.push(p4), w4 && (p4.__E = p4.__ = null);
      } catch (n4) {
        u4.__v = null, c4 || null != r4 ? (u4.__e = e4, u4.__u |= c4 ? 160 : 32, r4[r4.indexOf(e4)] = null) : (u4.__e = t4.__e, u4.__k = t4.__k), l.__e(n4, u4, t4);
      }
    else
      null == r4 && u4.__v === t4.__v ? (u4.__k = t4.__k, u4.__e = t4.__e) : u4.__e = z(t4.__e, u4, t4, i4, o4, r4, f4, c4, s4);
  (a4 = l.diffed) && a4(u4);
}
function j(n3, u4, t4) {
  for (var i4 = 0; i4 < t4.length; i4++)
    N(t4[i4], t4[++i4], t4[++i4]);
  l.__c && l.__c(u4, n3), n3.some(function(u5) {
    try {
      n3 = u5.__h, u5.__h = [], n3.some(function(n4) {
        n4.call(u5);
      });
    } catch (n4) {
      l.__e(n4, u5.__v);
    }
  });
}
function z(l4, u4, t4, i4, o4, r4, f4, e4, s4) {
  var a4, v4, y4, d4, _4, g3, b3, w4 = t4.props, k4 = u4.props, x4 = u4.type;
  if ("svg" === x4 && (o4 = true), null != r4) {
    for (a4 = 0; a4 < r4.length; a4++)
      if ((_4 = r4[a4]) && "setAttribute" in _4 == !!x4 && (x4 ? _4.localName === x4 : 3 === _4.nodeType)) {
        l4 = _4, r4[a4] = null;
        break;
      }
  }
  if (null == l4) {
    if (null === x4)
      return document.createTextNode(k4);
    l4 = o4 ? document.createElementNS("http://www.w3.org/2000/svg", x4) : document.createElement(x4, k4.is && k4), r4 = null, e4 = false;
  }
  if (null === x4)
    w4 === k4 || e4 && l4.data === k4 || (l4.data = k4);
  else {
    if (r4 = r4 && n.call(l4.childNodes), w4 = t4.props || c, !e4 && null != r4)
      for (w4 = {}, a4 = 0; a4 < l4.attributes.length; a4++)
        w4[(_4 = l4.attributes[a4]).name] = _4.value;
    for (a4 in w4)
      _4 = w4[a4], "children" == a4 || ("dangerouslySetInnerHTML" == a4 ? y4 = _4 : "key" === a4 || a4 in k4 || A(l4, a4, null, _4, o4));
    for (a4 in k4)
      _4 = k4[a4], "children" == a4 ? d4 = _4 : "dangerouslySetInnerHTML" == a4 ? v4 = _4 : "value" == a4 ? g3 = _4 : "checked" == a4 ? b3 = _4 : "key" === a4 || e4 && "function" != typeof _4 || w4[a4] === _4 || A(l4, a4, _4, w4[a4], o4);
    if (v4)
      e4 || y4 && (v4.__html === y4.__html || v4.__html === l4.innerHTML) || (l4.innerHTML = v4.__html), u4.__k = [];
    else if (y4 && (l4.innerHTML = ""), P(l4, h(d4) ? d4 : [d4], u4, t4, i4, o4 && "foreignObject" !== x4, r4, f4, r4 ? r4[0] : t4.__k && m(t4, 0), e4, s4), null != r4)
      for (a4 = r4.length; a4--; )
        null != r4[a4] && p(r4[a4]);
    e4 || (a4 = "value", void 0 !== g3 && (g3 !== l4[a4] || "progress" === x4 && !g3 || "option" === x4 && g3 !== w4[a4]) && A(l4, a4, g3, w4[a4], false), a4 = "checked", void 0 !== b3 && b3 !== l4[a4] && A(l4, a4, b3, w4[a4], false));
  }
  return l4;
}
function N(n3, u4, t4) {
  try {
    "function" == typeof n3 ? n3(u4) : n3.current = u4;
  } catch (n4) {
    l.__e(n4, t4);
  }
}
function O(n3, u4, t4) {
  var i4, o4;
  if (l.unmount && l.unmount(n3), (i4 = n3.ref) && (i4.current && i4.current !== n3.__e || N(i4, null, u4)), null != (i4 = n3.__c)) {
    if (i4.componentWillUnmount)
      try {
        i4.componentWillUnmount();
      } catch (n4) {
        l.__e(n4, u4);
      }
    i4.base = i4.__P = null, n3.__c = void 0;
  }
  if (i4 = n3.__k)
    for (o4 = 0; o4 < i4.length; o4++)
      i4[o4] && O(i4[o4], u4, t4 || "function" != typeof n3.type);
  t4 || null == n3.__e || p(n3.__e), n3.__ = n3.__e = n3.__d = void 0;
}
function q(n3, l4, u4) {
  return this.constructor(n3, u4);
}
function B(u4, t4, i4) {
  var o4, r4, f4, e4;
  l.__ && l.__(u4, t4), r4 = (o4 = "function" == typeof i4) ? null : i4 && i4.__k || t4.__k, f4 = [], e4 = [], M(t4, u4 = (!o4 && i4 || t4).__k = y(g, null, [u4]), r4 || c, c, void 0 !== t4.ownerSVGElement, !o4 && i4 ? [i4] : r4 ? null : t4.firstChild ? n.call(t4.childNodes) : null, f4, !o4 && i4 ? i4 : r4 ? r4.__e : t4.firstChild, o4, e4), u4.__d = void 0, j(f4, u4, e4);
}
function F(l4, u4, t4) {
  var i4, o4, r4, f4, e4 = v({}, l4.props);
  for (r4 in l4.type && l4.type.defaultProps && (f4 = l4.type.defaultProps), u4)
    "key" == r4 ? i4 = u4[r4] : "ref" == r4 ? o4 = u4[r4] : e4[r4] = void 0 === u4[r4] && void 0 !== f4 ? f4[r4] : u4[r4];
  return arguments.length > 2 && (e4.children = arguments.length > 3 ? n.call(arguments, 2) : t4), d(l4.type, e4, i4 || l4.key, o4 || l4.ref, null);
}
n = s.slice, l = { __e: function(n3, l4, u4, t4) {
  for (var i4, o4, r4; l4 = l4.__; )
    if ((i4 = l4.__c) && !i4.__)
      try {
        if ((o4 = i4.constructor) && null != o4.getDerivedStateFromError && (i4.setState(o4.getDerivedStateFromError(n3)), r4 = i4.__d), null != i4.componentDidCatch && (i4.componentDidCatch(n3, t4 || {}), r4 = i4.__d), r4)
          return i4.__E = i4;
      } catch (l5) {
        n3 = l5;
      }
  throw n3;
} }, u = 0, t = function(n3) {
  return null != n3 && null == n3.constructor;
}, b.prototype.setState = function(n3, l4) {
  var u4;
  u4 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v({}, this.state), "function" == typeof n3 && (n3 = n3(v({}, u4), this.props)), n3 && v(u4, n3), null != n3 && this.__v && (l4 && this._sb.push(l4), x(this));
}, b.prototype.forceUpdate = function(n3) {
  this.__v && (this.__e = true, n3 && this.__h.push(n3), x(this));
}, b.prototype.render = g, i = [], r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f = function(n3, l4) {
  return n3.__v.__b - l4.__v.__b;
}, C.__r = 0, e = 0;

// ../../node_modules/@uppy/utils/lib/isDOMElement.js
function isDOMElement(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  if (!("nodeType" in obj))
    return false;
  return obj.nodeType === Node.ELEMENT_NODE;
}

// ../../node_modules/@uppy/utils/lib/findDOMElement.js
function findDOMElement(element, context) {
  if (context === void 0) {
    context = document;
  }
  if (typeof element === "string") {
    return context.querySelector(element);
  }
  if (isDOMElement(element)) {
    return element;
  }
  return null;
}
var findDOMElement_default = findDOMElement;

// ../../node_modules/@uppy/utils/lib/getTextDirection.js
function getTextDirection(element) {
  var _element;
  while (element && !element.dir) {
    element = element.parentNode;
  }
  return (_element = element) == null ? void 0 : _element.dir;
}
var getTextDirection_default = getTextDirection;

// ../../node_modules/@uppy/core/lib/UIPlugin.js
function _classPrivateFieldLooseBase13(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id13 = 0;
function _classPrivateFieldLooseKey13(name) {
  return "__private_" + id13++ + "_" + name;
}
function debounce2(fn) {
  let calling = null;
  let latestArgs;
  return function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    latestArgs = args;
    if (!calling) {
      calling = Promise.resolve().then(() => {
        calling = null;
        return fn(...latestArgs);
      });
    }
    return calling;
  };
}
var _updateUI = /* @__PURE__ */ _classPrivateFieldLooseKey13("updateUI");
var UIPlugin = class _UIPlugin extends BasePlugin {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, _updateUI, {
      writable: true,
      value: void 0
    });
  }
  getTargetPlugin(target) {
    let targetPlugin;
    if (typeof (target == null ? void 0 : target.addTarget) === "function") {
      targetPlugin = target;
      if (!(targetPlugin instanceof _UIPlugin)) {
        console.warn(new Error("The provided plugin is not an instance of UIPlugin. This is an indication of a bug with the way Uppy is bundled.", {
          cause: {
            targetPlugin,
            UIPlugin: _UIPlugin
          }
        }));
      }
    } else if (typeof target === "function") {
      const Target = target;
      this.uppy.iteratePlugins((p4) => {
        if (p4 instanceof Target) {
          targetPlugin = p4;
        }
      });
    }
    return targetPlugin;
  }
  /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */
  mount(target, plugin) {
    const callerPluginName = plugin.id;
    const targetElement = findDOMElement_default(target);
    if (targetElement) {
      this.isTargetDOMEl = true;
      const uppyRootElement = document.createElement("div");
      uppyRootElement.classList.add("uppy-Root");
      _classPrivateFieldLooseBase13(this, _updateUI)[_updateUI] = debounce2((state) => {
        if (!this.uppy.getPlugin(this.id))
          return;
        B(this.render(state), uppyRootElement);
        this.afterUpdate();
      });
      this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);
      if (this.opts.replaceTargetContent) {
        targetElement.innerHTML = "";
      }
      B(this.render(this.uppy.getState()), uppyRootElement);
      this.el = uppyRootElement;
      targetElement.appendChild(uppyRootElement);
      uppyRootElement.dir = this.opts.direction || getTextDirection_default(uppyRootElement) || "ltr";
      this.onMount();
      return this.el;
    }
    const targetPlugin = this.getTargetPlugin(target);
    if (targetPlugin) {
      this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
      this.parent = targetPlugin;
      this.el = targetPlugin.addTarget(plugin);
      this.onMount();
      return this.el;
    }
    this.uppy.log(`Not installing ${callerPluginName}`);
    let message = `Invalid target option given to ${callerPluginName}.`;
    if (typeof target === "function") {
      message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.";
    } else {
      message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.";
    }
    throw new Error(message);
  }
  /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(state) {
    throw new Error("Extend the render method to add your plugin to a DOM element");
  }
  update(state) {
    if (this.el != null) {
      var _classPrivateFieldLoo, _classPrivateFieldLoo2;
      (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase13(this, _updateUI))[_updateUI]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
    }
  }
  unmount() {
    if (this.isTargetDOMEl) {
      var _this$el;
      (_this$el = this.el) == null || _this$el.remove();
    }
    this.onUnmount();
  }
  onMount() {
  }
  onUnmount() {
  }
};
var UIPlugin_default = UIPlugin;

// ../../node_modules/@uppy/react/lib/Dashboard.js
var import_prop_types2 = __toESM(require_prop_types(), 1);
import { createElement as h4, Component } from "react";

// ../../node_modules/@uppy/utils/lib/emaFilter.js
function emaFilter(newValue, previousSmoothedValue, halfLife, dt) {
  if (halfLife === 0 || newValue === previousSmoothedValue)
    return newValue;
  if (dt === 0)
    return previousSmoothedValue;
  return newValue + (previousSmoothedValue - newValue) * 2 ** (-dt / halfLife);
}

// ../../node_modules/@uppy/status-bar/lib/StatusBarStates.js
var StatusBarStates_default = {
  STATE_ERROR: "error",
  STATE_WAITING: "waiting",
  STATE_PREPROCESSING: "preprocessing",
  STATE_UPLOADING: "uploading",
  STATE_POSTPROCESSING: "postprocessing",
  STATE_COMPLETE: "complete"
};

// ../../node_modules/@uppy/status-bar/lib/StatusBarUI.js
var import_classnames2 = __toESM(require_classnames(), 1);

// ../../node_modules/@uppy/status-bar/lib/calculateProcessingProgress.js
function calculateProcessingProgress(files) {
  const values = [];
  let mode = "indeterminate";
  let message;
  for (const {
    progress
  } of Object.values(files)) {
    const {
      preprocess,
      postprocess
    } = progress;
    if (message == null && (preprocess || postprocess)) {
      ;
      ({
        mode,
        message
      } = preprocess || postprocess);
    }
    if ((preprocess == null ? void 0 : preprocess.mode) === "determinate")
      values.push(preprocess.value);
    if ((postprocess == null ? void 0 : postprocess.mode) === "determinate")
      values.push(postprocess.value);
  }
  const value = values.reduce((total, progressValue) => {
    return total + progressValue / values.length;
  }, 0);
  return {
    mode,
    message,
    value
  };
}

// ../../node_modules/@uppy/status-bar/lib/Components.js
var import_classnames = __toESM(require_classnames(), 1);
var import_prettier_bytes2 = __toESM(require_prettierBytes(), 1);

// ../../node_modules/@uppy/utils/lib/secondsToTime.js
function secondsToTime(rawSeconds) {
  const hours = Math.floor(rawSeconds / 3600) % 24;
  const minutes = Math.floor(rawSeconds / 60) % 60;
  const seconds = Math.floor(rawSeconds % 60);
  return {
    hours,
    minutes,
    seconds
  };
}

// ../../node_modules/@uppy/utils/lib/prettyETA.js
function prettyETA(seconds) {
  const time = secondsToTime(seconds);
  const hoursStr = time.hours === 0 ? "" : `${time.hours}h`;
  const minutesStr = time.minutes === 0 ? "" : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, "0")}`}m`;
  const secondsStr = time.hours !== 0 ? "" : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, "0")}`}s`;
  return `${hoursStr}${minutesStr}${secondsStr}`;
}

// ../../node_modules/@uppy/status-bar/lib/Components.js
var DOT = `\xB7`;
var renderDot = () => ` ${DOT} `;
function UploadBtn(props) {
  const {
    newFiles,
    isUploadStarted,
    recoveredState,
    i18n,
    uploadState,
    isSomeGhost,
    startUpload
  } = props;
  const uploadBtnClassNames = (0, import_classnames.default)("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--upload", {
    "uppy-c-btn-primary": uploadState === StatusBarStates_default.STATE_WAITING
  }, {
    "uppy-StatusBar-actionBtn--disabled": isSomeGhost
  });
  const uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n("uploadXNewFiles", {
    smart_count: newFiles
  }) : i18n("uploadXFiles", {
    smart_count: newFiles
  });
  return y("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n("uploadXFiles", {
      smart_count: newFiles
    }),
    onClick: startUpload,
    disabled: isSomeGhost,
    "data-uppy-super-focusable": true
  }, uploadBtnText);
}
function RetryBtn(props) {
  const {
    i18n,
    uppy: uppy2
  } = props;
  return y("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
    "aria-label": i18n("retryUpload"),
    onClick: () => uppy2.retryAll().catch(() => {
    }),
    "data-uppy-super-focusable": true,
    "data-cy": "retry"
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "8",
    height: "10",
    viewBox: "0 0 8 10"
  }, y("path", {
    d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
  })), i18n("retry"));
}
function CancelBtn(props) {
  const {
    i18n,
    uppy: uppy2
  } = props;
  return y("button", {
    type: "button",
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    title: i18n("cancel"),
    "aria-label": i18n("cancel"),
    onClick: () => uppy2.cancelAll(),
    "data-cy": "cancel",
    "data-uppy-super-focusable": true
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, y("g", {
    fill: "none",
    fillRule: "evenodd"
  }, y("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), y("path", {
    fill: "#FFF",
    d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
  }))));
}
function PauseResumeButton(props) {
  const {
    isAllPaused,
    i18n,
    isAllComplete,
    resumableUploads,
    uppy: uppy2
  } = props;
  const title = isAllPaused ? i18n("resume") : i18n("pause");
  function togglePauseResume() {
    if (isAllComplete)
      return;
    if (!resumableUploads) {
      uppy2.cancelAll();
      return;
    }
    if (isAllPaused) {
      uppy2.resumeAll();
      return;
    }
    uppy2.pauseAll();
  }
  return y("button", {
    title,
    "aria-label": title,
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    type: "button",
    onClick: togglePauseResume,
    "data-cy": "togglePauseResume",
    "data-uppy-super-focusable": true
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, y("g", {
    fill: "none",
    fillRule: "evenodd"
  }, y("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), y("path", {
    fill: "#FFF",
    d: isAllPaused ? "M6 4.25L11.5 8 6 11.75z" : "M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z"
  }))));
}
function DoneBtn(props) {
  const {
    i18n,
    doneButtonHandler
  } = props;
  return y("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
    onClick: doneButtonHandler,
    "data-uppy-super-focusable": true
  }, i18n("done"));
}
function LoadingSpinner() {
  return y("svg", {
    className: "uppy-StatusBar-spinner",
    "aria-hidden": "true",
    focusable: "false",
    width: "14",
    height: "14"
  }, y("path", {
    d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
    fillRule: "evenodd"
  }));
}
function ProgressBarProcessing(props) {
  const {
    progress
  } = props;
  const {
    value,
    mode,
    message
  } = progress;
  const dot = `\xB7`;
  return y("div", {
    className: "uppy-StatusBar-content"
  }, y(LoadingSpinner, null), mode === "determinate" ? `${Math.round(value * 100)}% ${dot} ` : "", message);
}
function ProgressDetails(props) {
  const {
    numUploads,
    complete,
    totalUploadedSize,
    totalSize,
    totalETA,
    i18n
  } = props;
  const ifShowFilesUploadedOfTotal = numUploads > 1;
  return y("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, ifShowFilesUploadedOfTotal && i18n("filesUploadedOfTotal", {
    complete,
    smart_count: numUploads
  }), y("span", {
    className: "uppy-StatusBar-additionalInfo"
  }, ifShowFilesUploadedOfTotal && renderDot(), i18n("dataUploadedOfTotal", {
    complete: (0, import_prettier_bytes2.default)(totalUploadedSize),
    total: (0, import_prettier_bytes2.default)(totalSize)
  }), renderDot(), i18n("xTimeLeft", {
    time: prettyETA(totalETA)
  })));
}
function FileUploadCount(props) {
  const {
    i18n,
    complete,
    numUploads
  } = props;
  return y("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, i18n("filesUploadedOfTotal", {
    complete,
    smart_count: numUploads
  }));
}
function UploadNewlyAddedFiles(props) {
  const {
    i18n,
    newFiles,
    startUpload
  } = props;
  const uploadBtnClassNames = (0, import_classnames.default)("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--uploadNewlyAdded");
  return y("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, y("div", {
    className: "uppy-StatusBar-statusSecondaryHint"
  }, i18n("xMoreFilesAdded", {
    smart_count: newFiles
  })), y("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n("uploadXFiles", {
      smart_count: newFiles
    }),
    onClick: startUpload
  }, i18n("upload")));
}
function ProgressBarUploading(props) {
  const {
    i18n,
    supportsUploadProgress: supportsUploadProgress2,
    totalProgress,
    showProgressDetails,
    isUploadStarted,
    isAllComplete,
    isAllPaused,
    newFiles,
    numUploads,
    complete,
    totalUploadedSize,
    totalSize,
    totalETA,
    startUpload
  } = props;
  const showUploadNewlyAddedFiles = newFiles && isUploadStarted;
  if (!isUploadStarted || isAllComplete) {
    return null;
  }
  const title = isAllPaused ? i18n("paused") : i18n("uploading");
  function renderProgressDetails() {
    if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
      if (supportsUploadProgress2) {
        return y(ProgressDetails, {
          numUploads,
          complete,
          totalUploadedSize,
          totalSize,
          totalETA,
          i18n
        });
      }
      return y(FileUploadCount, {
        i18n,
        complete,
        numUploads
      });
    }
    return null;
  }
  return y("div", {
    className: "uppy-StatusBar-content",
    "aria-label": title,
    title
  }, !isAllPaused ? y(LoadingSpinner, null) : null, y("div", {
    className: "uppy-StatusBar-status"
  }, y("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, supportsUploadProgress2 ? `${title}: ${totalProgress}%` : title), renderProgressDetails(), showUploadNewlyAddedFiles ? y(UploadNewlyAddedFiles, {
    i18n,
    newFiles,
    startUpload
  }) : null));
}
function ProgressBarComplete(props) {
  const {
    i18n
  } = props;
  return y("div", {
    className: "uppy-StatusBar-content",
    role: "status",
    title: i18n("complete")
  }, y("div", {
    className: "uppy-StatusBar-status"
  }, y("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "15",
    height: "11",
    viewBox: "0 0 15 11"
  }, y("path", {
    d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
  })), i18n("complete"))));
}
function ProgressBarError(props) {
  const {
    error,
    i18n,
    complete,
    numUploads
  } = props;
  function displayErrorAlert() {
    const errorMessage = `${i18n("uploadFailed")} 

 ${error}`;
    alert(errorMessage);
  }
  return y("div", {
    className: "uppy-StatusBar-content",
    title: i18n("uploadFailed")
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "11",
    height: "11",
    viewBox: "0 0 11 11"
  }, y("path", {
    d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
  })), y("div", {
    className: "uppy-StatusBar-status"
  }, y("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, i18n("uploadFailed"), y("button", {
    className: "uppy-u-reset uppy-StatusBar-details",
    "aria-label": i18n("showErrorDetails"),
    "data-microtip-position": "top-right",
    "data-microtip-size": "medium",
    onClick: displayErrorAlert,
    type: "button"
  }, "?")), y(FileUploadCount, {
    i18n,
    complete,
    numUploads
  })));
}

// ../../node_modules/@uppy/status-bar/lib/StatusBarUI.js
var {
  STATE_ERROR,
  STATE_WAITING,
  STATE_PREPROCESSING,
  STATE_UPLOADING,
  STATE_POSTPROCESSING,
  STATE_COMPLETE
} = StatusBarStates_default;
function StatusBar(props) {
  const {
    newFiles,
    allowNewUpload,
    isUploadInProgress,
    isAllPaused,
    resumableUploads,
    error,
    hideUploadButton,
    hidePauseResumeButton,
    hideCancelButton,
    hideRetryButton,
    recoveredState,
    uploadState,
    totalProgress,
    files,
    supportsUploadProgress: supportsUploadProgress2,
    hideAfterFinish,
    isSomeGhost,
    doneButtonHandler,
    isUploadStarted,
    i18n,
    startUpload,
    uppy: uppy2,
    isAllComplete,
    showProgressDetails,
    numUploads,
    complete,
    totalSize,
    totalETA,
    totalUploadedSize
  } = props;
  function getProgressValue() {
    switch (uploadState) {
      case STATE_POSTPROCESSING:
      case STATE_PREPROCESSING: {
        const progress = calculateProcessingProgress(files);
        if (progress.mode === "determinate") {
          return progress.value * 100;
        }
        return totalProgress;
      }
      case STATE_ERROR: {
        return null;
      }
      case STATE_UPLOADING: {
        if (!supportsUploadProgress2) {
          return null;
        }
        return totalProgress;
      }
      default:
        return totalProgress;
    }
  }
  function getIsIndeterminate() {
    switch (uploadState) {
      case STATE_POSTPROCESSING:
      case STATE_PREPROCESSING: {
        const {
          mode
        } = calculateProcessingProgress(files);
        return mode === "indeterminate";
      }
      case STATE_UPLOADING: {
        if (!supportsUploadProgress2) {
          return true;
        }
        return false;
      }
      default:
        return false;
    }
  }
  function getIsHidden() {
    if (recoveredState) {
      return false;
    }
    switch (uploadState) {
      case STATE_WAITING:
        return hideUploadButton || newFiles === 0;
      case STATE_COMPLETE:
        return hideAfterFinish;
      default:
        return false;
    }
  }
  const progressValue = getProgressValue();
  const isHidden = getIsHidden();
  const width = progressValue != null ? progressValue : 100;
  const showUploadBtn = !error && newFiles && !isUploadInProgress && !isAllPaused && allowNewUpload && !hideUploadButton;
  const showCancelBtn = !hideCancelButton && uploadState !== STATE_WAITING && uploadState !== STATE_COMPLETE;
  const showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === STATE_UPLOADING;
  const showRetryBtn = error && !isAllComplete && !hideRetryButton;
  const showDoneBtn = doneButtonHandler && uploadState === STATE_COMPLETE;
  const progressClassNames = (0, import_classnames2.default)("uppy-StatusBar-progress", {
    "is-indeterminate": getIsIndeterminate()
  });
  const statusBarClassNames = (0, import_classnames2.default)("uppy-StatusBar", `is-${uploadState}`, {
    "has-ghosts": isSomeGhost
  });
  return y("div", {
    className: statusBarClassNames,
    "aria-hidden": isHidden
  }, y("div", {
    className: progressClassNames,
    style: {
      width: `${width}%`
    },
    role: "progressbar",
    "aria-label": `${width}%`,
    "aria-valuetext": `${width}%`,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": progressValue
  }), (() => {
    switch (uploadState) {
      case STATE_PREPROCESSING:
      case STATE_POSTPROCESSING:
        return y(ProgressBarProcessing, {
          progress: calculateProcessingProgress(files)
        });
      case STATE_COMPLETE:
        return y(ProgressBarComplete, {
          i18n
        });
      case STATE_ERROR:
        return y(ProgressBarError, {
          error,
          i18n,
          numUploads,
          complete
        });
      case STATE_UPLOADING:
        return y(ProgressBarUploading, {
          i18n,
          supportsUploadProgress: supportsUploadProgress2,
          totalProgress,
          showProgressDetails,
          isUploadStarted,
          isAllComplete,
          isAllPaused,
          newFiles,
          numUploads,
          complete,
          totalUploadedSize,
          totalSize,
          totalETA,
          startUpload
        });
      default:
        return null;
    }
  })(), y("div", {
    className: "uppy-StatusBar-actions"
  }, recoveredState || showUploadBtn ? y(UploadBtn, {
    newFiles,
    isUploadStarted,
    recoveredState,
    i18n,
    isSomeGhost,
    startUpload,
    uploadState
  }) : null, showRetryBtn ? y(RetryBtn, {
    i18n,
    uppy: uppy2
  }) : null, showPauseResumeBtn ? y(PauseResumeButton, {
    isAllPaused,
    i18n,
    isAllComplete,
    resumableUploads,
    uppy: uppy2
  }) : null, showCancelBtn ? y(CancelBtn, {
    i18n,
    uppy: uppy2
  }) : null, showDoneBtn ? y(DoneBtn, {
    i18n,
    doneButtonHandler
  }) : null));
}
StatusBar.defaultProps = {
  doneButtonHandler: void 0,
  hideAfterFinish: false,
  hideCancelButton: false,
  hidePauseResumeButton: false,
  hideRetryButton: false,
  hideUploadButton: void 0,
  showProgressDetails: void 0
};

// ../../node_modules/@uppy/status-bar/lib/locale.js
var locale_default3 = {
  strings: {
    // Shown in the status bar while files are being uploaded.
    uploading: "Uploading",
    // Shown in the status bar once all files have been uploaded.
    complete: "Complete",
    // Shown in the status bar if an upload failed.
    uploadFailed: "Upload failed",
    // Shown in the status bar while the upload is paused.
    paused: "Paused",
    // Used as the label for the button that retries an upload.
    retry: "Retry",
    // Used as the label for the button that cancels an upload.
    cancel: "Cancel",
    // Used as the label for the button that pauses an upload.
    pause: "Pause",
    // Used as the label for the button that resumes an upload.
    resume: "Resume",
    // Used as the label for the button that resets the upload state after an upload
    done: "Done",
    // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
    filesUploadedOfTotal: {
      0: "%{complete} of %{smart_count} file uploaded",
      1: "%{complete} of %{smart_count} files uploaded"
    },
    // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
    dataUploadedOfTotal: "%{complete} of %{total}",
    // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
    xTimeLeft: "%{time} left",
    // Used as the label for the button that starts an upload.
    uploadXFiles: {
      0: "Upload %{smart_count} file",
      1: "Upload %{smart_count} files"
    },
    // Used as the label for the button that starts an upload, if another upload has been started in the past
    // and new files were added later.
    uploadXNewFiles: {
      0: "Upload +%{smart_count} file",
      1: "Upload +%{smart_count} files"
    },
    upload: "Upload",
    retryUpload: "Retry upload",
    xMoreFilesAdded: {
      0: "%{smart_count} more file added",
      1: "%{smart_count} more files added"
    },
    showErrorDetails: "Show error details"
  }
};

// ../../node_modules/@uppy/status-bar/lib/StatusBar.js
function _classPrivateFieldLooseBase14(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id14 = 0;
function _classPrivateFieldLooseKey14(name) {
  return "__private_" + id14++ + "_" + name;
}
var packageJson6 = {
  "version": "3.3.1"
};
var speedFilterHalfLife = 2e3;
var ETAFilterHalfLife = 2e3;
function getUploadingState(error, isAllComplete, recoveredState, files) {
  if (error) {
    return StatusBarStates_default.STATE_ERROR;
  }
  if (isAllComplete) {
    return StatusBarStates_default.STATE_COMPLETE;
  }
  if (recoveredState) {
    return StatusBarStates_default.STATE_WAITING;
  }
  let state = StatusBarStates_default.STATE_WAITING;
  const fileIDs = Object.keys(files);
  for (let i4 = 0; i4 < fileIDs.length; i4++) {
    const {
      progress
    } = files[fileIDs[i4]];
    if (progress.uploadStarted && !progress.uploadComplete) {
      return StatusBarStates_default.STATE_UPLOADING;
    }
    if (progress.preprocess) {
      state = StatusBarStates_default.STATE_PREPROCESSING;
    }
    if (progress.postprocess && state !== StatusBarStates_default.STATE_PREPROCESSING) {
      state = StatusBarStates_default.STATE_POSTPROCESSING;
    }
  }
  return state;
}
var defaultOptions3 = {
  target: "body",
  hideUploadButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideCancelButton: false,
  showProgressDetails: false,
  hideAfterFinish: true,
  doneButtonHandler: null
};
var _lastUpdateTime = /* @__PURE__ */ _classPrivateFieldLooseKey14("lastUpdateTime");
var _previousUploadedBytes = /* @__PURE__ */ _classPrivateFieldLooseKey14("previousUploadedBytes");
var _previousSpeed = /* @__PURE__ */ _classPrivateFieldLooseKey14("previousSpeed");
var _previousETA = /* @__PURE__ */ _classPrivateFieldLooseKey14("previousETA");
var _computeSmoothETA = /* @__PURE__ */ _classPrivateFieldLooseKey14("computeSmoothETA");
var _onUploadStart = /* @__PURE__ */ _classPrivateFieldLooseKey14("onUploadStart");
var StatusBar2 = class extends UIPlugin_default {
  constructor(uppy2, opts) {
    super(uppy2, {
      ...defaultOptions3,
      ...opts
    });
    Object.defineProperty(this, _computeSmoothETA, {
      value: _computeSmoothETA2
    });
    Object.defineProperty(this, _lastUpdateTime, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousUploadedBytes, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousSpeed, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousETA, {
      writable: true,
      value: void 0
    });
    this.startUpload = () => {
      return this.uppy.upload().catch(() => {
      });
    };
    Object.defineProperty(this, _onUploadStart, {
      writable: true,
      value: () => {
        const {
          recoveredState
        } = this.uppy.getState();
        _classPrivateFieldLooseBase14(this, _previousSpeed)[_previousSpeed] = null;
        _classPrivateFieldLooseBase14(this, _previousETA)[_previousETA] = null;
        if (recoveredState) {
          _classPrivateFieldLooseBase14(this, _previousUploadedBytes)[_previousUploadedBytes] = Object.values(recoveredState.files).reduce((pv, _ref) => {
            let {
              progress
            } = _ref;
            return pv + progress.bytesUploaded;
          }, 0);
          this.uppy.emit("restore-confirmed");
          return;
        }
        _classPrivateFieldLooseBase14(this, _lastUpdateTime)[_lastUpdateTime] = performance.now();
        _classPrivateFieldLooseBase14(this, _previousUploadedBytes)[_previousUploadedBytes] = 0;
      }
    });
    this.id = this.opts.id || "StatusBar";
    this.title = "StatusBar";
    this.type = "progressindicator";
    this.defaultLocale = locale_default3;
    this.i18nInit();
    this.render = this.render.bind(this);
    this.install = this.install.bind(this);
  }
  render(state) {
    const {
      capabilities,
      files,
      allowNewUpload,
      totalProgress,
      error,
      recoveredState
    } = state;
    const {
      newFiles,
      startedFiles,
      completeFiles,
      isUploadStarted,
      isAllComplete,
      isAllErrored,
      isAllPaused,
      isUploadInProgress,
      isSomeGhost
    } = this.uppy.getObjectOfFilesPerState();
    const newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
    const resumableUploads = !!capabilities.resumableUploads;
    const supportsUploadProgress2 = capabilities.uploadProgress !== false;
    let totalSize = 0;
    let totalUploadedSize = 0;
    startedFiles.forEach((file) => {
      totalSize += file.progress.bytesTotal || 0;
      totalUploadedSize += file.progress.bytesUploaded || 0;
    });
    const totalETA = _classPrivateFieldLooseBase14(this, _computeSmoothETA)[_computeSmoothETA]({
      uploaded: totalUploadedSize,
      total: totalSize,
      remaining: totalSize - totalUploadedSize
    });
    return StatusBar({
      error,
      uploadState: getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
      allowNewUpload,
      totalProgress,
      totalSize,
      totalUploadedSize,
      isAllComplete: false,
      isAllPaused,
      // @ts-expect-error TODO: remove this in 4.x branch
      isAllErrored,
      isUploadStarted,
      isUploadInProgress,
      isSomeGhost,
      recoveredState,
      complete: completeFiles.length,
      newFiles: newFilesOrRecovered.length,
      numUploads: startedFiles.length,
      totalETA,
      files,
      i18n: this.i18n,
      uppy: this.uppy,
      startUpload: this.startUpload,
      doneButtonHandler: this.opts.doneButtonHandler,
      resumableUploads,
      supportsUploadProgress: supportsUploadProgress2,
      showProgressDetails: this.opts.showProgressDetails,
      hideUploadButton: this.opts.hideUploadButton,
      hideRetryButton: this.opts.hideRetryButton,
      hidePauseResumeButton: this.opts.hidePauseResumeButton,
      hideCancelButton: this.opts.hideCancelButton,
      hideAfterFinish: this.opts.hideAfterFinish,
      // ts-expect-error TODO: remove this in 4.x branch
      isTargetDOMEl: this.isTargetDOMEl
    });
  }
  onMount() {
    const element = this.el;
    const direction = getTextDirection_default(element);
    if (!direction) {
      element.dir = "ltr";
    }
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
    this.uppy.on("upload", _classPrivateFieldLooseBase14(this, _onUploadStart)[_onUploadStart]);
    _classPrivateFieldLooseBase14(this, _lastUpdateTime)[_lastUpdateTime] = performance.now();
    _classPrivateFieldLooseBase14(this, _previousUploadedBytes)[_previousUploadedBytes] = this.uppy.getFiles().reduce((pv, file) => pv + file.progress.bytesUploaded, 0);
  }
  uninstall() {
    this.unmount();
    this.uppy.off("upload", _classPrivateFieldLooseBase14(this, _onUploadStart)[_onUploadStart]);
  }
};
function _computeSmoothETA2(totalBytes) {
  var _classPrivateFieldLoo, _classPrivateFieldLoo2;
  if (totalBytes.total === 0 || totalBytes.remaining === 0) {
    return 0;
  }
  (_classPrivateFieldLoo2 = (_classPrivateFieldLoo = _classPrivateFieldLooseBase14(this, _lastUpdateTime))[_lastUpdateTime]) != null ? _classPrivateFieldLoo2 : _classPrivateFieldLoo[_lastUpdateTime] = performance.now();
  const dt = performance.now() - _classPrivateFieldLooseBase14(this, _lastUpdateTime)[_lastUpdateTime];
  if (dt === 0) {
    var _classPrivateFieldLoo3;
    return Math.round(((_classPrivateFieldLoo3 = _classPrivateFieldLooseBase14(this, _previousETA)[_previousETA]) != null ? _classPrivateFieldLoo3 : 0) / 100) / 10;
  }
  const uploadedBytesSinceLastTick = totalBytes.uploaded - _classPrivateFieldLooseBase14(this, _previousUploadedBytes)[_previousUploadedBytes];
  _classPrivateFieldLooseBase14(this, _previousUploadedBytes)[_previousUploadedBytes] = totalBytes.uploaded;
  if (uploadedBytesSinceLastTick <= 0) {
    var _classPrivateFieldLoo4;
    return Math.round(((_classPrivateFieldLoo4 = _classPrivateFieldLooseBase14(this, _previousETA)[_previousETA]) != null ? _classPrivateFieldLoo4 : 0) / 100) / 10;
  }
  const currentSpeed = uploadedBytesSinceLastTick / dt;
  const filteredSpeed = _classPrivateFieldLooseBase14(this, _previousSpeed)[_previousSpeed] == null ? currentSpeed : emaFilter(currentSpeed, _classPrivateFieldLooseBase14(this, _previousSpeed)[_previousSpeed], speedFilterHalfLife, dt);
  _classPrivateFieldLooseBase14(this, _previousSpeed)[_previousSpeed] = filteredSpeed;
  const instantETA = totalBytes.remaining / filteredSpeed;
  const updatedPreviousETA = Math.max(_classPrivateFieldLooseBase14(this, _previousETA)[_previousETA] - dt, 0);
  const filteredETA = _classPrivateFieldLooseBase14(this, _previousETA)[_previousETA] == null ? instantETA : emaFilter(instantETA, updatedPreviousETA, ETAFilterHalfLife, dt);
  _classPrivateFieldLooseBase14(this, _previousETA)[_previousETA] = filteredETA;
  _classPrivateFieldLooseBase14(this, _lastUpdateTime)[_lastUpdateTime] = performance.now();
  return Math.round(filteredETA / 100) / 10;
}
StatusBar2.VERSION = packageJson6.version;

// ../../node_modules/@uppy/informer/lib/FadeIn.js
var TRANSITION_MS = 300;
var FadeIn = class extends b {
  constructor() {
    super(...arguments);
    this.ref = _();
  }
  componentWillEnter(callback) {
    this.ref.current.style.opacity = "1";
    this.ref.current.style.transform = "none";
    setTimeout(callback, TRANSITION_MS);
  }
  componentWillLeave(callback) {
    this.ref.current.style.opacity = "0";
    this.ref.current.style.transform = "translateY(350%)";
    setTimeout(callback, TRANSITION_MS);
  }
  render() {
    const {
      children
    } = this.props;
    return y("div", {
      className: "uppy-Informer-animated",
      ref: this.ref
    }, children);
  }
};

// ../../node_modules/@uppy/informer/lib/TransitionGroup.js
function assign(obj, props) {
  return Object.assign(obj, props);
}
function getKey(vnode, fallback) {
  var _vnode$key;
  return (_vnode$key = vnode == null ? void 0 : vnode.key) != null ? _vnode$key : fallback;
}
function linkRef(component, name) {
  const cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
  return cache[name] || (cache[name] = (c4) => {
    component.refs[name] = c4;
  });
}
function getChildMapping(children) {
  const out = {};
  for (let i4 = 0; i4 < children.length; i4++) {
    if (children[i4] != null) {
      const key = getKey(children[i4], i4.toString(36));
      out[key] = children[i4];
    }
  }
  return out;
}
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  const getValueForKey = (key) => next.hasOwnProperty(key) ? next[key] : prev[key];
  const nextKeysPending = {};
  let pendingKeys = [];
  for (const prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  const childMapping = {};
  for (const nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (let i4 = 0; i4 < nextKeysPending[nextKey].length; i4++) {
        const pendingNextKey = nextKeysPending[nextKey][i4];
        childMapping[nextKeysPending[nextKey][i4]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (let i4 = 0; i4 < pendingKeys.length; i4++) {
    childMapping[pendingKeys[i4]] = getValueForKey(pendingKeys[i4]);
  }
  return childMapping;
}
var identity = (i4) => i4;
var TransitionGroup = class extends b {
  constructor(props, context) {
    super(props, context);
    this.refs = {};
    this.state = {
      children: getChildMapping(H(H(this.props.children)) || [])
    };
    this.performAppear = this.performAppear.bind(this);
    this.performEnter = this.performEnter.bind(this);
    this.performLeave = this.performLeave.bind(this);
  }
  componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToAbortLeave = [];
    this.keysToEnter = [];
    this.keysToLeave = [];
  }
  componentDidMount() {
    const initialChildMapping = this.state.children;
    for (const key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    const nextChildMapping = getChildMapping(H(nextProps.children) || []);
    const prevChildMapping = this.state.children;
    this.setState((prevState) => ({
      children: mergeChildMappings(prevState.children, nextChildMapping)
    }));
    let key;
    for (key in nextChildMapping) {
      if (nextChildMapping.hasOwnProperty(key)) {
        const hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
        if (nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key]) {
          this.keysToEnter.push(key);
          this.keysToAbortLeave.push(key);
        } else if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
          this.keysToEnter.push(key);
        }
      }
    }
    for (key in prevChildMapping) {
      if (prevChildMapping.hasOwnProperty(key)) {
        const hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
        if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
          this.keysToLeave.push(key);
        }
      }
    }
  }
  componentDidUpdate() {
    const {
      keysToEnter
    } = this;
    this.keysToEnter = [];
    keysToEnter.forEach(this.performEnter);
    const {
      keysToLeave
    } = this;
    this.keysToLeave = [];
    keysToLeave.forEach(this.performLeave);
  }
  _finishAbort(key) {
    const idx = this.keysToAbortLeave.indexOf(key);
    if (idx !== -1) {
      this.keysToAbortLeave.splice(idx, 1);
    }
  }
  performAppear(key) {
    this.currentlyTransitioningKeys[key] = true;
    const component = this.refs[key];
    if (component != null && component.componentWillAppear) {
      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
    } else {
      this._handleDoneAppearing(key);
    }
  }
  _handleDoneAppearing(key) {
    const component = this.refs[key];
    if (component != null && component.componentDidAppear) {
      component.componentDidAppear();
    }
    delete this.currentlyTransitioningKeys[key];
    this._finishAbort(key);
    const currentChildMapping = getChildMapping(H(this.props.children) || []);
    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
      this.performLeave(key);
    }
  }
  performEnter(key) {
    this.currentlyTransitioningKeys[key] = true;
    const component = this.refs[key];
    if (component != null && component.componentWillEnter) {
      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
    } else {
      this._handleDoneEntering(key);
    }
  }
  _handleDoneEntering(key) {
    const component = this.refs[key];
    if (component != null && component.componentDidEnter) {
      component.componentDidEnter();
    }
    delete this.currentlyTransitioningKeys[key];
    this._finishAbort(key);
    const currentChildMapping = getChildMapping(H(this.props.children) || []);
    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
      this.performLeave(key);
    }
  }
  performLeave(key) {
    const idx = this.keysToAbortLeave.indexOf(key);
    if (idx !== -1) {
      return;
    }
    this.currentlyTransitioningKeys[key] = true;
    const component = this.refs[key];
    if (component != null && component.componentWillLeave) {
      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
    } else {
      this._handleDoneLeaving(key);
    }
  }
  _handleDoneLeaving(key) {
    const idx = this.keysToAbortLeave.indexOf(key);
    if (idx !== -1) {
      return;
    }
    const component = this.refs[key];
    if (component != null && component.componentDidLeave) {
      component.componentDidLeave();
    }
    delete this.currentlyTransitioningKeys[key];
    const currentChildMapping = getChildMapping(H(this.props.children) || []);
    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
      this.performEnter(key);
    } else {
      const children = assign({}, this.state.children);
      delete children[key];
      this.setState({
        children
      });
    }
  }
  render(_ref, _ref2) {
    let {
      childFactory,
      transitionLeave,
      transitionName: transitionName2,
      transitionAppear,
      transitionEnter,
      transitionLeaveTimeout,
      transitionEnterTimeout,
      transitionAppearTimeout,
      component,
      ...props
    } = _ref;
    let {
      children
    } = _ref2;
    const childrenToRender = Object.entries(children).map((_ref3) => {
      let [key, child] = _ref3;
      if (!child)
        return void 0;
      const ref = linkRef(this, key);
      return F(childFactory(child), {
        ref,
        key
      });
    }).filter(Boolean);
    return y(component, props, childrenToRender);
  }
};
TransitionGroup.defaultProps = {
  component: "span",
  childFactory: identity
};
var TransitionGroup_default = TransitionGroup;

// ../../node_modules/@uppy/informer/lib/Informer.js
var packageJson7 = {
  "version": "3.1.0"
};
var Informer = class extends UIPlugin_default {
  constructor(uppy2, opts) {
    super(uppy2, opts);
    this.render = (state) => {
      return y("div", {
        className: "uppy uppy-Informer"
      }, y(TransitionGroup_default, null, state.info.map((info) => y(FadeIn, {
        key: info.message
      }, y("p", {
        role: "alert"
      }, info.message, " ", info.details && y("span", {
        "aria-label": info.details,
        "data-microtip-position": "top-left",
        "data-microtip-size": "medium",
        role: "tooltip",
        onClick: () => (
          // eslint-disable-next-line no-alert
          alert(`${info.message} 

 ${info.details}`)
        )
      }, "?"))))));
    };
    this.type = "progressindicator";
    this.id = this.opts.id || "Informer";
    this.title = "Informer";
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }
};
Informer.VERSION = packageJson7.version;

// ../../node_modules/@uppy/utils/lib/dataURItoBlob.js
var DATA_URL_PATTERN = /^data:([^/]+\/[^,;]+(?:[^,]*?))(;base64)?,([\s\S]*)$/;
function dataURItoBlob(dataURI, opts, toFile) {
  var _ref, _opts$mimeType;
  const dataURIData = DATA_URL_PATTERN.exec(dataURI);
  const mimeType = (_ref = (_opts$mimeType = opts.mimeType) != null ? _opts$mimeType : dataURIData == null ? void 0 : dataURIData[1]) != null ? _ref : "plain/text";
  let data;
  if ((dataURIData == null ? void 0 : dataURIData[2]) != null) {
    const binary = atob(decodeURIComponent(dataURIData[3]));
    const bytes = new Uint8Array(binary.length);
    for (let i4 = 0; i4 < binary.length; i4++) {
      bytes[i4] = binary.charCodeAt(i4);
    }
    data = [bytes];
  } else if ((dataURIData == null ? void 0 : dataURIData[3]) != null) {
    data = [decodeURIComponent(dataURIData[3])];
  }
  if (toFile) {
    return new File(data, opts.name || "", {
      type: mimeType
    });
  }
  return new Blob(data, {
    type: mimeType
  });
}

// ../../node_modules/@uppy/utils/lib/isObjectURL.js
function isObjectURL(url) {
  return url.startsWith("blob:");
}

// ../../node_modules/@uppy/utils/lib/isPreviewSupported.js
function isPreviewSupported(fileType) {
  if (!fileType)
    return false;
  return /^[^/]+\/(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(fileType);
}

// ../../node_modules/exifr/dist/mini.esm.mjs
function e2(e4, t4, s4) {
  return t4 in e4 ? Object.defineProperty(e4, t4, { value: s4, enumerable: true, configurable: true, writable: true }) : e4[t4] = s4, e4;
}
var t2 = "undefined" != typeof self ? self : global;
var s2 = "undefined" != typeof navigator;
var i2 = s2 && "undefined" == typeof HTMLImageElement;
var n2 = !("undefined" == typeof global || "undefined" == typeof process || !process.versions || !process.versions.node);
var r2 = t2.Buffer;
var a2 = !!r2;
var h2 = (e4) => void 0 !== e4;
function f2(e4) {
  return void 0 === e4 || (e4 instanceof Map ? 0 === e4.size : 0 === Object.values(e4).filter(h2).length);
}
function l2(e4) {
  let t4 = new Error(e4);
  throw delete t4.stack, t4;
}
function o2(e4) {
  let t4 = function(e5) {
    let t5 = 0;
    return e5.ifd0.enabled && (t5 += 1024), e5.exif.enabled && (t5 += 2048), e5.makerNote && (t5 += 2048), e5.userComment && (t5 += 1024), e5.gps.enabled && (t5 += 512), e5.interop.enabled && (t5 += 100), e5.ifd1.enabled && (t5 += 1024), t5 + 2048;
  }(e4);
  return e4.jfif.enabled && (t4 += 50), e4.xmp.enabled && (t4 += 2e4), e4.iptc.enabled && (t4 += 14e3), e4.icc.enabled && (t4 += 6e3), t4;
}
var u2 = (e4) => String.fromCharCode.apply(null, e4);
var d2 = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
var c2 = class _c {
  static from(e4, t4) {
    return e4 instanceof this && e4.le === t4 ? e4 : new _c(e4, void 0, void 0, t4);
  }
  constructor(e4, t4 = 0, s4, i4) {
    if ("boolean" == typeof i4 && (this.le = i4), Array.isArray(e4) && (e4 = new Uint8Array(e4)), 0 === e4)
      this.byteOffset = 0, this.byteLength = 0;
    else if (e4 instanceof ArrayBuffer) {
      void 0 === s4 && (s4 = e4.byteLength - t4);
      let i5 = new DataView(e4, t4, s4);
      this._swapDataView(i5);
    } else if (e4 instanceof Uint8Array || e4 instanceof DataView || e4 instanceof _c) {
      void 0 === s4 && (s4 = e4.byteLength - t4), (t4 += e4.byteOffset) + s4 > e4.byteOffset + e4.byteLength && l2("Creating view outside of available memory in ArrayBuffer");
      let i5 = new DataView(e4.buffer, t4, s4);
      this._swapDataView(i5);
    } else if ("number" == typeof e4) {
      let t5 = new DataView(new ArrayBuffer(e4));
      this._swapDataView(t5);
    } else
      l2("Invalid input argument for BufferView: " + e4);
  }
  _swapArrayBuffer(e4) {
    this._swapDataView(new DataView(e4));
  }
  _swapBuffer(e4) {
    this._swapDataView(new DataView(e4.buffer, e4.byteOffset, e4.byteLength));
  }
  _swapDataView(e4) {
    this.dataView = e4, this.buffer = e4.buffer, this.byteOffset = e4.byteOffset, this.byteLength = e4.byteLength;
  }
  _lengthToEnd(e4) {
    return this.byteLength - e4;
  }
  set(e4, t4, s4 = _c) {
    return e4 instanceof DataView || e4 instanceof _c ? e4 = new Uint8Array(e4.buffer, e4.byteOffset, e4.byteLength) : e4 instanceof ArrayBuffer && (e4 = new Uint8Array(e4)), e4 instanceof Uint8Array || l2("BufferView.set(): Invalid data argument."), this.toUint8().set(e4, t4), new s4(this, t4, e4.byteLength);
  }
  subarray(e4, t4) {
    return t4 = t4 || this._lengthToEnd(e4), new _c(this, e4, t4);
  }
  toUint8() {
    return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
  }
  getUint8Array(e4, t4) {
    return new Uint8Array(this.buffer, this.byteOffset + e4, t4);
  }
  getString(e4 = 0, t4 = this.byteLength) {
    let s4 = this.getUint8Array(e4, t4);
    return i4 = s4, d2 ? d2.decode(i4) : a2 ? Buffer.from(i4).toString("utf8") : decodeURIComponent(escape(u2(i4)));
    var i4;
  }
  getLatin1String(e4 = 0, t4 = this.byteLength) {
    let s4 = this.getUint8Array(e4, t4);
    return u2(s4);
  }
  getUnicodeString(e4 = 0, t4 = this.byteLength) {
    const s4 = [];
    for (let i4 = 0; i4 < t4 && e4 + i4 < this.byteLength; i4 += 2)
      s4.push(this.getUint16(e4 + i4));
    return u2(s4);
  }
  getInt8(e4) {
    return this.dataView.getInt8(e4);
  }
  getUint8(e4) {
    return this.dataView.getUint8(e4);
  }
  getInt16(e4, t4 = this.le) {
    return this.dataView.getInt16(e4, t4);
  }
  getInt32(e4, t4 = this.le) {
    return this.dataView.getInt32(e4, t4);
  }
  getUint16(e4, t4 = this.le) {
    return this.dataView.getUint16(e4, t4);
  }
  getUint32(e4, t4 = this.le) {
    return this.dataView.getUint32(e4, t4);
  }
  getFloat32(e4, t4 = this.le) {
    return this.dataView.getFloat32(e4, t4);
  }
  getFloat64(e4, t4 = this.le) {
    return this.dataView.getFloat64(e4, t4);
  }
  getFloat(e4, t4 = this.le) {
    return this.dataView.getFloat32(e4, t4);
  }
  getDouble(e4, t4 = this.le) {
    return this.dataView.getFloat64(e4, t4);
  }
  getUintBytes(e4, t4, s4) {
    switch (t4) {
      case 1:
        return this.getUint8(e4, s4);
      case 2:
        return this.getUint16(e4, s4);
      case 4:
        return this.getUint32(e4, s4);
      case 8:
        return this.getUint64 && this.getUint64(e4, s4);
    }
  }
  getUint(e4, t4, s4) {
    switch (t4) {
      case 8:
        return this.getUint8(e4, s4);
      case 16:
        return this.getUint16(e4, s4);
      case 32:
        return this.getUint32(e4, s4);
      case 64:
        return this.getUint64 && this.getUint64(e4, s4);
    }
  }
  toString(e4) {
    return this.dataView.toString(e4, this.constructor.name);
  }
  ensureChunk() {
  }
};
function p2(e4, t4) {
  l2(`${e4} '${t4}' was not loaded, try using full build of exifr.`);
}
var g2 = class extends Map {
  constructor(e4) {
    super(), this.kind = e4;
  }
  get(e4, t4) {
    return this.has(e4) || p2(this.kind, e4), t4 && (e4 in t4 || function(e5, t5) {
      l2(`Unknown ${e5} '${t5}'.`);
    }(this.kind, e4), t4[e4].enabled || p2(this.kind, e4)), super.get(e4);
  }
  keyList() {
    return Array.from(this.keys());
  }
};
var m2 = new g2("file parser");
var y2 = new g2("segment parser");
var b2 = new g2("file reader");
var w2 = t2.fetch;
function k2(e4, t4) {
  return (i4 = e4).startsWith("data:") || i4.length > 1e4 ? v2(e4, t4, "base64") : n2 && e4.includes("://") ? O2(e4, t4, "url", S2) : n2 ? v2(e4, t4, "fs") : s2 ? O2(e4, t4, "url", S2) : void l2("Invalid input argument");
  var i4;
}
async function O2(e4, t4, s4, i4) {
  return b2.has(s4) ? v2(e4, t4, s4) : i4 ? async function(e5, t5) {
    let s5 = await t5(e5);
    return new c2(s5);
  }(e4, i4) : void l2(`Parser ${s4} is not loaded`);
}
async function v2(e4, t4, s4) {
  let i4 = new (b2.get(s4))(e4, t4);
  return await i4.read(), i4;
}
var S2 = (e4) => w2(e4).then((e5) => e5.arrayBuffer());
var A2 = (e4) => new Promise((t4, s4) => {
  let i4 = new FileReader();
  i4.onloadend = () => t4(i4.result || new ArrayBuffer()), i4.onerror = s4, i4.readAsArrayBuffer(e4);
});
var U = class extends Map {
  get tagKeys() {
    return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
  }
  get tagValues() {
    return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
  }
};
function x2(e4, t4, s4) {
  let i4 = new U();
  for (let [e5, t5] of s4)
    i4.set(e5, t5);
  if (Array.isArray(t4))
    for (let s5 of t4)
      e4.set(s5, i4);
  else
    e4.set(t4, i4);
  return i4;
}
function C2(e4, t4, s4) {
  let i4, n3 = e4.get(t4);
  for (i4 of s4)
    n3.set(i4[0], i4[1]);
}
var B2 = /* @__PURE__ */ new Map();
var V = /* @__PURE__ */ new Map();
var I2 = /* @__PURE__ */ new Map();
var L2 = ["chunked", "firstChunkSize", "firstChunkSizeNode", "firstChunkSizeBrowser", "chunkSize", "chunkLimit"];
var T2 = ["jfif", "xmp", "icc", "iptc", "ihdr"];
var z2 = ["tiff", ...T2];
var P2 = ["ifd0", "ifd1", "exif", "gps", "interop"];
var F2 = [...z2, ...P2];
var j2 = ["makerNote", "userComment"];
var E = ["translateKeys", "translateValues", "reviveValues", "multiSegment"];
var M2 = [...E, "sanitize", "mergeOutput", "silentErrors"];
var _2 = class {
  get translate() {
    return this.translateKeys || this.translateValues || this.reviveValues;
  }
};
var D2 = class extends _2 {
  get needed() {
    return this.enabled || this.deps.size > 0;
  }
  constructor(t4, s4, i4, n3) {
    if (super(), e2(this, "enabled", false), e2(this, "skip", /* @__PURE__ */ new Set()), e2(this, "pick", /* @__PURE__ */ new Set()), e2(this, "deps", /* @__PURE__ */ new Set()), e2(this, "translateKeys", false), e2(this, "translateValues", false), e2(this, "reviveValues", false), this.key = t4, this.enabled = s4, this.parse = this.enabled, this.applyInheritables(n3), this.canBeFiltered = P2.includes(t4), this.canBeFiltered && (this.dict = B2.get(t4)), void 0 !== i4)
      if (Array.isArray(i4))
        this.parse = this.enabled = true, this.canBeFiltered && i4.length > 0 && this.translateTagSet(i4, this.pick);
      else if ("object" == typeof i4) {
        if (this.enabled = true, this.parse = false !== i4.parse, this.canBeFiltered) {
          let { pick: e4, skip: t5 } = i4;
          e4 && e4.length > 0 && this.translateTagSet(e4, this.pick), t5 && t5.length > 0 && this.translateTagSet(t5, this.skip);
        }
        this.applyInheritables(i4);
      } else
        true === i4 || false === i4 ? this.parse = this.enabled = i4 : l2(`Invalid options argument: ${i4}`);
  }
  applyInheritables(e4) {
    let t4, s4;
    for (t4 of E)
      s4 = e4[t4], void 0 !== s4 && (this[t4] = s4);
  }
  translateTagSet(e4, t4) {
    if (this.dict) {
      let s4, i4, { tagKeys: n3, tagValues: r4 } = this.dict;
      for (s4 of e4)
        "string" == typeof s4 ? (i4 = r4.indexOf(s4), -1 === i4 && (i4 = n3.indexOf(Number(s4))), -1 !== i4 && t4.add(Number(n3[i4]))) : t4.add(s4);
    } else
      for (let s4 of e4)
        t4.add(s4);
  }
  finalizeFilters() {
    !this.enabled && this.deps.size > 0 ? (this.enabled = true, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
  }
};
var N2 = { jfif: false, tiff: true, xmp: false, icc: false, iptc: false, ifd0: true, ifd1: false, exif: true, gps: true, interop: false, ihdr: void 0, makerNote: false, userComment: false, multiSegment: false, skip: [], pick: [], translateKeys: true, translateValues: true, reviveValues: true, sanitize: true, mergeOutput: true, silentErrors: true, chunked: true, firstChunkSize: void 0, firstChunkSizeNode: 512, firstChunkSizeBrowser: 65536, chunkSize: 65536, chunkLimit: 5 };
var $2 = /* @__PURE__ */ new Map();
var R = class extends _2 {
  static useCached(e4) {
    let t4 = $2.get(e4);
    return void 0 !== t4 || (t4 = new this(e4), $2.set(e4, t4)), t4;
  }
  constructor(e4) {
    super(), true === e4 ? this.setupFromTrue() : void 0 === e4 ? this.setupFromUndefined() : Array.isArray(e4) ? this.setupFromArray(e4) : "object" == typeof e4 ? this.setupFromObject(e4) : l2(`Invalid options argument ${e4}`), void 0 === this.firstChunkSize && (this.firstChunkSize = s2 ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = false), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
  }
  setupFromUndefined() {
    let e4;
    for (e4 of L2)
      this[e4] = N2[e4];
    for (e4 of M2)
      this[e4] = N2[e4];
    for (e4 of j2)
      this[e4] = N2[e4];
    for (e4 of F2)
      this[e4] = new D2(e4, N2[e4], void 0, this);
  }
  setupFromTrue() {
    let e4;
    for (e4 of L2)
      this[e4] = N2[e4];
    for (e4 of M2)
      this[e4] = N2[e4];
    for (e4 of j2)
      this[e4] = true;
    for (e4 of F2)
      this[e4] = new D2(e4, true, void 0, this);
  }
  setupFromArray(e4) {
    let t4;
    for (t4 of L2)
      this[t4] = N2[t4];
    for (t4 of M2)
      this[t4] = N2[t4];
    for (t4 of j2)
      this[t4] = N2[t4];
    for (t4 of F2)
      this[t4] = new D2(t4, false, void 0, this);
    this.setupGlobalFilters(e4, void 0, P2);
  }
  setupFromObject(e4) {
    let t4;
    for (t4 of (P2.ifd0 = P2.ifd0 || P2.image, P2.ifd1 = P2.ifd1 || P2.thumbnail, Object.assign(this, e4), L2))
      this[t4] = W(e4[t4], N2[t4]);
    for (t4 of M2)
      this[t4] = W(e4[t4], N2[t4]);
    for (t4 of j2)
      this[t4] = W(e4[t4], N2[t4]);
    for (t4 of z2)
      this[t4] = new D2(t4, N2[t4], e4[t4], this);
    for (t4 of P2)
      this[t4] = new D2(t4, N2[t4], e4[t4], this.tiff);
    this.setupGlobalFilters(e4.pick, e4.skip, P2, F2), true === e4.tiff ? this.batchEnableWithBool(P2, true) : false === e4.tiff ? this.batchEnableWithUserValue(P2, e4) : Array.isArray(e4.tiff) ? this.setupGlobalFilters(e4.tiff, void 0, P2) : "object" == typeof e4.tiff && this.setupGlobalFilters(e4.tiff.pick, e4.tiff.skip, P2);
  }
  batchEnableWithBool(e4, t4) {
    for (let s4 of e4)
      this[s4].enabled = t4;
  }
  batchEnableWithUserValue(e4, t4) {
    for (let s4 of e4) {
      let e5 = t4[s4];
      this[s4].enabled = false !== e5 && void 0 !== e5;
    }
  }
  setupGlobalFilters(e4, t4, s4, i4 = s4) {
    if (e4 && e4.length) {
      for (let e5 of i4)
        this[e5].enabled = false;
      let t5 = K(e4, s4);
      for (let [e5, s5] of t5)
        X(this[e5].pick, s5), this[e5].enabled = true;
    } else if (t4 && t4.length) {
      let e5 = K(t4, s4);
      for (let [t5, s5] of e5)
        X(this[t5].skip, s5);
    }
  }
  filterNestedSegmentTags() {
    let { ifd0: e4, exif: t4, xmp: s4, iptc: i4, icc: n3 } = this;
    this.makerNote ? t4.deps.add(37500) : t4.skip.add(37500), this.userComment ? t4.deps.add(37510) : t4.skip.add(37510), s4.enabled || e4.skip.add(700), i4.enabled || e4.skip.add(33723), n3.enabled || e4.skip.add(34675);
  }
  traverseTiffDependencyTree() {
    let { ifd0: e4, exif: t4, gps: s4, interop: i4 } = this;
    i4.needed && (t4.deps.add(40965), e4.deps.add(40965)), t4.needed && e4.deps.add(34665), s4.needed && e4.deps.add(34853), this.tiff.enabled = P2.some((e5) => true === this[e5].enabled) || this.makerNote || this.userComment;
    for (let e5 of P2)
      this[e5].finalizeFilters();
  }
  get onlyTiff() {
    return !T2.map((e4) => this[e4].enabled).some((e4) => true === e4) && this.tiff.enabled;
  }
  checkLoadedPlugins() {
    for (let e4 of z2)
      this[e4].enabled && !y2.has(e4) && p2("segment parser", e4);
  }
};
function K(e4, t4) {
  let s4, i4, n3, r4, a4 = [];
  for (n3 of t4) {
    for (r4 of (s4 = B2.get(n3), i4 = [], s4))
      (e4.includes(r4[0]) || e4.includes(r4[1])) && i4.push(r4[0]);
    i4.length && a4.push([n3, i4]);
  }
  return a4;
}
function W(e4, t4) {
  return void 0 !== e4 ? e4 : void 0 !== t4 ? t4 : void 0;
}
function X(e4, t4) {
  for (let s4 of t4)
    e4.add(s4);
}
e2(R, "default", N2);
var H2 = class {
  constructor(t4) {
    e2(this, "parsers", {}), e2(this, "output", {}), e2(this, "errors", []), e2(this, "pushToErrors", (e4) => this.errors.push(e4)), this.options = R.useCached(t4);
  }
  async read(e4) {
    this.file = await function(e5, t4) {
      return "string" == typeof e5 ? k2(e5, t4) : s2 && !i2 && e5 instanceof HTMLImageElement ? k2(e5.src, t4) : e5 instanceof Uint8Array || e5 instanceof ArrayBuffer || e5 instanceof DataView ? new c2(e5) : s2 && e5 instanceof Blob ? O2(e5, t4, "blob", A2) : void l2("Invalid input argument");
    }(e4, this.options);
  }
  setup() {
    if (this.fileParser)
      return;
    let { file: e4 } = this, t4 = e4.getUint16(0);
    for (let [s4, i4] of m2)
      if (i4.canHandle(e4, t4))
        return this.fileParser = new i4(this.options, this.file, this.parsers), e4[s4] = true;
    this.file.close && this.file.close(), l2("Unknown file format");
  }
  async parse() {
    let { output: e4, errors: t4 } = this;
    return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), t4.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && t4.length > 0 && (e4.errors = t4), f2(s4 = e4) ? void 0 : s4;
    var s4;
  }
  async executeParsers() {
    let { output: e4 } = this;
    await this.fileParser.parse();
    let t4 = Object.values(this.parsers).map(async (t5) => {
      let s4 = await t5.parse();
      t5.assignToOutput(e4, s4);
    });
    this.options.silentErrors && (t4 = t4.map((e5) => e5.catch(this.pushToErrors))), await Promise.all(t4);
  }
  async extractThumbnail() {
    this.setup();
    let { options: e4, file: t4 } = this, s4 = y2.get("tiff", e4);
    var i4;
    if (t4.tiff ? i4 = { start: 0, type: "tiff" } : t4.jpeg && (i4 = await this.fileParser.getOrFindSegment("tiff")), void 0 === i4)
      return;
    let n3 = await this.fileParser.ensureSegmentChunk(i4), r4 = this.parsers.tiff = new s4(n3, e4, t4), a4 = await r4.extractThumbnail();
    return t4.close && t4.close(), a4;
  }
};
async function Y(e4, t4) {
  let s4 = new H2(t4);
  return await s4.read(e4), s4.parse();
}
var G = Object.freeze({ __proto__: null, parse: Y, Exifr: H2, fileParsers: m2, segmentParsers: y2, fileReaders: b2, tagKeys: B2, tagValues: V, tagRevivers: I2, createDictionary: x2, extendDictionary: C2, fetchUrlAsArrayBuffer: S2, readBlobAsArrayBuffer: A2, chunkedProps: L2, otherSegments: T2, segments: z2, tiffBlocks: P2, segmentsAndBlocks: F2, tiffExtractables: j2, inheritables: E, allFormatters: M2, Options: R });
var J = class {
  static findPosition(e4, t4) {
    let s4 = e4.getUint16(t4 + 2) + 2, i4 = "function" == typeof this.headerLength ? this.headerLength(e4, t4, s4) : this.headerLength, n3 = t4 + i4, r4 = s4 - i4;
    return { offset: t4, length: s4, headerLength: i4, start: n3, size: r4, end: n3 + r4 };
  }
  static parse(e4, t4 = {}) {
    return new this(e4, new R({ [this.type]: t4 }), e4).parse();
  }
  normalizeInput(e4) {
    return e4 instanceof c2 ? e4 : new c2(e4);
  }
  constructor(t4, s4 = {}, i4) {
    e2(this, "errors", []), e2(this, "raw", /* @__PURE__ */ new Map()), e2(this, "handleError", (e4) => {
      if (!this.options.silentErrors)
        throw e4;
      this.errors.push(e4.message);
    }), this.chunk = this.normalizeInput(t4), this.file = i4, this.type = this.constructor.type, this.globalOptions = this.options = s4, this.localOptions = s4[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
  }
  translate() {
    this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
  }
  get output() {
    return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
  }
  translateBlock(e4, t4) {
    let s4 = I2.get(t4), i4 = V.get(t4), n3 = B2.get(t4), r4 = this.options[t4], a4 = r4.reviveValues && !!s4, h10 = r4.translateValues && !!i4, f4 = r4.translateKeys && !!n3, l4 = {};
    for (let [t5, r5] of e4)
      a4 && s4.has(t5) ? r5 = s4.get(t5)(r5) : h10 && i4.has(t5) && (r5 = this.translateValue(r5, i4.get(t5))), f4 && n3.has(t5) && (t5 = n3.get(t5) || t5), l4[t5] = r5;
    return l4;
  }
  translateValue(e4, t4) {
    return t4[e4] || t4.DEFAULT || e4;
  }
  assignToOutput(e4, t4) {
    this.assignObjectToOutput(e4, this.constructor.type, t4);
  }
  assignObjectToOutput(e4, t4, s4) {
    if (this.globalOptions.mergeOutput)
      return Object.assign(e4, s4);
    e4[t4] ? Object.assign(e4[t4], s4) : e4[t4] = s4;
  }
};
e2(J, "headerLength", 4), e2(J, "type", void 0), e2(J, "multiSegment", false), e2(J, "canHandle", () => false);
function q2(e4) {
  return 192 === e4 || 194 === e4 || 196 === e4 || 219 === e4 || 221 === e4 || 218 === e4 || 254 === e4;
}
function Q(e4) {
  return e4 >= 224 && e4 <= 239;
}
function Z(e4, t4, s4) {
  for (let [i4, n3] of y2)
    if (n3.canHandle(e4, t4, s4))
      return i4;
}
var ee3 = class extends class {
  constructor(t4, s4, i4) {
    e2(this, "errors", []), e2(this, "ensureSegmentChunk", async (e4) => {
      let t5 = e4.start, s5 = e4.size || 65536;
      if (this.file.chunked)
        if (this.file.available(t5, s5))
          e4.chunk = this.file.subarray(t5, s5);
        else
          try {
            e4.chunk = await this.file.readChunk(t5, s5);
          } catch (t6) {
            l2(`Couldn't read segment: ${JSON.stringify(e4)}. ${t6.message}`);
          }
      else
        this.file.byteLength > t5 + s5 ? e4.chunk = this.file.subarray(t5, s5) : void 0 === e4.size ? e4.chunk = this.file.subarray(t5) : l2("Segment unreachable: " + JSON.stringify(e4));
      return e4.chunk;
    }), this.extendOptions && this.extendOptions(t4), this.options = t4, this.file = s4, this.parsers = i4;
  }
  injectSegment(e4, t4) {
    this.options[e4].enabled && this.createParser(e4, t4);
  }
  createParser(e4, t4) {
    let s4 = new (y2.get(e4))(t4, this.options, this.file);
    return this.parsers[e4] = s4;
  }
  createParsers(e4) {
    for (let t4 of e4) {
      let { type: e5, chunk: s4 } = t4, i4 = this.options[e5];
      if (i4 && i4.enabled) {
        let t5 = this.parsers[e5];
        t5 && t5.append || t5 || this.createParser(e5, s4);
      }
    }
  }
  async readSegments(e4) {
    let t4 = e4.map(this.ensureSegmentChunk);
    await Promise.all(t4);
  }
} {
  constructor(...t4) {
    super(...t4), e2(this, "appSegments", []), e2(this, "jpegSegments", []), e2(this, "unknownSegments", []);
  }
  static canHandle(e4, t4) {
    return 65496 === t4;
  }
  async parse() {
    await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
  }
  setupSegmentFinderArgs(e4) {
    true === e4 ? (this.findAll = true, this.wanted = new Set(y2.keyList())) : (e4 = void 0 === e4 ? y2.keyList().filter((e5) => this.options[e5].enabled) : e4.filter((e5) => this.options[e5].enabled && y2.has(e5)), this.findAll = false, this.remaining = new Set(e4), this.wanted = new Set(e4)), this.unfinishedMultiSegment = false;
  }
  async findAppSegments(e4 = 0, t4) {
    this.setupSegmentFinderArgs(t4);
    let { file: s4, findAll: i4, wanted: n3, remaining: r4 } = this;
    if (!i4 && this.file.chunked && (i4 = Array.from(n3).some((e5) => {
      let t5 = y2.get(e5), s5 = this.options[e5];
      return t5.multiSegment && s5.multiSegment;
    }), i4 && await this.file.readWhole()), e4 = this.findAppSegmentsInRange(e4, s4.byteLength), !this.options.onlyTiff && s4.chunked) {
      let t5 = false;
      for (; r4.size > 0 && !t5 && (s4.canReadNextChunk || this.unfinishedMultiSegment); ) {
        let { nextChunkOffset: i5 } = s4, n4 = this.appSegments.some((e5) => !this.file.available(e5.offset || e5.start, e5.length || e5.size));
        if (t5 = e4 > i5 && !n4 ? !await s4.readNextChunk(e4) : !await s4.readNextChunk(i5), void 0 === (e4 = this.findAppSegmentsInRange(e4, s4.byteLength)))
          return;
      }
    }
  }
  findAppSegmentsInRange(e4, t4) {
    t4 -= 2;
    let s4, i4, n3, r4, a4, h10, { file: f4, findAll: l4, wanted: o4, remaining: u4, options: d4 } = this;
    for (; e4 < t4; e4++)
      if (255 === f4.getUint8(e4)) {
        if (s4 = f4.getUint8(e4 + 1), Q(s4)) {
          if (i4 = f4.getUint16(e4 + 2), n3 = Z(f4, e4, i4), n3 && o4.has(n3) && (r4 = y2.get(n3), a4 = r4.findPosition(f4, e4), h10 = d4[n3], a4.type = n3, this.appSegments.push(a4), !l4 && (r4.multiSegment && h10.multiSegment ? (this.unfinishedMultiSegment = a4.chunkNumber < a4.chunkCount, this.unfinishedMultiSegment || u4.delete(n3)) : u4.delete(n3), 0 === u4.size)))
            break;
          d4.recordUnknownSegments && (a4 = J.findPosition(f4, e4), a4.marker = s4, this.unknownSegments.push(a4)), e4 += i4 + 1;
        } else if (q2(s4)) {
          if (i4 = f4.getUint16(e4 + 2), 218 === s4 && false !== d4.stopAfterSos)
            return;
          d4.recordJpegSegments && this.jpegSegments.push({ offset: e4, length: i4, marker: s4 }), e4 += i4 + 1;
        }
      }
    return e4;
  }
  mergeMultiSegments() {
    if (!this.appSegments.some((e5) => e5.multiSegment))
      return;
    let e4 = function(e5, t4) {
      let s4, i4, n3, r4 = /* @__PURE__ */ new Map();
      for (let a4 = 0; a4 < e5.length; a4++)
        s4 = e5[a4], i4 = s4[t4], r4.has(i4) ? n3 = r4.get(i4) : r4.set(i4, n3 = []), n3.push(s4);
      return Array.from(r4);
    }(this.appSegments, "type");
    this.mergedAppSegments = e4.map(([e5, t4]) => {
      let s4 = y2.get(e5, this.options);
      if (s4.handleMultiSegments) {
        return { type: e5, chunk: s4.handleMultiSegments(t4) };
      }
      return t4[0];
    });
  }
  getSegment(e4) {
    return this.appSegments.find((t4) => t4.type === e4);
  }
  async getOrFindSegment(e4) {
    let t4 = this.getSegment(e4);
    return void 0 === t4 && (await this.findAppSegments(0, [e4]), t4 = this.getSegment(e4)), t4;
  }
};
e2(ee3, "type", "jpeg"), m2.set("jpeg", ee3);
var te = [void 0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8, 4];
var se = class extends J {
  parseHeader() {
    var e4 = this.chunk.getUint16();
    18761 === e4 ? this.le = true : 19789 === e4 && (this.le = false), this.chunk.le = this.le, this.headerParsed = true;
  }
  parseTags(e4, t4, s4 = /* @__PURE__ */ new Map()) {
    let { pick: i4, skip: n3 } = this.options[t4];
    i4 = new Set(i4);
    let r4 = i4.size > 0, a4 = 0 === n3.size, h10 = this.chunk.getUint16(e4);
    e4 += 2;
    for (let f4 = 0; f4 < h10; f4++) {
      let h11 = this.chunk.getUint16(e4);
      if (r4) {
        if (i4.has(h11) && (s4.set(h11, this.parseTag(e4, h11, t4)), i4.delete(h11), 0 === i4.size))
          break;
      } else
        !a4 && n3.has(h11) || s4.set(h11, this.parseTag(e4, h11, t4));
      e4 += 12;
    }
    return s4;
  }
  parseTag(e4, t4, s4) {
    let { chunk: i4 } = this, n3 = i4.getUint16(e4 + 2), r4 = i4.getUint32(e4 + 4), a4 = te[n3];
    if (a4 * r4 <= 4 ? e4 += 8 : e4 = i4.getUint32(e4 + 8), (n3 < 1 || n3 > 13) && l2(`Invalid TIFF value type. block: ${s4.toUpperCase()}, tag: ${t4.toString(16)}, type: ${n3}, offset ${e4}`), e4 > i4.byteLength && l2(`Invalid TIFF value offset. block: ${s4.toUpperCase()}, tag: ${t4.toString(16)}, type: ${n3}, offset ${e4} is outside of chunk size ${i4.byteLength}`), 1 === n3)
      return i4.getUint8Array(e4, r4);
    if (2 === n3)
      return "" === (h10 = function(e5) {
        for (; e5.endsWith("\0"); )
          e5 = e5.slice(0, -1);
        return e5;
      }(h10 = i4.getString(e4, r4)).trim()) ? void 0 : h10;
    var h10;
    if (7 === n3)
      return i4.getUint8Array(e4, r4);
    if (1 === r4)
      return this.parseTagValue(n3, e4);
    {
      let t5 = new (function(e5) {
        switch (e5) {
          case 1:
            return Uint8Array;
          case 3:
            return Uint16Array;
          case 4:
            return Uint32Array;
          case 5:
            return Array;
          case 6:
            return Int8Array;
          case 8:
            return Int16Array;
          case 9:
            return Int32Array;
          case 10:
            return Array;
          case 11:
            return Float32Array;
          case 12:
            return Float64Array;
          default:
            return Array;
        }
      }(n3))(r4), s5 = a4;
      for (let i5 = 0; i5 < r4; i5++)
        t5[i5] = this.parseTagValue(n3, e4), e4 += s5;
      return t5;
    }
  }
  parseTagValue(e4, t4) {
    let { chunk: s4 } = this;
    switch (e4) {
      case 1:
        return s4.getUint8(t4);
      case 3:
        return s4.getUint16(t4);
      case 4:
        return s4.getUint32(t4);
      case 5:
        return s4.getUint32(t4) / s4.getUint32(t4 + 4);
      case 6:
        return s4.getInt8(t4);
      case 8:
        return s4.getInt16(t4);
      case 9:
        return s4.getInt32(t4);
      case 10:
        return s4.getInt32(t4) / s4.getInt32(t4 + 4);
      case 11:
        return s4.getFloat(t4);
      case 12:
        return s4.getDouble(t4);
      case 13:
        return s4.getUint32(t4);
      default:
        l2(`Invalid tiff type ${e4}`);
    }
  }
};
var ie = class extends se {
  static canHandle(e4, t4) {
    return 225 === e4.getUint8(t4 + 1) && 1165519206 === e4.getUint32(t4 + 4) && 0 === e4.getUint16(t4 + 8);
  }
  async parse() {
    this.parseHeader();
    let { options: e4 } = this;
    return e4.ifd0.enabled && await this.parseIfd0Block(), e4.exif.enabled && await this.safeParse("parseExifBlock"), e4.gps.enabled && await this.safeParse("parseGpsBlock"), e4.interop.enabled && await this.safeParse("parseInteropBlock"), e4.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
  }
  safeParse(e4) {
    let t4 = this[e4]();
    return void 0 !== t4.catch && (t4 = t4.catch(this.handleError)), t4;
  }
  findIfd0Offset() {
    void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
  }
  findIfd1Offset() {
    if (void 0 === this.ifd1Offset) {
      this.findIfd0Offset();
      let e4 = this.chunk.getUint16(this.ifd0Offset), t4 = this.ifd0Offset + 2 + 12 * e4;
      this.ifd1Offset = this.chunk.getUint32(t4);
    }
  }
  parseBlock(e4, t4) {
    let s4 = /* @__PURE__ */ new Map();
    return this[t4] = s4, this.parseTags(e4, t4, s4), s4;
  }
  async parseIfd0Block() {
    if (this.ifd0)
      return;
    let { file: e4 } = this;
    this.findIfd0Offset(), this.ifd0Offset < 8 && l2("Malformed EXIF data"), !e4.chunked && this.ifd0Offset > e4.byteLength && l2(`IFD0 offset points to outside of file.
this.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${e4.byteLength}`), e4.tiff && await e4.ensureChunk(this.ifd0Offset, o2(this.options));
    let t4 = this.parseBlock(this.ifd0Offset, "ifd0");
    return 0 !== t4.size ? (this.exifOffset = t4.get(34665), this.interopOffset = t4.get(40965), this.gpsOffset = t4.get(34853), this.xmp = t4.get(700), this.iptc = t4.get(33723), this.icc = t4.get(34675), this.options.sanitize && (t4.delete(34665), t4.delete(40965), t4.delete(34853), t4.delete(700), t4.delete(33723), t4.delete(34675)), t4) : void 0;
  }
  async parseExifBlock() {
    if (this.exif)
      return;
    if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.exifOffset)
      return;
    this.file.tiff && await this.file.ensureChunk(this.exifOffset, o2(this.options));
    let e4 = this.parseBlock(this.exifOffset, "exif");
    return this.interopOffset || (this.interopOffset = e4.get(40965)), this.makerNote = e4.get(37500), this.userComment = e4.get(37510), this.options.sanitize && (e4.delete(40965), e4.delete(37500), e4.delete(37510)), this.unpack(e4, 41728), this.unpack(e4, 41729), e4;
  }
  unpack(e4, t4) {
    let s4 = e4.get(t4);
    s4 && 1 === s4.length && e4.set(t4, s4[0]);
  }
  async parseGpsBlock() {
    if (this.gps)
      return;
    if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.gpsOffset)
      return;
    let e4 = this.parseBlock(this.gpsOffset, "gps");
    return e4 && e4.has(2) && e4.has(4) && (e4.set("latitude", ne(...e4.get(2), e4.get(1))), e4.set("longitude", ne(...e4.get(4), e4.get(3)))), e4;
  }
  async parseInteropBlock() {
    if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), void 0 !== this.interopOffset || this.exif || await this.parseExifBlock(), void 0 !== this.interopOffset))
      return this.parseBlock(this.interopOffset, "interop");
  }
  async parseThumbnailBlock(e4 = false) {
    if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e4))
      return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = true), this.ifd1;
  }
  async extractThumbnail() {
    if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(true), void 0 === this.ifd1)
      return;
    let e4 = this.ifd1.get(513), t4 = this.ifd1.get(514);
    return this.chunk.getUint8Array(e4, t4);
  }
  get image() {
    return this.ifd0;
  }
  get thumbnail() {
    return this.ifd1;
  }
  createOutput() {
    let e4, t4, s4, i4 = {};
    for (t4 of P2)
      if (e4 = this[t4], !f2(e4))
        if (s4 = this.canTranslate ? this.translateBlock(e4, t4) : Object.fromEntries(e4), this.options.mergeOutput) {
          if ("ifd1" === t4)
            continue;
          Object.assign(i4, s4);
        } else
          i4[t4] = s4;
    return this.makerNote && (i4.makerNote = this.makerNote), this.userComment && (i4.userComment = this.userComment), i4;
  }
  assignToOutput(e4, t4) {
    if (this.globalOptions.mergeOutput)
      Object.assign(e4, t4);
    else
      for (let [s4, i4] of Object.entries(t4))
        this.assignObjectToOutput(e4, s4, i4);
  }
};
function ne(e4, t4, s4, i4) {
  var n3 = e4 + t4 / 60 + s4 / 3600;
  return "S" !== i4 && "W" !== i4 || (n3 *= -1), n3;
}
e2(ie, "type", "tiff"), e2(ie, "headerLength", 10), y2.set("tiff", ie);
var re = Object.freeze({ __proto__: null, default: G, Exifr: H2, fileParsers: m2, segmentParsers: y2, fileReaders: b2, tagKeys: B2, tagValues: V, tagRevivers: I2, createDictionary: x2, extendDictionary: C2, fetchUrlAsArrayBuffer: S2, readBlobAsArrayBuffer: A2, chunkedProps: L2, otherSegments: T2, segments: z2, tiffBlocks: P2, segmentsAndBlocks: F2, tiffExtractables: j2, inheritables: E, allFormatters: M2, Options: R, parse: Y });
var ae = { ifd0: false, ifd1: false, exif: false, gps: false, interop: false, sanitize: false, reviveValues: true, translateKeys: false, translateValues: false, mergeOutput: false };
var he = Object.assign({}, ae, { firstChunkSize: 4e4, gps: [1, 2, 3, 4] });
var le = Object.assign({}, ae, { tiff: false, ifd1: true, mergeOutput: false });
var de = Object.assign({}, ae, { firstChunkSize: 4e4, ifd0: [274] });
async function ce(e4) {
  let t4 = new H2(de);
  await t4.read(e4);
  let s4 = await t4.parse();
  if (s4 && s4.ifd0)
    return s4.ifd0[274];
}
var pe = Object.freeze({ 1: { dimensionSwapped: false, scaleX: 1, scaleY: 1, deg: 0, rad: 0 }, 2: { dimensionSwapped: false, scaleX: -1, scaleY: 1, deg: 0, rad: 0 }, 3: { dimensionSwapped: false, scaleX: 1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 4: { dimensionSwapped: false, scaleX: -1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 5: { dimensionSwapped: true, scaleX: 1, scaleY: -1, deg: 90, rad: 90 * Math.PI / 180 }, 6: { dimensionSwapped: true, scaleX: 1, scaleY: 1, deg: 90, rad: 90 * Math.PI / 180 }, 7: { dimensionSwapped: true, scaleX: 1, scaleY: -1, deg: 270, rad: 270 * Math.PI / 180 }, 8: { dimensionSwapped: true, scaleX: 1, scaleY: 1, deg: 270, rad: 270 * Math.PI / 180 } });
var ge = true;
var me = true;
if ("object" == typeof navigator) {
  let e4 = navigator.userAgent;
  if (e4.includes("iPad") || e4.includes("iPhone")) {
    let t4 = e4.match(/OS (\d+)_(\d+)/);
    if (t4) {
      let [, e5, s4] = t4, i4 = Number(e5) + 0.1 * Number(s4);
      ge = i4 < 13.4, me = false;
    }
  } else if (e4.includes("OS X 10")) {
    let [, t4] = e4.match(/OS X 10[_.](\d+)/);
    ge = me = Number(t4) < 15;
  }
  if (e4.includes("Chrome/")) {
    let [, t4] = e4.match(/Chrome\/(\d+)/);
    ge = me = Number(t4) < 81;
  } else if (e4.includes("Firefox/")) {
    let [, t4] = e4.match(/Firefox\/(\d+)/);
    ge = me = Number(t4) < 77;
  }
}
async function ye(e4) {
  let t4 = await ce(e4);
  return Object.assign({ canvas: ge, css: me }, pe[t4]);
}
var be = class extends c2 {
  constructor(...t4) {
    super(...t4), e2(this, "ranges", new we()), 0 !== this.byteLength && this.ranges.add(0, this.byteLength);
  }
  _tryExtend(e4, t4, s4) {
    if (0 === e4 && 0 === this.byteLength && s4) {
      let e5 = new DataView(s4.buffer || s4, s4.byteOffset, s4.byteLength);
      this._swapDataView(e5);
    } else {
      let s5 = e4 + t4;
      if (s5 > this.byteLength) {
        let { dataView: e5 } = this._extend(s5);
        this._swapDataView(e5);
      }
    }
  }
  _extend(e4) {
    let t4;
    t4 = a2 ? r2.allocUnsafe(e4) : new Uint8Array(e4);
    let s4 = new DataView(t4.buffer, t4.byteOffset, t4.byteLength);
    return t4.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), { uintView: t4, dataView: s4 };
  }
  subarray(e4, t4, s4 = false) {
    return t4 = t4 || this._lengthToEnd(e4), s4 && this._tryExtend(e4, t4), this.ranges.add(e4, t4), super.subarray(e4, t4);
  }
  set(e4, t4, s4 = false) {
    s4 && this._tryExtend(t4, e4.byteLength, e4);
    let i4 = super.set(e4, t4);
    return this.ranges.add(t4, i4.byteLength), i4;
  }
  async ensureChunk(e4, t4) {
    this.chunked && (this.ranges.available(e4, t4) || await this.readChunk(e4, t4));
  }
  available(e4, t4) {
    return this.ranges.available(e4, t4);
  }
};
var we = class {
  constructor() {
    e2(this, "list", []);
  }
  get length() {
    return this.list.length;
  }
  add(e4, t4, s4 = 0) {
    let i4 = e4 + t4, n3 = this.list.filter((t5) => ke(e4, t5.offset, i4) || ke(e4, t5.end, i4));
    if (n3.length > 0) {
      e4 = Math.min(e4, ...n3.map((e5) => e5.offset)), i4 = Math.max(i4, ...n3.map((e5) => e5.end)), t4 = i4 - e4;
      let s5 = n3.shift();
      s5.offset = e4, s5.length = t4, s5.end = i4, this.list = this.list.filter((e5) => !n3.includes(e5));
    } else
      this.list.push({ offset: e4, length: t4, end: i4 });
  }
  available(e4, t4) {
    let s4 = e4 + t4;
    return this.list.some((t5) => t5.offset <= e4 && s4 <= t5.end);
  }
};
function ke(e4, t4, s4) {
  return e4 <= t4 && t4 <= s4;
}
var Oe = class extends be {
  constructor(t4, s4) {
    super(0), e2(this, "chunksRead", 0), this.input = t4, this.options = s4;
  }
  async readWhole() {
    this.chunked = false, await this.readChunk(this.nextChunkOffset);
  }
  async readChunked() {
    this.chunked = true, await this.readChunk(0, this.options.firstChunkSize);
  }
  async readNextChunk(e4 = this.nextChunkOffset) {
    if (this.fullyRead)
      return this.chunksRead++, false;
    let t4 = this.options.chunkSize, s4 = await this.readChunk(e4, t4);
    return !!s4 && s4.byteLength === t4;
  }
  async readChunk(e4, t4) {
    if (this.chunksRead++, 0 !== (t4 = this.safeWrapAddress(e4, t4)))
      return this._readChunk(e4, t4);
  }
  safeWrapAddress(e4, t4) {
    return void 0 !== this.size && e4 + t4 > this.size ? Math.max(0, this.size - e4) : t4;
  }
  get nextChunkOffset() {
    if (0 !== this.ranges.list.length)
      return this.ranges.list[0].length;
  }
  get canReadNextChunk() {
    return this.chunksRead < this.options.chunkLimit;
  }
  get fullyRead() {
    return void 0 !== this.size && this.nextChunkOffset === this.size;
  }
  read() {
    return this.options.chunked ? this.readChunked() : this.readWhole();
  }
  close() {
  }
};
b2.set("blob", class extends Oe {
  async readWhole() {
    this.chunked = false;
    let e4 = await A2(this.input);
    this._swapArrayBuffer(e4);
  }
  readChunked() {
    return this.chunked = true, this.size = this.input.size, super.readChunked();
  }
  async _readChunk(e4, t4) {
    let s4 = t4 ? e4 + t4 : void 0, i4 = this.input.slice(e4, s4), n3 = await A2(i4);
    return this.set(n3, e4, true);
  }
});

// ../../node_modules/@uppy/thumbnail-generator/lib/locale.js
var locale_default4 = {
  strings: {
    generatingThumbnails: "Generating thumbnails..."
  }
};

// ../../node_modules/@uppy/thumbnail-generator/lib/index.js
var packageJson8 = {
  "version": "3.1.0"
};
function canvasToBlob(canvas, type, quality) {
  try {
    canvas.getContext("2d").getImageData(0, 0, 1, 1);
  } catch (err) {
    if (err.code === 18) {
      return Promise.reject(new Error("cannot read image, probably an svg with external resources"));
    }
  }
  if (canvas.toBlob) {
    return new Promise((resolve) => {
      canvas.toBlob(resolve, type, quality);
    }).then((blob) => {
      if (blob === null) {
        throw new Error("cannot read image, probably an svg with external resources");
      }
      return blob;
    });
  }
  return Promise.resolve().then(() => {
    return dataURItoBlob(canvas.toDataURL(type, quality), {});
  }).then((blob) => {
    if (blob === null) {
      throw new Error("could not extract blob, probably an old browser");
    }
    return blob;
  });
}
function rotateImage(image, translate) {
  let w4 = image.width;
  let h10 = image.height;
  if (translate.deg === 90 || translate.deg === 270) {
    w4 = image.height;
    h10 = image.width;
  }
  const canvas = document.createElement("canvas");
  canvas.width = w4;
  canvas.height = h10;
  const context = canvas.getContext("2d");
  context.translate(w4 / 2, h10 / 2);
  if (translate.canvas) {
    context.rotate(translate.rad);
    context.scale(translate.scaleX, translate.scaleY);
  }
  context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
  return canvas;
}
function protect(image) {
  const ratio = image.width / image.height;
  const maxSquare = 5e6;
  const maxSize = 4096;
  let maxW = Math.floor(Math.sqrt(maxSquare * ratio));
  let maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));
  if (maxW > maxSize) {
    maxW = maxSize;
    maxH = Math.round(maxW / ratio);
  }
  if (maxH > maxSize) {
    maxH = maxSize;
    maxW = Math.round(ratio * maxH);
  }
  if (image.width > maxW) {
    const canvas = document.createElement("canvas");
    canvas.width = maxW;
    canvas.height = maxH;
    canvas.getContext("2d").drawImage(image, 0, 0, maxW, maxH);
    return canvas;
  }
  return image;
}
var defaultOptions4 = {
  thumbnailWidth: null,
  thumbnailHeight: null,
  thumbnailType: "image/jpeg",
  waitForThumbnailsBeforeUpload: false,
  lazy: false
};
var ThumbnailGenerator = class extends UIPlugin_default {
  constructor(uppy2, opts) {
    super(uppy2, {
      ...defaultOptions4,
      ...opts
    });
    this.onFileAdded = (file) => {
      if (!file.preview && file.data && isPreviewSupported(file.type) && !file.isRemote) {
        this.addToQueue(file.id);
      }
    };
    this.onCancelRequest = (file) => {
      const index = this.queue.indexOf(file.id);
      if (index !== -1) {
        this.queue.splice(index, 1);
      }
    };
    this.onFileRemoved = (file) => {
      const index = this.queue.indexOf(file.id);
      if (index !== -1) {
        this.queue.splice(index, 1);
      }
      if (file.preview && isObjectURL(file.preview)) {
        URL.revokeObjectURL(file.preview);
      }
    };
    this.onRestored = () => {
      const restoredFiles = this.uppy.getFiles().filter((file) => file.isRestored);
      restoredFiles.forEach((file) => {
        if (!file.preview || isObjectURL(file.preview)) {
          this.addToQueue(file.id);
        }
      });
    };
    this.onAllFilesRemoved = () => {
      this.queue = [];
    };
    this.waitUntilAllProcessed = (fileIDs) => {
      fileIDs.forEach((fileID) => {
        const file = this.uppy.getFile(fileID);
        this.uppy.emit("preprocess-progress", file, {
          mode: "indeterminate",
          message: this.i18n("generatingThumbnails")
        });
      });
      const emitPreprocessCompleteForAll = () => {
        fileIDs.forEach((fileID) => {
          const file = this.uppy.getFile(fileID);
          this.uppy.emit("preprocess-complete", file);
        });
      };
      return new Promise((resolve) => {
        if (this.queueProcessing) {
          this.uppy.once("thumbnail:all-generated", () => {
            emitPreprocessCompleteForAll();
            resolve();
          });
        } else {
          emitPreprocessCompleteForAll();
          resolve();
        }
      });
    };
    this.type = "modifier";
    this.id = this.opts.id || "ThumbnailGenerator";
    this.title = "Thumbnail Generator";
    this.queue = [];
    this.queueProcessing = false;
    this.defaultThumbnailDimension = 200;
    this.thumbnailType = this.opts.thumbnailType;
    this.defaultLocale = locale_default4;
    this.i18nInit();
    if (this.opts.lazy && this.opts.waitForThumbnailsBeforeUpload) {
      throw new Error("ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.");
    }
  }
  createThumbnail(file, targetWidth, targetHeight) {
    const originalUrl = URL.createObjectURL(file.data);
    const onload = new Promise((resolve, reject) => {
      const image = new Image();
      image.src = originalUrl;
      image.addEventListener("load", () => {
        URL.revokeObjectURL(originalUrl);
        resolve(image);
      });
      image.addEventListener("error", (event) => {
        URL.revokeObjectURL(originalUrl);
        reject(event.error || new Error("Could not create thumbnail"));
      });
    });
    const orientationPromise = ye(file.data).catch(() => 1);
    return Promise.all([onload, orientationPromise]).then((_ref) => {
      let [image, orientation] = _ref;
      const dimensions = this.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg);
      const rotatedImage = rotateImage(image, orientation);
      const resizedImage = this.resizeImage(rotatedImage, dimensions.width, dimensions.height);
      return canvasToBlob(resizedImage, this.thumbnailType, 80);
    }).then((blob) => {
      return URL.createObjectURL(blob);
    });
  }
  /**
   * Get the new calculated dimensions for the given image and a target width
   * or height. If both width and height are given, only width is taken into
   * account. If neither width nor height are given, the default dimension
   * is used.
   */
  getProportionalDimensions(img, width, height, deg) {
    let aspect = img.width / img.height;
    if (deg === 90 || deg === 270) {
      aspect = img.height / img.width;
    }
    if (width != null) {
      return {
        width,
        height: Math.round(width / aspect)
      };
    }
    if (height != null) {
      return {
        width: Math.round(height * aspect),
        height
      };
    }
    return {
      width: this.defaultThumbnailDimension,
      height: Math.round(this.defaultThumbnailDimension / aspect)
    };
  }
  /**
   * Resize an image to the target `width` and `height`.
   *
   * Returns a Canvas with the resized image on it.
   */
  // eslint-disable-next-line class-methods-use-this
  resizeImage(image, targetWidth, targetHeight) {
    let img = protect(image);
    let steps = Math.ceil(Math.log2(img.width / targetWidth));
    if (steps < 1) {
      steps = 1;
    }
    let sW = targetWidth * 2 ** (steps - 1);
    let sH = targetHeight * 2 ** (steps - 1);
    const x4 = 2;
    while (steps--) {
      const canvas = document.createElement("canvas");
      canvas.width = sW;
      canvas.height = sH;
      canvas.getContext("2d").drawImage(img, 0, 0, sW, sH);
      img = canvas;
      sW = Math.round(sW / x4);
      sH = Math.round(sH / x4);
    }
    return img;
  }
  /**
   * Set the preview URL for a file.
   */
  setPreviewURL(fileID, preview) {
    this.uppy.setFileState(fileID, {
      preview
    });
  }
  addToQueue(fileID) {
    this.queue.push(fileID);
    if (this.queueProcessing === false) {
      this.processQueue();
    }
  }
  processQueue() {
    this.queueProcessing = true;
    if (this.queue.length > 0) {
      const current = this.uppy.getFile(this.queue.shift());
      if (!current) {
        this.uppy.log("[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug", "error");
        return Promise.resolve();
      }
      return this.requestThumbnail(current).catch(() => {
      }).then(() => this.processQueue());
    }
    this.queueProcessing = false;
    this.uppy.log("[ThumbnailGenerator] Emptied thumbnail queue");
    this.uppy.emit("thumbnail:all-generated");
    return Promise.resolve();
  }
  requestThumbnail(file) {
    if (isPreviewSupported(file.type) && !file.isRemote) {
      return this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then((preview) => {
        this.setPreviewURL(file.id, preview);
        this.uppy.log(`[ThumbnailGenerator] Generated thumbnail for ${file.id}`);
        this.uppy.emit("thumbnail:generated", this.uppy.getFile(file.id), preview);
      }).catch((err) => {
        this.uppy.log(`[ThumbnailGenerator] Failed thumbnail for ${file.id}:`, "warning");
        this.uppy.log(err, "warning");
        this.uppy.emit("thumbnail:error", this.uppy.getFile(file.id), err);
      });
    }
    return Promise.resolve();
  }
  install() {
    this.uppy.on("file-removed", this.onFileRemoved);
    this.uppy.on("cancel-all", this.onAllFilesRemoved);
    if (this.opts.lazy) {
      this.uppy.on("thumbnail:request", this.onFileAdded);
      this.uppy.on("thumbnail:cancel", this.onCancelRequest);
    } else {
      this.uppy.on("thumbnail:request", this.onFileAdded);
      this.uppy.on("file-added", this.onFileAdded);
      this.uppy.on("restored", this.onRestored);
    }
    if (this.opts.waitForThumbnailsBeforeUpload) {
      this.uppy.addPreProcessor(this.waitUntilAllProcessed);
    }
  }
  uninstall() {
    this.uppy.off("file-removed", this.onFileRemoved);
    this.uppy.off("cancel-all", this.onAllFilesRemoved);
    if (this.opts.lazy) {
      this.uppy.off("thumbnail:request", this.onFileAdded);
      this.uppy.off("thumbnail:cancel", this.onCancelRequest);
    } else {
      this.uppy.off("thumbnail:request", this.onFileAdded);
      this.uppy.off("file-added", this.onFileAdded);
      this.uppy.off("restored", this.onRestored);
    }
    if (this.opts.waitForThumbnailsBeforeUpload) {
      this.uppy.removePreProcessor(this.waitUntilAllProcessed);
    }
  }
};
ThumbnailGenerator.VERSION = packageJson8.version;

// ../../node_modules/@uppy/utils/lib/findAllDOMElements.js
function findAllDOMElements(element) {
  if (typeof element === "string") {
    const elements = document.querySelectorAll(element);
    return elements.length === 0 ? null : Array.from(elements);
  }
  if (typeof element === "object" && isDOMElement(element)) {
    return [element];
  }
  return null;
}
var findAllDOMElements_default = findAllDOMElements;

// ../../node_modules/@uppy/utils/lib/toArray.js
var toArray_default = Array.from;

// ../../node_modules/@uppy/utils/lib/getDroppedFiles/utils/webkitGetAsEntryApi/getFilesAndDirectoriesFromDirectory.js
function getFilesAndDirectoriesFromDirectory(directoryReader, oldEntries, logDropError, _ref) {
  let {
    onSuccess
  } = _ref;
  directoryReader.readEntries(
    (entries) => {
      const newEntries = [...oldEntries, ...entries];
      if (entries.length) {
        queueMicrotask(() => {
          getFilesAndDirectoriesFromDirectory(directoryReader, newEntries, logDropError, {
            onSuccess
          });
        });
      } else {
        onSuccess(newEntries);
      }
    },
    // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error) => {
      logDropError(error);
      onSuccess(oldEntries);
    }
  );
}

// ../../node_modules/@uppy/utils/lib/getDroppedFiles/utils/webkitGetAsEntryApi/index.js
function getAsFileSystemHandleFromEntry(entry, logDropError) {
  if (entry == null)
    return entry;
  return {
    kind: (
      // eslint-disable-next-line no-nested-ternary
      entry.isFile ? "file" : entry.isDirectory ? "directory" : void 0
    ),
    name: entry.name,
    getFile() {
      return new Promise((resolve, reject) => entry.file(resolve, reject));
    },
    async *values() {
      const directoryReader = entry.createReader();
      const entries = await new Promise((resolve) => {
        getFilesAndDirectoriesFromDirectory(directoryReader, [], logDropError, {
          onSuccess: (dirEntries) => resolve(dirEntries.map((file) => getAsFileSystemHandleFromEntry(file, logDropError)))
        });
      });
      yield* entries;
    },
    isSameEntry: void 0
  };
}
function createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
  try {
    if (lastResortFile === void 0) {
      lastResortFile = void 0;
    }
    return async function* () {
      const getNextRelativePath = () => `${relativePath}/${entry.name}`;
      if (entry.kind === "file") {
        const file = await entry.getFile();
        if (file != null) {
          ;
          file.relativePath = relativePath ? getNextRelativePath() : null;
          yield file;
        } else if (lastResortFile != null)
          yield lastResortFile;
      } else if (entry.kind === "directory") {
        for await (const handle of entry.values()) {
          yield* createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name);
        }
      } else if (lastResortFile != null)
        yield lastResortFile;
    }();
  } catch (e4) {
    return Promise.reject(e4);
  }
}
async function* getFilesFromDataTransfer(dataTransfer, logDropError) {
  const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item) => {
    var _fileSystemHandle;
    let fileSystemHandle;
    const getAsEntry = () => typeof item.getAsEntry === "function" ? item.getAsEntry() : item.webkitGetAsEntry();
    (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
    return {
      fileSystemHandle,
      lastResortFile: item.getAsFile()
      // can be used as a fallback in case other methods fail
    };
  }));
  for (const {
    lastResortFile,
    fileSystemHandle
  } of fileSystemHandles) {
    if (fileSystemHandle != null) {
      try {
        yield* createPromiseToAddFileOrParseDirectory(fileSystemHandle, "", lastResortFile);
      } catch (err) {
        if (lastResortFile != null) {
          yield lastResortFile;
        } else {
          logDropError(err);
        }
      }
    } else if (lastResortFile != null)
      yield lastResortFile;
  }
}

// ../../node_modules/@uppy/utils/lib/getDroppedFiles/utils/fallbackApi.js
function fallbackApi(dataTransfer) {
  const files = toArray_default(dataTransfer.files);
  return Promise.resolve(files);
}

// ../../node_modules/@uppy/utils/lib/getDroppedFiles/index.js
async function getDroppedFiles(dataTransfer, options) {
  var _options$logDropError;
  const logDropError = (_options$logDropError = options == null ? void 0 : options.logDropError) != null ? _options$logDropError : Function.prototype;
  try {
    const accumulator = [];
    for await (const file of getFilesFromDataTransfer(dataTransfer, logDropError)) {
      accumulator.push(file);
    }
    return accumulator;
  } catch {
    return fallbackApi(dataTransfer);
  }
}

// ../../node_modules/eventemitter3/index.mjs
var import_index = __toESM(require_eventemitter3(), 1);

// ../../node_modules/p-timeout/index.js
var TimeoutError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "TimeoutError";
  }
};
var AbortError2 = class extends Error {
  constructor(message) {
    super();
    this.name = "AbortError";
    this.message = message;
  }
};
var getDOMException = (errorMessage) => globalThis.DOMException === void 0 ? new AbortError2(errorMessage) : new DOMException(errorMessage);
var getAbortedReason = (signal) => {
  const reason = signal.reason === void 0 ? getDOMException("This operation was aborted.") : signal.reason;
  return reason instanceof Error ? reason : getDOMException(reason);
};
function pTimeout(promise, milliseconds, fallback, options) {
  let timer;
  const cancelablePromise = new Promise((resolve, reject) => {
    if (typeof milliseconds !== "number" || Math.sign(milliseconds) !== 1) {
      throw new TypeError(`Expected \`milliseconds\` to be a positive number, got \`${milliseconds}\``);
    }
    if (milliseconds === Number.POSITIVE_INFINITY) {
      resolve(promise);
      return;
    }
    options = {
      customTimers: { setTimeout, clearTimeout },
      ...options
    };
    if (options.signal) {
      const { signal } = options;
      if (signal.aborted) {
        reject(getAbortedReason(signal));
      }
      signal.addEventListener("abort", () => {
        reject(getAbortedReason(signal));
      });
    }
    timer = options.customTimers.setTimeout.call(void 0, () => {
      if (typeof fallback === "function") {
        try {
          resolve(fallback());
        } catch (error) {
          reject(error);
        }
        return;
      }
      const message = typeof fallback === "string" ? fallback : `Promise timed out after ${milliseconds} milliseconds`;
      const timeoutError = fallback instanceof Error ? fallback : new TimeoutError(message);
      if (typeof promise.cancel === "function") {
        promise.cancel();
      }
      reject(timeoutError);
    }, milliseconds);
    (async () => {
      try {
        resolve(await promise);
      } catch (error) {
        reject(error);
      } finally {
        options.customTimers.clearTimeout.call(void 0, timer);
      }
    })();
  });
  cancelablePromise.clear = () => {
    clearTimeout(timer);
    timer = void 0;
  };
  return cancelablePromise;
}

// ../../node_modules/p-queue/dist/lower-bound.js
function lowerBound(array, value, comparator) {
  let first = 0;
  let count = array.length;
  while (count > 0) {
    const step = Math.trunc(count / 2);
    let it = first + step;
    if (comparator(array[it], value) <= 0) {
      first = ++it;
      count -= step + 1;
    } else {
      count = step;
    }
  }
  return first;
}

// ../../node_modules/p-queue/dist/priority-queue.js
var __classPrivateFieldGet = function(receiver, state, kind, f4) {
  if (kind === "a" && !f4)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f4 : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f4 : kind === "a" ? f4.call(receiver) : f4 ? f4.value : state.get(receiver);
};
var _PriorityQueue_queue;
var PriorityQueue = class {
  constructor() {
    _PriorityQueue_queue.set(this, []);
  }
  enqueue(run, options) {
    options = {
      priority: 0,
      ...options
    };
    const element = {
      priority: options.priority,
      run
    };
    if (this.size && __classPrivateFieldGet(this, _PriorityQueue_queue, "f")[this.size - 1].priority >= options.priority) {
      __classPrivateFieldGet(this, _PriorityQueue_queue, "f").push(element);
      return;
    }
    const index = lowerBound(__classPrivateFieldGet(this, _PriorityQueue_queue, "f"), element, (a4, b3) => b3.priority - a4.priority);
    __classPrivateFieldGet(this, _PriorityQueue_queue, "f").splice(index, 0, element);
  }
  dequeue() {
    const item = __classPrivateFieldGet(this, _PriorityQueue_queue, "f").shift();
    return item === null || item === void 0 ? void 0 : item.run;
  }
  filter(options) {
    return __classPrivateFieldGet(this, _PriorityQueue_queue, "f").filter((element) => element.priority === options.priority).map((element) => element.run);
  }
  get size() {
    return __classPrivateFieldGet(this, _PriorityQueue_queue, "f").length;
  }
};
_PriorityQueue_queue = /* @__PURE__ */ new WeakMap();
var priority_queue_default = PriorityQueue;

// ../../node_modules/p-queue/dist/index.js
var __classPrivateFieldSet = function(receiver, state, value, kind, f4) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f4)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f4 : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f4.call(receiver, value) : f4 ? f4.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet2 = function(receiver, state, kind, f4) {
  if (kind === "a" && !f4)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f4 : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f4 : kind === "a" ? f4.call(receiver) : f4 ? f4.value : state.get(receiver);
};
var _PQueue_instances;
var _PQueue_carryoverConcurrencyCount;
var _PQueue_isIntervalIgnored;
var _PQueue_intervalCount;
var _PQueue_intervalCap;
var _PQueue_interval;
var _PQueue_intervalEnd;
var _PQueue_intervalId;
var _PQueue_timeoutId;
var _PQueue_queue;
var _PQueue_queueClass;
var _PQueue_pending;
var _PQueue_concurrency;
var _PQueue_isPaused;
var _PQueue_throwOnTimeout;
var _PQueue_doesIntervalAllowAnother_get;
var _PQueue_doesConcurrentAllowAnother_get;
var _PQueue_next;
var _PQueue_onResumeInterval;
var _PQueue_isIntervalPaused_get;
var _PQueue_tryToStartAnother;
var _PQueue_initializeIntervalIfNeeded;
var _PQueue_onInterval;
var _PQueue_processQueue;
var _PQueue_throwOnAbort;
var _PQueue_onEvent;
var AbortError3 = class extends Error {
};
var PQueue = class extends import_index.default {
  // TODO: The `throwOnTimeout` option should affect the return types of `add()` and `addAll()`
  constructor(options) {
    var _a, _b, _c, _d;
    super();
    _PQueue_instances.add(this);
    _PQueue_carryoverConcurrencyCount.set(this, void 0);
    _PQueue_isIntervalIgnored.set(this, void 0);
    _PQueue_intervalCount.set(this, 0);
    _PQueue_intervalCap.set(this, void 0);
    _PQueue_interval.set(this, void 0);
    _PQueue_intervalEnd.set(this, 0);
    _PQueue_intervalId.set(this, void 0);
    _PQueue_timeoutId.set(this, void 0);
    _PQueue_queue.set(this, void 0);
    _PQueue_queueClass.set(this, void 0);
    _PQueue_pending.set(this, 0);
    _PQueue_concurrency.set(this, void 0);
    _PQueue_isPaused.set(this, void 0);
    _PQueue_throwOnTimeout.set(this, void 0);
    Object.defineProperty(this, "timeout", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    options = {
      carryoverConcurrencyCount: false,
      intervalCap: Number.POSITIVE_INFINITY,
      interval: 0,
      concurrency: Number.POSITIVE_INFINITY,
      autoStart: true,
      queueClass: priority_queue_default,
      ...options
    };
    if (!(typeof options.intervalCap === "number" && options.intervalCap >= 1)) {
      throw new TypeError(`Expected \`intervalCap\` to be a number from 1 and up, got \`${(_b = (_a = options.intervalCap) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : ""}\` (${typeof options.intervalCap})`);
    }
    if (options.interval === void 0 || !(Number.isFinite(options.interval) && options.interval >= 0)) {
      throw new TypeError(`Expected \`interval\` to be a finite number >= 0, got \`${(_d = (_c = options.interval) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ""}\` (${typeof options.interval})`);
    }
    __classPrivateFieldSet(this, _PQueue_carryoverConcurrencyCount, options.carryoverConcurrencyCount, "f");
    __classPrivateFieldSet(this, _PQueue_isIntervalIgnored, options.intervalCap === Number.POSITIVE_INFINITY || options.interval === 0, "f");
    __classPrivateFieldSet(this, _PQueue_intervalCap, options.intervalCap, "f");
    __classPrivateFieldSet(this, _PQueue_interval, options.interval, "f");
    __classPrivateFieldSet(this, _PQueue_queue, new options.queueClass(), "f");
    __classPrivateFieldSet(this, _PQueue_queueClass, options.queueClass, "f");
    this.concurrency = options.concurrency;
    this.timeout = options.timeout;
    __classPrivateFieldSet(this, _PQueue_throwOnTimeout, options.throwOnTimeout === true, "f");
    __classPrivateFieldSet(this, _PQueue_isPaused, options.autoStart === false, "f");
  }
  get concurrency() {
    return __classPrivateFieldGet2(this, _PQueue_concurrency, "f");
  }
  set concurrency(newConcurrency) {
    if (!(typeof newConcurrency === "number" && newConcurrency >= 1)) {
      throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${newConcurrency}\` (${typeof newConcurrency})`);
    }
    __classPrivateFieldSet(this, _PQueue_concurrency, newConcurrency, "f");
    __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_processQueue).call(this);
  }
  async add(function_, options = {}) {
    options = {
      timeout: this.timeout,
      throwOnTimeout: __classPrivateFieldGet2(this, _PQueue_throwOnTimeout, "f"),
      ...options
    };
    return new Promise((resolve, reject) => {
      __classPrivateFieldGet2(this, _PQueue_queue, "f").enqueue(async () => {
        var _a;
        var _b, _c;
        __classPrivateFieldSet(this, _PQueue_pending, (_b = __classPrivateFieldGet2(this, _PQueue_pending, "f"), _b++, _b), "f");
        __classPrivateFieldSet(this, _PQueue_intervalCount, (_c = __classPrivateFieldGet2(this, _PQueue_intervalCount, "f"), _c++, _c), "f");
        try {
          if ((_a = options.signal) === null || _a === void 0 ? void 0 : _a.aborted) {
            throw new AbortError3("The task was aborted.");
          }
          let operation = function_({ signal: options.signal });
          if (options.timeout) {
            operation = pTimeout(Promise.resolve(operation), options.timeout);
          }
          if (options.signal) {
            operation = Promise.race([operation, __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_throwOnAbort).call(this, options.signal)]);
          }
          const result = await operation;
          resolve(result);
          this.emit("completed", result);
        } catch (error) {
          if (error instanceof TimeoutError && !options.throwOnTimeout) {
            resolve();
            return;
          }
          reject(error);
          this.emit("error", error);
        } finally {
          __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_next).call(this);
        }
      }, options);
      this.emit("add");
      __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_tryToStartAnother).call(this);
    });
  }
  async addAll(functions, options) {
    return Promise.all(functions.map(async (function_) => this.add(function_, options)));
  }
  /**
  Start (or resume) executing enqueued tasks within concurrency limit. No need to call this if queue is not paused (via `options.autoStart = false` or by `.pause()` method.)
  */
  start() {
    if (!__classPrivateFieldGet2(this, _PQueue_isPaused, "f")) {
      return this;
    }
    __classPrivateFieldSet(this, _PQueue_isPaused, false, "f");
    __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_processQueue).call(this);
    return this;
  }
  /**
  Put queue execution on hold.
  */
  pause() {
    __classPrivateFieldSet(this, _PQueue_isPaused, true, "f");
  }
  /**
  Clear the queue.
  */
  clear() {
    __classPrivateFieldSet(this, _PQueue_queue, new (__classPrivateFieldGet2(this, _PQueue_queueClass, "f"))(), "f");
  }
  /**
      Can be called multiple times. Useful if you for example add additional items at a later time.
  
      @returns A promise that settles when the queue becomes empty.
      */
  async onEmpty() {
    if (__classPrivateFieldGet2(this, _PQueue_queue, "f").size === 0) {
      return;
    }
    await __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onEvent).call(this, "empty");
  }
  /**
      @returns A promise that settles when the queue size is less than the given limit: `queue.size < limit`.
  
      If you want to avoid having the queue grow beyond a certain size you can `await queue.onSizeLessThan()` before adding a new item.
  
      Note that this only limits the number of items waiting to start. There could still be up to `concurrency` jobs already running that this call does not include in its calculation.
      */
  async onSizeLessThan(limit) {
    if (__classPrivateFieldGet2(this, _PQueue_queue, "f").size < limit) {
      return;
    }
    await __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onEvent).call(this, "next", () => __classPrivateFieldGet2(this, _PQueue_queue, "f").size < limit);
  }
  /**
      The difference with `.onEmpty` is that `.onIdle` guarantees that all work from the queue has finished. `.onEmpty` merely signals that the queue is empty, but it could mean that some promises haven't completed yet.
  
      @returns A promise that settles when the queue becomes empty, and all promises have completed; `queue.size === 0 && queue.pending === 0`.
      */
  async onIdle() {
    if (__classPrivateFieldGet2(this, _PQueue_pending, "f") === 0 && __classPrivateFieldGet2(this, _PQueue_queue, "f").size === 0) {
      return;
    }
    await __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onEvent).call(this, "idle");
  }
  /**
  Size of the queue, the number of queued items waiting to run.
  */
  get size() {
    return __classPrivateFieldGet2(this, _PQueue_queue, "f").size;
  }
  /**
      Size of the queue, filtered by the given options.
  
      For example, this can be used to find the number of items remaining in the queue with a specific priority level.
      */
  sizeBy(options) {
    return __classPrivateFieldGet2(this, _PQueue_queue, "f").filter(options).length;
  }
  /**
  Number of running items (no longer in the queue).
  */
  get pending() {
    return __classPrivateFieldGet2(this, _PQueue_pending, "f");
  }
  /**
  Whether the queue is currently paused.
  */
  get isPaused() {
    return __classPrivateFieldGet2(this, _PQueue_isPaused, "f");
  }
};
_PQueue_carryoverConcurrencyCount = /* @__PURE__ */ new WeakMap(), _PQueue_isIntervalIgnored = /* @__PURE__ */ new WeakMap(), _PQueue_intervalCount = /* @__PURE__ */ new WeakMap(), _PQueue_intervalCap = /* @__PURE__ */ new WeakMap(), _PQueue_interval = /* @__PURE__ */ new WeakMap(), _PQueue_intervalEnd = /* @__PURE__ */ new WeakMap(), _PQueue_intervalId = /* @__PURE__ */ new WeakMap(), _PQueue_timeoutId = /* @__PURE__ */ new WeakMap(), _PQueue_queue = /* @__PURE__ */ new WeakMap(), _PQueue_queueClass = /* @__PURE__ */ new WeakMap(), _PQueue_pending = /* @__PURE__ */ new WeakMap(), _PQueue_concurrency = /* @__PURE__ */ new WeakMap(), _PQueue_isPaused = /* @__PURE__ */ new WeakMap(), _PQueue_throwOnTimeout = /* @__PURE__ */ new WeakMap(), _PQueue_instances = /* @__PURE__ */ new WeakSet(), _PQueue_doesIntervalAllowAnother_get = function _PQueue_doesIntervalAllowAnother_get2() {
  return __classPrivateFieldGet2(this, _PQueue_isIntervalIgnored, "f") || __classPrivateFieldGet2(this, _PQueue_intervalCount, "f") < __classPrivateFieldGet2(this, _PQueue_intervalCap, "f");
}, _PQueue_doesConcurrentAllowAnother_get = function _PQueue_doesConcurrentAllowAnother_get2() {
  return __classPrivateFieldGet2(this, _PQueue_pending, "f") < __classPrivateFieldGet2(this, _PQueue_concurrency, "f");
}, _PQueue_next = function _PQueue_next2() {
  var _a;
  __classPrivateFieldSet(this, _PQueue_pending, (_a = __classPrivateFieldGet2(this, _PQueue_pending, "f"), _a--, _a), "f");
  __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_tryToStartAnother).call(this);
  this.emit("next");
}, _PQueue_onResumeInterval = function _PQueue_onResumeInterval2() {
  __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onInterval).call(this);
  __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_initializeIntervalIfNeeded).call(this);
  __classPrivateFieldSet(this, _PQueue_timeoutId, void 0, "f");
}, _PQueue_isIntervalPaused_get = function _PQueue_isIntervalPaused_get2() {
  const now = Date.now();
  if (__classPrivateFieldGet2(this, _PQueue_intervalId, "f") === void 0) {
    const delay = __classPrivateFieldGet2(this, _PQueue_intervalEnd, "f") - now;
    if (delay < 0) {
      __classPrivateFieldSet(this, _PQueue_intervalCount, __classPrivateFieldGet2(this, _PQueue_carryoverConcurrencyCount, "f") ? __classPrivateFieldGet2(this, _PQueue_pending, "f") : 0, "f");
    } else {
      if (__classPrivateFieldGet2(this, _PQueue_timeoutId, "f") === void 0) {
        __classPrivateFieldSet(this, _PQueue_timeoutId, setTimeout(() => {
          __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onResumeInterval).call(this);
        }, delay), "f");
      }
      return true;
    }
  }
  return false;
}, _PQueue_tryToStartAnother = function _PQueue_tryToStartAnother2() {
  if (__classPrivateFieldGet2(this, _PQueue_queue, "f").size === 0) {
    if (__classPrivateFieldGet2(this, _PQueue_intervalId, "f")) {
      clearInterval(__classPrivateFieldGet2(this, _PQueue_intervalId, "f"));
    }
    __classPrivateFieldSet(this, _PQueue_intervalId, void 0, "f");
    this.emit("empty");
    if (__classPrivateFieldGet2(this, _PQueue_pending, "f") === 0) {
      this.emit("idle");
    }
    return false;
  }
  if (!__classPrivateFieldGet2(this, _PQueue_isPaused, "f")) {
    const canInitializeInterval = !__classPrivateFieldGet2(this, _PQueue_instances, "a", _PQueue_isIntervalPaused_get);
    if (__classPrivateFieldGet2(this, _PQueue_instances, "a", _PQueue_doesIntervalAllowAnother_get) && __classPrivateFieldGet2(this, _PQueue_instances, "a", _PQueue_doesConcurrentAllowAnother_get)) {
      const job = __classPrivateFieldGet2(this, _PQueue_queue, "f").dequeue();
      if (!job) {
        return false;
      }
      this.emit("active");
      job();
      if (canInitializeInterval) {
        __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_initializeIntervalIfNeeded).call(this);
      }
      return true;
    }
  }
  return false;
}, _PQueue_initializeIntervalIfNeeded = function _PQueue_initializeIntervalIfNeeded2() {
  if (__classPrivateFieldGet2(this, _PQueue_isIntervalIgnored, "f") || __classPrivateFieldGet2(this, _PQueue_intervalId, "f") !== void 0) {
    return;
  }
  __classPrivateFieldSet(this, _PQueue_intervalId, setInterval(() => {
    __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onInterval).call(this);
  }, __classPrivateFieldGet2(this, _PQueue_interval, "f")), "f");
  __classPrivateFieldSet(this, _PQueue_intervalEnd, Date.now() + __classPrivateFieldGet2(this, _PQueue_interval, "f"), "f");
}, _PQueue_onInterval = function _PQueue_onInterval2() {
  if (__classPrivateFieldGet2(this, _PQueue_intervalCount, "f") === 0 && __classPrivateFieldGet2(this, _PQueue_pending, "f") === 0 && __classPrivateFieldGet2(this, _PQueue_intervalId, "f")) {
    clearInterval(__classPrivateFieldGet2(this, _PQueue_intervalId, "f"));
    __classPrivateFieldSet(this, _PQueue_intervalId, void 0, "f");
  }
  __classPrivateFieldSet(this, _PQueue_intervalCount, __classPrivateFieldGet2(this, _PQueue_carryoverConcurrencyCount, "f") ? __classPrivateFieldGet2(this, _PQueue_pending, "f") : 0, "f");
  __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_processQueue).call(this);
}, _PQueue_processQueue = function _PQueue_processQueue2() {
  while (__classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_tryToStartAnother).call(this)) {
  }
}, _PQueue_throwOnAbort = async function _PQueue_throwOnAbort2(signal) {
  return new Promise((_resolve, reject) => {
    signal.addEventListener("abort", () => {
      reject(new AbortError3("The task was aborted."));
    }, { once: true });
  });
}, _PQueue_onEvent = async function _PQueue_onEvent2(event, filter) {
  return new Promise((resolve) => {
    const listener = () => {
      if (filter && !filter()) {
        return;
      }
      this.off(event, listener);
      resolve();
    };
    this.on(event, listener);
  });
};
var dist_default = PQueue;

// ../../node_modules/preact/hooks/dist/hooks.mjs
var t3;
var r3;
var u3;
var i3;
var o3 = 0;
var f3 = [];
var c3 = [];
var e3 = l;
var a3 = e3.__b;
var v3 = e3.__r;
var l3 = e3.diffed;
var m3 = e3.__c;
var s3 = e3.unmount;
var d3 = e3.__;
function h3(n3, t4) {
  e3.__h && e3.__h(r3, n3, o3 || t4), o3 = 0;
  var u4 = r3.__H || (r3.__H = { __: [], __h: [] });
  return n3 >= u4.__.length && u4.__.push({ __V: c3 }), u4.__[n3];
}
function p3(n3) {
  return o3 = 1, y3(D3, n3);
}
function y3(n3, u4, i4) {
  var o4 = h3(t3++, 2);
  if (o4.t = n3, !o4.__c && (o4.__ = [i4 ? i4(u4) : D3(void 0, u4), function(n4) {
    var t4 = o4.__N ? o4.__N[0] : o4.__[0], r4 = o4.t(t4, n4);
    t4 !== r4 && (o4.__N = [r4, o4.__[1]], o4.__c.setState({}));
  }], o4.__c = r3, !r3.u)) {
    var f4 = function(n4, t4, r4) {
      if (!o4.__c.__H)
        return true;
      var u5 = o4.__c.__H.__.filter(function(n5) {
        return !!n5.__c;
      });
      if (u5.every(function(n5) {
        return !n5.__N;
      }))
        return !c4 || c4.call(this, n4, t4, r4);
      var i5 = false;
      return u5.forEach(function(n5) {
        if (n5.__N) {
          var t5 = n5.__[0];
          n5.__ = n5.__N, n5.__N = void 0, t5 !== n5.__[0] && (i5 = true);
        }
      }), !(!i5 && o4.__c.props === n4) && (!c4 || c4.call(this, n4, t4, r4));
    };
    r3.u = true;
    var c4 = r3.shouldComponentUpdate, e4 = r3.componentWillUpdate;
    r3.componentWillUpdate = function(n4, t4, r4) {
      if (this.__e) {
        var u5 = c4;
        c4 = void 0, f4(n4, t4, r4), c4 = u5;
      }
      e4 && e4.call(this, n4, t4, r4);
    }, r3.shouldComponentUpdate = f4;
  }
  return o4.__N || o4.__;
}
function _3(n3, u4) {
  var i4 = h3(t3++, 3);
  !e3.__s && C3(i4.__H, u4) && (i4.__ = n3, i4.i = u4, r3.__H.__h.push(i4));
}
function F3(n3) {
  return o3 = 5, q3(function() {
    return { current: n3 };
  }, []);
}
function q3(n3, r4) {
  var u4 = h3(t3++, 7);
  return C3(u4.__H, r4) ? (u4.__V = n3(), u4.i = r4, u4.__h = n3, u4.__V) : u4.__;
}
function x3(n3, t4) {
  return o3 = 8, q3(function() {
    return n3;
  }, t4);
}
function j3() {
  for (var n3; n3 = f3.shift(); )
    if (n3.__P && n3.__H)
      try {
        n3.__H.__h.forEach(z3), n3.__H.__h.forEach(B3), n3.__H.__h = [];
      } catch (t4) {
        n3.__H.__h = [], e3.__e(t4, n3.__v);
      }
}
e3.__b = function(n3) {
  r3 = null, a3 && a3(n3);
}, e3.__ = function(n3, t4) {
  n3 && t4.__k && t4.__k.__m && (n3.__m = t4.__k.__m), d3 && d3(n3, t4);
}, e3.__r = function(n3) {
  v3 && v3(n3), t3 = 0;
  var i4 = (r3 = n3.__c).__H;
  i4 && (u3 === r3 ? (i4.__h = [], r3.__h = [], i4.__.forEach(function(n4) {
    n4.__N && (n4.__ = n4.__N), n4.__V = c3, n4.__N = n4.i = void 0;
  })) : (i4.__h.forEach(z3), i4.__h.forEach(B3), i4.__h = [], t3 = 0)), u3 = r3;
}, e3.diffed = function(n3) {
  l3 && l3(n3);
  var t4 = n3.__c;
  t4 && t4.__H && (t4.__H.__h.length && (1 !== f3.push(t4) && i3 === e3.requestAnimationFrame || ((i3 = e3.requestAnimationFrame) || w3)(j3)), t4.__H.__.forEach(function(n4) {
    n4.i && (n4.__H = n4.i), n4.__V !== c3 && (n4.__ = n4.__V), n4.i = void 0, n4.__V = c3;
  })), u3 = r3 = null;
}, e3.__c = function(n3, t4) {
  t4.some(function(n4) {
    try {
      n4.__h.forEach(z3), n4.__h = n4.__h.filter(function(n5) {
        return !n5.__ || B3(n5);
      });
    } catch (r4) {
      t4.some(function(n5) {
        n5.__h && (n5.__h = []);
      }), t4 = [], e3.__e(r4, n4.__v);
    }
  }), m3 && m3(n3, t4);
}, e3.unmount = function(n3) {
  s3 && s3(n3);
  var t4, r4 = n3.__c;
  r4 && r4.__H && (r4.__H.__.forEach(function(n4) {
    try {
      z3(n4);
    } catch (n5) {
      t4 = n5;
    }
  }), r4.__H = void 0, t4 && e3.__e(t4, r4.__v));
};
var k3 = "function" == typeof requestAnimationFrame;
function w3(n3) {
  var t4, r4 = function() {
    clearTimeout(u4), k3 && cancelAnimationFrame(t4), setTimeout(n3);
  }, u4 = setTimeout(r4, 100);
  k3 && (t4 = requestAnimationFrame(r4));
}
function z3(n3) {
  var t4 = r3, u4 = n3.__c;
  "function" == typeof u4 && (n3.__c = void 0, u4()), r3 = t4;
}
function B3(n3) {
  var t4 = r3;
  n3.__c = n3.__(), r3 = t4;
}
function C3(n3, t4) {
  return !n3 || n3.length !== t4.length || t4.some(function(t5, r4) {
    return t5 !== n3[r4];
  });
}
function D3(n3, t4) {
  return "function" == typeof t4 ? t4(n3) : t4;
}

// ../../node_modules/@uppy/provider-views/lib/ProviderView/AuthView.js
function GoogleIcon() {
  return y("svg", {
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, y("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, y("circle", {
    fill: "#FFF",
    cx: "13",
    cy: "13",
    r: "13"
  }), y("path", {
    d: "M21.64 13.205c0-.639-.057-1.252-.164-1.841H13v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
    fill: "#4285F4",
    "fill-rule": "nonzero"
  }), y("path", {
    d: "M13 22c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H4.957v2.332A8.997 8.997 0 0013 22z",
    fill: "#34A853",
    "fill-rule": "nonzero"
  }), y("path", {
    d: "M7.964 14.71A5.41 5.41 0 017.682 13c0-.593.102-1.17.282-1.71V8.958H4.957A8.996 8.996 0 004 13c0 1.452.348 2.827.957 4.042l3.007-2.332z",
    fill: "#FBBC05",
    "fill-rule": "nonzero"
  }), y("path", {
    d: "M13 7.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C17.463 4.891 15.426 4 13 4a8.997 8.997 0 00-8.043 4.958l3.007 2.332C8.672 9.163 10.656 7.58 13 7.58z",
    fill: "#EA4335",
    "fill-rule": "nonzero"
  }), y("path", {
    d: "M4 4h18v18H4z"
  })));
}
function DefaultForm(_ref) {
  let {
    pluginName,
    i18n,
    onAuth
  } = _ref;
  const isGoogleDrive = pluginName === "Google Drive";
  const onSubmit = x3((e4) => {
    e4.preventDefault();
    onAuth();
  }, [onAuth]);
  return y("form", {
    onSubmit
  }, isGoogleDrive ? y("button", {
    type: "submit",
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn uppy-Provider-btn-google",
    "data-uppy-super-focusable": true
  }, y(GoogleIcon, null), i18n("signInWithGoogle")) : y("button", {
    type: "submit",
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn",
    "data-uppy-super-focusable": true
  }, i18n("authenticateWith", {
    pluginName
  })));
}
var defaultRenderForm = (_ref2) => {
  let {
    pluginName,
    i18n,
    onAuth
  } = _ref2;
  return y(DefaultForm, {
    pluginName,
    i18n,
    onAuth
  });
};
function AuthView(props) {
  const {
    loading,
    pluginName,
    pluginIcon,
    i18n,
    handleAuth,
    renderForm = defaultRenderForm
  } = props;
  return y("div", {
    className: "uppy-Provider-auth"
  }, y("div", {
    className: "uppy-Provider-authIcon"
  }, pluginIcon()), y("div", {
    className: "uppy-Provider-authTitle"
  }, i18n("authenticateWithTitle", {
    pluginName
  })), y("div", {
    className: "uppy-Provider-authForm"
  }, renderForm({
    pluginName,
    i18n,
    loading,
    onAuth: handleAuth
  })));
}

// ../../node_modules/@uppy/provider-views/lib/ProviderView/User.js
function User(_ref) {
  let {
    i18n,
    logout,
    username
  } = _ref;
  return y(g, null, y("span", {
    className: "uppy-ProviderBrowser-user",
    key: "username"
  }, username), y("button", {
    type: "button",
    onClick: logout,
    className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowser-userLogout",
    key: "logout"
  }, i18n("logOut")));
}

// ../../node_modules/@uppy/provider-views/lib/Breadcrumbs.js
var Breadcrumb = (props) => {
  const {
    getFolder,
    title,
    isLast
  } = props;
  return y(g, null, y("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn",
    onClick: getFolder
  }, title), !isLast ? " / " : "");
};
function Breadcrumbs(props) {
  const {
    getFolder,
    title,
    breadcrumbsIcon,
    breadcrumbs
  } = props;
  return y("div", {
    className: "uppy-Provider-breadcrumbs"
  }, y("div", {
    className: "uppy-Provider-breadcrumbsIcon"
  }, breadcrumbsIcon), breadcrumbs.map((directory, i4) => y(Breadcrumb, {
    key: directory.id,
    getFolder: () => getFolder(directory.requestPath, directory.name),
    title: i4 === 0 ? title : directory.name,
    isLast: i4 + 1 === breadcrumbs.length
  })));
}

// ../../node_modules/@uppy/provider-views/lib/ProviderView/Header.js
function Header(props) {
  return y(g, null, props.showBreadcrumbs && y(Breadcrumbs, {
    getFolder: props.getFolder,
    breadcrumbs: props.breadcrumbs,
    breadcrumbsIcon: props.pluginIcon && props.pluginIcon(),
    title: props.title
  }), y(User, {
    logout: props.logout,
    username: props.username,
    i18n: props.i18n
  }));
}

// ../../node_modules/@uppy/provider-views/lib/Browser.js
var import_classnames5 = __toESM(require_classnames(), 1);

// ../../node_modules/@uppy/utils/lib/remoteFileObjToLocal.js
function remoteFileObjToLocal(file) {
  return {
    ...file,
    type: file.mimeType,
    extension: file.name ? getFileNameAndExtension(file.name).extension : null
  };
}

// ../../node_modules/@uppy/utils/lib/VirtualList.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var STYLE_INNER = {
  position: "relative",
  // Disabled for our use case: the wrapper elements around FileList already deal with overflow,
  // and this additional property would hide things that we want to show.
  //
  // overflow: 'hidden',
  width: "100%",
  minHeight: "100%"
};
var STYLE_CONTENT = {
  position: "absolute",
  top: 0,
  left: 0,
  // Because the `top` value gets set to some offset, this `height` being 100% would make the scrollbar
  // stretch far beyond the content. For our use case, the content div actually can get its height from
  // the elements inside it, so we don't need to specify a `height` property at all.
  //
  // height: '100%',
  width: "100%",
  overflow: "visible"
};
var VirtualList = class extends b {
  constructor(props) {
    super(props);
    this.handleScroll = () => {
      this.setState({
        offset: this.base.scrollTop
      });
    };
    this.handleResize = () => {
      this.resize();
    };
    this.focusElement = null;
    this.state = {
      offset: 0,
      height: 0
    };
  }
  componentDidMount() {
    this.resize();
    window.addEventListener("resize", this.handleResize);
  }
  // TODO: refactor to stable lifecycle method
  // eslint-disable-next-line
  componentWillUpdate() {
    if (this.base.contains(document.activeElement)) {
      this.focusElement = document.activeElement;
    }
  }
  componentDidUpdate() {
    if (this.focusElement && this.focusElement.parentNode && document.activeElement !== this.focusElement) {
      this.focusElement.focus();
    }
    this.focusElement = null;
    this.resize();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  resize() {
    const {
      height
    } = this.state;
    if (height !== this.base.offsetHeight) {
      this.setState({
        height: this.base.offsetHeight
      });
    }
  }
  render(_ref) {
    let {
      data,
      rowHeight,
      renderRow,
      overscanCount = 10,
      ...props
    } = _ref;
    const {
      offset,
      height
    } = this.state;
    let start = Math.floor(offset / rowHeight);
    let visibleRowCount = Math.floor(height / rowHeight);
    if (overscanCount) {
      start = Math.max(0, start - start % overscanCount);
      visibleRowCount += overscanCount;
    }
    const end = start + visibleRowCount + 4;
    const selection = data.slice(start, end);
    const styleInner = {
      ...STYLE_INNER,
      height: data.length * rowHeight
    };
    const styleContent = {
      ...STYLE_CONTENT,
      top: start * rowHeight
    };
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y("div", _extends({
        onScroll: this.handleScroll
      }, props), y("div", {
        role: "presentation",
        style: styleInner
      }, y("div", {
        role: "presentation",
        style: styleContent
      }, selection.map(renderRow))))
    );
  }
};
var VirtualList_default = VirtualList;

// ../../node_modules/@uppy/provider-views/lib/SearchFilterInput.js
function SearchFilterInput(props) {
  const {
    search,
    searchOnInput,
    searchTerm,
    showButton,
    inputLabel,
    clearSearchLabel,
    buttonLabel,
    clearSearch,
    inputClassName,
    buttonCSSClassName
  } = props;
  const [searchText, setSearchText] = p3(searchTerm != null ? searchTerm : "");
  const validateAndSearch = x3((ev) => {
    ev.preventDefault();
    search(searchText);
  }, [search, searchText]);
  const handleInput = x3((ev) => {
    const inputValue = ev.target.value;
    setSearchText(inputValue);
    if (searchOnInput)
      search(inputValue);
  }, [setSearchText, searchOnInput, search]);
  const handleReset = () => {
    setSearchText("");
    if (clearSearch)
      clearSearch();
  };
  const [form] = p3(() => {
    const formEl = document.createElement("form");
    formEl.setAttribute("tabindex", "-1");
    formEl.id = nanoid();
    return formEl;
  });
  _3(() => {
    document.body.appendChild(form);
    form.addEventListener("submit", validateAndSearch);
    return () => {
      form.removeEventListener("submit", validateAndSearch);
      document.body.removeChild(form);
    };
  }, [form, validateAndSearch]);
  return y(g, null, y("input", {
    className: `uppy-u-reset ${inputClassName}`,
    type: "search",
    "aria-label": inputLabel,
    placeholder: inputLabel,
    value: searchText,
    onInput: handleInput,
    form: form.id,
    "data-uppy-super-focusable": true
  }), !showButton && y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon uppy-ProviderBrowser-searchFilterIcon",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, y("path", {
    d: "M8.638 7.99l3.172 3.172a.492.492 0 1 1-.697.697L7.91 8.656a4.977 4.977 0 0 1-2.983.983C2.206 9.639 0 7.481 0 4.819 0 2.158 2.206 0 4.927 0c2.721 0 4.927 2.158 4.927 4.82a4.74 4.74 0 0 1-1.216 3.17zm-3.71.685c2.176 0 3.94-1.726 3.94-3.856 0-2.129-1.764-3.855-3.94-3.855C2.75.964.984 2.69.984 4.819c0 2.13 1.765 3.856 3.942 3.856z"
  })), !showButton && searchText && y("button", {
    className: "uppy-u-reset uppy-ProviderBrowser-searchFilterReset",
    type: "button",
    "aria-label": clearSearchLabel,
    title: clearSearchLabel,
    onClick: handleReset
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    viewBox: "0 0 19 19"
  }, y("path", {
    d: "M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"
  }))), showButton && y("button", {
    className: `uppy-u-reset uppy-c-btn uppy-c-btn-primary ${buttonCSSClassName}`,
    type: "submit",
    form: form.id
  }, buttonLabel));
}

// ../../node_modules/@uppy/provider-views/lib/FooterActions.js
function FooterActions(_ref) {
  let {
    cancel,
    done,
    i18n,
    selected
  } = _ref;
  return y("div", {
    className: "uppy-ProviderBrowser-footer"
  }, y("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary",
    onClick: done,
    type: "button"
  }, i18n("selectX", {
    smart_count: selected
  })), y("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-link",
    onClick: cancel,
    type: "button"
  }, i18n("cancel")));
}

// ../../node_modules/@uppy/provider-views/lib/Item/index.js
var import_classnames4 = __toESM(require_classnames(), 1);

// ../../node_modules/@uppy/provider-views/lib/Item/components/ItemIcon.js
function FileIcon() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: 11,
    height: 14.5,
    viewBox: "0 0 44 58"
  }, y("path", {
    d: "M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z"
  }));
}
function FolderIcon() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    style: {
      minWidth: 16,
      marginRight: 3
    },
    viewBox: "0 0 276.157 276.157"
  }, y("path", {
    d: "M273.08 101.378c-3.3-4.65-8.86-7.32-15.254-7.32h-24.34V67.59c0-10.2-8.3-18.5-18.5-18.5h-85.322c-3.63 0-9.295-2.875-11.436-5.805l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.73c-9.292 0-18.638 6.608-21.737 15.372l-2.033 5.752c-.958 2.71-4.72 5.37-7.596 5.37H18.5C8.3 49.09 0 57.39 0 67.59v167.07c0 .886.16 1.73.443 2.52.152 3.306 1.18 6.424 3.053 9.064 3.3 4.652 8.86 7.32 15.255 7.32h188.487c11.395 0 23.27-8.425 27.035-19.18l40.677-116.188c2.11-6.035 1.43-12.164-1.87-16.816zM18.5 64.088h8.864c9.295 0 18.64-6.607 21.738-15.37l2.032-5.75c.96-2.712 4.722-5.373 7.597-5.373h29.565c3.63 0 9.295 2.876 11.437 5.806l6.386 8.735c4.982 6.815 15.104 11.954 23.546 11.954h85.322c1.898 0 3.5 1.602 3.5 3.5v26.47H69.34c-11.395 0-23.27 8.423-27.035 19.178L15 191.23V67.59c0-1.898 1.603-3.5 3.5-3.5zm242.29 49.15l-40.676 116.188c-1.674 4.78-7.812 9.135-12.877 9.135H18.75c-1.447 0-2.576-.372-3.02-.997-.442-.625-.422-1.814.057-3.18l40.677-116.19c1.674-4.78 7.812-9.134 12.877-9.134h188.487c1.448 0 2.577.372 3.02.997.443.625.423 1.814-.056 3.18z"
  }));
}
function VideoIcon() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    style: {
      width: 16,
      marginRight: 4
    },
    viewBox: "0 0 58 58"
  }, y("path", {
    d: "M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z"
  }), y("path", {
    d: "M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z"
  }));
}
function ItemIcon(props) {
  const {
    itemIconString
  } = props;
  if (itemIconString === null)
    return null;
  switch (itemIconString) {
    case "file":
      return y(FileIcon, null);
    case "folder":
      return y(FolderIcon, null);
    case "video":
      return y(VideoIcon, null);
    default: {
      const {
        alt
      } = props;
      return y("img", {
        src: itemIconString,
        alt,
        referrerPolicy: "no-referrer",
        loading: "lazy",
        width: 16,
        height: 16
      });
    }
  }
}

// ../../node_modules/@uppy/provider-views/lib/Item/components/GridLi.js
var import_classnames3 = __toESM(require_classnames(), 1);
function GridListItem(props) {
  const {
    className,
    isDisabled,
    restrictionError,
    isChecked,
    title,
    itemIconEl,
    showTitles,
    toggleCheckbox,
    recordShiftKeyPress,
    id: id18,
    children
  } = props;
  const checkBoxClassName = (0, import_classnames3.default)("uppy-u-reset", "uppy-ProviderBrowserItem-checkbox", "uppy-ProviderBrowserItem-checkbox--grid", {
    "uppy-ProviderBrowserItem-checkbox--is-checked": isChecked
  });
  return y("li", {
    className,
    title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : void 0
  }, y("input", {
    type: "checkbox",
    className: checkBoxClassName,
    onChange: toggleCheckbox,
    onKeyDown: recordShiftKeyPress,
    onMouseDown: recordShiftKeyPress,
    name: "listitem",
    id: id18,
    checked: isChecked,
    disabled: isDisabled,
    "data-uppy-super-focusable": true
  }), y("label", {
    htmlFor: id18,
    "aria-label": title,
    className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
  }, itemIconEl, showTitles && title, children));
}
var GridLi_default = GridListItem;

// ../../node_modules/@uppy/provider-views/lib/Item/components/ListLi.js
function ListItem2(props) {
  const {
    className,
    isDisabled,
    restrictionError,
    isCheckboxDisabled,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    type,
    id: id18,
    itemIconEl,
    title,
    handleFolderClick,
    showTitles,
    i18n
  } = props;
  return y("li", {
    className,
    title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : void 0
  }, !isCheckboxDisabled ? y("input", {
    type: "checkbox",
    className: `uppy-u-reset uppy-ProviderBrowserItem-checkbox ${isChecked ? "uppy-ProviderBrowserItem-checkbox--is-checked" : ""}`,
    onChange: toggleCheckbox,
    onKeyDown: recordShiftKeyPress,
    onMouseDown: recordShiftKeyPress,
    name: "listitem",
    id: id18,
    checked: isChecked,
    "aria-label": type === "file" ? null : i18n("allFilesFromFolderNamed", {
      name: title
    }),
    disabled: isDisabled,
    "data-uppy-super-focusable": true
  }) : null, type === "file" ? (
    // label for a checkbox
    y("label", {
      htmlFor: id18,
      className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, y("div", {
      className: "uppy-ProviderBrowserItem-iconWrap"
    }, itemIconEl), showTitles && title)
  ) : y("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowserItem-inner",
    onClick: handleFolderClick,
    "aria-label": i18n("openFolderNamed", {
      name: title
    })
  }, y("div", {
    className: "uppy-ProviderBrowserItem-iconWrap"
  }, itemIconEl), showTitles && y("span", null, title)));
}

// ../../node_modules/@uppy/provider-views/lib/Item/index.js
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
function Item(props) {
  const {
    author,
    getItemIcon,
    isChecked,
    isDisabled,
    viewType
  } = props;
  const itemIconString = getItemIcon();
  const className = (0, import_classnames4.default)("uppy-ProviderBrowserItem", {
    "uppy-ProviderBrowserItem--selected": isChecked
  }, {
    "uppy-ProviderBrowserItem--disabled": isDisabled
  }, {
    "uppy-ProviderBrowserItem--noPreview": itemIconString === "video"
  });
  const itemIconEl = y(ItemIcon, {
    itemIconString
  });
  switch (viewType) {
    case "grid":
      return y(GridLi_default, _extends2({}, props, {
        className,
        itemIconEl
      }));
    case "list":
      return y(ListItem2, _extends2({}, props, {
        className,
        itemIconEl
      }));
    case "unsplash":
      return y(GridLi_default, _extends2({}, props, {
        className,
        itemIconEl
      }), y("a", {
        href: `${author.url}?utm_source=Companion&utm_medium=referral`,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "uppy-ProviderBrowserItem-author",
        tabIndex: -1
      }, author.name));
    default:
      throw new Error(`There is no such type ${viewType}`);
  }
}

// ../../node_modules/@uppy/provider-views/lib/Browser.js
var VIRTUAL_SHARED_DIR = "shared-with-me";
function ListItem3(props) {
  const {
    currentSelection,
    uppyFiles,
    viewType,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    showTitles,
    i18n,
    validateRestrictions,
    getNextFolder,
    f: f4
  } = props;
  if (f4.isFolder) {
    return Item({
      showTitles,
      viewType,
      i18n,
      id: f4.id,
      title: f4.name,
      getItemIcon: () => f4.icon,
      isChecked: isChecked(f4),
      toggleCheckbox: (event) => toggleCheckbox(event, f4),
      recordShiftKeyPress,
      type: "folder",
      // TODO: when was this supposed to be true?
      isDisabled: false,
      isCheckboxDisabled: f4.id === VIRTUAL_SHARED_DIR,
      // getNextFolder always exists when f.isFolder is true
      handleFolderClick: () => getNextFolder(f4)
    });
  }
  const restrictionError = validateRestrictions(remoteFileObjToLocal(f4), [...uppyFiles, ...currentSelection]);
  return Item({
    id: f4.id,
    title: f4.name,
    author: f4.author,
    getItemIcon: () => f4.icon,
    isChecked: isChecked(f4),
    toggleCheckbox: (event) => toggleCheckbox(event, f4),
    isCheckboxDisabled: false,
    recordShiftKeyPress,
    showTitles,
    viewType,
    i18n,
    type: "file",
    isDisabled: Boolean(restrictionError) && !isChecked(f4),
    restrictionError
  });
}
function Browser(props) {
  const {
    currentSelection,
    folders,
    files,
    uppyFiles,
    viewType,
    headerComponent,
    showBreadcrumbs,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    handleScroll,
    showTitles,
    i18n,
    validateRestrictions,
    isLoading,
    showSearchFilter,
    search,
    searchTerm,
    clearSearch,
    searchOnInput,
    searchInputLabel,
    clearSearchLabel,
    getNextFolder,
    cancel,
    done,
    noResultsLabel,
    loadAllFiles
  } = props;
  const selected = currentSelection.length;
  const rows = q3(() => [...folders, ...files], [folders, files]);
  return y("div", {
    className: (0, import_classnames5.default)("uppy-ProviderBrowser", `uppy-ProviderBrowser-viewType--${viewType}`)
  }, headerComponent && y("div", {
    className: "uppy-ProviderBrowser-header"
  }, y("div", {
    className: (0, import_classnames5.default)("uppy-ProviderBrowser-headerBar", !showBreadcrumbs && "uppy-ProviderBrowser-headerBar--simple")
  }, headerComponent)), showSearchFilter && y("div", {
    class: "uppy-ProviderBrowser-searchFilter"
  }, y(SearchFilterInput, {
    search,
    searchTerm,
    clearSearch,
    inputLabel: searchInputLabel,
    clearSearchLabel,
    inputClassName: "uppy-ProviderBrowser-searchFilterInput",
    searchOnInput
  })), (() => {
    if (isLoading) {
      return y("div", {
        className: "uppy-Provider-loading"
      }, y("span", null, i18n("loading")));
    }
    if (!folders.length && !files.length) {
      return y("div", {
        className: "uppy-Provider-empty"
      }, noResultsLabel);
    }
    if (loadAllFiles) {
      return y("div", {
        className: "uppy-ProviderBrowser-body"
      }, y("ul", {
        className: "uppy-ProviderBrowser-list"
      }, y(VirtualList_default, {
        data: rows,
        renderRow: (f4) => y(ListItem3, {
          currentSelection,
          uppyFiles,
          viewType,
          isChecked,
          toggleCheckbox,
          recordShiftKeyPress,
          showTitles,
          i18n,
          validateRestrictions,
          getNextFolder,
          f: f4
        }),
        rowHeight: 31
      })));
    }
    return y("div", {
      className: "uppy-ProviderBrowser-body"
    }, y("ul", {
      className: "uppy-ProviderBrowser-list",
      onScroll: handleScroll,
      role: "listbox",
      tabIndex: -1
    }, rows.map((f4) => y(ListItem3, {
      currentSelection,
      uppyFiles,
      viewType,
      isChecked,
      toggleCheckbox,
      recordShiftKeyPress,
      showTitles,
      i18n,
      validateRestrictions,
      getNextFolder,
      f: f4
    }))));
  })(), selected > 0 && y(FooterActions, {
    selected,
    done,
    cancel,
    i18n
  }));
}
var Browser_default = Browser;

// ../../node_modules/@uppy/provider-views/lib/CloseWrapper.js
var CloseWrapper = class extends b {
  componentWillUnmount() {
    const {
      onUnmount
    } = this.props;
    onUnmount();
  }
  render() {
    const {
      children
    } = this.props;
    return H(children)[0];
  }
};

// ../../node_modules/@uppy/provider-views/lib/View.js
var View = class {
  constructor(plugin, opts) {
    this.filterItems = (items) => {
      const state = this.plugin.getPluginState();
      if (!state.filterInput || state.filterInput === "") {
        return items;
      }
      return items.filter((folder) => {
        return folder.name.toLowerCase().indexOf(state.filterInput.toLowerCase()) !== -1;
      });
    };
    this.recordShiftKeyPress = (e4) => {
      this.isShiftKeyPressed = e4.shiftKey;
    };
    this.isChecked = (file) => {
      const {
        currentSelection
      } = this.plugin.getPluginState();
      return currentSelection.some((item) => item.id === file.id);
    };
    this.plugin = plugin;
    this.provider = opts.provider;
    this.opts = opts;
    this.isHandlingScroll = false;
    this.preFirstRender = this.preFirstRender.bind(this);
    this.handleError = this.handleError.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.cancelPicking = this.cancelPicking.bind(this);
  }
  preFirstRender() {
    this.plugin.setPluginState({
      didFirstRender: true
    });
    this.plugin.onFirstRender();
  }
  shouldHandleScroll(event) {
    const {
      scrollHeight,
      scrollTop,
      offsetHeight
    } = event.target;
    const scrollPosition = scrollHeight - (scrollTop + offsetHeight);
    return scrollPosition < 50 && !this.isHandlingScroll;
  }
  clearSelection() {
    this.plugin.setPluginState({
      currentSelection: [],
      filterInput: ""
    });
  }
  cancelPicking() {
    this.clearSelection();
    const dashboard = this.plugin.uppy.getPlugin("Dashboard");
    if (dashboard) {
      dashboard.hideAllPanels();
    }
  }
  handleError(error) {
    var _error$cause;
    const {
      uppy: uppy2
    } = this.plugin;
    const message = uppy2.i18n("companionError");
    uppy2.log(error.toString());
    if (error.isAuthError || ((_error$cause = error.cause) == null ? void 0 : _error$cause.name) === "AbortError") {
      return;
    }
    uppy2.info({
      message,
      details: error.toString()
    }, "error", 5e3);
  }
  registerRequestClient() {
    this.requestClientId = this.provider.provider;
    this.plugin.uppy.registerRequestClient(this.requestClientId, this.provider);
  }
  // TODO: document what is a "tagFile" or get rid of this concept
  getTagFile(file) {
    const tagFile = {
      id: file.id,
      source: this.plugin.id,
      name: file.name || file.id,
      type: file.mimeType,
      isRemote: true,
      data: file,
      // @ts-expect-error meta is filled conditionally below
      meta: {},
      body: {
        fileId: file.id
      },
      remote: {
        companionUrl: this.plugin.opts.companionUrl,
        // @ts-expect-error untyped for now
        url: `${this.provider.fileUrl(file.requestPath)}`,
        body: {
          fileId: file.id
        },
        providerName: this.provider.name,
        provider: this.provider.provider,
        requestClientId: this.requestClientId
      }
    };
    const fileType = getFileType(tagFile);
    if (fileType && isPreviewSupported(fileType)) {
      tagFile.preview = file.thumbnail;
    }
    if (file.author) {
      if (file.author.name != null)
        tagFile.meta.authorName = String(file.author.name);
      if (file.author.url)
        tagFile.meta.authorUrl = file.author.url;
    }
    if (file.relDirPath != null)
      tagFile.meta.relativePath = file.relDirPath ? `${file.relDirPath}/${tagFile.name}` : null;
    if (file.absDirPath != null)
      tagFile.meta.absolutePath = file.absDirPath ? `/${file.absDirPath}/${tagFile.name}` : `/${tagFile.name}`;
    return tagFile;
  }
  /**
   * Toggles file/folder checkbox to on/off state while updating files list.
   *
   * Note that some extra complexity comes from supporting shift+click to
   * toggle multiple checkboxes at once, which is done by getting all files
   * in between last checked file and current one.
   */
  toggleCheckbox(e4, file) {
    e4.stopPropagation();
    e4.preventDefault();
    e4.currentTarget.focus();
    const {
      folders,
      files
    } = this.plugin.getPluginState();
    const items = this.filterItems(folders.concat(files));
    if (this.lastCheckbox && this.isShiftKeyPressed) {
      const {
        currentSelection: currentSelection2
      } = this.plugin.getPluginState();
      const prevIndex = items.indexOf(this.lastCheckbox);
      const currentIndex = items.indexOf(file);
      const newSelection = prevIndex < currentIndex ? items.slice(prevIndex, currentIndex + 1) : items.slice(currentIndex, prevIndex + 1);
      const reducedNewSelection = [];
      for (const item of newSelection) {
        const {
          uppy: uppy2
        } = this.plugin;
        const restrictionError = uppy2.validateRestrictions(remoteFileObjToLocal(item), [...uppy2.getFiles(), ...reducedNewSelection]);
        if (!restrictionError) {
          reducedNewSelection.push(item);
        } else {
          uppy2.info({
            message: restrictionError.message
          }, "error", uppy2.opts.infoTimeout);
        }
      }
      this.plugin.setPluginState({
        currentSelection: [.../* @__PURE__ */ new Set([...currentSelection2, ...reducedNewSelection])]
      });
      return;
    }
    this.lastCheckbox = file;
    const {
      currentSelection
    } = this.plugin.getPluginState();
    if (this.isChecked(file)) {
      this.plugin.setPluginState({
        currentSelection: currentSelection.filter((item) => item.id !== file.id)
      });
    } else {
      this.plugin.setPluginState({
        currentSelection: currentSelection.concat([file])
      });
    }
  }
  setLoading(loading) {
    this.plugin.setPluginState({
      loading
    });
  }
};

// ../../node_modules/@uppy/provider-views/lib/ProviderView/ProviderView.js
function _classPrivateFieldLooseBase15(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id15 = 0;
function _classPrivateFieldLooseKey15(name) {
  return "__private_" + id15++ + "_" + name;
}
var packageJson9 = {
  "version": "3.11.0"
};
function formatBreadcrumbs(breadcrumbs) {
  return breadcrumbs.slice(1).map((directory) => directory.name).join("/");
}
function prependPath(path, component) {
  if (!path)
    return component;
  return `${path}/${component}`;
}
function defaultPickerIcon() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30"
  }, y("path", {
    d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
  }));
}
var defaultOptions5 = {
  viewType: "list",
  showTitles: true,
  showFilter: true,
  showBreadcrumbs: true,
  loadAllFiles: false
};
var _abortController2 = /* @__PURE__ */ _classPrivateFieldLooseKey15("abortController");
var _withAbort = /* @__PURE__ */ _classPrivateFieldLooseKey15("withAbort");
var _list = /* @__PURE__ */ _classPrivateFieldLooseKey15("list");
var _listFilesAndFolders = /* @__PURE__ */ _classPrivateFieldLooseKey15("listFilesAndFolders");
var _recursivelyListAllFiles = /* @__PURE__ */ _classPrivateFieldLooseKey15("recursivelyListAllFiles");
var ProviderView = class extends View {
  constructor(plugin, opts) {
    super(plugin, {
      ...defaultOptions5,
      ...opts
    });
    Object.defineProperty(this, _recursivelyListAllFiles, {
      value: _recursivelyListAllFiles2
    });
    Object.defineProperty(this, _listFilesAndFolders, {
      value: _listFilesAndFolders2
    });
    Object.defineProperty(this, _list, {
      value: _list2
    });
    Object.defineProperty(this, _withAbort, {
      value: _withAbort2
    });
    Object.defineProperty(this, _abortController2, {
      writable: true,
      value: void 0
    });
    this.filterQuery = this.filterQuery.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.getFolder = this.getFolder.bind(this);
    this.getNextFolder = this.getNextFolder.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuth = this.handleAuth.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.donePicking = this.donePicking.bind(this);
    this.render = this.render.bind(this);
    this.plugin.setPluginState({
      authenticated: void 0,
      // we don't know yet
      files: [],
      folders: [],
      breadcrumbs: [],
      filterInput: "",
      isSearchVisible: false,
      currentSelection: []
    });
    this.registerRequestClient();
  }
  // eslint-disable-next-line class-methods-use-this
  tearDown() {
  }
  /**
   * Select a folder based on its id: fetches the folder and then updates state with its contents
   * TODO rename to something better like selectFolder or navigateToFolder (breaking change?)
   *
   */
  async getFolder(requestPath, name) {
    this.setLoading(true);
    try {
      await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
        this.lastCheckbox = void 0;
        let {
          breadcrumbs
        } = this.plugin.getPluginState();
        const index = breadcrumbs.findIndex((dir) => requestPath === dir.requestPath);
        if (index !== -1) {
          breadcrumbs = breadcrumbs.slice(0, index + 1);
        } else {
          breadcrumbs = [...breadcrumbs, {
            requestPath,
            name
          }];
        }
        this.nextPagePath = requestPath;
        let files = [];
        let folders = [];
        do {
          const {
            files: newFiles,
            folders: newFolders
          } = await _classPrivateFieldLooseBase15(this, _listFilesAndFolders)[_listFilesAndFolders]({
            breadcrumbs,
            signal
          });
          files = files.concat(newFiles);
          folders = folders.concat(newFolders);
          this.setLoading(this.plugin.uppy.i18n("loadedXFiles", {
            numFiles: files.length + folders.length
          }));
        } while (this.opts.loadAllFiles && this.nextPagePath);
        this.plugin.setPluginState({
          folders,
          files,
          breadcrumbs,
          filterInput: ""
        });
      });
    } catch (err) {
      if ((err == null ? void 0 : err.name) === "UserFacingApiError") {
        this.plugin.uppy.info({
          message: this.plugin.uppy.i18n(err.message)
        }, "warning", 5e3);
        return;
      }
      this.handleError(err);
    } finally {
      this.setLoading(false);
    }
  }
  /**
   * Fetches new folder
   */
  getNextFolder(folder) {
    this.getFolder(folder.requestPath, folder.name);
    this.lastCheckbox = void 0;
  }
  /**
   * Removes session token on client side.
   */
  async logout() {
    try {
      await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
        const res = await this.provider.logout({
          signal
        });
        if (res.ok) {
          if (!res.revoked) {
            const message = this.plugin.uppy.i18n("companionUnauthorizeHint", {
              provider: this.plugin.title,
              url: res.manual_revoke_url
            });
            this.plugin.uppy.info(message, "info", 7e3);
          }
          const newState = {
            authenticated: false,
            files: [],
            folders: [],
            breadcrumbs: [],
            filterInput: ""
          };
          this.plugin.setPluginState(newState);
        }
      });
    } catch (err) {
      this.handleError(err);
    }
  }
  filterQuery(input) {
    this.plugin.setPluginState({
      filterInput: input
    });
  }
  clearFilter() {
    this.plugin.setPluginState({
      filterInput: ""
    });
  }
  async handleAuth(authFormData) {
    try {
      await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
        this.setLoading(true);
        await this.provider.login({
          authFormData,
          signal
        });
        this.plugin.setPluginState({
          authenticated: true
        });
        this.preFirstRender();
      });
    } catch (err) {
      if (err.name === "UserFacingApiError") {
        this.plugin.uppy.info({
          message: this.plugin.uppy.i18n(err.message)
        }, "warning", 5e3);
        return;
      }
      this.plugin.uppy.log(`login failed: ${err.message}`);
    } finally {
      this.setLoading(false);
    }
  }
  async handleScroll(event) {
    if (this.shouldHandleScroll(event) && this.nextPagePath) {
      this.isHandlingScroll = true;
      try {
        await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
          const {
            files,
            folders,
            breadcrumbs
          } = this.plugin.getPluginState();
          const {
            files: newFiles,
            folders: newFolders
          } = await _classPrivateFieldLooseBase15(this, _listFilesAndFolders)[_listFilesAndFolders]({
            breadcrumbs,
            signal
          });
          const combinedFiles = files.concat(newFiles);
          const combinedFolders = folders.concat(newFolders);
          this.plugin.setPluginState({
            folders: combinedFolders,
            files: combinedFiles
          });
        });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isHandlingScroll = false;
      }
    }
  }
  async donePicking() {
    this.setLoading(true);
    try {
      await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
        const {
          currentSelection
        } = this.plugin.getPluginState();
        const messages = [];
        const newFiles = [];
        for (const selectedItem of currentSelection) {
          const {
            requestPath
          } = selectedItem;
          const withRelDirPath = (newItem) => ({
            ...newItem,
            // calculate the file's path relative to the user's selected item's path
            // see https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
            relDirPath: newItem.absDirPath.replace(selectedItem.absDirPath, "").replace(/^\//, "")
          });
          if (selectedItem.isFolder) {
            let isEmpty = true;
            let numNewFiles = 0;
            const queue = new dist_default({
              concurrency: 6
            });
            const onFiles = (files) => {
              for (const newFile of files) {
                const tagFile = this.getTagFile(newFile);
                const id18 = getSafeFileId(tagFile);
                if (!this.plugin.uppy.checkIfFileAlreadyExists(id18)) {
                  newFiles.push(withRelDirPath(newFile));
                  numNewFiles++;
                  this.setLoading(this.plugin.uppy.i18n("addedNumFiles", {
                    numFiles: numNewFiles
                  }));
                }
                isEmpty = false;
              }
            };
            await _classPrivateFieldLooseBase15(this, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
              requestPath,
              absDirPath: prependPath(selectedItem.absDirPath, selectedItem.name),
              relDirPath: selectedItem.name,
              queue,
              onFiles,
              signal
            });
            await queue.onIdle();
            let message;
            if (isEmpty) {
              message = this.plugin.uppy.i18n("emptyFolderAdded");
            } else if (numNewFiles === 0) {
              message = this.plugin.uppy.i18n("folderAlreadyAdded", {
                folder: selectedItem.name
              });
            } else {
              message = this.plugin.uppy.i18n("folderAdded", {
                smart_count: numNewFiles,
                folder: selectedItem.name
              });
            }
            messages.push(message);
          } else {
            newFiles.push(withRelDirPath(selectedItem));
          }
        }
        this.plugin.uppy.log("Adding files from a remote provider");
        this.plugin.uppy.addFiles(
          // @ts-expect-error `addFiles` expects `body` to be `File` or `Blob`,
          // but as the todo comment in `View.ts` indicates, we strangly pass `CompanionFile` as `body`.
          // For now it's better to ignore than to have a potential breaking change.
          newFiles.map((file) => this.getTagFile(file, this.requestClientId))
        );
        this.plugin.setPluginState({
          filterInput: ""
        });
        messages.forEach((message) => this.plugin.uppy.info(message));
        this.clearSelection();
      });
    } catch (err) {
      this.handleError(err);
    } finally {
      this.setLoading(false);
    }
  }
  render(state, viewOptions) {
    var _this = this;
    if (viewOptions === void 0) {
      viewOptions = {};
    }
    const {
      authenticated,
      didFirstRender
    } = this.plugin.getPluginState();
    const {
      i18n
    } = this.plugin.uppy;
    if (!didFirstRender) {
      this.preFirstRender();
    }
    const targetViewOptions = {
      ...this.opts,
      ...viewOptions
    };
    const {
      files,
      folders,
      filterInput,
      loading,
      currentSelection
    } = this.plugin.getPluginState();
    const {
      isChecked,
      recordShiftKeyPress,
      filterItems
    } = this;
    const hasInput = filterInput !== "";
    const pluginIcon = this.plugin.icon || defaultPickerIcon;
    const headerProps = {
      showBreadcrumbs: targetViewOptions.showBreadcrumbs,
      getFolder: this.getFolder,
      breadcrumbs: this.plugin.getPluginState().breadcrumbs,
      pluginIcon,
      title: this.plugin.title,
      logout: this.logout,
      username: this.username,
      i18n
    };
    const browserProps = {
      isChecked,
      toggleCheckbox: this.toggleCheckbox.bind(this),
      recordShiftKeyPress,
      currentSelection,
      files: hasInput ? filterItems(files) : files,
      folders: hasInput ? filterItems(folders) : folders,
      getNextFolder: this.getNextFolder,
      getFolder: this.getFolder,
      loadAllFiles: this.opts.loadAllFiles,
      // For SearchFilterInput component
      showSearchFilter: targetViewOptions.showFilter,
      search: this.filterQuery,
      clearSearch: this.clearFilter,
      searchTerm: filterInput,
      searchOnInput: true,
      searchInputLabel: i18n("filter"),
      clearSearchLabel: i18n("resetFilter"),
      noResultsLabel: i18n("noFilesFound"),
      logout: this.logout,
      handleScroll: this.handleScroll,
      done: this.donePicking,
      cancel: this.cancelPicking,
      // eslint-disable-next-line react/jsx-props-no-spreading
      headerComponent: y(Header, headerProps),
      title: this.plugin.title,
      viewType: targetViewOptions.viewType,
      showTitles: targetViewOptions.showTitles,
      showBreadcrumbs: targetViewOptions.showBreadcrumbs,
      pluginIcon,
      i18n: this.plugin.uppy.i18n,
      uppyFiles: this.plugin.uppy.getFiles(),
      validateRestrictions: function() {
        return _this.plugin.uppy.validateRestrictions(...arguments);
      },
      isLoading: loading
    };
    if (authenticated === false) {
      return y(CloseWrapper, {
        onUnmount: this.clearSelection
      }, y(AuthView, {
        pluginName: this.plugin.title,
        pluginIcon,
        handleAuth: this.handleAuth,
        i18n: this.plugin.uppy.i18nArray,
        renderForm: this.opts.renderAuthForm,
        loading
      }));
    }
    return y(CloseWrapper, {
      onUnmount: this.clearSelection
    }, y(Browser_default, browserProps));
  }
};
async function _withAbort2(op) {
  var _classPrivateFieldLoo;
  (_classPrivateFieldLoo = _classPrivateFieldLooseBase15(this, _abortController2)[_abortController2]) == null || _classPrivateFieldLoo.abort();
  const abortController = new AbortController();
  _classPrivateFieldLooseBase15(this, _abortController2)[_abortController2] = abortController;
  const cancelRequest = () => {
    abortController.abort();
    this.clearSelection();
  };
  try {
    this.plugin.uppy.on("dashboard:close-panel", cancelRequest);
    this.plugin.uppy.on("cancel-all", cancelRequest);
    await op(abortController.signal);
  } finally {
    this.plugin.uppy.off("dashboard:close-panel", cancelRequest);
    this.plugin.uppy.off("cancel-all", cancelRequest);
    _classPrivateFieldLooseBase15(this, _abortController2)[_abortController2] = void 0;
  }
}
async function _list2(_ref) {
  let {
    requestPath,
    absDirPath,
    signal
  } = _ref;
  const {
    username,
    nextPagePath,
    items
  } = await this.provider.list(requestPath, {
    signal
  });
  this.username = username || this.username;
  return {
    items: items.map((item) => ({
      ...item,
      absDirPath
    })),
    nextPagePath
  };
}
async function _listFilesAndFolders2(_ref2) {
  let {
    breadcrumbs,
    signal
  } = _ref2;
  const absDirPath = formatBreadcrumbs(breadcrumbs);
  const {
    items,
    nextPagePath
  } = await _classPrivateFieldLooseBase15(this, _list)[_list]({
    requestPath: this.nextPagePath,
    absDirPath,
    signal
  });
  this.nextPagePath = nextPagePath;
  const files = [];
  const folders = [];
  items.forEach((item) => {
    if (item.isFolder) {
      folders.push(item);
    } else {
      files.push(item);
    }
  });
  return {
    files,
    folders
  };
}
async function _recursivelyListAllFiles2(_ref3) {
  let {
    requestPath,
    absDirPath,
    relDirPath,
    queue,
    onFiles,
    signal
  } = _ref3;
  let curPath = requestPath;
  while (curPath) {
    const res = await _classPrivateFieldLooseBase15(this, _list)[_list]({
      requestPath: curPath,
      absDirPath,
      signal
    });
    curPath = res.nextPagePath;
    const files = res.items.filter((item) => !item.isFolder);
    const folders = res.items.filter((item) => item.isFolder);
    onFiles(files);
    const promises = folders.map(async (folder) => queue.add(async () => _classPrivateFieldLooseBase15(this, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
      requestPath: folder.requestPath,
      absDirPath: prependPath(absDirPath, folder.name),
      relDirPath: prependPath(relDirPath, folder.name),
      queue,
      onFiles,
      signal
    })));
    await Promise.all(promises);
  }
}
ProviderView.VERSION = packageJson9.version;

// ../../node_modules/@uppy/provider-views/lib/SearchProviderView/SearchProviderView.js
function _classPrivateFieldLooseBase16(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id16 = 0;
function _classPrivateFieldLooseKey16(name) {
  return "__private_" + id16++ + "_" + name;
}
var packageJson10 = {
  "version": "3.11.0"
};
var defaultState = {
  isInputMode: true,
  files: [],
  folders: [],
  breadcrumbs: [],
  filterInput: "",
  currentSelection: [],
  searchTerm: null
};
var defaultOptions6 = {
  viewType: "grid",
  showTitles: true,
  showFilter: true,
  showBreadcrumbs: true
};
var _updateFilesAndInputMode = /* @__PURE__ */ _classPrivateFieldLooseKey16("updateFilesAndInputMode");
var SearchProviderView = class extends View {
  constructor(plugin, opts) {
    super(plugin, {
      ...defaultOptions6,
      ...opts
    });
    Object.defineProperty(this, _updateFilesAndInputMode, {
      value: _updateFilesAndInputMode2
    });
    this.nextPageQuery = null;
    this.search = this.search.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.resetPluginState = this.resetPluginState.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.donePicking = this.donePicking.bind(this);
    this.render = this.render.bind(this);
    this.plugin.setPluginState(defaultState);
    this.registerRequestClient();
  }
  // eslint-disable-next-line class-methods-use-this
  tearDown() {
  }
  resetPluginState() {
    this.plugin.setPluginState(defaultState);
  }
  async search(query) {
    const {
      searchTerm
    } = this.plugin.getPluginState();
    if (query && query === searchTerm) {
      return;
    }
    this.setLoading(true);
    try {
      const res = await this.provider.search(query);
      _classPrivateFieldLooseBase16(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](res, []);
    } catch (err) {
      this.handleError(err);
    } finally {
      this.setLoading(false);
    }
  }
  clearSearch() {
    this.plugin.setPluginState({
      currentSelection: [],
      files: [],
      searchTerm: null
    });
  }
  async handleScroll(event) {
    const query = this.nextPageQuery || null;
    if (this.shouldHandleScroll(event) && query) {
      this.isHandlingScroll = true;
      try {
        const {
          files,
          searchTerm
        } = this.plugin.getPluginState();
        const response = await this.provider.search(searchTerm, query);
        _classPrivateFieldLooseBase16(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](response, files);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isHandlingScroll = false;
      }
    }
  }
  donePicking() {
    const {
      currentSelection
    } = this.plugin.getPluginState();
    this.plugin.uppy.log("Adding remote search provider files");
    this.plugin.uppy.addFiles(currentSelection.map((file) => this.getTagFile(file)));
    this.resetPluginState();
  }
  render(state, viewOptions) {
    var _this = this;
    if (viewOptions === void 0) {
      viewOptions = {};
    }
    const {
      didFirstRender,
      isInputMode,
      searchTerm
    } = this.plugin.getPluginState();
    const {
      i18n
    } = this.plugin.uppy;
    if (!didFirstRender) {
      this.preFirstRender();
    }
    const targetViewOptions = {
      ...this.opts,
      ...viewOptions
    };
    const {
      files,
      folders,
      filterInput,
      loading,
      currentSelection
    } = this.plugin.getPluginState();
    const {
      isChecked,
      filterItems,
      recordShiftKeyPress
    } = this;
    const hasInput = filterInput !== "";
    const browserProps = {
      isChecked,
      toggleCheckbox: this.toggleCheckbox.bind(this),
      recordShiftKeyPress,
      currentSelection,
      files: hasInput ? filterItems(files) : files,
      folders: hasInput ? filterItems(folders) : folders,
      handleScroll: this.handleScroll,
      done: this.donePicking,
      cancel: this.cancelPicking,
      // For SearchFilterInput component
      showSearchFilter: targetViewOptions.showFilter,
      search: this.search,
      clearSearch: this.clearSearch,
      searchTerm,
      searchOnInput: false,
      searchInputLabel: i18n("search"),
      clearSearchLabel: i18n("resetSearch"),
      noResultsLabel: i18n("noSearchResults"),
      title: this.plugin.title,
      viewType: targetViewOptions.viewType,
      showTitles: targetViewOptions.showTitles,
      showFilter: targetViewOptions.showFilter,
      isLoading: loading,
      showBreadcrumbs: targetViewOptions.showBreadcrumbs,
      pluginIcon: this.plugin.icon,
      i18n,
      uppyFiles: this.plugin.uppy.getFiles(),
      validateRestrictions: function() {
        return _this.plugin.uppy.validateRestrictions(...arguments);
      }
    };
    if (isInputMode) {
      return y(CloseWrapper, {
        onUnmount: this.resetPluginState
      }, y("div", {
        className: "uppy-SearchProvider"
      }, y(SearchFilterInput, {
        search: this.search,
        inputLabel: i18n("enterTextToSearch"),
        buttonLabel: i18n("searchImages"),
        inputClassName: "uppy-c-textInput uppy-SearchProvider-input",
        buttonCSSClassName: "uppy-SearchProvider-searchButton",
        showButton: true
      })));
    }
    return y(CloseWrapper, {
      onUnmount: this.resetPluginState
    }, y(Browser_default, browserProps));
  }
};
function _updateFilesAndInputMode2(res, files) {
  this.nextPageQuery = res.nextPageQuery;
  res.items.forEach((item) => {
    files.push(item);
  });
  this.plugin.setPluginState({
    currentSelection: [],
    isInputMode: false,
    files,
    searchTerm: res.searchedFor
  });
}
SearchProviderView.VERSION = packageJson10.version;

// ../../node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i4 = 0; i4 < newInputs.length; i4++) {
    if (!isEqual(newInputs[i4], lastInputs[i4])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var cache = null;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (cache && cache.lastThis === this && isEqual2(newArgs, cache.lastArgs)) {
      return cache.lastResult;
    }
    var lastResult = resultFn.apply(this, newArgs);
    cache = {
      lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }
  memoized.clear = function clear() {
    cache = null;
  };
  return memoized;
}

// ../../node_modules/@uppy/utils/lib/FOCUSABLE_ELEMENTS.js
var FOCUSABLE_ELEMENTS_default = ['a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', "input:not([disabled]):not([inert]):not([aria-hidden])", "select:not([disabled]):not([inert]):not([aria-hidden])", "textarea:not([disabled]):not([inert]):not([aria-hidden])", "button:not([disabled]):not([inert]):not([aria-hidden])", 'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])', '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'];

// ../../node_modules/@uppy/dashboard/lib/utils/getActiveOverlayEl.js
function getActiveOverlayEl(dashboardEl, activeOverlayType) {
  if (activeOverlayType) {
    const overlayEl = dashboardEl.querySelector(`[data-uppy-paneltype="${activeOverlayType}"]`);
    if (overlayEl)
      return overlayEl;
  }
  return dashboardEl;
}

// ../../node_modules/@uppy/dashboard/lib/utils/trapFocus.js
function focusOnFirstNode(event, nodes) {
  const node70 = nodes[0];
  if (node70) {
    node70.focus();
    event.preventDefault();
  }
}
function focusOnLastNode(event, nodes) {
  const node70 = nodes[nodes.length - 1];
  if (node70) {
    node70.focus();
    event.preventDefault();
  }
}
function isFocusInOverlay(activeOverlayEl) {
  return activeOverlayEl.contains(document.activeElement);
}
function trapFocus(event, activeOverlayType, dashboardEl) {
  const activeOverlayEl = getActiveOverlayEl(dashboardEl, activeOverlayType);
  const focusableNodes = toArray_default(activeOverlayEl.querySelectorAll(FOCUSABLE_ELEMENTS_default));
  const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
  if (!isFocusInOverlay(activeOverlayEl)) {
    focusOnFirstNode(event, focusableNodes);
  } else if (event.shiftKey && focusedItemIndex === 0) {
    focusOnLastNode(event, focusableNodes);
  } else if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) {
    focusOnFirstNode(event, focusableNodes);
  }
}
function forInline(event, activeOverlayType, dashboardEl) {
  if (activeOverlayType === null) {
  } else {
    trapFocus(event, activeOverlayType, dashboardEl);
  }
}

// ../../node_modules/@uppy/dashboard/lib/utils/createSuperFocus.js
var import_debounce = __toESM(require_debounce(), 1);
function createSuperFocus() {
  let lastFocusWasOnSuperFocusableEl = false;
  const superFocus = (dashboardEl, activeOverlayType) => {
    const overlayEl = getActiveOverlayEl(dashboardEl, activeOverlayType);
    const isFocusInOverlay2 = overlayEl.contains(document.activeElement);
    if (isFocusInOverlay2 && lastFocusWasOnSuperFocusableEl)
      return;
    const superFocusableEl = overlayEl.querySelector("[data-uppy-super-focusable]");
    if (isFocusInOverlay2 && !superFocusableEl)
      return;
    if (superFocusableEl) {
      superFocusableEl.focus({
        preventScroll: true
      });
      lastFocusWasOnSuperFocusableEl = true;
    } else {
      const firstEl = overlayEl.querySelector(FOCUSABLE_ELEMENTS_default);
      firstEl == null || firstEl.focus({
        preventScroll: true
      });
      lastFocusWasOnSuperFocusableEl = false;
    }
  };
  return (0, import_debounce.default)(superFocus, 260);
}

// ../../node_modules/@uppy/dashboard/lib/components/Dashboard.js
var import_classnames12 = __toESM(require_classnames(), 1);

// ../../node_modules/@uppy/utils/lib/isDragDropSupported.js
function isDragDropSupported() {
  const div = document.body;
  if (!("draggable" in div) || !("ondragstart" in div && "ondrop" in div)) {
    return false;
  }
  if (!("FormData" in window)) {
    return false;
  }
  if (!("FileReader" in window)) {
    return false;
  }
  return true;
}

// ../../node_modules/@uppy/dashboard/lib/components/FileItem/index.js
var import_classnames6 = __toESM(require_classnames(), 1);
var import_is_shallow_equal = __toESM(require_is_shallow_equal(), 1);

// ../../node_modules/@uppy/dashboard/lib/utils/getFileTypeIcon.js
function iconImage() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y("g", {
    fill: "#686DE0",
    fillRule: "evenodd"
  }, y("path", {
    d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
    fillRule: "nonzero"
  }), y("path", {
    d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z",
    fillRule: "nonzero"
  }), y("circle", {
    cx: "7.5",
    cy: "9.5",
    r: "1.5"
  })));
}
function iconAudio() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y("path", {
    d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z",
    fill: "#049BCF",
    fillRule: "nonzero"
  }));
}
function iconVideo() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y("path", {
    d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z",
    fill: "#19AF67",
    fillRule: "nonzero"
  }));
}
function iconPDF() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y("path", {
    d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z",
    fill: "#E2514A",
    fillRule: "nonzero"
  }));
}
function iconArchive() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y("path", {
    d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z",
    fill: "#00C469",
    fillRule: "nonzero"
  }));
}
function iconFile() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y("g", {
    fill: "#A7AFB7",
    fillRule: "nonzero"
  }, y("path", {
    d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z"
  }), y("path", {
    d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z"
  })));
}
function iconText() {
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y("path", {
    d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z",
    fill: "#5A5E69",
    fillRule: "nonzero"
  }));
}
function getIconByMime(fileType) {
  const defaultChoice = {
    color: "#838999",
    icon: iconFile()
  };
  if (!fileType)
    return defaultChoice;
  const fileTypeGeneral = fileType.split("/")[0];
  const fileTypeSpecific = fileType.split("/")[1];
  if (fileTypeGeneral === "text") {
    return {
      color: "#5a5e69",
      icon: iconText()
    };
  }
  if (fileTypeGeneral === "image") {
    return {
      color: "#686de0",
      icon: iconImage()
    };
  }
  if (fileTypeGeneral === "audio") {
    return {
      color: "#068dbb",
      icon: iconAudio()
    };
  }
  if (fileTypeGeneral === "video") {
    return {
      color: "#19af67",
      icon: iconVideo()
    };
  }
  if (fileTypeGeneral === "application" && fileTypeSpecific === "pdf") {
    return {
      color: "#e25149",
      icon: iconPDF()
    };
  }
  const archiveTypes = ["zip", "x-7z-compressed", "x-zip-compressed", "x-rar-compressed", "x-tar", "x-gzip", "x-apple-diskimage"];
  if (fileTypeGeneral === "application" && archiveTypes.indexOf(fileTypeSpecific) !== -1) {
    return {
      color: "#00C469",
      icon: iconArchive()
    };
  }
  return defaultChoice;
}

// ../../node_modules/@uppy/dashboard/lib/components/FilePreview.js
function FilePreview(props) {
  const {
    file
  } = props;
  if (file.preview) {
    return y("img", {
      className: "uppy-Dashboard-Item-previewImg",
      alt: file.name,
      src: file.preview
    });
  }
  const {
    color,
    icon
  } = getIconByMime(file.type);
  return y("div", {
    className: "uppy-Dashboard-Item-previewIconWrap"
  }, y("span", {
    className: "uppy-Dashboard-Item-previewIcon",
    style: {
      color
    }
  }, icon), y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-Dashboard-Item-previewIconBg",
    width: "58",
    height: "76",
    viewBox: "0 0 58 76"
  }, y("rect", {
    fill: "#FFF",
    width: "58",
    height: "76",
    rx: "3",
    fillRule: "evenodd"
  })));
}

// ../../node_modules/@uppy/dashboard/lib/components/FileItem/MetaErrorMessage.js
var metaFieldIdToName = (metaFieldId, metaFields2) => {
  const fields = typeof metaFields2 === "function" ? metaFields2() : metaFields2;
  const field = fields.filter((f4) => f4.id === metaFieldId);
  return field[0].name;
};
function MetaErrorMessage(props) {
  const {
    file,
    toggleFileCard,
    i18n,
    metaFields: metaFields2
  } = props;
  const {
    missingRequiredMetaFields
  } = file;
  if (!(missingRequiredMetaFields != null && missingRequiredMetaFields.length)) {
    return null;
  }
  const metaFieldsString = missingRequiredMetaFields.map((missingMetaField) => metaFieldIdToName(missingMetaField, metaFields2)).join(", ");
  return y("div", {
    className: "uppy-Dashboard-Item-errorMessage"
  }, i18n("missingRequiredMetaFields", {
    smart_count: missingRequiredMetaFields.length,
    fields: metaFieldsString
  }), " ", y("button", {
    type: "button",
    class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn",
    onClick: () => toggleFileCard(true, file.id)
  }, i18n("editFile")));
}

// ../../node_modules/@uppy/dashboard/lib/components/FileItem/FilePreviewAndLink/index.js
function FilePreviewAndLink(props) {
  const {
    file,
    i18n,
    toggleFileCard,
    metaFields: metaFields2,
    showLinkToFileUploadResult
  } = props;
  const white = "rgba(255, 255, 255, 0.5)";
  const previewBackgroundColor = file.preview ? white : getIconByMime(file.type).color;
  return y("div", {
    className: "uppy-Dashboard-Item-previewInnerWrap",
    style: {
      backgroundColor: previewBackgroundColor
    }
  }, showLinkToFileUploadResult && file.uploadURL && y("a", {
    className: "uppy-Dashboard-Item-previewLink",
    href: file.uploadURL,
    rel: "noreferrer noopener",
    target: "_blank",
    "aria-label": file.meta.name
  }, y("span", {
    hidden: true
  }, file.meta.name)), y(FilePreview, {
    file
  }), y(MetaErrorMessage, {
    file,
    i18n,
    toggleFileCard,
    metaFields: metaFields2
  }));
}

// ../../node_modules/@uppy/dashboard/lib/components/FileItem/FileProgress/index.js
function onPauseResumeCancelRetry(props) {
  if (props.isUploaded)
    return;
  if (props.error && !props.hideRetryButton) {
    props.uppy.retryUpload(props.file.id);
    return;
  }
  if (props.resumableUploads && !props.hidePauseResumeButton) {
    props.uppy.pauseResume(props.file.id);
  } else if (props.individualCancellation && !props.hideCancelButton) {
    props.uppy.removeFile(props.file.id);
  }
}
function progressIndicatorTitle(props) {
  if (props.isUploaded) {
    return props.i18n("uploadComplete");
  }
  if (props.error) {
    return props.i18n("retryUpload");
  }
  if (props.resumableUploads) {
    if (props.file.isPaused) {
      return props.i18n("resumeUpload");
    }
    return props.i18n("pauseUpload");
  }
  if (props.individualCancellation) {
    return props.i18n("cancelUpload");
  }
  return "";
}
function ProgressIndicatorButton(props) {
  return y("div", {
    className: "uppy-Dashboard-Item-progress"
  }, y("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-progressIndicator",
    type: "button",
    "aria-label": progressIndicatorTitle(props),
    title: progressIndicatorTitle(props),
    onClick: () => onPauseResumeCancelRetry(props)
  }, props.children));
}
function ProgressCircleContainer(_ref) {
  let {
    children
  } = _ref;
  return y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "70",
    height: "70",
    viewBox: "0 0 36 36",
    className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle"
  }, children);
}
function ProgressCircle(_ref2) {
  let {
    progress
  } = _ref2;
  const circleLength = 2 * Math.PI * 15;
  return y("g", null, y("circle", {
    className: "uppy-Dashboard-Item-progressIcon--bg",
    r: "15",
    cx: "18",
    cy: "18",
    "stroke-width": "2",
    fill: "none"
  }), y("circle", {
    className: "uppy-Dashboard-Item-progressIcon--progress",
    r: "15",
    cx: "18",
    cy: "18",
    transform: "rotate(-90, 18, 18)",
    fill: "none",
    "stroke-width": "2",
    "stroke-dasharray": circleLength,
    "stroke-dashoffset": circleLength - circleLength / 100 * progress
  }));
}
function FileProgress(props) {
  if (!props.file.progress.uploadStarted) {
    return null;
  }
  if (props.isUploaded) {
    return y("div", {
      className: "uppy-Dashboard-Item-progress"
    }, y("div", {
      className: "uppy-Dashboard-Item-progressIndicator"
    }, y(ProgressCircleContainer, null, y("circle", {
      r: "15",
      cx: "18",
      cy: "18",
      fill: "#1bb240"
    }), y("polygon", {
      className: "uppy-Dashboard-Item-progressIcon--check",
      transform: "translate(2, 3)",
      points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
    }))));
  }
  if (props.recoveredState) {
    return void 0;
  }
  if (props.error && !props.hideRetryButton) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y(ProgressIndicatorButton, props, y("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry",
        width: "28",
        height: "31",
        viewBox: "0 0 16 19"
      }, y("path", {
        d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"
      }), y("path", {
        d: "M7.9 3H10v2H7.9z"
      }), y("path", {
        d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"
      }), y("path", {
        d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"
      })))
    );
  }
  if (props.resumableUploads && !props.hidePauseResumeButton) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y(ProgressIndicatorButton, props, y(ProgressCircleContainer, null, y(ProgressCircle, {
        progress: props.file.progress.percentage
      }), props.file.isPaused ? y("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--play",
        transform: "translate(3, 3)",
        points: "12 20 12 10 20 15"
      }) : y("g", {
        className: "uppy-Dashboard-Item-progressIcon--pause",
        transform: "translate(14.5, 13)"
      }, y("rect", {
        x: "0",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
      }), y("rect", {
        x: "5",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
      }))))
    );
  }
  if (!props.resumableUploads && props.individualCancellation && !props.hideCancelButton) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y(ProgressIndicatorButton, props, y(ProgressCircleContainer, null, y(ProgressCircle, {
        progress: props.file.progress.percentage
      }), y("polygon", {
        className: "cancel",
        transform: "translate(2, 2)",
        points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
      })))
    );
  }
  return y("div", {
    className: "uppy-Dashboard-Item-progress"
  }, y("div", {
    className: "uppy-Dashboard-Item-progressIndicator"
  }, y(ProgressCircleContainer, null, y(ProgressCircle, {
    progress: props.file.progress.percentage
  }))));
}

// ../../node_modules/@uppy/dashboard/lib/components/FileItem/FileInfo/index.js
var import_prettier_bytes3 = __toESM(require_prettierBytes(), 1);

// ../../node_modules/@uppy/utils/lib/truncateString.js
var separator = "...";
function truncateString(string10, maxLength) {
  if (maxLength === 0)
    return "";
  if (string10.length <= maxLength)
    return string10;
  if (maxLength <= separator.length + 1)
    return `${string10.slice(0, maxLength - 1)}\u2026`;
  const charsToShow = maxLength - separator.length;
  const frontChars = Math.ceil(charsToShow / 2);
  const backChars = Math.floor(charsToShow / 2);
  return string10.slice(0, frontChars) + separator + string10.slice(-backChars);
}

// ../../node_modules/@uppy/dashboard/lib/components/FileItem/FileInfo/index.js
var renderFileName = (props) => {
  const {
    author,
    name
  } = props.file.meta;
  function getMaxNameLength() {
    if (props.isSingleFile && props.containerHeight >= 350) {
      return 90;
    }
    if (props.containerWidth <= 352) {
      return 35;
    }
    if (props.containerWidth <= 576) {
      return 60;
    }
    return author ? 20 : 30;
  }
  return y("div", {
    className: "uppy-Dashboard-Item-name",
    title: name
  }, truncateString(name, getMaxNameLength()));
};
var renderAuthor = (props) => {
  var _props$file$remote;
  const {
    author
  } = props.file.meta;
  const providerName = (_props$file$remote = props.file.remote) == null ? void 0 : _props$file$remote.providerName;
  const dot = `\xB7`;
  if (!author) {
    return null;
  }
  return y("div", {
    className: "uppy-Dashboard-Item-author"
  }, y("a", {
    href: `${author.url}?utm_source=Companion&utm_medium=referral`,
    target: "_blank",
    rel: "noopener noreferrer"
  }, truncateString(author.name, 13)), providerName ? y(g, null, ` ${dot} `, providerName, ` ${dot} `) : null);
};
var renderFileSize = (props) => props.file.size && y("div", {
  className: "uppy-Dashboard-Item-statusSize"
}, (0, import_prettier_bytes3.default)(props.file.size));
var ReSelectButton = (props) => props.file.isGhost && y("span", null, " \u2022 ", y("button", {
  className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect",
  type: "button",
  onClick: props.toggleAddFilesPanel
}, props.i18n("reSelect")));
var ErrorButton = (_ref) => {
  let {
    file,
    onClick
  } = _ref;
  if (file.error) {
    return y("button", {
      className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-errorDetails",
      "aria-label": file.error,
      "data-microtip-position": "bottom",
      "data-microtip-size": "medium",
      onClick,
      type: "button"
    }, "?");
  }
  return null;
};
function FileInfo(props) {
  const {
    file
  } = props;
  return y("div", {
    className: "uppy-Dashboard-Item-fileInfo",
    "data-uppy-file-source": file.source
  }, y("div", {
    className: "uppy-Dashboard-Item-fileName"
  }, renderFileName(props), y(ErrorButton, {
    file: props.file,
    onClick: () => alert(props.file.error)
    // TODO: move to a custom alert implementation
  })), y("div", {
    className: "uppy-Dashboard-Item-status"
  }, renderAuthor(props), renderFileSize(props), ReSelectButton(props)), y(MetaErrorMessage, {
    file: props.file,
    i18n: props.i18n,
    toggleFileCard: props.toggleFileCard,
    metaFields: props.metaFields
  }));
}

// ../../node_modules/@uppy/dashboard/lib/utils/copyToClipboard.js
function copyToClipboard(textToCopy, fallbackString) {
  if (fallbackString === void 0) {
    fallbackString = "Copy the URL below";
  }
  return new Promise((resolve) => {
    const textArea = document.createElement("textarea");
    textArea.setAttribute("style", {
      position: "fixed",
      top: 0,
      left: 0,
      width: "2em",
      height: "2em",
      padding: 0,
      border: "none",
      outline: "none",
      boxShadow: "none",
      background: "transparent"
    });
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    const magicCopyFailed = (cause) => {
      document.body.removeChild(textArea);
      window.prompt(fallbackString, textToCopy);
      resolve();
    };
    try {
      const successful = document.execCommand("copy");
      if (!successful) {
        return magicCopyFailed("copy command unavailable");
      }
      document.body.removeChild(textArea);
      return resolve();
    } catch (err) {
      document.body.removeChild(textArea);
      return magicCopyFailed(err);
    }
  });
}

// ../../node_modules/@uppy/dashboard/lib/components/FileItem/Buttons/index.js
function EditButton(_ref) {
  let {
    file,
    uploadInProgressOrComplete,
    metaFields: metaFields2,
    canEditFile,
    i18n,
    onClick
  } = _ref;
  if (!uploadInProgressOrComplete && metaFields2 && metaFields2.length > 0 || !uploadInProgressOrComplete && canEditFile(file)) {
    return y("button", {
      className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit",
      type: "button",
      "aria-label": i18n("editFileWithFilename", {
        file: file.meta.name
      }),
      title: i18n("editFileWithFilename", {
        file: file.meta.name
      }),
      onClick: () => onClick()
    }, y("svg", {
      "aria-hidden": "true",
      focusable: "false",
      className: "uppy-c-icon",
      width: "14",
      height: "14",
      viewBox: "0 0 14 14"
    }, y("g", {
      fillRule: "evenodd"
    }, y("path", {
      d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z",
      fillRule: "nonzero"
    }), y("rect", {
      x: "1",
      y: "12.293",
      width: "11",
      height: "1",
      rx: ".5"
    }), y("path", {
      fillRule: "nonzero",
      d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z"
    }))));
  }
  return null;
}
function RemoveButton(_ref2) {
  let {
    i18n,
    onClick,
    file
  } = _ref2;
  return y("button", {
    className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove",
    type: "button",
    "aria-label": i18n("removeFile", {
      file: file.meta.name
    }),
    title: i18n("removeFile", {
      file: file.meta.name
    }),
    onClick: () => onClick()
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, y("path", {
    d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z"
  }), y("path", {
    fill: "#FFF",
    d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z"
  })));
}
var copyLinkToClipboard = (event, props) => {
  copyToClipboard(props.file.uploadURL, props.i18n("copyLinkToClipboardFallback")).then(() => {
    props.uppy.log("Link copied to clipboard.");
    props.uppy.info(props.i18n("copyLinkToClipboardSuccess"), "info", 3e3);
  }).catch(props.uppy.log).then(() => event.target.focus({
    preventScroll: true
  }));
};
function CopyLinkButton(props) {
  const {
    i18n
  } = props;
  return y("button", {
    className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink",
    type: "button",
    "aria-label": i18n("copyLink"),
    title: i18n("copyLink"),
    onClick: (event) => copyLinkToClipboard(event, props)
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "14",
    height: "14",
    viewBox: "0 0 14 12"
  }, y("path", {
    d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z"
  })));
}
function Buttons(props) {
  const {
    uppy: uppy2,
    file,
    uploadInProgressOrComplete,
    canEditFile,
    metaFields: metaFields2,
    showLinkToFileUploadResult,
    showRemoveButton,
    i18n,
    toggleFileCard,
    openFileEditor
  } = props;
  const editAction = () => {
    if (metaFields2 && metaFields2.length > 0) {
      toggleFileCard(true, file.id);
    } else {
      openFileEditor(file);
    }
  };
  return y("div", {
    className: "uppy-Dashboard-Item-actionWrapper"
  }, y(EditButton, {
    i18n,
    file,
    uploadInProgressOrComplete,
    canEditFile,
    metaFields: metaFields2,
    onClick: editAction
  }), showLinkToFileUploadResult && file.uploadURL ? y(CopyLinkButton, {
    file,
    uppy: uppy2,
    i18n
  }) : null, showRemoveButton ? y(RemoveButton, {
    i18n,
    file,
    uppy: uppy2,
    onClick: () => uppy2.removeFile(file.id, "removed-by-user")
  }) : null);
}

// ../../node_modules/@uppy/dashboard/lib/components/FileItem/index.js
var FileItem = class extends b {
  componentDidMount() {
    const {
      file
    } = this.props;
    if (!file.preview) {
      this.props.handleRequestThumbnail(file);
    }
  }
  shouldComponentUpdate(nextProps) {
    return !(0, import_is_shallow_equal.default)(this.props, nextProps);
  }
  // VirtualList mounts FileItems again and they emit `thumbnail:request`
  // Otherwise thumbnails are broken or missing after Golden Retriever restores files
  componentDidUpdate() {
    const {
      file
    } = this.props;
    if (!file.preview) {
      this.props.handleRequestThumbnail(file);
    }
  }
  componentWillUnmount() {
    const {
      file
    } = this.props;
    if (!file.preview) {
      this.props.handleCancelThumbnail(file);
    }
  }
  render() {
    const {
      file
    } = this.props;
    const isProcessing = file.progress.preprocess || file.progress.postprocess;
    const isUploaded = file.progress.uploadComplete && !isProcessing && !file.error;
    const uploadInProgressOrComplete = file.progress.uploadStarted || isProcessing;
    const uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
    const error = file.error || false;
    const {
      isGhost
    } = file;
    let showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;
    if (isUploaded && this.props.showRemoveButtonAfterComplete) {
      showRemoveButton = true;
    }
    const dashboardItemClass = (0, import_classnames6.default)({
      "uppy-Dashboard-Item": true,
      "is-inprogress": uploadInProgress && !this.props.recoveredState,
      "is-processing": isProcessing,
      "is-complete": isUploaded,
      "is-error": !!error,
      "is-resumable": this.props.resumableUploads,
      "is-noIndividualCancellation": !this.props.individualCancellation,
      "is-ghost": isGhost
    });
    return y("div", {
      className: dashboardItemClass,
      id: `uppy_${file.id}`,
      role: this.props.role
    }, y("div", {
      className: "uppy-Dashboard-Item-preview"
    }, y(FilePreviewAndLink, {
      file,
      showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
      i18n: this.props.i18n,
      toggleFileCard: this.props.toggleFileCard,
      metaFields: this.props.metaFields
    }), y(FileProgress, {
      uppy: this.props.uppy,
      file,
      error,
      isUploaded,
      hideRetryButton: this.props.hideRetryButton,
      hideCancelButton: this.props.hideCancelButton,
      hidePauseResumeButton: this.props.hidePauseResumeButton,
      recoveredState: this.props.recoveredState,
      showRemoveButtonAfterComplete: this.props.showRemoveButtonAfterComplete,
      resumableUploads: this.props.resumableUploads,
      individualCancellation: this.props.individualCancellation,
      i18n: this.props.i18n
    })), y("div", {
      className: "uppy-Dashboard-Item-fileInfoAndButtons"
    }, y(FileInfo, {
      file,
      id: this.props.id,
      acquirers: this.props.acquirers,
      containerWidth: this.props.containerWidth,
      containerHeight: this.props.containerHeight,
      i18n: this.props.i18n,
      toggleAddFilesPanel: this.props.toggleAddFilesPanel,
      toggleFileCard: this.props.toggleFileCard,
      metaFields: this.props.metaFields,
      isSingleFile: this.props.isSingleFile
    }), y(Buttons, {
      file,
      metaFields: this.props.metaFields,
      showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
      showRemoveButton,
      canEditFile: this.props.canEditFile,
      uploadInProgressOrComplete,
      toggleFileCard: this.props.toggleFileCard,
      openFileEditor: this.props.openFileEditor,
      uppy: this.props.uppy,
      i18n: this.props.i18n
    })));
  }
};

// ../../node_modules/@uppy/dashboard/lib/components/FileList.js
function chunks(list, size) {
  const chunked = [];
  let currentChunk = [];
  list.forEach((item) => {
    if (currentChunk.length < size) {
      currentChunk.push(item);
    } else {
      chunked.push(currentChunk);
      currentChunk = [item];
    }
  });
  if (currentChunk.length)
    chunked.push(currentChunk);
  return chunked;
}
function FileList(_ref) {
  let {
    id: id18,
    error,
    i18n,
    uppy: uppy2,
    files,
    acquirers,
    resumableUploads,
    hideRetryButton,
    hidePauseResumeButton,
    hideCancelButton,
    showLinkToFileUploadResult,
    showRemoveButtonAfterComplete,
    isWide,
    metaFields: metaFields2,
    isSingleFile,
    toggleFileCard,
    handleRequestThumbnail,
    handleCancelThumbnail,
    recoveredState,
    individualCancellation,
    itemsPerRow,
    openFileEditor,
    canEditFile,
    toggleAddFilesPanel,
    containerWidth,
    containerHeight
  } = _ref;
  const rowHeight = itemsPerRow === 1 ? (
    // Mobile
    71
  ) : 200;
  const rows = q3(() => {
    const sortByGhostComesFirst = (file1, file2) => files[file2].isGhost - files[file1].isGhost;
    const fileIds = Object.keys(files);
    if (recoveredState)
      fileIds.sort(sortByGhostComesFirst);
    return chunks(fileIds, itemsPerRow);
  }, [files, itemsPerRow, recoveredState]);
  const renderRow = (row) => (
    // associated with the `VirtualList` element.
    // We use the first file ID as the key—this should not change across scroll rerenders
    y("div", {
      class: "uppy-Dashboard-filesInner",
      role: "presentation",
      key: row[0]
    }, row.map((fileID) => y(FileItem, {
      key: fileID,
      uppy: uppy2,
      id: id18,
      error,
      i18n,
      acquirers,
      resumableUploads,
      individualCancellation,
      hideRetryButton,
      hidePauseResumeButton,
      hideCancelButton,
      showLinkToFileUploadResult,
      showRemoveButtonAfterComplete,
      isWide,
      metaFields: metaFields2,
      recoveredState,
      isSingleFile,
      containerWidth,
      containerHeight,
      toggleFileCard,
      handleRequestThumbnail,
      handleCancelThumbnail,
      role: "listitem",
      openFileEditor,
      canEditFile,
      toggleAddFilesPanel,
      file: files[fileID]
    })))
  );
  if (isSingleFile) {
    return y("div", {
      class: "uppy-Dashboard-files"
    }, renderRow(rows[0]));
  }
  return y(VirtualList_default, {
    class: "uppy-Dashboard-files",
    role: "list",
    data: rows,
    renderRow,
    rowHeight
  });
}

// ../../node_modules/@uppy/dashboard/lib/components/AddFiles.js
var _Symbol$for6;
_Symbol$for6 = Symbol.for("uppy test: disable unused locale key warning");
var AddFiles = class extends b {
  constructor() {
    super(...arguments);
    this.triggerFileInputClick = () => {
      this.fileInput.click();
    };
    this.triggerFolderInputClick = () => {
      this.folderInput.click();
    };
    this.triggerVideoCameraInputClick = () => {
      this.mobileVideoFileInput.click();
    };
    this.triggerPhotoCameraInputClick = () => {
      this.mobilePhotoFileInput.click();
    };
    this.onFileInputChange = (event) => {
      this.props.handleInputChange(event);
      event.target.value = null;
    };
    this.renderHiddenInput = (isFolder, refCallback) => {
      return y("input", {
        className: "uppy-Dashboard-input",
        hidden: true,
        "aria-hidden": "true",
        tabIndex: -1,
        webkitdirectory: isFolder,
        type: "file",
        name: "files[]",
        multiple: this.props.maxNumberOfFiles !== 1,
        onChange: this.onFileInputChange,
        accept: this.props.allowedFileTypes,
        ref: refCallback
      });
    };
    this.renderHiddenCameraInput = (type, nativeCameraFacingMode, refCallback) => {
      const typeToAccept = {
        photo: "image/*",
        video: "video/*"
      };
      const accept = typeToAccept[type];
      return y("input", {
        className: "uppy-Dashboard-input",
        hidden: true,
        "aria-hidden": "true",
        tabIndex: -1,
        type: "file",
        name: `camera-${type}`,
        onChange: this.onFileInputChange,
        capture: nativeCameraFacingMode,
        accept,
        ref: refCallback
      });
    };
    this.renderMyDeviceAcquirer = () => {
      return y("div", {
        className: "uppy-DashboardTab",
        role: "presentation",
        "data-uppy-acquirer-id": "MyDevice"
      }, y("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
        role: "tab",
        tabIndex: 0,
        "data-uppy-super-focusable": true,
        onClick: this.triggerFileInputClick
      }, y("div", {
        className: "uppy-DashboardTab-inner"
      }, y("svg", {
        className: "uppy-DashboardTab-iconMyDevice",
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, y("path", {
        d: "M8.45 22.087l-1.305-6.674h17.678l-1.572 6.674H8.45zm4.975-12.412l1.083 1.765a.823.823 0 00.715.386h7.951V13.5H8.587V9.675h4.838zM26.043 13.5h-1.195v-2.598c0-.463-.336-.75-.798-.75h-8.356l-1.082-1.766A.823.823 0 0013.897 8H7.728c-.462 0-.815.256-.815.718V13.5h-.956a.97.97 0 00-.746.37.972.972 0 00-.19.81l1.724 8.565c.095.44.484.755.933.755H24c.44 0 .824-.3.929-.727l2.043-8.568a.972.972 0 00-.176-.825.967.967 0 00-.753-.38z",
        fill: "currentcolor",
        "fill-rule": "evenodd"
      }))), y("div", {
        className: "uppy-DashboardTab-name"
      }, this.props.i18n("myDevice"))));
    };
    this.renderPhotoCamera = () => {
      return y("div", {
        className: "uppy-DashboardTab",
        role: "presentation",
        "data-uppy-acquirer-id": "MobilePhotoCamera"
      }, y("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
        role: "tab",
        tabIndex: 0,
        "data-uppy-super-focusable": true,
        onClick: this.triggerPhotoCameraInputClick
      }, y("div", {
        className: "uppy-DashboardTab-inner"
      }, y("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, y("path", {
        d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
        fill: "#02B383",
        "fill-rule": "nonzero"
      }))), y("div", {
        className: "uppy-DashboardTab-name"
      }, this.props.i18n("takePictureBtn"))));
    };
    this.renderVideoCamera = () => {
      return y("div", {
        className: "uppy-DashboardTab",
        role: "presentation",
        "data-uppy-acquirer-id": "MobileVideoCamera"
      }, y("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
        role: "tab",
        tabIndex: 0,
        "data-uppy-super-focusable": true,
        onClick: this.triggerVideoCameraInputClick
      }, y("div", {
        className: "uppy-DashboardTab-inner"
      }, y("svg", {
        "aria-hidden": "true",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, y("path", {
        fill: "#FF675E",
        fillRule: "nonzero",
        d: "m21.254 14.277 2.941-2.588c.797-.313 1.243.818 1.09 1.554-.01 2.094.02 4.189-.017 6.282-.126.915-1.145 1.08-1.58.34l-2.434-2.142c-.192.287-.504 1.305-.738.468-.104-1.293-.028-2.596-.05-3.894.047-.312.381.823.426 1.069.063-.384.206-.744.362-1.09zm-12.939-3.73c3.858.013 7.717-.025 11.574.02.912.129 1.492 1.237 1.351 2.217-.019 2.412.04 4.83-.03 7.239-.17 1.025-1.166 1.59-2.029 1.429-3.705-.012-7.41.025-11.114-.019-.913-.129-1.492-1.237-1.352-2.217.018-2.404-.036-4.813.029-7.214.136-.82.83-1.473 1.571-1.454z "
      }))), y("div", {
        className: "uppy-DashboardTab-name"
      }, this.props.i18n("recordVideoBtn"))));
    };
    this.renderBrowseButton = (text, onClickFn) => {
      const numberOfAcquirers = this.props.acquirers.length;
      return y("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-browse",
        onClick: onClickFn,
        "data-uppy-super-focusable": numberOfAcquirers === 0
      }, text);
    };
    this.renderDropPasteBrowseTagline = (numberOfAcquirers) => {
      const browseFiles = this.renderBrowseButton(this.props.i18n("browseFiles"), this.triggerFileInputClick);
      const browseFolders = this.renderBrowseButton(this.props.i18n("browseFolders"), this.triggerFolderInputClick);
      const lowerFMSelectionType = this.props.fileManagerSelectionType;
      const camelFMSelectionType = lowerFMSelectionType.charAt(0).toUpperCase() + lowerFMSelectionType.slice(1);
      return y(
        "div",
        {
          class: "uppy-Dashboard-AddFiles-title"
        },
        // eslint-disable-next-line no-nested-ternary
        this.props.disableLocalFiles ? this.props.i18n("importFiles") : numberOfAcquirers > 0 ? this.props.i18nArray(`dropPasteImport${camelFMSelectionType}`, {
          browseFiles,
          browseFolders,
          browse: browseFiles
        }) : this.props.i18nArray(`dropPaste${camelFMSelectionType}`, {
          browseFiles,
          browseFolders,
          browse: browseFiles
        })
      );
    };
    this.renderAcquirer = (acquirer) => {
      var _this$props$activePic;
      return y("div", {
        className: "uppy-DashboardTab",
        role: "presentation",
        "data-uppy-acquirer-id": acquirer.id
      }, y("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
        role: "tab",
        tabIndex: 0,
        "data-cy": acquirer.id,
        "aria-controls": `uppy-DashboardContent-panel--${acquirer.id}`,
        "aria-selected": ((_this$props$activePic = this.props.activePickerPanel) == null ? void 0 : _this$props$activePic.id) === acquirer.id,
        "data-uppy-super-focusable": true,
        onClick: () => this.props.showPanel(acquirer.id)
      }, y("div", {
        className: "uppy-DashboardTab-inner"
      }, acquirer.icon()), y("div", {
        className: "uppy-DashboardTab-name"
      }, acquirer.name)));
    };
    this.renderAcquirers = (acquirers) => {
      const acquirersWithoutLastTwo = [...acquirers];
      const lastTwoAcquirers = acquirersWithoutLastTwo.splice(acquirers.length - 2, acquirers.length);
      return y(g, null, acquirersWithoutLastTwo.map((acquirer) => this.renderAcquirer(acquirer)), y("span", {
        role: "presentation",
        style: {
          "white-space": "nowrap"
        }
      }, lastTwoAcquirers.map((acquirer) => this.renderAcquirer(acquirer))));
    };
    this.renderSourcesList = (acquirers, disableLocalFiles) => {
      const {
        showNativePhotoCameraButton,
        showNativeVideoCameraButton
      } = this.props;
      let list = [];
      const myDeviceKey = "myDevice";
      if (!disableLocalFiles)
        list.push({
          key: myDeviceKey,
          elements: this.renderMyDeviceAcquirer()
        });
      if (showNativePhotoCameraButton)
        list.push({
          key: "nativePhotoCameraButton",
          elements: this.renderPhotoCamera()
        });
      if (showNativeVideoCameraButton)
        list.push({
          key: "nativePhotoCameraButton",
          elements: this.renderVideoCamera()
        });
      list.push(...acquirers.map((acquirer) => ({
        key: acquirer.id,
        elements: this.renderAcquirer(acquirer)
      })));
      const hasOnlyMyDevice = list.length === 1 && list[0].key === myDeviceKey;
      if (hasOnlyMyDevice)
        list = [];
      const listWithoutLastTwo = [...list];
      const lastTwo = listWithoutLastTwo.splice(list.length - 2, list.length);
      const renderList = (l4) => l4.map((_ref) => {
        let {
          key,
          elements
        } = _ref;
        return y(g, {
          key
        }, elements);
      });
      return y(g, null, this.renderDropPasteBrowseTagline(list.length), y("div", {
        className: "uppy-Dashboard-AddFiles-list",
        role: "tablist"
      }, renderList(listWithoutLastTwo), y("span", {
        role: "presentation",
        style: {
          "white-space": "nowrap"
        }
      }, renderList(lastTwo))));
    };
  }
  [_Symbol$for6]() {
    this.props.i18nArray("dropPasteBoth");
    this.props.i18nArray("dropPasteFiles");
    this.props.i18nArray("dropPasteFolders");
    this.props.i18nArray("dropPasteImportBoth");
    this.props.i18nArray("dropPasteImportFiles");
    this.props.i18nArray("dropPasteImportFolders");
  }
  renderPoweredByUppy() {
    const {
      i18nArray
    } = this.props;
    const uppyBranding = y("span", null, y("svg", {
      "aria-hidden": "true",
      focusable: "false",
      className: "uppy-c-icon uppy-Dashboard-poweredByIcon",
      width: "11",
      height: "11",
      viewBox: "0 0 11 11"
    }, y("path", {
      d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z",
      fillRule: "evenodd"
    })), y("span", {
      className: "uppy-Dashboard-poweredByUppy"
    }, "Uppy"));
    const linkText = i18nArray("poweredBy", {
      uppy: uppyBranding
    });
    return y("a", {
      tabIndex: -1,
      href: "https://uppy.io",
      rel: "noreferrer noopener",
      target: "_blank",
      className: "uppy-Dashboard-poweredBy"
    }, linkText);
  }
  render() {
    const {
      showNativePhotoCameraButton,
      showNativeVideoCameraButton,
      nativeCameraFacingMode
    } = this.props;
    return y("div", {
      className: "uppy-Dashboard-AddFiles"
    }, this.renderHiddenInput(false, (ref) => {
      this.fileInput = ref;
    }), this.renderHiddenInput(true, (ref) => {
      this.folderInput = ref;
    }), showNativePhotoCameraButton && this.renderHiddenCameraInput("photo", nativeCameraFacingMode, (ref) => {
      this.mobilePhotoFileInput = ref;
    }), showNativeVideoCameraButton && this.renderHiddenCameraInput("video", nativeCameraFacingMode, (ref) => {
      this.mobileVideoFileInput = ref;
    }), this.renderSourcesList(this.props.acquirers, this.props.disableLocalFiles), y("div", {
      className: "uppy-Dashboard-AddFiles-info"
    }, this.props.note && y("div", {
      className: "uppy-Dashboard-note"
    }, this.props.note), this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy(this.props)));
  }
};
var AddFiles_default = AddFiles;

// ../../node_modules/@uppy/dashboard/lib/components/AddFilesPanel.js
var import_classnames7 = __toESM(require_classnames(), 1);
var AddFilesPanel = (props) => {
  return y("div", {
    className: (0, import_classnames7.default)("uppy-Dashboard-AddFilesPanel", props.className),
    "data-uppy-panelType": "AddFiles",
    "aria-hidden": !props.showAddFilesPanel
  }, y("div", {
    className: "uppy-DashboardContent-bar"
  }, y("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, props.i18n("addingMoreFiles")), y("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: () => props.toggleAddFilesPanel(false)
  }, props.i18n("back"))), y(AddFiles_default, props));
};
var AddFilesPanel_default = AddFilesPanel;

// ../../node_modules/@uppy/dashboard/lib/components/PickerPanelContent.js
var import_classnames8 = __toESM(require_classnames(), 1);

// ../../node_modules/@uppy/dashboard/lib/utils/ignoreEvent.js
function ignoreEvent(ev) {
  const {
    tagName
  } = ev.target;
  if (tagName === "INPUT" || tagName === "TEXTAREA") {
    ev.stopPropagation();
    return;
  }
  ev.preventDefault();
  ev.stopPropagation();
}
var ignoreEvent_default = ignoreEvent;

// ../../node_modules/@uppy/dashboard/lib/components/PickerPanelContent.js
function PickerPanelContent(_ref) {
  let {
    activePickerPanel,
    className,
    hideAllPanels,
    i18n,
    state,
    uppy: uppy2
  } = _ref;
  return y("div", {
    className: (0, import_classnames8.default)("uppy-DashboardContent-panel", className),
    role: "tabpanel",
    "data-uppy-panelType": "PickerPanel",
    id: `uppy-DashboardContent-panel--${activePickerPanel.id}`,
    onDragOver: ignoreEvent_default,
    onDragLeave: ignoreEvent_default,
    onDrop: ignoreEvent_default,
    onPaste: ignoreEvent_default
  }, y("div", {
    className: "uppy-DashboardContent-bar"
  }, y("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, i18n("importFrom", {
    name: activePickerPanel.name
  })), y("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: hideAllPanels
  }, i18n("cancel"))), y("div", {
    className: "uppy-DashboardContent-panelBody"
  }, uppy2.getPlugin(activePickerPanel.id).render(state)));
}
var PickerPanelContent_default = PickerPanelContent;

// ../../node_modules/@uppy/dashboard/lib/components/EditorPanel.js
var import_classnames9 = __toESM(require_classnames(), 1);
function EditorPanel(props) {
  const file = props.files[props.fileCardFor];
  const handleCancel = () => {
    props.uppy.emit("file-editor:cancel", file);
    props.closeFileEditor();
  };
  return y("div", {
    className: (0, import_classnames9.default)("uppy-DashboardContent-panel", props.className),
    role: "tabpanel",
    "data-uppy-panelType": "FileEditor",
    id: "uppy-DashboardContent-panel--editor"
  }, y("div", {
    className: "uppy-DashboardContent-bar"
  }, y("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, props.i18nArray("editing", {
    file: y("span", {
      className: "uppy-DashboardContent-titleFile"
    }, file.meta ? file.meta.name : file.name)
  })), y("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: handleCancel
  }, props.i18n("cancel")), y("button", {
    className: "uppy-DashboardContent-save",
    type: "button",
    onClick: props.saveFileEditor
  }, props.i18n("save"))), y("div", {
    className: "uppy-DashboardContent-panelBody"
  }, props.editors.map((target) => {
    return props.uppy.getPlugin(target.id).render(props.state);
  })));
}
var EditorPanel_default = EditorPanel;

// ../../node_modules/@uppy/dashboard/lib/components/PickerPanelTopBar.js
var uploadStates = {
  STATE_ERROR: "error",
  STATE_WAITING: "waiting",
  STATE_PREPROCESSING: "preprocessing",
  STATE_UPLOADING: "uploading",
  STATE_POSTPROCESSING: "postprocessing",
  STATE_COMPLETE: "complete",
  STATE_PAUSED: "paused"
};
function getUploadingState2(isAllErrored, isAllComplete, isAllPaused, files) {
  if (files === void 0) {
    files = {};
  }
  if (isAllErrored) {
    return uploadStates.STATE_ERROR;
  }
  if (isAllComplete) {
    return uploadStates.STATE_COMPLETE;
  }
  if (isAllPaused) {
    return uploadStates.STATE_PAUSED;
  }
  let state = uploadStates.STATE_WAITING;
  const fileIDs = Object.keys(files);
  for (let i4 = 0; i4 < fileIDs.length; i4++) {
    const {
      progress
    } = files[fileIDs[i4]];
    if (progress.uploadStarted && !progress.uploadComplete) {
      return uploadStates.STATE_UPLOADING;
    }
    if (progress.preprocess && state !== uploadStates.STATE_UPLOADING) {
      state = uploadStates.STATE_PREPROCESSING;
    }
    if (progress.postprocess && state !== uploadStates.STATE_UPLOADING && state !== uploadStates.STATE_PREPROCESSING) {
      state = uploadStates.STATE_POSTPROCESSING;
    }
  }
  return state;
}
function UploadStatus(_ref) {
  let {
    files,
    i18n,
    isAllComplete,
    isAllErrored,
    isAllPaused,
    inProgressNotPausedFiles,
    newFiles,
    processingFiles
  } = _ref;
  const uploadingState = getUploadingState2(isAllErrored, isAllComplete, isAllPaused, files);
  switch (uploadingState) {
    case "uploading":
      return i18n("uploadingXFiles", {
        smart_count: inProgressNotPausedFiles.length
      });
    case "preprocessing":
    case "postprocessing":
      return i18n("processingXFiles", {
        smart_count: processingFiles.length
      });
    case "paused":
      return i18n("uploadPaused");
    case "waiting":
      return i18n("xFilesSelected", {
        smart_count: newFiles.length
      });
    case "complete":
      return i18n("uploadComplete");
    case "error":
      return i18n("error");
    default:
  }
}
function PanelTopBar(props) {
  const {
    i18n,
    isAllComplete,
    hideCancelButton,
    maxNumberOfFiles,
    toggleAddFilesPanel,
    uppy: uppy2
  } = props;
  let {
    allowNewUpload
  } = props;
  if (allowNewUpload && maxNumberOfFiles) {
    allowNewUpload = props.totalFileCount < props.maxNumberOfFiles;
  }
  return y("div", {
    className: "uppy-DashboardContent-bar"
  }, !isAllComplete && !hideCancelButton ? y("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: () => uppy2.cancelAll()
  }, i18n("cancel")) : y("div", null), y("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, y(UploadStatus, props)), allowNewUpload ? y("button", {
    className: "uppy-DashboardContent-addMore",
    type: "button",
    "aria-label": i18n("addMoreFiles"),
    title: i18n("addMoreFiles"),
    onClick: () => toggleAddFilesPanel(true)
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15"
  }, y("path", {
    d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z"
  })), y("span", {
    className: "uppy-DashboardContent-addMoreCaption"
  }, i18n("addMore"))) : y("div", null));
}
var PickerPanelTopBar_default = PanelTopBar;

// ../../node_modules/@uppy/dashboard/lib/components/FileCard/index.js
var import_classnames10 = __toESM(require_classnames(), 1);

// ../../node_modules/@uppy/dashboard/lib/components/FileCard/RenderMetaFields.js
function RenderMetaFields(props) {
  const {
    computedMetaFields,
    requiredMetaFields,
    updateMeta,
    form,
    formState
  } = props;
  const fieldCSSClasses = {
    text: "uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input"
  };
  return computedMetaFields.map((field) => {
    const id18 = `uppy-Dashboard-FileCard-input-${field.id}`;
    const required = requiredMetaFields.includes(field.id);
    return y("fieldset", {
      key: field.id,
      className: "uppy-Dashboard-FileCard-fieldset"
    }, y("label", {
      className: "uppy-Dashboard-FileCard-label",
      htmlFor: id18
    }, field.name), field.render !== void 0 ? field.render({
      value: formState[field.id],
      onChange: (newVal) => updateMeta(newVal, field.id),
      fieldCSSClasses,
      required,
      form: form.id
    }, y) : y("input", {
      className: fieldCSSClasses.text,
      id: id18,
      form: form.id,
      type: field.type || "text",
      required,
      value: formState[field.id],
      placeholder: field.placeholder,
      onInput: (ev) => updateMeta(ev.target.value, field.id),
      "data-uppy-super-focusable": true
    }));
  });
}

// ../../node_modules/@uppy/dashboard/lib/components/FileCard/index.js
function FileCard(props) {
  var _getMetaFields;
  const {
    files,
    fileCardFor,
    toggleFileCard,
    saveFileCard,
    metaFields: metaFields2,
    requiredMetaFields,
    openFileEditor,
    i18n,
    i18nArray,
    className,
    canEditFile
  } = props;
  const getMetaFields = () => {
    return typeof metaFields2 === "function" ? metaFields2(files[fileCardFor]) : metaFields2;
  };
  const file = files[fileCardFor];
  const computedMetaFields = (_getMetaFields = getMetaFields()) != null ? _getMetaFields : [];
  const showEditButton = canEditFile(file);
  const storedMetaData = {};
  computedMetaFields.forEach((field) => {
    var _file$meta$field$id;
    storedMetaData[field.id] = (_file$meta$field$id = file.meta[field.id]) != null ? _file$meta$field$id : "";
  });
  const [formState, setFormState] = p3(storedMetaData);
  const handleSave = x3((ev) => {
    ev.preventDefault();
    saveFileCard(formState, fileCardFor);
  }, [saveFileCard, formState, fileCardFor]);
  const updateMeta = (newVal, name) => {
    setFormState({
      ...formState,
      [name]: newVal
    });
  };
  const handleCancel = () => {
    toggleFileCard(false);
  };
  const [form] = p3(() => {
    const formEl = document.createElement("form");
    formEl.setAttribute("tabindex", "-1");
    formEl.id = nanoid();
    return formEl;
  });
  _3(() => {
    document.body.appendChild(form);
    form.addEventListener("submit", handleSave);
    return () => {
      form.removeEventListener("submit", handleSave);
      document.body.removeChild(form);
    };
  }, [form, handleSave]);
  return y("div", {
    className: (0, import_classnames10.default)("uppy-Dashboard-FileCard", className),
    "data-uppy-panelType": "FileCard",
    onDragOver: ignoreEvent_default,
    onDragLeave: ignoreEvent_default,
    onDrop: ignoreEvent_default,
    onPaste: ignoreEvent_default
  }, y("div", {
    className: "uppy-DashboardContent-bar"
  }, y("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, i18nArray("editing", {
    file: y("span", {
      className: "uppy-DashboardContent-titleFile"
    }, file.meta ? file.meta.name : file.name)
  })), y("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    form: form.id,
    title: i18n("finishEditingFile"),
    onClick: handleCancel
  }, i18n("cancel"))), y("div", {
    className: "uppy-Dashboard-FileCard-inner"
  }, y("div", {
    className: "uppy-Dashboard-FileCard-preview",
    style: {
      backgroundColor: getIconByMime(file.type).color
    }
  }, y(FilePreview, {
    file
  }), showEditButton && y("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
    onClick: (event) => {
      handleSave(event);
      openFileEditor(file);
    }
  }, i18n("editImage"))), y("div", {
    className: "uppy-Dashboard-FileCard-info"
  }, y(RenderMetaFields, {
    computedMetaFields,
    requiredMetaFields,
    updateMeta,
    form,
    formState
  })), y("div", {
    className: "uppy-Dashboard-FileCard-actions"
  }, y("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn",
    type: "submit",
    form: form.id
  }, i18n("saveChanges")), y("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
    type: "button",
    onClick: handleCancel,
    form: form.id
  }, i18n("cancel")))));
}

// ../../node_modules/@uppy/dashboard/lib/components/Slide.js
var import_classnames11 = __toESM(require_classnames(), 1);
var transitionName = "uppy-transition-slideDownUp";
var duration = 250;
function Slide(_ref) {
  let {
    children
  } = _ref;
  const [cachedChildren, setCachedChildren] = p3(null);
  const [className, setClassName] = p3("");
  const enterTimeoutRef = F3();
  const leaveTimeoutRef = F3();
  const animationFrameRef = F3();
  const handleEnterTransition = () => {
    setClassName(`${transitionName}-enter`);
    cancelAnimationFrame(animationFrameRef.current);
    clearTimeout(leaveTimeoutRef.current);
    leaveTimeoutRef.current = void 0;
    animationFrameRef.current = requestAnimationFrame(() => {
      setClassName(`${transitionName}-enter ${transitionName}-enter-active`);
      enterTimeoutRef.current = setTimeout(() => {
        setClassName("");
      }, duration);
    });
  };
  const handleLeaveTransition = () => {
    setClassName(`${transitionName}-leave`);
    cancelAnimationFrame(animationFrameRef.current);
    clearTimeout(enterTimeoutRef.current);
    enterTimeoutRef.current = void 0;
    animationFrameRef.current = requestAnimationFrame(() => {
      setClassName(`${transitionName}-leave ${transitionName}-leave-active`);
      leaveTimeoutRef.current = setTimeout(() => {
        setCachedChildren(null);
        setClassName("");
      }, duration);
    });
  };
  _3(() => {
    const child = H(children)[0];
    if (cachedChildren === child)
      return;
    if (child && !cachedChildren) {
      handleEnterTransition();
    } else if (cachedChildren && !child && !leaveTimeoutRef.current) {
      handleLeaveTransition();
    }
    setCachedChildren(child);
  }, [children, cachedChildren]);
  _3(() => {
    return () => {
      clearTimeout(enterTimeoutRef.current);
      clearTimeout(leaveTimeoutRef.current);
      cancelAnimationFrame(animationFrameRef.current);
    };
  }, []);
  if (!cachedChildren)
    return null;
  return F(cachedChildren, {
    className: (0, import_classnames11.default)(className, cachedChildren.props.className)
  });
}
var Slide_default = Slide;

// ../../node_modules/@uppy/dashboard/lib/components/Dashboard.js
function _extends3() {
  _extends3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
var WIDTH_XL = 900;
var WIDTH_LG = 700;
var WIDTH_MD = 576;
var HEIGHT_MD = 330;
function Dashboard(props) {
  const isNoFiles = props.totalFileCount === 0;
  const isSingleFile = props.totalFileCount === 1;
  const isSizeMD = props.containerWidth > WIDTH_MD;
  const isSizeHeightMD = props.containerHeight > HEIGHT_MD;
  const dashboardClassName = (0, import_classnames12.default)({
    "uppy-Dashboard": true,
    "uppy-Dashboard--isDisabled": props.disabled,
    "uppy-Dashboard--animateOpenClose": props.animateOpenClose,
    "uppy-Dashboard--isClosing": props.isClosing,
    "uppy-Dashboard--isDraggingOver": props.isDraggingOver,
    "uppy-Dashboard--modal": !props.inline,
    "uppy-size--md": props.containerWidth > WIDTH_MD,
    "uppy-size--lg": props.containerWidth > WIDTH_LG,
    "uppy-size--xl": props.containerWidth > WIDTH_XL,
    "uppy-size--height-md": props.containerHeight > HEIGHT_MD,
    // We might want to enable this in the future
    // 'uppy-size--height-lg': props.containerHeight > HEIGHT_LG,
    // 'uppy-size--height-xl': props.containerHeight > HEIGHT_XL,
    "uppy-Dashboard--isAddFilesPanelVisible": props.showAddFilesPanel,
    "uppy-Dashboard--isInnerWrapVisible": props.areInsidesReadyToBeVisible,
    // Only enable “centered single file” mode when Dashboard is tall enough
    "uppy-Dashboard--singleFile": props.singleFileFullScreen && isSingleFile && isSizeHeightMD
  });
  let itemsPerRow = 1;
  if (props.containerWidth > WIDTH_XL) {
    itemsPerRow = 5;
  } else if (props.containerWidth > WIDTH_LG) {
    itemsPerRow = 4;
  } else if (props.containerWidth > WIDTH_MD) {
    itemsPerRow = 3;
  }
  const showFileList = props.showSelectedFiles && !isNoFiles;
  const numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null;
  const numberOfGhosts = props.files ? Object.keys(props.files).filter((fileID) => props.files[fileID].isGhost).length : null;
  const renderRestoredText = () => {
    if (numberOfGhosts > 0) {
      return props.i18n("recoveredXFiles", {
        smart_count: numberOfGhosts
      });
    }
    return props.i18n("recoveredAllFiles");
  };
  const dashboard = y("div", {
    className: dashboardClassName,
    "data-uppy-theme": props.theme,
    "data-uppy-num-acquirers": props.acquirers.length,
    "data-uppy-drag-drop-supported": !props.disableLocalFiles && isDragDropSupported(),
    "aria-hidden": props.inline ? "false" : props.isHidden,
    "aria-disabled": props.disabled,
    "aria-label": !props.inline ? props.i18n("dashboardWindowTitle") : props.i18n("dashboardTitle"),
    onPaste: props.handlePaste,
    onDragOver: props.handleDragOver,
    onDragLeave: props.handleDragLeave,
    onDrop: props.handleDrop
  }, y("div", {
    "aria-hidden": "true",
    className: "uppy-Dashboard-overlay",
    tabIndex: -1,
    onClick: props.handleClickOutside
  }), y("div", {
    className: "uppy-Dashboard-inner",
    "aria-modal": !props.inline && "true",
    role: props.inline ? void 0 : "dialog",
    style: {
      width: props.inline && props.width ? props.width : "",
      height: props.inline && props.height ? props.height : ""
    }
  }, !props.inline ? y("button", {
    className: "uppy-u-reset uppy-Dashboard-close",
    type: "button",
    "aria-label": props.i18n("closeModal"),
    title: props.i18n("closeModal"),
    onClick: props.closeModal
  }, y("span", {
    "aria-hidden": "true"
  }, "\xD7")) : null, y("div", {
    className: "uppy-Dashboard-innerWrap"
  }, y("div", {
    className: "uppy-Dashboard-dropFilesHereHint"
  }, props.i18n("dropHint")), showFileList && y(PickerPanelTopBar_default, props), numberOfFilesForRecovery && y("div", {
    className: "uppy-Dashboard-serviceMsg"
  }, y("svg", {
    className: "uppy-Dashboard-serviceMsg-icon",
    "aria-hidden": "true",
    focusable: "false",
    width: "21",
    height: "16",
    viewBox: "0 0 24 19"
  }, y("g", {
    transform: "translate(0 -1)",
    fill: "none",
    fillRule: "evenodd"
  }, y("path", {
    d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
    fill: "#FFD300"
  }), y("path", {
    fill: "#000",
    d: "M11 6h2l-.3 8h-1.4z"
  }), y("circle", {
    fill: "#000",
    cx: "12",
    cy: "17",
    r: "1"
  }))), y("strong", {
    className: "uppy-Dashboard-serviceMsg-title"
  }, props.i18n("sessionRestored")), y("div", {
    className: "uppy-Dashboard-serviceMsg-text"
  }, renderRestoredText())), showFileList ? y(FileList, {
    id: props.id,
    error: props.error,
    i18n: props.i18n,
    uppy: props.uppy,
    files: props.files,
    acquirers: props.acquirers,
    resumableUploads: props.resumableUploads,
    hideRetryButton: props.hideRetryButton,
    hidePauseResumeButton: props.hidePauseResumeButton,
    hideCancelButton: props.hideCancelButton,
    showLinkToFileUploadResult: props.showLinkToFileUploadResult,
    showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
    isWide: props.isWide,
    metaFields: props.metaFields,
    toggleFileCard: props.toggleFileCard,
    handleRequestThumbnail: props.handleRequestThumbnail,
    handleCancelThumbnail: props.handleCancelThumbnail,
    recoveredState: props.recoveredState,
    individualCancellation: props.individualCancellation,
    openFileEditor: props.openFileEditor,
    canEditFile: props.canEditFile,
    toggleAddFilesPanel: props.toggleAddFilesPanel,
    isSingleFile,
    itemsPerRow
  }) : y(AddFiles_default, _extends3({}, props, {
    isSizeMD
  })), y(Slide_default, null, props.showAddFilesPanel ? y(AddFilesPanel_default, _extends3({
    key: "AddFiles"
  }, props, {
    isSizeMD
  })) : null), y(Slide_default, null, props.fileCardFor ? y(FileCard, _extends3({
    key: "FileCard"
  }, props)) : null), y(Slide_default, null, props.activePickerPanel ? y(PickerPanelContent_default, _extends3({
    key: "Picker"
  }, props)) : null), y(Slide_default, null, props.showFileEditor ? y(EditorPanel_default, _extends3({
    key: "Editor"
  }, props)) : null), y("div", {
    className: "uppy-Dashboard-progressindicators"
  }, props.progressindicators.map((target) => {
    return props.uppy.getPlugin(target.id).render(props.state);
  })))));
  return dashboard;
}

// ../../node_modules/@uppy/dashboard/lib/locale.js
var locale_default5 = {
  strings: {
    // When `inline: false`, used as the screen reader label for the button that closes the modal.
    closeModal: "Close Modal",
    // Used as the screen reader label for the plus (+) button that shows the “Add more files” screen
    addMoreFiles: "Add more files",
    addingMoreFiles: "Adding more files",
    // Used as the header for import panels, e.g., “Import from Google Drive”.
    importFrom: "Import from %{name}",
    // When `inline: false`, used as the screen reader label for the dashboard modal.
    dashboardWindowTitle: "Uppy Dashboard Window (Press escape to close)",
    // When `inline: true`, used as the screen reader label for the dashboard area.
    dashboardTitle: "Uppy Dashboard",
    // Shown in the Informer when a link to a file was copied to the clipboard.
    copyLinkToClipboardSuccess: "Link copied to clipboard.",
    // Used when a link cannot be copied automatically — the user has to select the text from the
    // input element below this string.
    copyLinkToClipboardFallback: "Copy the URL below",
    // Used as the hover title and screen reader label for buttons that copy a file link.
    copyLink: "Copy link",
    back: "Back",
    // Used as the screen reader label for buttons that remove a file.
    removeFile: "Remove file",
    // Used as the screen reader label for buttons that open the metadata editor panel for a file.
    editFile: "Edit file",
    editImage: "Edit image",
    // Shown in the panel header for the metadata editor. Rendered as “Editing image.png”.
    editing: "Editing %{file}",
    // Shown on the main upload screen when an upload error occurs
    error: "Error",
    // Used as the screen reader label for the button that saves metadata edits and returns to the
    // file list view.
    finishEditingFile: "Finish editing file",
    saveChanges: "Save changes",
    // Used as the label for the tab button that opens the system file selection dialog.
    myDevice: "My Device",
    dropHint: "Drop your files here",
    // Used as the hover text and screen reader label for file progress indicators when
    // they have been fully uploaded.
    uploadComplete: "Upload complete",
    uploadPaused: "Upload paused",
    // Used as the hover text and screen reader label for the buttons to resume paused uploads.
    resumeUpload: "Resume upload",
    // Used as the hover text and screen reader label for the buttons to pause uploads.
    pauseUpload: "Pause upload",
    // Used as the hover text and screen reader label for the buttons to retry failed uploads.
    retryUpload: "Retry upload",
    // Used as the hover text and screen reader label for the buttons to cancel uploads.
    cancelUpload: "Cancel upload",
    // Used in a title, how many files are currently selected
    xFilesSelected: {
      0: "%{smart_count} file selected",
      1: "%{smart_count} files selected"
    },
    uploadingXFiles: {
      0: "Uploading %{smart_count} file",
      1: "Uploading %{smart_count} files"
    },
    processingXFiles: {
      0: "Processing %{smart_count} file",
      1: "Processing %{smart_count} files"
    },
    // The "powered by Uppy" link at the bottom of the Dashboard.
    poweredBy: "Powered by %{uppy}",
    addMore: "Add more",
    editFileWithFilename: "Edit file %{file}",
    save: "Save",
    cancel: "Cancel",
    dropPasteFiles: "Drop files here or %{browseFiles}",
    dropPasteFolders: "Drop files here or %{browseFolders}",
    dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}",
    dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:",
    dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:",
    dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:",
    importFiles: "Import files from:",
    browseFiles: "browse files",
    browseFolders: "browse folders",
    recoveredXFiles: {
      0: "We could not fully recover 1 file. Please re-select it and resume the upload.",
      1: "We could not fully recover %{smart_count} files. Please re-select them and resume the upload."
    },
    recoveredAllFiles: "We restored all files. You can now resume the upload.",
    sessionRestored: "Session restored",
    reSelect: "Re-select",
    missingRequiredMetaFields: {
      0: "Missing required meta field: %{fields}.",
      1: "Missing required meta fields: %{fields}."
    },
    // Used for native device camera buttons on mobile
    takePictureBtn: "Take Picture",
    recordVideoBtn: "Record Video"
  }
};

// ../../node_modules/@uppy/dashboard/lib/Dashboard.js
function _classPrivateFieldLooseBase17(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id17 = 0;
function _classPrivateFieldLooseKey17(name) {
  return "__private_" + id17++ + "_" + name;
}
var packageJson11 = {
  "version": "3.8.1"
};
var memoize = memoizeOne.default || memoizeOne;
var TAB_KEY = 9;
var ESC_KEY = 27;
function createPromise() {
  const o4 = {};
  o4.promise = new Promise((resolve, reject) => {
    o4.resolve = resolve;
    o4.reject = reject;
  });
  return o4;
}
var defaultOptions7 = {
  target: "body",
  metaFields: [],
  inline: false,
  width: 750,
  height: 550,
  thumbnailWidth: 280,
  thumbnailType: "image/jpeg",
  waitForThumbnailsBeforeUpload: false,
  defaultPickerIcon,
  showLinkToFileUploadResult: false,
  showProgressDetails: false,
  hideUploadButton: false,
  hideCancelButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideProgressAfterFinish: false,
  note: null,
  closeModalOnClickOutside: false,
  closeAfterFinish: false,
  singleFileFullScreen: true,
  disableStatusBar: false,
  disableInformer: false,
  disableThumbnailGenerator: false,
  disablePageScrollWhenModalOpen: true,
  animateOpenClose: true,
  fileManagerSelectionType: "files",
  proudlyDisplayPoweredByUppy: true,
  showSelectedFiles: true,
  showRemoveButtonAfterComplete: false,
  browserBackButtonClose: false,
  showNativePhotoCameraButton: false,
  showNativeVideoCameraButton: false,
  theme: "light",
  autoOpen: null,
  autoOpenFileEditor: false,
  disabled: false,
  disableLocalFiles: false,
  // Dynamic default options, they have to be defined in the constructor (because
  // they require access to the `this` keyword), but we still want them to
  // appear in the default options so TS knows they'll be defined.
  doneButtonHandler: null,
  onRequestCloseModal: null
};
var _disabledNodes = /* @__PURE__ */ _classPrivateFieldLooseKey17("disabledNodes");
var _generateLargeThumbnailIfSingleFile = /* @__PURE__ */ _classPrivateFieldLooseKey17("generateLargeThumbnailIfSingleFile");
var _openFileEditorWhenFilesAdded = /* @__PURE__ */ _classPrivateFieldLooseKey17("openFileEditorWhenFilesAdded");
var _attachRenderFunctionToTarget = /* @__PURE__ */ _classPrivateFieldLooseKey17("attachRenderFunctionToTarget");
var _isTargetSupported = /* @__PURE__ */ _classPrivateFieldLooseKey17("isTargetSupported");
var _getAcquirers = /* @__PURE__ */ _classPrivateFieldLooseKey17("getAcquirers");
var _getProgressIndicators = /* @__PURE__ */ _classPrivateFieldLooseKey17("getProgressIndicators");
var _getEditors = /* @__PURE__ */ _classPrivateFieldLooseKey17("getEditors");
var _addSpecifiedPluginsFromOptions = /* @__PURE__ */ _classPrivateFieldLooseKey17("addSpecifiedPluginsFromOptions");
var _autoDiscoverPlugins = /* @__PURE__ */ _classPrivateFieldLooseKey17("autoDiscoverPlugins");
var _addSupportedPluginIfNoTarget = /* @__PURE__ */ _classPrivateFieldLooseKey17("addSupportedPluginIfNoTarget");
var Dashboard2 = class extends UIPlugin_default {
  // Timeouts
  constructor(uppy2, _opts) {
    var _this$opts4, _this$opts4$doneButto, _this$opts5, _this$opts5$onRequest;
    let autoOpen;
    if (!_opts) {
      autoOpen = null;
    } else if (_opts.autoOpen === void 0) {
      autoOpen = _opts.autoOpenFileEditor ? "imageEditor" : null;
    } else {
      autoOpen = _opts.autoOpen;
    }
    super(uppy2, {
      ...defaultOptions7,
      ..._opts,
      autoOpen
    });
    Object.defineProperty(this, _disabledNodes, {
      writable: true,
      value: void 0
    });
    this.modalName = `uppy-Dashboard-${nanoid()}`;
    this.superFocus = createSuperFocus();
    this.ifFocusedOnUppyRecently = false;
    this.removeTarget = (plugin) => {
      const pluginState = this.getPluginState();
      const newTargets = pluginState.targets.filter((target) => target.id !== plugin.id);
      this.setPluginState({
        targets: newTargets
      });
    };
    this.addTarget = (plugin) => {
      const callerPluginId = plugin.id || plugin.constructor.name;
      const callerPluginName = plugin.title || callerPluginId;
      const callerPluginType = plugin.type;
      if (callerPluginType !== "acquirer" && callerPluginType !== "progressindicator" && callerPluginType !== "editor") {
        const msg = "Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor";
        this.uppy.log(msg, "error");
        return null;
      }
      const target = {
        id: callerPluginId,
        name: callerPluginName,
        type: callerPluginType
      };
      const state = this.getPluginState();
      const newTargets = state.targets.slice();
      newTargets.push(target);
      this.setPluginState({
        targets: newTargets
      });
      return this.el;
    };
    this.hideAllPanels = () => {
      var _state$activePickerPa;
      const state = this.getPluginState();
      const update = {
        activePickerPanel: void 0,
        showAddFilesPanel: false,
        activeOverlayType: null,
        fileCardFor: null,
        showFileEditor: false
      };
      if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) {
        return;
      }
      this.setPluginState(update);
      this.uppy.emit("dashboard:close-panel", (_state$activePickerPa = state.activePickerPanel) == null ? void 0 : _state$activePickerPa.id);
    };
    this.showPanel = (id18) => {
      const {
        targets
      } = this.getPluginState();
      const activePickerPanel = targets.find((target) => {
        return target.type === "acquirer" && target.id === id18;
      });
      this.setPluginState({
        activePickerPanel,
        activeOverlayType: "PickerPanel"
      });
      this.uppy.emit("dashboard:show-panel", id18);
    };
    this.canEditFile = (file) => {
      const {
        targets
      } = this.getPluginState();
      const editors = _classPrivateFieldLooseBase17(this, _getEditors)[_getEditors](targets);
      return editors.some((target) => this.uppy.getPlugin(target.id).canEditFile(file));
    };
    this.openFileEditor = (file) => {
      const {
        targets
      } = this.getPluginState();
      const editors = _classPrivateFieldLooseBase17(this, _getEditors)[_getEditors](targets);
      this.setPluginState({
        showFileEditor: true,
        fileCardFor: file.id || null,
        activeOverlayType: "FileEditor"
      });
      editors.forEach((editor) => {
        ;
        this.uppy.getPlugin(editor.id).selectFile(file);
      });
    };
    this.closeFileEditor = () => {
      const {
        metaFields: metaFields2
      } = this.getPluginState();
      const isMetaEditorEnabled = metaFields2 && metaFields2.length > 0;
      if (isMetaEditorEnabled) {
        this.setPluginState({
          showFileEditor: false,
          activeOverlayType: "FileCard"
        });
      } else {
        this.setPluginState({
          showFileEditor: false,
          fileCardFor: null,
          activeOverlayType: "AddFiles"
        });
      }
    };
    this.saveFileEditor = () => {
      const {
        targets
      } = this.getPluginState();
      const editors = _classPrivateFieldLooseBase17(this, _getEditors)[_getEditors](targets);
      editors.forEach((editor) => {
        ;
        this.uppy.getPlugin(editor.id).save();
      });
      this.closeFileEditor();
    };
    this.openModal = () => {
      const {
        promise,
        resolve
      } = createPromise();
      this.savedScrollPosition = window.pageYOffset;
      this.savedActiveElement = document.activeElement;
      if (this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.add("uppy-Dashboard-isFixed");
      }
      if (this.opts.animateOpenClose && this.getPluginState().isClosing) {
        const handler = () => {
          this.setPluginState({
            isHidden: false
          });
          this.el.removeEventListener("animationend", handler, false);
          resolve();
        };
        this.el.addEventListener("animationend", handler, false);
      } else {
        this.setPluginState({
          isHidden: false
        });
        resolve();
      }
      if (this.opts.browserBackButtonClose) {
        this.updateBrowserHistory();
      }
      document.addEventListener("keydown", this.handleKeyDownInModal);
      this.uppy.emit("dashboard:modal-open");
      return promise;
    };
    this.closeModal = (opts) => {
      var _opts$manualClose;
      const manualClose = (_opts$manualClose = opts == null ? void 0 : opts.manualClose) != null ? _opts$manualClose : true;
      const {
        isHidden,
        isClosing
      } = this.getPluginState();
      if (isHidden || isClosing) {
        return void 0;
      }
      const {
        promise,
        resolve
      } = createPromise();
      if (this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.remove("uppy-Dashboard-isFixed");
      }
      if (this.opts.animateOpenClose) {
        this.setPluginState({
          isClosing: true
        });
        const handler = () => {
          this.setPluginState({
            isHidden: true,
            isClosing: false
          });
          this.superFocus.cancel();
          this.savedActiveElement.focus();
          this.el.removeEventListener("animationend", handler, false);
          resolve();
        };
        this.el.addEventListener("animationend", handler, false);
      } else {
        this.setPluginState({
          isHidden: true
        });
        this.superFocus.cancel();
        this.savedActiveElement.focus();
        resolve();
      }
      document.removeEventListener("keydown", this.handleKeyDownInModal);
      if (manualClose) {
        if (this.opts.browserBackButtonClose) {
          var _history$state;
          if ((_history$state = history.state) != null && _history$state[this.modalName]) {
            history.back();
          }
        }
      }
      this.uppy.emit("dashboard:modal-closed");
      return promise;
    };
    this.isModalOpen = () => {
      return !this.getPluginState().isHidden || false;
    };
    this.requestCloseModal = () => {
      if (this.opts.onRequestCloseModal) {
        return this.opts.onRequestCloseModal();
      }
      return this.closeModal();
    };
    this.setDarkModeCapability = (isDarkModeOn) => {
      const {
        capabilities
      } = this.uppy.getState();
      this.uppy.setState({
        capabilities: {
          ...capabilities,
          darkMode: isDarkModeOn
        }
      });
    };
    this.handleSystemDarkModeChange = (event) => {
      const isDarkModeOnNow = event.matches;
      this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnNow ? "on" : "off"}`);
      this.setDarkModeCapability(isDarkModeOnNow);
    };
    this.toggleFileCard = (show, fileID) => {
      const file = this.uppy.getFile(fileID);
      if (show) {
        this.uppy.emit("dashboard:file-edit-start", file);
      } else {
        this.uppy.emit("dashboard:file-edit-complete", file);
      }
      this.setPluginState({
        fileCardFor: show ? fileID : null,
        activeOverlayType: show ? "FileCard" : null
      });
    };
    this.toggleAddFilesPanel = (show) => {
      this.setPluginState({
        showAddFilesPanel: show,
        activeOverlayType: show ? "AddFiles" : null
      });
    };
    this.addFiles = (files) => {
      const descriptors = files.map((file) => ({
        source: this.id,
        name: file.name,
        type: file.type,
        data: file,
        meta: {
          // path of the file relative to the ancestor directory the user selected.
          // e.g. 'docs/Old Prague/airbnb.pdf'
          relativePath: file.relativePath || file.webkitRelativePath || null
        }
      }));
      try {
        this.uppy.addFiles(descriptors);
      } catch (err) {
        this.uppy.log(err);
      }
    };
    this.startListeningToResize = () => {
      this.resizeObserver = new ResizeObserver((entries) => {
        const uppyDashboardInnerEl = entries[0];
        const {
          width,
          height
        } = uppyDashboardInnerEl.contentRect;
        this.setPluginState({
          containerWidth: width,
          containerHeight: height,
          areInsidesReadyToBeVisible: true
        });
      });
      this.resizeObserver.observe(this.el.querySelector(".uppy-Dashboard-inner"));
      this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(() => {
        const pluginState = this.getPluginState();
        const isModalAndClosed = !this.opts.inline && pluginState.isHidden;
        if (
          // We might want to enable this in the future
          // if ResizeObserver hasn't yet fired,
          !pluginState.areInsidesReadyToBeVisible && // and it's not due to the modal being closed
          !isModalAndClosed
        ) {
          this.uppy.log("[Dashboard] resize event didn\u2019t fire on time: defaulted to mobile layout", "warning");
          this.setPluginState({
            areInsidesReadyToBeVisible: true
          });
        }
      }, 1e3);
    };
    this.stopListeningToResize = () => {
      this.resizeObserver.disconnect();
      clearTimeout(this.makeDashboardInsidesVisibleAnywayTimeout);
    };
    this.recordIfFocusedOnUppyRecently = (event) => {
      if (this.el.contains(event.target)) {
        this.ifFocusedOnUppyRecently = true;
      } else {
        this.ifFocusedOnUppyRecently = false;
        this.superFocus.cancel();
      }
    };
    this.disableInteractiveElements = (disable) => {
      var _classPrivateFieldLoo;
      const NODES_TO_DISABLE = ["a[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", '[role="button"]:not([disabled])'];
      const nodesToDisable = (_classPrivateFieldLoo = _classPrivateFieldLooseBase17(this, _disabledNodes)[_disabledNodes]) != null ? _classPrivateFieldLoo : toArray_default(this.el.querySelectorAll(NODES_TO_DISABLE)).filter((node70) => !node70.classList.contains("uppy-Dashboard-close"));
      for (const node70 of nodesToDisable) {
        if (node70.tagName === "A") {
          node70.setAttribute("aria-disabled", disable);
        } else {
          node70.disabled = disable;
        }
      }
      if (disable) {
        _classPrivateFieldLooseBase17(this, _disabledNodes)[_disabledNodes] = nodesToDisable;
      } else {
        _classPrivateFieldLooseBase17(this, _disabledNodes)[_disabledNodes] = null;
      }
      this.dashboardIsDisabled = disable;
    };
    this.updateBrowserHistory = () => {
      var _history$state2;
      if (!((_history$state2 = history.state) != null && _history$state2[this.modalName])) {
        history.pushState({
          // eslint-disable-next-line no-restricted-globals
          ...history.state,
          [this.modalName]: true
        }, "");
      }
      window.addEventListener("popstate", this.handlePopState, false);
    };
    this.handlePopState = (event) => {
      var _event$state;
      if (this.isModalOpen() && (!event.state || !event.state[this.modalName])) {
        this.closeModal({
          manualClose: false
        });
      }
      if (!this.isModalOpen() && (_event$state = event.state) != null && _event$state[this.modalName]) {
        history.back();
      }
    };
    this.handleKeyDownInModal = (event) => {
      if (event.keyCode === ESC_KEY)
        this.requestCloseModal();
      if (event.keyCode === TAB_KEY)
        trapFocus(event, this.getPluginState().activeOverlayType, this.el);
    };
    this.handleClickOutside = () => {
      if (this.opts.closeModalOnClickOutside)
        this.requestCloseModal();
    };
    this.handlePaste = (event) => {
      this.uppy.iteratePlugins((plugin) => {
        if (plugin.type === "acquirer") {
          ;
          plugin.handleRootPaste == null || plugin.handleRootPaste(event);
        }
      });
      const files = toArray_default(event.clipboardData.files);
      if (files.length > 0) {
        this.uppy.log("[Dashboard] Files pasted");
        this.addFiles(files);
      }
    };
    this.handleInputChange = (event) => {
      event.preventDefault();
      const files = toArray_default(event.target.files);
      if (files.length > 0) {
        this.uppy.log("[Dashboard] Files selected through input");
        this.addFiles(files);
      }
    };
    this.handleDragOver = (event) => {
      var _this$opts$onDragOver, _this$opts;
      event.preventDefault();
      event.stopPropagation();
      const canSomePluginHandleRootDrop = () => {
        let somePluginCanHandleRootDrop2 = true;
        this.uppy.iteratePlugins((plugin) => {
          if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) {
            somePluginCanHandleRootDrop2 = true;
          }
        });
        return somePluginCanHandleRootDrop2;
      };
      const doesEventHaveFiles = () => {
        const {
          types
        } = event.dataTransfer;
        return types.some((type) => type === "Files");
      };
      const somePluginCanHandleRootDrop = canSomePluginHandleRootDrop();
      const hasFiles = doesEventHaveFiles();
      if (!somePluginCanHandleRootDrop && !hasFiles || this.opts.disabled || // opts.disableLocalFiles should only be taken into account if no plugins
      // can handle the datatransfer
      this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !this.uppy.getState().allowNewUpload) {
        event.dataTransfer.dropEffect = "none";
        clearTimeout(this.removeDragOverClassTimeout);
        return;
      }
      event.dataTransfer.dropEffect = "copy";
      clearTimeout(this.removeDragOverClassTimeout);
      this.setPluginState({
        isDraggingOver: true
      });
      (_this$opts$onDragOver = (_this$opts = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
    };
    this.handleDragLeave = (event) => {
      var _this$opts$onDragLeav, _this$opts2;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.removeDragOverClassTimeout);
      this.removeDragOverClassTimeout = setTimeout(() => {
        this.setPluginState({
          isDraggingOver: false
        });
      }, 50);
      (_this$opts$onDragLeav = (_this$opts2 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
    };
    this.handleDrop = async (event) => {
      var _this$opts$onDrop, _this$opts3;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.removeDragOverClassTimeout);
      this.setPluginState({
        isDraggingOver: false
      });
      this.uppy.iteratePlugins((plugin) => {
        if (plugin.type === "acquirer") {
          ;
          plugin.handleRootDrop == null || plugin.handleRootDrop(event);
        }
      });
      let executedDropErrorOnce = false;
      const logDropError = (error) => {
        this.uppy.log(error, "error");
        if (!executedDropErrorOnce) {
          this.uppy.info(error.message, "error");
          executedDropErrorOnce = true;
        }
      };
      this.uppy.log("[Dashboard] Processing dropped files");
      const files = await getDroppedFiles(event.dataTransfer, {
        logDropError
      });
      if (files.length > 0) {
        this.uppy.log("[Dashboard] Files dropped");
        this.addFiles(files);
      }
      (_this$opts$onDrop = (_this$opts3 = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
    };
    this.handleRequestThumbnail = (file) => {
      if (!this.opts.waitForThumbnailsBeforeUpload) {
        this.uppy.emit("thumbnail:request", file);
      }
    };
    this.handleCancelThumbnail = (file) => {
      if (!this.opts.waitForThumbnailsBeforeUpload) {
        this.uppy.emit("thumbnail:cancel", file);
      }
    };
    this.handleKeyDownInInline = (event) => {
      if (event.keyCode === TAB_KEY)
        forInline(event, this.getPluginState().activeOverlayType, this.el);
    };
    this.handlePasteOnBody = (event) => {
      const isFocusInOverlay2 = this.el.contains(document.activeElement);
      if (isFocusInOverlay2) {
        this.handlePaste(event);
      }
    };
    this.handleComplete = (_ref) => {
      let {
        failed
      } = _ref;
      if (this.opts.closeAfterFinish && !(failed != null && failed.length)) {
        this.requestCloseModal();
      }
    };
    this.handleCancelRestore = () => {
      this.uppy.emit("restore-canceled");
    };
    Object.defineProperty(this, _generateLargeThumbnailIfSingleFile, {
      writable: true,
      value: () => {
        if (this.opts.disableThumbnailGenerator) {
          return;
        }
        const LARGE_THUMBNAIL = 600;
        const files = this.uppy.getFiles();
        if (files.length === 1) {
          const thumbnailGenerator = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
          thumbnailGenerator == null || thumbnailGenerator.setOptions({
            thumbnailWidth: LARGE_THUMBNAIL
          });
          const fileForThumbnail = {
            ...files[0],
            preview: void 0
          };
          thumbnailGenerator == null || thumbnailGenerator.requestThumbnail(fileForThumbnail).then(() => {
            thumbnailGenerator == null || thumbnailGenerator.setOptions({
              thumbnailWidth: this.opts.thumbnailWidth
            });
          });
        }
      }
    });
    Object.defineProperty(this, _openFileEditorWhenFilesAdded, {
      writable: true,
      value: (files) => {
        const firstFile = files[0];
        const {
          metaFields: metaFields2
        } = this.getPluginState();
        const isMetaEditorEnabled = metaFields2 && metaFields2.length > 0;
        const isImageEditorEnabled = this.canEditFile(firstFile);
        if (isMetaEditorEnabled && this.opts.autoOpen === "metaEditor") {
          this.toggleFileCard(true, firstFile.id);
        } else if (isImageEditorEnabled && this.opts.autoOpen === "imageEditor") {
          this.openFileEditor(firstFile);
        }
      }
    });
    this.initEvents = () => {
      if (this.opts.trigger && !this.opts.inline) {
        const showModalTrigger = findAllDOMElements_default(this.opts.trigger);
        if (showModalTrigger) {
          showModalTrigger.forEach((trigger) => trigger.addEventListener("click", this.openModal));
        } else {
          this.uppy.log("Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself", "warning");
        }
      }
      this.startListeningToResize();
      document.addEventListener("paste", this.handlePasteOnBody);
      this.uppy.on("plugin-added", _classPrivateFieldLooseBase17(this, _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      this.uppy.on("plugin-remove", this.removeTarget);
      this.uppy.on("file-added", this.hideAllPanels);
      this.uppy.on("dashboard:modal-closed", this.hideAllPanels);
      this.uppy.on("complete", this.handleComplete);
      this.uppy.on("files-added", _classPrivateFieldLooseBase17(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      this.uppy.on("file-removed", _classPrivateFieldLooseBase17(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      document.addEventListener("focus", this.recordIfFocusedOnUppyRecently, true);
      document.addEventListener("click", this.recordIfFocusedOnUppyRecently, true);
      if (this.opts.inline) {
        this.el.addEventListener("keydown", this.handleKeyDownInInline);
      }
      if (this.opts.autoOpen) {
        this.uppy.on("files-added", _classPrivateFieldLooseBase17(this, _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };
    this.removeEvents = () => {
      const showModalTrigger = findAllDOMElements_default(this.opts.trigger);
      if (!this.opts.inline && showModalTrigger) {
        showModalTrigger.forEach((trigger) => trigger.removeEventListener("click", this.openModal));
      }
      this.stopListeningToResize();
      document.removeEventListener("paste", this.handlePasteOnBody);
      window.removeEventListener("popstate", this.handlePopState, false);
      this.uppy.off("plugin-added", _classPrivateFieldLooseBase17(this, _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      this.uppy.off("plugin-remove", this.removeTarget);
      this.uppy.off("file-added", this.hideAllPanels);
      this.uppy.off("dashboard:modal-closed", this.hideAllPanels);
      this.uppy.off("complete", this.handleComplete);
      this.uppy.off("files-added", _classPrivateFieldLooseBase17(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      this.uppy.off("file-removed", _classPrivateFieldLooseBase17(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      document.removeEventListener("focus", this.recordIfFocusedOnUppyRecently);
      document.removeEventListener("click", this.recordIfFocusedOnUppyRecently);
      if (this.opts.inline) {
        this.el.removeEventListener("keydown", this.handleKeyDownInInline);
      }
      if (this.opts.autoOpen) {
        this.uppy.off("files-added", _classPrivateFieldLooseBase17(this, _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };
    this.superFocusOnEachUpdate = () => {
      const isFocusInUppy = this.el.contains(document.activeElement);
      const isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
      const isInformerHidden = this.uppy.getState().info.length === 0;
      const isModal = !this.opts.inline;
      if (
        // If update is connected to showing the Informer - let the screen reader calmly read it.
        isInformerHidden && // If we are in a modal - always superfocus without concern for other elements
        // on the page (user is unlikely to want to interact with the rest of the page)
        (isModal || // If we are already inside of Uppy, or
        isFocusInUppy || // If we are not focused on anything BUT we have already, at least once, focused on uppy
        //   1. We focus when isFocusNowhere, because when the element we were focused
        //      on disappears (e.g. an overlay), - focus gets lost. If user is typing
        //      something somewhere else on the page, - focus won't be 'nowhere'.
        //   2. We only focus when focus is nowhere AND this.ifFocusedOnUppyRecently,
        //      to avoid focus jumps if we do something else on the page.
        //   [Practical check] Without '&& this.ifFocusedOnUppyRecently', in Safari, in inline mode,
        //                     when file is uploading, - navigate via tab to the checkbox,
        //                     try to press space multiple times. Focus will jump to Uppy.
        isFocusNowhere && this.ifFocusedOnUppyRecently)
      ) {
        this.superFocus(this.el, this.getPluginState().activeOverlayType);
      } else {
        this.superFocus.cancel();
      }
    };
    this.afterUpdate = () => {
      if (this.opts.disabled && !this.dashboardIsDisabled) {
        this.disableInteractiveElements(true);
        return;
      }
      if (!this.opts.disabled && this.dashboardIsDisabled) {
        this.disableInteractiveElements(false);
      }
      this.superFocusOnEachUpdate();
    };
    this.saveFileCard = (meta, fileID) => {
      this.uppy.setFileMeta(fileID, meta);
      this.toggleFileCard(false, fileID);
    };
    Object.defineProperty(this, _attachRenderFunctionToTarget, {
      writable: true,
      value: (target) => {
        const plugin = this.uppy.getPlugin(target.id);
        return {
          ...target,
          icon: plugin.icon || this.opts.defaultPickerIcon,
          render: plugin.render
        };
      }
    });
    Object.defineProperty(this, _isTargetSupported, {
      writable: true,
      value: (target) => {
        const plugin = this.uppy.getPlugin(target.id);
        if (typeof plugin.isSupported !== "function") {
          return true;
        }
        return plugin.isSupported();
      }
    });
    Object.defineProperty(this, _getAcquirers, {
      writable: true,
      value: memoize((targets) => {
        return targets.filter((target) => target.type === "acquirer" && _classPrivateFieldLooseBase17(this, _isTargetSupported)[_isTargetSupported](target)).map(_classPrivateFieldLooseBase17(this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(this, _getProgressIndicators, {
      writable: true,
      value: memoize((targets) => {
        return targets.filter((target) => target.type === "progressindicator").map(_classPrivateFieldLooseBase17(this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(this, _getEditors, {
      writable: true,
      value: memoize((targets) => {
        return targets.filter((target) => target.type === "editor").map(_classPrivateFieldLooseBase17(this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    this.render = (state) => {
      const pluginState = this.getPluginState();
      const {
        files,
        capabilities,
        allowNewUpload
      } = state;
      const {
        newFiles,
        uploadStartedFiles,
        completeFiles,
        erroredFiles,
        inProgressFiles,
        inProgressNotPausedFiles,
        processingFiles,
        isUploadStarted,
        isAllComplete,
        isAllErrored,
        isAllPaused
      } = this.uppy.getObjectOfFilesPerState();
      const acquirers = _classPrivateFieldLooseBase17(this, _getAcquirers)[_getAcquirers](pluginState.targets);
      const progressindicators = _classPrivateFieldLooseBase17(this, _getProgressIndicators)[_getProgressIndicators](pluginState.targets);
      const editors = _classPrivateFieldLooseBase17(this, _getEditors)[_getEditors](pluginState.targets);
      let theme;
      if (this.opts.theme === "auto") {
        theme = capabilities.darkMode ? "dark" : "light";
      } else {
        theme = this.opts.theme;
      }
      if (["files", "folders", "both"].indexOf(this.opts.fileManagerSelectionType) < 0) {
        this.opts.fileManagerSelectionType = "files";
        console.warn(`Unsupported option for "fileManagerSelectionType". Using default of "${this.opts.fileManagerSelectionType}".`);
      }
      return Dashboard({
        state,
        isHidden: pluginState.isHidden,
        files,
        newFiles,
        uploadStartedFiles,
        completeFiles,
        erroredFiles,
        inProgressFiles,
        inProgressNotPausedFiles,
        processingFiles,
        isUploadStarted,
        isAllComplete,
        isAllErrored,
        isAllPaused,
        totalFileCount: Object.keys(files).length,
        totalProgress: state.totalProgress,
        allowNewUpload,
        acquirers,
        theme,
        disabled: this.opts.disabled,
        disableLocalFiles: this.opts.disableLocalFiles,
        direction: this.opts.direction,
        activePickerPanel: pluginState.activePickerPanel,
        showFileEditor: pluginState.showFileEditor,
        saveFileEditor: this.saveFileEditor,
        closeFileEditor: this.closeFileEditor,
        disableInteractiveElements: this.disableInteractiveElements,
        animateOpenClose: this.opts.animateOpenClose,
        isClosing: pluginState.isClosing,
        progressindicators,
        editors,
        autoProceed: this.uppy.opts.autoProceed,
        id: this.id,
        closeModal: this.requestCloseModal,
        handleClickOutside: this.handleClickOutside,
        handleInputChange: this.handleInputChange,
        handlePaste: this.handlePaste,
        inline: this.opts.inline,
        showPanel: this.showPanel,
        hideAllPanels: this.hideAllPanels,
        i18n: this.i18n,
        i18nArray: this.i18nArray,
        uppy: this.uppy,
        note: this.opts.note,
        recoveredState: state.recoveredState,
        metaFields: pluginState.metaFields,
        resumableUploads: capabilities.resumableUploads || false,
        individualCancellation: capabilities.individualCancellation,
        isMobileDevice: capabilities.isMobileDevice,
        fileCardFor: pluginState.fileCardFor,
        toggleFileCard: this.toggleFileCard,
        toggleAddFilesPanel: this.toggleAddFilesPanel,
        showAddFilesPanel: pluginState.showAddFilesPanel,
        saveFileCard: this.saveFileCard,
        openFileEditor: this.openFileEditor,
        canEditFile: this.canEditFile,
        width: this.opts.width,
        height: this.opts.height,
        showLinkToFileUploadResult: this.opts.showLinkToFileUploadResult,
        fileManagerSelectionType: this.opts.fileManagerSelectionType,
        proudlyDisplayPoweredByUppy: this.opts.proudlyDisplayPoweredByUppy,
        hideCancelButton: this.opts.hideCancelButton,
        hideRetryButton: this.opts.hideRetryButton,
        hidePauseResumeButton: this.opts.hidePauseResumeButton,
        showRemoveButtonAfterComplete: this.opts.showRemoveButtonAfterComplete,
        containerWidth: pluginState.containerWidth,
        containerHeight: pluginState.containerHeight,
        areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
        isTargetDOMEl: this.isTargetDOMEl,
        parentElement: this.el,
        allowedFileTypes: this.uppy.opts.restrictions.allowedFileTypes,
        maxNumberOfFiles: this.uppy.opts.restrictions.maxNumberOfFiles,
        requiredMetaFields: this.uppy.opts.restrictions.requiredMetaFields,
        showSelectedFiles: this.opts.showSelectedFiles,
        showNativePhotoCameraButton: this.opts.showNativePhotoCameraButton,
        showNativeVideoCameraButton: this.opts.showNativeVideoCameraButton,
        nativeCameraFacingMode: this.opts.nativeCameraFacingMode,
        singleFileFullScreen: this.opts.singleFileFullScreen,
        handleCancelRestore: this.handleCancelRestore,
        handleRequestThumbnail: this.handleRequestThumbnail,
        handleCancelThumbnail: this.handleCancelThumbnail,
        // drag props
        isDraggingOver: pluginState.isDraggingOver,
        handleDragOver: this.handleDragOver,
        handleDragLeave: this.handleDragLeave,
        handleDrop: this.handleDrop
      });
    };
    Object.defineProperty(this, _addSpecifiedPluginsFromOptions, {
      writable: true,
      value: () => {
        const plugins2 = this.opts.plugins || [];
        plugins2.forEach((pluginID) => {
          const plugin = this.uppy.getPlugin(pluginID);
          if (plugin) {
            ;
            plugin.mount(this, plugin);
          } else {
            this.uppy.log(`[Uppy] Dashboard could not find plugin '${pluginID}', make sure to uppy.use() the plugins you are specifying`, "warning");
          }
        });
      }
    });
    Object.defineProperty(this, _autoDiscoverPlugins, {
      writable: true,
      value: () => {
        this.uppy.iteratePlugins(_classPrivateFieldLooseBase17(this, _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      }
    });
    Object.defineProperty(this, _addSupportedPluginIfNoTarget, {
      writable: true,
      value: (plugin) => {
        var _plugin$opts;
        const typesAllowed = ["acquirer", "editor"];
        if (plugin && !((_plugin$opts = plugin.opts) != null && _plugin$opts.target) && typesAllowed.includes(plugin.type)) {
          const pluginAlreadyAdded = this.getPluginState().targets.some((installedPlugin) => plugin.id === installedPlugin.id);
          if (!pluginAlreadyAdded) {
            ;
            plugin.mount(this, plugin);
          }
        }
      }
    });
    this.install = () => {
      this.setPluginState({
        isHidden: true,
        fileCardFor: null,
        activeOverlayType: null,
        showAddFilesPanel: false,
        activePickerPanel: void 0,
        showFileEditor: false,
        metaFields: this.opts.metaFields,
        targets: [],
        // We'll make them visible once .containerWidth is determined
        areInsidesReadyToBeVisible: false,
        isDraggingOver: false
      });
      const {
        inline,
        closeAfterFinish
      } = this.opts;
      if (inline && closeAfterFinish) {
        throw new Error("[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.");
      }
      const {
        allowMultipleUploads,
        allowMultipleUploadBatches
      } = this.uppy.opts;
      if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) {
        this.uppy.log("[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true", "warning");
      }
      const {
        target
      } = this.opts;
      if (target) {
        this.mount(target, this);
      }
      if (!this.opts.disableStatusBar) {
        this.uppy.use(StatusBar2, {
          id: `${this.id}:StatusBar`,
          target: this,
          hideUploadButton: this.opts.hideUploadButton,
          hideRetryButton: this.opts.hideRetryButton,
          hidePauseResumeButton: this.opts.hidePauseResumeButton,
          hideCancelButton: this.opts.hideCancelButton,
          showProgressDetails: this.opts.showProgressDetails,
          hideAfterFinish: this.opts.hideProgressAfterFinish,
          locale: this.opts.locale,
          doneButtonHandler: this.opts.doneButtonHandler
        });
      }
      if (!this.opts.disableInformer) {
        this.uppy.use(Informer, {
          id: `${this.id}:Informer`,
          target: this
        });
      }
      if (!this.opts.disableThumbnailGenerator) {
        this.uppy.use(ThumbnailGenerator, {
          id: `${this.id}:ThumbnailGenerator`,
          thumbnailWidth: this.opts.thumbnailWidth,
          thumbnailHeight: this.opts.thumbnailHeight,
          thumbnailType: this.opts.thumbnailType,
          waitForThumbnailsBeforeUpload: this.opts.waitForThumbnailsBeforeUpload,
          // If we don't block on thumbnails, we can lazily generate them
          lazy: !this.opts.waitForThumbnailsBeforeUpload
        });
      }
      this.darkModeMediaQuery = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
      const isDarkModeOnFromTheStart = this.darkModeMediaQuery ? this.darkModeMediaQuery.matches : false;
      this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnFromTheStart ? "on" : "off"}`);
      this.setDarkModeCapability(isDarkModeOnFromTheStart);
      if (this.opts.theme === "auto") {
        var _this$darkModeMediaQu;
        (_this$darkModeMediaQu = this.darkModeMediaQuery) == null || _this$darkModeMediaQu.addListener(this.handleSystemDarkModeChange);
      }
      _classPrivateFieldLooseBase17(this, _addSpecifiedPluginsFromOptions)[_addSpecifiedPluginsFromOptions]();
      _classPrivateFieldLooseBase17(this, _autoDiscoverPlugins)[_autoDiscoverPlugins]();
      this.initEvents();
    };
    this.uninstall = () => {
      if (!this.opts.disableInformer) {
        const informer = this.uppy.getPlugin(`${this.id}:Informer`);
        if (informer)
          this.uppy.removePlugin(informer);
      }
      if (!this.opts.disableStatusBar) {
        const statusBar = this.uppy.getPlugin(`${this.id}:StatusBar`);
        if (statusBar)
          this.uppy.removePlugin(statusBar);
      }
      if (!this.opts.disableThumbnailGenerator) {
        const thumbnail = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
        if (thumbnail)
          this.uppy.removePlugin(thumbnail);
      }
      const plugins2 = this.opts.plugins || [];
      plugins2.forEach((pluginID) => {
        const plugin = this.uppy.getPlugin(pluginID);
        if (plugin)
          plugin.unmount();
      });
      if (this.opts.theme === "auto") {
        var _this$darkModeMediaQu2;
        (_this$darkModeMediaQu2 = this.darkModeMediaQuery) == null || _this$darkModeMediaQu2.removeListener(this.handleSystemDarkModeChange);
      }
      if (this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.remove("uppy-Dashboard-isFixed");
      }
      this.unmount();
      this.removeEvents();
    };
    this.id = this.opts.id || "Dashboard";
    this.title = "Dashboard";
    this.type = "orchestrator";
    this.defaultLocale = locale_default5;
    (_this$opts4$doneButto = (_this$opts4 = this.opts).doneButtonHandler) != null ? _this$opts4$doneButto : _this$opts4.doneButtonHandler = () => {
      this.uppy.clearUploadedFiles();
      this.requestCloseModal();
    };
    (_this$opts5$onRequest = (_this$opts5 = this.opts).onRequestCloseModal) != null ? _this$opts5$onRequest : _this$opts5.onRequestCloseModal = () => this.closeModal();
    this.i18nInit();
  }
};
Dashboard2.VERSION = packageJson11.version;

// ../../node_modules/@uppy/react/lib/propTypes.js
var import_prop_types = __toESM(require_prop_types(), 1);
var uppy = import_prop_types.default.instanceOf(Uppy_default);
var plugins = import_prop_types.default.arrayOf(import_prop_types.default.string);
var locale = import_prop_types.default.shape({
  strings: import_prop_types.default.object,
  // eslint-disable-line react/forbid-prop-types
  pluralize: import_prop_types.default.func
});
var metaField = import_prop_types.default.shape({
  id: import_prop_types.default.string.isRequired,
  name: import_prop_types.default.string.isRequired,
  placeholder: import_prop_types.default.string
});
var metaFields = import_prop_types.default.oneOfType([import_prop_types.default.arrayOf(metaField), import_prop_types.default.func]);
var cssSize = import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.number]);

// ../../node_modules/@uppy/react/lib/getHTMLProps.js
var reactSupportedHtmlAttr = [
  // React-specific Attributes
  "defaultChecked",
  "defaultValue",
  "suppressContentEditableWarning",
  "suppressHydrationWarning",
  "dangerouslySetInnerHTML",
  // Standard HTML Attributes
  "accessKey",
  "className",
  "contentEditable",
  "contextMenu",
  "dir",
  "draggable",
  "hidden",
  "id",
  "lang",
  "placeholder",
  "slot",
  "spellCheck",
  "style",
  "tabIndex",
  "title",
  "translate",
  // Unknown
  "radioGroup",
  // WAI-ARIA
  "role",
  // RDFa Attributes
  "about",
  "datatype",
  "inlist",
  "prefix",
  "property",
  "resource",
  "typeof",
  "vocab",
  // Non-standard Attributes
  "autoCapitalize",
  "autoCorrect",
  "autoSave",
  "color",
  "itemProp",
  "itemScope",
  "itemType",
  "itemID",
  "itemRef",
  "results",
  "security",
  "unselectable",
  // Living Standard
  "inputMode",
  "is",
  // Clipboard Events
  "onCopy",
  "onCopyCapture",
  "onCut",
  "onCutCapture",
  "onPaste",
  "onPasteCapture",
  // Composition Events
  "onCompositionEnd",
  "onCompositionEndCapture",
  "onCompositionStart",
  "onCompositionStartCapture",
  "onCompositionUpdate",
  "onCompositionUpdateCapture",
  // Focus Events
  "onFocus",
  "onFocusCapture",
  "onBlur",
  "onBlurCapture",
  // Form Events
  "onChange",
  "onChangeCapture",
  "onBeforeInput",
  "onBeforeInputCapture",
  "onInput",
  "onInputCapture",
  "onReset",
  "onResetCapture",
  "onSubmit",
  "onSubmitCapture",
  "onInvalid",
  "onInvalidCapture",
  // Image Events
  "onLoad",
  "onLoadCapture",
  "onError",
  // also a Media Event
  "onErrorCapture",
  // also a Media Event
  // Keyboard Events
  "onKeyDown",
  "onKeyDownCapture",
  "onKeyPress",
  "onKeyPressCapture",
  "onKeyUp",
  "onKeyUpCapture",
  // Media Events
  "onAbort",
  "onAbortCapture",
  "onCanPlay",
  "onCanPlayCapture",
  "onCanPlayThrough",
  "onCanPlayThroughCapture",
  "onDurationChange",
  "onDurationChangeCapture",
  "onEmptied",
  "onEmptiedCapture",
  "onEncrypted",
  "onEncryptedCapture",
  "onEnded",
  "onEndedCapture",
  "onLoadedData",
  "onLoadedDataCapture",
  "onLoadedMetadata",
  "onLoadedMetadataCapture",
  "onLoadStart",
  "onLoadStartCapture",
  "onPause",
  "onPauseCapture",
  "onPlay",
  "onPlayCapture",
  "onPlaying",
  "onPlayingCapture",
  "onProgress",
  "onProgressCapture",
  "onRateChange",
  "onRateChangeCapture",
  "onSeeked",
  "onSeekedCapture",
  "onSeeking",
  "onSeekingCapture",
  "onStalled",
  "onStalledCapture",
  "onSuspend",
  "onSuspendCapture",
  "onTimeUpdate",
  "onTimeUpdateCapture",
  "onVolumeChange",
  "onVolumeChangeCapture",
  "onWaiting",
  "onWaitingCapture",
  // MouseEvents
  "onAuxClick",
  "onAuxClickCapture",
  "onClick",
  "onClickCapture",
  "onContextMenu",
  "onContextMenuCapture",
  "onDoubleClick",
  "onDoubleClickCapture",
  "onDrag",
  "onDragCapture",
  "onDragEnd",
  "onDragEndCapture",
  "onDragEnter",
  "onDragEnterCapture",
  "onDragExit",
  "onDragExitCapture",
  "onDragLeave",
  "onDragLeaveCapture",
  "onDragOver",
  "onDragOverCapture",
  "onDragStart",
  "onDragStartCapture",
  "onDrop",
  "onDropCapture",
  "onMouseDown",
  "onMouseDownCapture",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseMoveCapture",
  "onMouseOut",
  "onMouseOutCapture",
  "onMouseOver",
  "onMouseOverCapture",
  "onMouseUp",
  "onMouseUpCapture",
  // Selection Events
  "onSelect",
  "onSelectCapture",
  // Touch Events
  "onTouchCancel",
  "onTouchCancelCapture",
  "onTouchEnd",
  "onTouchEndCapture",
  "onTouchMove",
  "onTouchMoveCapture",
  "onTouchStart",
  "onTouchStartCapture",
  // Pointer Events
  "onPointerDown",
  "onPointerDownCapture",
  "onPointerMove",
  "onPointerMoveCapture",
  "onPointerUp",
  "onPointerUpCapture",
  "onPointerCancel",
  "onPointerCancelCapture",
  "onPointerEnter",
  "onPointerEnterCapture",
  "onPointerLeave",
  "onPointerLeaveCapture",
  "onPointerOver",
  "onPointerOverCapture",
  "onPointerOut",
  "onPointerOutCapture",
  "onGotPointerCapture",
  "onGotPointerCaptureCapture",
  "onLostPointerCapture",
  "onLostPointerCaptureCapture",
  // UI Events
  "onScroll",
  "onScrollCapture",
  // Wheel Events
  "onWheel",
  "onWheelCapture",
  // Animation Events
  "onAnimationStart",
  "onAnimationStartCapture",
  "onAnimationEnd",
  "onAnimationEndCapture",
  "onAnimationIteration",
  "onAnimationIterationCapture",
  // Transition Events
  "onTransitionEnd",
  "onTransitionEndCapture"
];
var validHTMLAttribute = /^(aria-|data-)/;
var getHTMLProps = (props) => {
  return Object.fromEntries(Object.entries(props).filter((_ref) => {
    let [key] = _ref;
    return validHTMLAttribute.test(key) || reactSupportedHtmlAttr.includes(key);
  }));
};
var getHTMLProps_default = getHTMLProps;

// ../../node_modules/@uppy/react/lib/nonHtmlPropsHaveChanged.js
function nonHtmlPropsHaveChanged(props, prevProps) {
  return Object.keys(props).some((key) => !Object.hasOwn(props, key) && props[key] !== prevProps[key]);
}

// ../../node_modules/@uppy/react/lib/Dashboard.js
var Dashboard3 = class extends Component {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const {
        uppy: uppy2,
        ...options
      } = {
        ...this.props,
        target: this.container
      };
      this.plugin.setOptions(options);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy2,
      ...options
    } = {
      id: "react:Dashboard",
      inline: true,
      ...this.props,
      target: this.container
    };
    uppy2.use(Dashboard2, options);
    this.plugin = uppy2.getPlugin(options.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy2
    } = props;
    uppy2.removePlugin(this.plugin);
  }
  render() {
    return h4("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
Dashboard3.propsTypes = {
  uppy,
  disableInformer: import_prop_types2.default.bool,
  disableStatusBar: import_prop_types2.default.bool,
  disableThumbnailGenerator: import_prop_types2.default.bool,
  height: cssSize,
  hideProgressAfterFinish: import_prop_types2.default.bool,
  hideUploadButton: import_prop_types2.default.bool,
  locale,
  metaFields,
  note: import_prop_types2.default.string,
  plugins,
  proudlyDisplayPoweredByUppy: import_prop_types2.default.bool,
  showProgressDetails: import_prop_types2.default.bool,
  width: cssSize,
  // pass-through to ThumbnailGenerator
  thumbnailType: import_prop_types2.default.string,
  thumbnailWidth: import_prop_types2.default.number
};
var Dashboard_default = Dashboard3;

// ../../node_modules/@uppy/react/lib/DashboardModal.js
var import_prop_types3 = __toESM(require_prop_types(), 1);
import { createElement as h5, Component as Component2 } from "react";
var DashboardModal = class extends Component2 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    const {
      uppy: uppy2,
      open,
      onRequestClose
    } = this.props;
    if (prevProps.uppy !== uppy2) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const {
        uppy: uppy3,
        ...options
      } = {
        ...this.props,
        inline: false,
        onRequestCloseModal: onRequestClose
      };
      this.plugin.setOptions(options);
    }
    if (prevProps.open && !open) {
      this.plugin.closeModal();
    } else if (!prevProps.open && open) {
      this.plugin.openModal();
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      target = this.container,
      open,
      onRequestClose,
      uppy: uppy2,
      ...rest
    } = this.props;
    const options = {
      ...rest,
      id: "react:DashboardModal",
      inline: false,
      target,
      open,
      onRequestCloseModal: onRequestClose
    };
    uppy2.use(Dashboard2, options);
    this.plugin = uppy2.getPlugin(options.id);
    if (open) {
      this.plugin.openModal();
    }
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy2
    } = props;
    uppy2.removePlugin(this.plugin);
  }
  render() {
    return h5("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
DashboardModal.propTypes = {
  uppy: uppy.isRequired,
  target: typeof window !== "undefined" ? import_prop_types3.default.instanceOf(window.HTMLElement) : import_prop_types3.default.any,
  open: import_prop_types3.default.bool,
  onRequestClose: import_prop_types3.default.func,
  closeModalOnClickOutside: import_prop_types3.default.bool,
  disablePageScrollWhenModalOpen: import_prop_types3.default.bool,
  plugins,
  width: cssSize,
  height: cssSize,
  showProgressDetails: import_prop_types3.default.bool,
  note: import_prop_types3.default.string,
  metaFields,
  proudlyDisplayPoweredByUppy: import_prop_types3.default.bool,
  autoOpenFileEditor: import_prop_types3.default.bool,
  animateOpenClose: import_prop_types3.default.bool,
  browserBackButtonClose: import_prop_types3.default.bool,
  closeAfterFinish: import_prop_types3.default.bool,
  disableStatusBar: import_prop_types3.default.bool,
  disableInformer: import_prop_types3.default.bool,
  disableThumbnailGenerator: import_prop_types3.default.bool,
  disableLocalFiles: import_prop_types3.default.bool,
  disabled: import_prop_types3.default.bool,
  hideCancelButton: import_prop_types3.default.bool,
  hidePauseResumeButton: import_prop_types3.default.bool,
  hideProgressAfterFinish: import_prop_types3.default.bool,
  hideRetryButton: import_prop_types3.default.bool,
  hideUploadButton: import_prop_types3.default.bool,
  showLinkToFileUploadResult: import_prop_types3.default.bool,
  showRemoveButtonAfterComplete: import_prop_types3.default.bool,
  showSelectedFiles: import_prop_types3.default.bool,
  waitForThumbnailsBeforeUpload: import_prop_types3.default.bool,
  fileManagerSelectionType: import_prop_types3.default.string,
  theme: import_prop_types3.default.string,
  // pass-through to ThumbnailGenerator
  thumbnailType: import_prop_types3.default.string,
  thumbnailWidth: import_prop_types3.default.number,
  locale
};
DashboardModal.defaultProps = {
  metaFields: [],
  plugins: [],
  width: 750,
  height: 550,
  thumbnailWidth: 280,
  thumbnailType: "image/jpeg",
  waitForThumbnailsBeforeUpload: false,
  showLinkToFileUploadResult: false,
  showProgressDetails: false,
  hideUploadButton: false,
  hideCancelButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideProgressAfterFinish: false,
  note: null,
  closeModalOnClickOutside: false,
  closeAfterFinish: false,
  disableStatusBar: false,
  disableInformer: false,
  disableThumbnailGenerator: false,
  disablePageScrollWhenModalOpen: true,
  animateOpenClose: true,
  fileManagerSelectionType: "files",
  proudlyDisplayPoweredByUppy: true,
  showSelectedFiles: true,
  showRemoveButtonAfterComplete: false,
  browserBackButtonClose: false,
  theme: "light",
  autoOpenFileEditor: false,
  disabled: false,
  disableLocalFiles: false,
  // extra
  open: void 0,
  target: void 0,
  locale: null,
  onRequestClose: void 0
};

// ../../node_modules/@uppy/react/lib/DragDrop.js
var import_prop_types4 = __toESM(require_prop_types(), 1);
import { createElement as h6, Component as Component3 } from "react";

// ../../node_modules/@uppy/drag-drop/lib/locale.js
var locale_default6 = {
  strings: {
    // Text to show on the droppable area.
    // `%{browse}` is replaced with a link that opens the system file selection dialog.
    dropHereOr: "Drop here or %{browse}",
    // Used as the label for the link that opens the system file selection dialog.
    browse: "browse"
  }
};

// ../../node_modules/@uppy/drag-drop/lib/DragDrop.js
var packageJson12 = {
  "version": "3.1.0"
};
var defaultOptions8 = {
  inputName: "files[]",
  width: "100%",
  height: "100%"
};
var DragDrop = class _DragDrop extends UIPlugin_default {
  constructor(uppy2, opts) {
    super(uppy2, {
      ...defaultOptions8,
      ...opts
    });
    this.isDragDropSupported = isDragDropSupported();
    this.addFiles = (files) => {
      const descriptors = files.map((file) => ({
        source: this.id,
        name: file.name,
        type: file.type,
        data: file,
        meta: {
          // path of the file relative to the ancestor directory the user selected.
          // e.g. 'docs/Old Prague/airbnb.pdf'
          relativePath: file.relativePath || null
        }
      }));
      try {
        this.uppy.addFiles(descriptors);
      } catch (err) {
        this.uppy.log(err);
      }
    };
    this.onInputChange = (event) => {
      const files = toArray_default(event.target.files);
      if (files.length > 0) {
        this.uppy.log("[DragDrop] Files selected through input");
        this.addFiles(files);
      }
      event.target.value = null;
    };
    this.handleDragOver = (event) => {
      var _this$opts$onDragOver, _this$opts;
      event.preventDefault();
      event.stopPropagation();
      const {
        types
      } = event.dataTransfer;
      const hasFiles = types.some((type) => type === "Files");
      const {
        allowNewUpload
      } = this.uppy.getState();
      if (!hasFiles || !allowNewUpload) {
        event.dataTransfer.dropEffect = "none";
        clearTimeout(this.removeDragOverClassTimeout);
        return;
      }
      event.dataTransfer.dropEffect = "copy";
      clearTimeout(this.removeDragOverClassTimeout);
      this.setPluginState({
        isDraggingOver: true
      });
      (_this$opts$onDragOver = (_this$opts = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
    };
    this.handleDragLeave = (event) => {
      var _this$opts$onDragLeav, _this$opts2;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.removeDragOverClassTimeout);
      this.removeDragOverClassTimeout = setTimeout(() => {
        this.setPluginState({
          isDraggingOver: false
        });
      }, 50);
      (_this$opts$onDragLeav = (_this$opts2 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
    };
    this.handleDrop = async (event) => {
      var _this$opts$onDrop, _this$opts3;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.removeDragOverClassTimeout);
      this.setPluginState({
        isDraggingOver: false
      });
      const logDropError = (error) => {
        this.uppy.log(error, "error");
      };
      const files = await getDroppedFiles(event.dataTransfer, {
        logDropError
      });
      if (files.length > 0) {
        this.uppy.log("[DragDrop] Files dropped");
        this.addFiles(files);
      }
      (_this$opts$onDrop = (_this$opts3 = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
    };
    this.type = "acquirer";
    this.id = this.opts.id || "DragDrop";
    this.title = "Drag & Drop";
    this.defaultLocale = locale_default6;
    this.i18nInit();
  }
  renderHiddenFileInput() {
    const {
      restrictions
    } = this.uppy.opts;
    return y("input", {
      className: "uppy-DragDrop-input",
      type: "file",
      hidden: true,
      ref: (ref) => {
        this.fileInputRef = ref;
      },
      name: this.opts.inputName,
      multiple: restrictions.maxNumberOfFiles !== 1,
      accept: restrictions.allowedFileTypes,
      onChange: this.onInputChange
    });
  }
  static renderArrowSvg() {
    return y("svg", {
      "aria-hidden": "true",
      focusable: "false",
      className: "uppy-c-icon uppy-DragDrop-arrow",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16"
    }, y("path", {
      d: "M11 10V0H5v10H2l6 6 6-6h-3zm0 0",
      fillRule: "evenodd"
    }));
  }
  renderLabel() {
    return y("div", {
      className: "uppy-DragDrop-label"
    }, this.i18nArray("dropHereOr", {
      browse: y("span", {
        className: "uppy-DragDrop-browse"
      }, this.i18n("browse"))
    }));
  }
  renderNote() {
    return y("span", {
      className: "uppy-DragDrop-note"
    }, this.opts.note);
  }
  render() {
    const dragDropClass = `uppy-u-reset
      uppy-DragDrop-container
      ${this.isDragDropSupported ? "uppy-DragDrop--isDragDropSupported" : ""}
      ${this.getPluginState().isDraggingOver ? "uppy-DragDrop--isDraggingOver" : ""}
    `;
    const dragDropStyle = {
      width: this.opts.width,
      height: this.opts.height
    };
    return y("button", {
      type: "button",
      className: dragDropClass,
      style: dragDropStyle,
      onClick: () => this.fileInputRef.click(),
      onDragOver: this.handleDragOver,
      onDragLeave: this.handleDragLeave,
      onDrop: this.handleDrop
    }, this.renderHiddenFileInput(), y("div", {
      className: "uppy-DragDrop-inner"
    }, _DragDrop.renderArrowSvg(), this.renderLabel(), this.renderNote()));
  }
  install() {
    const {
      target
    } = this.opts;
    this.setPluginState({
      isDraggingOver: false
    });
    if (target) {
      this.mount(target, this);
    }
  }
  uninstall() {
    this.unmount();
  }
};
DragDrop.VERSION = packageJson12.version;

// ../../node_modules/@uppy/react/lib/DragDrop.js
var DragDrop2 = class extends Component3 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const {
        uppy: uppy2,
        ...options
      } = {
        ...this.props,
        target: this.container
      };
      this.plugin.setOptions(options);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy2,
      locale: locale2,
      inputName,
      width,
      height,
      note
    } = this.props;
    const options = {
      id: "react:DragDrop",
      locale: locale2,
      inputName,
      width,
      height,
      note,
      target: this.container
    };
    uppy2.use(DragDrop, options);
    this.plugin = uppy2.getPlugin(options.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy2
    } = props;
    uppy2.removePlugin(this.plugin);
  }
  render() {
    return h6("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
DragDrop2.propTypes = {
  uppy: uppy.isRequired,
  locale,
  inputName: import_prop_types4.default.string,
  width: import_prop_types4.default.string,
  height: import_prop_types4.default.string,
  note: import_prop_types4.default.string
};
DragDrop2.defaultProps = {
  locale: null,
  inputName: "files[]",
  width: "100%",
  height: "100%",
  note: null
};

// ../../node_modules/@uppy/react/lib/ProgressBar.js
var import_prop_types5 = __toESM(require_prop_types(), 1);
import { createElement as h7, Component as Component4 } from "react";

// ../../node_modules/@uppy/progress-bar/lib/ProgressBar.js
var packageJson13 = {
  "version": "3.1.1"
};
var defaultOptions9 = {
  target: "body",
  fixed: false,
  hideAfterFinish: true
};
var ProgressBar = class extends UIPlugin_default {
  constructor(uppy2, opts) {
    super(uppy2, {
      ...defaultOptions9,
      ...opts
    });
    this.id = this.opts.id || "ProgressBar";
    this.title = "Progress Bar";
    this.type = "progressindicator";
    this.render = this.render.bind(this);
  }
  render(state) {
    const progress = state.totalProgress || 0;
    const isHidden = (progress === 0 || progress === 100) && this.opts.hideAfterFinish;
    return y("div", {
      className: "uppy uppy-ProgressBar",
      style: {
        position: this.opts.fixed ? "fixed" : "initial"
      },
      "aria-hidden": isHidden
    }, y("div", {
      className: "uppy-ProgressBar-inner",
      style: {
        width: `${progress}%`
      }
    }), y("div", {
      className: "uppy-ProgressBar-percentage"
    }, progress));
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }
  uninstall() {
    this.unmount();
  }
};
ProgressBar.VERSION = packageJson13.version;

// ../../node_modules/@uppy/react/lib/ProgressBar.js
var ProgressBar2 = class extends Component4 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const {
        uppy: uppy2,
        ...options
      } = {
        ...this.props,
        target: this.container
      };
      this.plugin.setOptions(options);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy2,
      fixed,
      hideAfterFinish
    } = this.props;
    const options = {
      id: "react:ProgressBar",
      fixed,
      hideAfterFinish,
      target: this.container
    };
    uppy2.use(ProgressBar, options);
    this.plugin = uppy2.getPlugin(options.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy2
    } = props;
    uppy2.removePlugin(this.plugin);
  }
  render() {
    return h7("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
ProgressBar2.propTypes = {
  uppy: uppy.isRequired,
  fixed: import_prop_types5.default.bool,
  hideAfterFinish: import_prop_types5.default.bool
};
ProgressBar2.defaultProps = {
  fixed: false,
  hideAfterFinish: true
};

// ../../node_modules/@uppy/react/lib/StatusBar.js
var import_prop_types6 = __toESM(require_prop_types(), 1);
import { createElement as h8, Component as Component5 } from "react";
var StatusBar3 = class extends Component5 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const {
        uppy: uppy2,
        ...options
      } = {
        ...this.props,
        target: this.container
      };
      this.plugin.setOptions(options);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy2,
      hideUploadButton,
      hideRetryButton,
      hidePauseResumeButton,
      hideCancelButton,
      showProgressDetails,
      hideAfterFinish,
      doneButtonHandler
    } = this.props;
    const options = {
      id: "react:StatusBar",
      hideUploadButton,
      hideRetryButton,
      hidePauseResumeButton,
      hideCancelButton,
      showProgressDetails,
      hideAfterFinish,
      doneButtonHandler,
      target: this.container
    };
    uppy2.use(StatusBar2, options);
    this.plugin = uppy2.getPlugin(options.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy2
    } = props;
    uppy2.removePlugin(this.plugin);
  }
  render() {
    return h8("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
StatusBar3.propTypes = {
  uppy: uppy.isRequired,
  hideUploadButton: import_prop_types6.default.bool,
  hideRetryButton: import_prop_types6.default.bool,
  hidePauseResumeButton: import_prop_types6.default.bool,
  hideCancelButton: import_prop_types6.default.bool,
  showProgressDetails: import_prop_types6.default.bool,
  hideAfterFinish: import_prop_types6.default.bool,
  doneButtonHandler: import_prop_types6.default.func
};
StatusBar3.defaultProps = {
  hideUploadButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideCancelButton: false,
  showProgressDetails: false,
  hideAfterFinish: true,
  doneButtonHandler: null
};

// ../../node_modules/@uppy/react/lib/FileInput.js
var import_prop_types7 = __toESM(require_prop_types(), 1);
import { createElement as h9, Component as Component6 } from "react";

// ../../node_modules/@uppy/file-input/lib/locale.js
var locale_default7 = {
  strings: {
    chooseFiles: "Choose files"
  }
};

// ../../node_modules/@uppy/file-input/lib/FileInput.js
var packageJson14 = {
  "version": "3.1.1"
};
var defaultOptions10 = {
  pretty: true,
  inputName: "files[]"
};
var FileInput = class extends UIPlugin_default {
  constructor(uppy2, opts) {
    super(uppy2, {
      ...defaultOptions10,
      ...opts
    });
    this.id = this.opts.id || "FileInput";
    this.title = "File Input";
    this.type = "acquirer";
    this.defaultLocale = locale_default7;
    this.i18nInit();
    this.render = this.render.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  addFiles(files) {
    const descriptors = files.map((file) => ({
      source: this.id,
      name: file.name,
      type: file.type,
      data: file
    }));
    try {
      this.uppy.addFiles(descriptors);
    } catch (err) {
      this.uppy.log(err);
    }
  }
  handleInputChange(event) {
    this.uppy.log("[FileInput] Something selected through input...");
    const files = toArray_default(event.target.files);
    this.addFiles(files);
    event.target.value = null;
  }
  handleClick() {
    this.input.click();
  }
  render() {
    const hiddenInputStyle = {
      width: "0.1px",
      height: "0.1px",
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      zIndex: -1
    };
    const {
      restrictions
    } = this.uppy.opts;
    const accept = restrictions.allowedFileTypes ? restrictions.allowedFileTypes.join(",") : void 0;
    return y("div", {
      className: "uppy-FileInput-container"
    }, y("input", {
      className: "uppy-FileInput-input",
      style: this.opts.pretty ? hiddenInputStyle : void 0,
      type: "file",
      name: this.opts.inputName,
      onChange: this.handleInputChange,
      multiple: restrictions.maxNumberOfFiles !== 1,
      accept,
      ref: (input) => {
        this.input = input;
      }
    }), this.opts.pretty && y("button", {
      className: "uppy-FileInput-btn",
      type: "button",
      onClick: this.handleClick
    }, this.i18n("chooseFiles")));
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }
  uninstall() {
    this.unmount();
  }
};
FileInput.VERSION = packageJson14.version;

// ../../node_modules/@uppy/react/lib/FileInput.js
var FileInput2 = class extends Component6 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy2,
      locale: locale2,
      pretty,
      inputName
    } = this.props;
    const options = {
      id: "react:FileInput",
      locale: locale2,
      pretty,
      inputName,
      target: this.container
    };
    uppy2.use(FileInput, options);
    this.plugin = uppy2.getPlugin(options.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy2
    } = props;
    uppy2.removePlugin(this.plugin);
  }
  render() {
    return h9("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      }
    });
  }
};
FileInput2.propTypes = {
  uppy: uppy.isRequired,
  locale,
  pretty: import_prop_types7.default.bool,
  inputName: import_prop_types7.default.string
};
FileInput2.defaultProps = {
  locale: void 0,
  pretty: true,
  inputName: "files[]"
};

// ../../node_modules/@uppy/react/lib/useUppy.js
import { useEffect as useEffect2, useRef } from "react";

// src/components/accounts/EmployerLogoUpload.tsx
import { useFragment as useFragment3, useRelayEnvironment } from "react-relay";
import {
  LogLevel,
  commitAsyncMutation,
  createClientMutationId as createClientMutationId3,
  useLogger,
  useUnhandledError
} from "shared-lib";
import { Button, ButtonList, Spinner } from "shared-ui";
import { Fragment as Fragment3, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var fragmentDef3 = EmployerLogoUploadFragment_graphql_default;
var EmployerLogoUpload = ({
  employer,
  employerId,
  onUploadStarted,
  onSuccess,
  onCancel
}) => {
  const [log] = useLogger();
  const [, setUnhandledError] = useUnhandledError();
  const [isLoading, setIsLoading] = useState3(false);
  const [signedUrl] = useEmployerLogoUpload();
  const [update, isUpdating] = useEmployerDetailsUpdate();
  const [mutationError, setMutationError] = useState3();
  const environment = useRelayEnvironment();
  const data = useFragment3(
    fragmentDef3,
    employer
  );
  const onSave = useCallback4(async (data2) => {
    const updateDetailsInput = {
      industry: data2.industry || "",
      website: data2.webSite || "",
      clientMutationId: createClientMutationId3(),
      details: data2.details || "",
      employerId,
      headOfficeAddress: "",
      logoUrl: data2.logoUrl || ""
    };
    try {
      const detailsResponse = await update({ input: updateDetailsInput });
      if (detailsResponse?.data?.userErrors && detailsResponse?.data?.userErrors.length > 0) {
        setMutationError(detailsResponse?.data?.userErrors?.[0]?.message);
      }
      if (detailsResponse?.data) {
        onSuccess();
      }
    } catch (error) {
      console.error("Error occurred during mutations", error);
      setMutationError("An error occurred while uploading logo.");
    }
  }, []);
  const uppy2 = new Uppy_default({
    restrictions: { maxNumberOfFiles: 1 }
  });
  uppy2.use(AwsS3, {
    async getUploadParameters(file) {
      setIsLoading(true);
      const data2 = await signedUrl({
        input: {
          employerId,
          clientMutationId: createClientMutationId3()
        }
      });
      return {
        method: "PUT",
        url: data2?.uploadUrl.payload || "",
        headers: {
          "Content-Type": file.type || "*/*"
        }
      };
    }
  });
  const [errors, setErrors] = useState3([]);
  uppy2.on("upload-error", (file, err) => {
    setErrors([err.message]);
    setIsLoading(false);
    setUnhandledError(err);
  });
  uppy2.on("upload-success", async (file) => {
    log("uppy upload success");
    onUploadStarted();
    if (!file) {
      log("Undefined file", LogLevel.ERROR);
      return;
    }
    const importResponse = await commitAsyncMutation(
      environment,
      UseEmployerLogoUploadGraphQL,
      {
        input: {
          employerId,
          clientMutationId: createClientMutationId3()
        }
      }
    );
    if (importResponse.uploadUrl.payload) {
      onSave({
        name: data.name,
        details: data.details || "",
        industry: data.industry || "",
        webSite: data.webSite || "",
        logoUrl: importResponse.uploadUrl.payload
      });
    }
  });
  return /* @__PURE__ */ jsx6("div", { className: "mx-5 flex flex-1 bg-gray-100 p-4", children: /* @__PURE__ */ jsxs5("div", { className: "flex h-fit w-full flex-col justify-between rounded-lg bg-white px-6 py-5 xl:border", children: [
    /* @__PURE__ */ jsx6("div", { className: "pb-2 sm:flex sm:items-center sm:justify-between", children: /* @__PURE__ */ jsx6("h1", { className: "text-info-900 p-2 text-2xl", children: "Upload your Logo" }) }),
    /* @__PURE__ */ jsx6("div", { className: "relative flex w-full justify-center", children: /* @__PURE__ */ jsxs5("div", { className: "flex w-full flex-col justify-center gap-5 sm:w-[750px]", children: [
      mutationError && /* @__PURE__ */ jsx6("div", { children: mutationError }),
      /* @__PURE__ */ jsx6(Error2, { errors }),
      /* @__PURE__ */ jsx6(
        Dashboard_default,
        {
          style: { width: "100%", display: isLoading ? "none" : "auto" },
          width: "100%",
          hideUploadButton: false,
          showSelectedFiles: true,
          showProgressDetails: true,
          proudlyDisplayPoweredByUppy: false,
          uppy: uppy2
        }
      ),
      isLoading && /* @__PURE__ */ jsx6("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx6(Spinner, {}) })
    ] }) }),
    /* @__PURE__ */ jsx6(ButtonList, { children: /* @__PURE__ */ jsx6("div", { children: /* @__PURE__ */ jsx6(
      Button,
      {
        "aria-label": "Cancel upload logo",
        color: "gray",
        disabled: isLoading || isUpdating,
        onClick: onCancel,
        className: "mt-4",
        children: "Cancel"
      }
    ) }) })
  ] }) });
};
var Error2 = function(props) {
  if (props.errors.length == 0) {
    return /* @__PURE__ */ jsx6(Fragment3, {});
  }
  return /* @__PURE__ */ jsx6("div", { className: "bg-danger-50 rounded-md p-4", children: /* @__PURE__ */ jsxs5("div", { className: "flex", children: [
    /* @__PURE__ */ jsx6("div", { className: "flex-shrink-0", children: /* @__PURE__ */ jsx6(XCircleIcon, { className: "text-danger-400 h-5 w-5", "aria-hidden": "true" }) }),
    /* @__PURE__ */ jsxs5("div", { className: "ml-3", children: [
      /* @__PURE__ */ jsxs5("h3", { className: "text-danger-800 text-sm font-medium", children: [
        "There ",
        props.errors.length == 1 ? "is" : "are",
        " ",
        props.errors.length,
        "error",
        props.errors.length == 1 ? "" : "s",
        " with your submission"
      ] }),
      /* @__PURE__ */ jsx6("div", { className: "text-danger-700 mt-2 text-sm", children: /* @__PURE__ */ jsx6("ul", { role: "list", className: "list-disc space-y-1 pl-5", children: props.errors.map((x4, key) => {
        return /* @__PURE__ */ jsx6("li", { children: x4 }, key);
      }) }) })
    ] })
  ] }) });
};

// src/components/accounts/EmployerDetails.tsx
import { Fragment as Fragment4, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var queryDef2 = EmployerDetailsQuery_graphql_default;
async function loader(environment, params, context) {
  const employerId = resolveEmployerId(params, context);
  const queryRef = loadQuery(environment, queryDef2, {
    id: employerId
  });
  return {
    employerId,
    queryRef
  };
}
function useRouteData(routeId) {
  const { employerId, queryRef } = useRouteLoaderData(routeId);
  const query = usePreloadedQuery(queryDef2, queryRef);
  return {
    employerId,
    query
  };
}
var EmployerDetails = ({ routeId }) => {
  const { query, employerId } = useRouteData(routeId);
  const { employer } = query;
  const [log] = useLogger2();
  const [isEditingDetails, toggleIsEditingDetails] = useToggle();
  const [isEditingLogo, toggleIsEditingLogo] = useToggle();
  if (!employer) {
    return /* @__PURE__ */ jsx7(EdSkeleton, {});
  }
  const renderEmployerComponent = (employer2) => {
    switch (true) {
      case isEditingLogo:
        return /* @__PURE__ */ jsx7(
          EmployerLogoUpload,
          {
            employer: employer2,
            employerId,
            onUploadStarted: () => log("LogoUpload Upload Started"),
            onSuccess: toggleIsEditingLogo,
            onCancel: toggleIsEditingLogo
          }
        );
      case isEditingDetails:
        return /* @__PURE__ */ jsx7(
          EmployerDetailsEdit,
          {
            employerFragmentRef: employer2,
            onCancel: toggleIsEditingDetails,
            onDone: toggleIsEditingDetails,
            employerId
          }
        );
      default:
        return /* @__PURE__ */ jsxs6(Fragment4, { children: [
          /* @__PURE__ */ jsx7(
            EmployerLogoView,
            {
              employer: employer2,
              onEdit: toggleIsEditingLogo
            }
          ),
          /* @__PURE__ */ jsx7(
            EmployerDetailsView,
            {
              employer: employer2,
              onEdit: toggleIsEditingDetails
            }
          )
        ] });
    }
  };
  return /* @__PURE__ */ jsx7(Suspense, { fallback: /* @__PURE__ */ jsx7(EdSkeleton, {}), children: /* @__PURE__ */ jsx7("div", { className: "mt-5 flex flex-col xl:container", children: /* @__PURE__ */ jsxs6("div", { className: "flex flex-col ", children: [
    /* @__PURE__ */ jsx7("h1", { className: "text-md mb-3 grow px-10 font-bold text-gray-600 sm:text-2xl", children: "Employer Details" }),
    renderEmployerComponent(employer)
  ] }) }) });
};
var createEmployerDetailsRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-employer-details`;
  return [
    {
      path: "*",
      id: routeId,
      element: /* @__PURE__ */ jsx7(EmployerDetails, { routeId }),
      errorElement: /* @__PURE__ */ jsx7(ErrorContainer, {}),
      loader: ({ params }) => {
        return loader(environment, params, context);
      }
    }
  ];
};

// src/components/accounts/EmployerEmailConfigurationForm.tsx
import { useCallback as useCallback5 } from "react";
import * as zod3 from "zod";
import { useForm as useForm3 } from "react-hook-form";
import { zodResolver as zodResolver3 } from "@hookform/resolvers/zod";
import { Suspense as Suspense2 } from "shared-ui";
import { createClientMutationId as createClientMutationId4, useUserErrorCode as useUserErrorCode3 } from "shared-lib";
import {
  ActionContainer as ActionContainer3,
  EdSkeleton as EdSkeleton2,
  ErrorField as ErrorField3,
  FormInputRow as FormInputRow3,
  InputField as InputField2
} from "shared-ui";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var formSchema3 = zod3.object({
  email: zod3.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  })
});
var EmployerEmailConfigurationForm = ({
  employerId,
  onDone
}) => {
  const { register, handleSubmit, formState } = useForm3({
    resolver: zodResolver3(formSchema3),
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode3();
  const [setEmail, isSettingEmail] = useEmployerEmailsSendingAddressChange();
  const onSetCompany = useCallback5(
    async (form) => {
      const input = {
        email: form.email,
        clientMutationId: createClientMutationId4(),
        employerId
      };
      const response = await setEmail({ input });
      if (response.data.payload) {
        onDone();
      }
    },
    [setEmail]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSetCompany(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  return /* @__PURE__ */ jsxs7(Suspense2, { fallback: /* @__PURE__ */ jsx8(EdSkeleton2, {}), children: [
    userErrorCode && /* @__PURE__ */ jsxs7("div", { children: [
      "Error Code: ",
      userErrorCode
    ] }),
    /* @__PURE__ */ jsx8("form", { onSubmit, children: /* @__PURE__ */ jsx8(
      ActionContainer3,
      {
        isDirty,
        showSubmit: true,
        submitText: "Save Email",
        showCancel: true,
        isDisabled: !isValid,
        isSaving: isSettingEmail,
        titleTop: `Update Sending Email`,
        children: /* @__PURE__ */ jsxs7(FormInputRow3, { name: "email", title: "Email *", children: [
          /* @__PURE__ */ jsx8(
            InputField2,
            {
              "aria-label": "Enter Sending Email",
              register,
              name: "email",
              required: true,
              placeholder: "Sending Email"
            }
          ),
          /* @__PURE__ */ jsx8(ErrorField3, { field: errors.email })
        ] })
      }
    ) })
  ] });
};

// src/components/accounts/__generated__/EmployerLocationsQuery.graphql.ts
var node34 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "webSite",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "details",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerOfficeLocationId",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerLocationsQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerById",
          "plural": false,
          "selections": [
            v22,
            v32,
            v4,
            v5,
            v6,
            v7,
            {
              "alias": null,
              "args": null,
              "concreteType": "EmployerOfficeLocation",
              "kind": "LinkedField",
              "name": "officeLocations",
              "plural": true,
              "selections": [
                v22,
                v4,
                v8,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EmployerLocationDetailsEditor_location"
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerLocationsQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerById",
          "plural": false,
          "selections": [
            v22,
            v32,
            v4,
            v5,
            v6,
            v7,
            {
              "alias": null,
              "args": null,
              "concreteType": "EmployerOfficeLocation",
              "kind": "LinkedField",
              "name": "officeLocations",
              "plural": true,
              "selections": [
                v22,
                v4,
                v8,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OfficeLocationAddress",
                  "kind": "LinkedField",
                  "name": "address",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "line1",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "line2",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "city",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "county",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "country",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "postCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v9
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fc0fb92fa8b0f5667de7961d3313a96f",
      "id": null,
      "metadata": {},
      "name": "EmployerLocationsQuery",
      "operationKind": "query",
      "text": "query EmployerLocationsQuery(\n  $id: UUID!\n) {\n  employer: accountsEmployerById(id: $id) {\n    id\n    employerId\n    name\n    webSite\n    industry\n    details\n    officeLocations {\n      id\n      name\n      employerOfficeLocationId\n      ...EmployerLocationDetailsEditor_location\n    }\n  }\n}\n\nfragment EmployerLocationDetailsEditor_location on EmployerOfficeLocation {\n  id\n  name\n  address {\n    line1\n    line2\n    city\n    county\n    country\n    postCode\n  }\n}\n"
    }
  };
}();
node34.hash = "e5bcb518dd0a2c20c18c79dffebf6967";
var EmployerLocationsQuery_graphql_default = node34;

// src/components/accounts/__generated__/EmployerLocationsRemoveMutation.graphql.ts
var node35 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": "data",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "AccountsEmployerOfficeRemoveLocationPayload",
      "kind": "LinkedField",
      "name": "accountsEmployerOfficeRemoveLocation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfOfficeLocation",
          "kind": "LinkedField",
          "name": "location",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmployerOfficeLocation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OfficeLocationAddress",
                  "kind": "LinkedField",
                  "name": "address",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "line1",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "line2",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "city",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "county",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "country",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "postCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerLocationsRemoveMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerLocationsRemoveMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "bf034b44fb3608a5aa976b2490ee058a",
      "id": null,
      "metadata": {},
      "name": "EmployerLocationsRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation EmployerLocationsRemoveMutation(\n  $input: AccountsEmployerOfficeRemoveLocationInput!\n) {\n  data: accountsEmployerOfficeRemoveLocation(input: $input) {\n    location {\n      node {\n        id\n        name\n        code\n        updatedAt\n        createdAt\n        address {\n          line1\n          line2\n          city\n          county\n          country\n          postCode\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node35.hash = "dfedc2d413978820766630e637c5baab";
var EmployerLocationsRemoveMutation_graphql_default = node35;

// src/components/accounts/EmployerLocations.tsx
import { useState as useState5 } from "react";
import {
  loadQuery as loadQuery2,
  useMutation,
  usePreloadedQuery as usePreloadedQuery2
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData2 } from "react-router-dom";
import { Suspense as Suspense5 } from "shared-ui";
import { resolveEmployerId as resolveEmployerId2 } from "app-core";
import { useToggle as useToggle2 } from "shared-lib";
import { Button as Button4, EdSkeleton as EdSkeleton5, ErrorContainer as ErrorContainer2 } from "shared-ui";

// src/components/accounts/__generated__/EmployerLocationDetailsQuery.graphql.ts
var node36 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerOfficeLocationId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerLocationDetailsQuery",
      "selections": [
        {
          "alias": "officeLocations",
          "args": v1,
          "concreteType": "EmployerOfficeLocation",
          "kind": "LinkedField",
          "name": "accountOfficeLocationByNodeId",
          "plural": false,
          "selections": [
            v22,
            v32,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerLocationDetailsEditor_location"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerLocationDetailsView_location"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerLocationDetailsQuery",
      "selections": [
        {
          "alias": "officeLocations",
          "args": v1,
          "concreteType": "EmployerOfficeLocation",
          "kind": "LinkedField",
          "name": "accountOfficeLocationByNodeId",
          "plural": false,
          "selections": [
            v22,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "OfficeLocationAddress",
              "kind": "LinkedField",
              "name": "address",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "line1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "line2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "city",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "county",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "country",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "postCode",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "221e5a04a89b87a061592d6bbca56147",
      "id": null,
      "metadata": {},
      "name": "EmployerLocationDetailsQuery",
      "operationKind": "query",
      "text": "query EmployerLocationDetailsQuery(\n  $id: ID!\n) {\n  officeLocations: accountOfficeLocationByNodeId(id: $id) {\n    id\n    name\n    employerOfficeLocationId\n    ...EmployerLocationDetailsEditor_location\n    ...EmployerLocationDetailsView_location\n  }\n}\n\nfragment EmployerLocationDetailsEditor_location on EmployerOfficeLocation {\n  id\n  name\n  address {\n    line1\n    line2\n    city\n    county\n    country\n    postCode\n  }\n}\n\nfragment EmployerLocationDetailsView_location on EmployerOfficeLocation {\n  id\n  name\n  address {\n    line1\n    line2\n    city\n    county\n    country\n    postCode\n  }\n}\n"
    }
  };
}();
node36.hash = "381cbae316be2bacd8eef7e2838f2c39";
var EmployerLocationDetailsQuery_graphql_default = node36;

// src/components/accounts/EmployerLocationDetails.tsx
import { Suspense as Suspense4 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery3 } from "react-relay";
import { EdSkeleton as EdSkeleton4 } from "shared-ui";

// src/components/accounts/__generated__/EmployerLocationDetailsView_location.graphql.ts
var node37 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerLocationDetailsView_location",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OfficeLocationAddress",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "county",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployerOfficeLocation",
  "abstractKey": null
};
node37.hash = "e1f46db700c48fe3882af3523906108c";
var EmployerLocationDetailsView_location_graphql_default = node37;

// src/components/accounts/EmployerLocationDetailsView.tsx
import { useFragment as useFragment4 } from "react-relay";
import { Button as Button2, Size } from "shared-ui";
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var fragmentDef4 = EmployerLocationDetailsView_location_graphql_default;
var EmployerLocationDetailsView = ({
  onCancel,
  fragmentRef,
  onEdit
}) => {
  const data = useFragment4(
    fragmentDef4,
    fragmentRef
  );
  return /* @__PURE__ */ jsx9("div", { className: "flex justify-between p-4", children: /* @__PURE__ */ jsx9("div", { className: "flex flex-1 lg:mx-5", children: /* @__PURE__ */ jsxs8("div", { className: "flex w-full flex-col rounded-lg bg-white px-6 py-5 xl:border", children: [
    /* @__PURE__ */ jsx9("div", { className: "flex justify-end", children: /* @__PURE__ */ jsx9(
      Button2,
      {
        "aria-label": "Edit location",
        color: "primary",
        size: Size.md,
        onClick: onEdit,
        children: "Edit"
      }
    ) }),
    /* @__PURE__ */ jsxs8("div", { className: "flex flex-col justify-center gap-8", children: [
      /* @__PURE__ */ jsxs8("div", { className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4", children: [
        /* @__PURE__ */ jsx9("label", { className: "text-gray-600", children: "Name: " }),
        data?.name
      ] }),
      /* @__PURE__ */ jsxs8("div", { className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4", children: [
        /* @__PURE__ */ jsx9("label", { className: "text-gray-600", children: "Address Line 1: " }),
        data?.address?.line1
      ] }),
      /* @__PURE__ */ jsxs8("div", { className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4", children: [
        /* @__PURE__ */ jsx9("label", { className: "text-gray-600", children: "Address Line 2: " }),
        data?.address?.line2
      ] }),
      /* @__PURE__ */ jsxs8("div", { className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4", children: [
        /* @__PURE__ */ jsx9("label", { className: "text-gray-600", children: "City: " }),
        data?.address?.city
      ] }),
      /* @__PURE__ */ jsxs8("div", { className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4", children: [
        /* @__PURE__ */ jsx9("label", { className: "text-gray-600", children: "County: " }),
        data?.address?.county
      ] }),
      /* @__PURE__ */ jsxs8("div", { className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4", children: [
        /* @__PURE__ */ jsx9("label", { className: "text-gray-600", children: "Postal Code: " }),
        data?.address?.postCode
      ] }),
      /* @__PURE__ */ jsxs8("div", { className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4", children: [
        /* @__PURE__ */ jsx9("label", { className: "text-gray-600", children: "Country: " }),
        data?.address?.country
      ] })
    ] }),
    /* @__PURE__ */ jsx9("div", { className: "mt-4 flex items-center justify-end", children: /* @__PURE__ */ jsx9(
      Button2,
      {
        "aria-label": "Cancel location",
        color: "gray",
        size: Size.md,
        onClick: onCancel,
        children: "Cancel"
      }
    ) })
  ] }) }) });
};

// src/components/accounts/__generated__/EmployerLocationDetailsEditor_location.graphql.ts
var node38 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerLocationDetailsEditor_location",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OfficeLocationAddress",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "county",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "EmployerOfficeLocation",
  "abstractKey": null
};
node38.hash = "8860c0ffc1ae0e2b8e64dd030187ab1c";
var EmployerLocationDetailsEditor_location_graphql_default = node38;

// src/components/accounts/EmployerLocationDetailsEditor.tsx
import { useCallback as useCallback6, useState as useState4 } from "react";
import { zodResolver as zodResolver4 } from "@hookform/resolvers/zod";
import { useForm as useForm4 } from "react-hook-form";
import { useFragment as useFragment5 } from "react-relay";
import * as zod4 from "zod";
import { createClientMutationId as createClientMutationId5, useUserErrorCode as useUserErrorCode4 } from "shared-lib";
import {
  ActionContainer as ActionContainer4,
  AlertMessage as AlertMessage2,
  EdSkeleton as EdSkeleton3,
  ErrorField as ErrorField4,
  FormInput as FormInput2,
  FormInputRow as FormInputRow4,
  Suspense as Suspense3
} from "shared-ui";
import { jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var fragmentDef5 = EmployerLocationDetailsEditor_location_graphql_default;
var formSchema4 = zod4.object({
  name: zod4.string().min(1, { message: "Name cannot be blank" }),
  addressLine1: zod4.string().min(1, { message: "Address line 1 cannot be blank" }),
  addressLine2: zod4.string().optional(),
  city: zod4.string().min(1, { message: "City cannot be blank" }),
  county: zod4.string().min(1, { message: "County cannot be blank" }),
  postalCode: zod4.string().min(1, { message: "Postal Code cannot be blank" }),
  country: zod4.string().min(1, { message: "Country cannot be blank" })
});
var EmployerLocationDetailsEditor = ({
  fragmentRef,
  editLocation,
  create,
  isCreating,
  update,
  isUpdating,
  onCancel,
  employerId,
  locationDetails,
  setLocationDetails
}) => {
  const data = useFragment5(
    fragmentDef5,
    fragmentRef
  );
  const [mutationErrors, setMutationErrors] = useState4([]);
  const errorCode = useUserErrorCode4();
  const defaultValues = {
    name: data?.name || "",
    addressLine1: data?.address?.line1 || "",
    addressLine2: data?.address?.line2 || "",
    city: data?.address?.city || "",
    county: data?.address?.county || "",
    postalCode: data?.address?.postCode || "",
    country: data?.address?.country || ""
  };
  const { register, handleSubmit, formState } = useForm4({
    resolver: zodResolver4(formSchema4),
    defaultValues
  });
  const { errors, isValid, isDirty } = formState;
  const onSave = useCallback6(
    async (isValid2, form, editLocation2) => {
      if (!isValid2 || !form?.name || !form?.addressLine1 || !form?.city || !form?.county || !form?.postalCode || !form?.country) {
        return;
      }
      if (editLocation2 && update) {
        const input = {
          id: locationDetails?.employerOfficeLocationId,
          employerId,
          clientMutationId: createClientMutationId5(),
          name: form.name,
          line1: form.addressLine1,
          line2: form.addressLine2,
          city: form.city,
          county: form.county,
          postCode: form.postalCode,
          country: form.country
        };
        const result = await update({
          input
        });
        if (result?.data?.employer) {
          setLocationDetails({
            open: false,
            locationId: "",
            employerOfficeLocationId: ""
          });
          return;
        }
        if (result?.data?.userErrors) {
          setMutationErrors(result.data?.userErrors);
          return;
        }
      } else if (create) {
        const input = {
          employerId,
          clientMutationId: createClientMutationId5(),
          name: form.name,
          line1: form.addressLine1,
          line2: form.addressLine2,
          city: form.city,
          county: form.county,
          postCode: form.postalCode,
          country: form.country
        };
        const result = await create({
          input
        });
        if (result?.data?.employer) {
          setLocationDetails({
            open: false,
            locationId: "",
            employerOfficeLocationId: ""
          });
          return;
        }
        if (result?.data?.userErrors) {
          setMutationErrors(result.data?.userErrors);
          return;
        }
      }
    },
    [
      locationDetails?.employerOfficeLocationId,
      employerId,
      create,
      update,
      setLocationDetails,
      setMutationErrors
    ]
  );
  return /* @__PURE__ */ jsx10(Suspense3, { fallback: /* @__PURE__ */ jsx10(EdSkeleton3, {}), children: /* @__PURE__ */ jsx10("div", { className: "flex flex-1 bg-gray-100 lg:mx-5", children: /* @__PURE__ */ jsx10("div", { className: "flex w-full justify-between p-4", children: /* @__PURE__ */ jsxs9(
    ActionContainer4,
    {
      onSubmit: handleSubmit((data2) => onSave(isValid, data2, editLocation)),
      onCancel,
      showCancel: true,
      isSaving: isUpdating,
      isDirty,
      children: [
        errorCode && /* @__PURE__ */ jsx10(AlertMessage2, { message: "An error has occurred" }),
        /* @__PURE__ */ jsxs9(FormInputRow4, { name: "name", title: "Name", children: [
          /* @__PURE__ */ jsx10(
            FormInput2,
            {
              "aria-label": "name",
              type: "text",
              name: "name",
              placeholder: "Name",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx10(ErrorField4, { field: errors.name })
        ] }),
        /* @__PURE__ */ jsxs9(FormInputRow4, { name: "addressLine1", title: "Address Line 1", children: [
          /* @__PURE__ */ jsx10(
            FormInput2,
            {
              "aria-label": "Address Line 1",
              type: "text",
              name: "addressLine1",
              placeholder: "Address Line 1",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx10(ErrorField4, { field: errors.addressLine1 })
        ] }),
        /* @__PURE__ */ jsxs9(FormInputRow4, { name: "addressLine2", title: "Address Line 2", children: [
          /* @__PURE__ */ jsx10(
            FormInput2,
            {
              "aria-label": "Address Line 2",
              type: "text",
              name: "addressLine2",
              placeholder: "Address Line 2",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx10(ErrorField4, { field: errors.addressLine2 })
        ] }),
        /* @__PURE__ */ jsxs9(FormInputRow4, { name: "city", title: "City", children: [
          /* @__PURE__ */ jsx10(
            FormInput2,
            {
              "aria-label": "City",
              type: "text",
              name: "city",
              placeholder: "City",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx10(ErrorField4, { field: errors.city })
        ] }),
        /* @__PURE__ */ jsxs9(FormInputRow4, { name: "county", title: "County", children: [
          /* @__PURE__ */ jsx10(
            FormInput2,
            {
              "aria-label": "County",
              type: "text",
              name: "county",
              placeholder: "County",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx10(ErrorField4, { field: errors.county })
        ] }),
        /* @__PURE__ */ jsxs9(FormInputRow4, { name: "postalCode", title: "Postal Code", children: [
          /* @__PURE__ */ jsx10(
            FormInput2,
            {
              "aria-label": "Postal Code",
              type: "text",
              name: "postalCode",
              placeholder: "Postal Code",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx10(ErrorField4, { field: errors.postalCode })
        ] }),
        /* @__PURE__ */ jsxs9(FormInputRow4, { name: "country", title: "Country", children: [
          /* @__PURE__ */ jsx10(
            FormInput2,
            {
              "aria-label": "Country",
              type: "text",
              name: "country",
              placeholder: "Country",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx10(ErrorField4, { field: errors.country })
        ] })
      ]
    }
  ) }) }) });
};

// src/components/accounts/EmployerLocationDetails.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var queryDef3 = EmployerLocationDetailsQuery_graphql_default;
var EmployerLocationDetails = ({
  onCancel,
  isEditing,
  employerId,
  isUpdating,
  updateLocation,
  toggleIsEditing,
  locationDetails,
  setLocationDetails
}) => {
  const locationData = useLazyLoadQuery3(
    queryDef3,
    { id: locationDetails.locationId },
    { fetchPolicy: "store-and-network" }
  );
  if (locationData === null || locationData === void 0) {
    return /* @__PURE__ */ jsx11(EdSkeleton4, {});
  }
  return /* @__PURE__ */ jsx11("div", { children: isEditing ? /* @__PURE__ */ jsx11(Suspense4, { fallback: /* @__PURE__ */ jsx11(EdSkeleton4, {}), children: /* @__PURE__ */ jsx11(
    EmployerLocationDetailsEditor,
    {
      editLocation: true,
      fragmentRef: locationData?.officeLocations,
      update: updateLocation,
      isUpdating,
      onCancel: toggleIsEditing,
      employerId,
      locationDetails,
      setLocationDetails
    },
    locationData?.officeLocations?.id
  ) }) : /* @__PURE__ */ jsx11(Suspense4, { fallback: /* @__PURE__ */ jsx11(EdSkeleton4, {}), children: /* @__PURE__ */ jsx11(
    EmployerLocationDetailsView,
    {
      onCancel,
      fragmentRef: locationData?.officeLocations,
      onEdit: toggleIsEditing
    }
  ) }) });
};

// src/components/accounts/EmployerLocationsRemoveDialog.tsx
import { Fragment as Fragment5 } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Button as Button3 } from "shared-ui";
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var EmployerLocationsRemoveDialog = ({
  showDialog,
  onCancel,
  onConfirm
}) => {
  return /* @__PURE__ */ jsx12("div", { children: /* @__PURE__ */ jsx12(Transition, { appear: true, show: showDialog, as: Fragment5, children: /* @__PURE__ */ jsxs10(Dialog, { as: "div", className: "relative z-10", onClose: onCancel, children: [
    /* @__PURE__ */ jsx12(
      Transition.Child,
      {
        as: Fragment5,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /* @__PURE__ */ jsx12("div", { className: "fixed inset-0 bg-black bg-opacity-25" })
      }
    ),
    /* @__PURE__ */ jsx12("div", { className: "fixed inset-0 overflow-y-auto", children: /* @__PURE__ */ jsx12("div", { className: "flex min-h-full items-center justify-center p-4 text-center", children: /* @__PURE__ */ jsx12(
      Transition.Child,
      {
        as: Fragment5,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95",
        children: /* @__PURE__ */ jsxs10(Dialog.Panel, { className: "w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all", children: [
          /* @__PURE__ */ jsx12(Dialog.Title, { className: "text-center text-2xl text-gray-900", children: "Are you sure you want to delete this location?" }),
          /* @__PURE__ */ jsxs10("div", { className: "m-5 flex justify-center gap-3", children: [
            /* @__PURE__ */ jsx12("div", { children: /* @__PURE__ */ jsx12(Button3, { color: "primary", onClick: onConfirm, children: "Confirm" }) }),
            /* @__PURE__ */ jsx12("div", { children: /* @__PURE__ */ jsx12(Button3, { color: "gray", onClick: onCancel, children: "Cancel" }) })
          ] })
        ] })
      }
    ) }) })
  ] }) }) });
};

// src/components/accounts/EmployerLocations.tsx
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var queryDef4 = EmployerLocationsQuery_graphql_default;
var mutationDef26 = EmployerLocationsRemoveMutation_graphql_default;
async function loader2(environment, params, context) {
  const employerId = resolveEmployerId2(params, context);
  const queryRef = loadQuery2(environment, queryDef4, {
    id: employerId
  });
  return {
    employerId,
    queryRef
  };
}
function useRouteData2(routeId) {
  const { employerId, queryRef } = useRouteLoaderData2(routeId);
  const query = usePreloadedQuery2(queryDef4, queryRef);
  return {
    employerId,
    query
  };
}
var RenderLocationList = ({
  employer,
  toggleCreateLocationStatus,
  setLocationDetails
}) => {
  const [openModal, toggleModal] = useToggle2();
  const [locationIdToDelete, setLocationIdToDelete] = useState5("");
  const [commitMutation, isRemoving] = useMutation(mutationDef26);
  const handleRemoveLocation = (locationId) => {
    const input = {
      id: locationId
    };
    commitMutation({
      variables: { input },
      updater: (store) => {
        if (locationId) {
          const application = store.get(locationId);
          application?.invalidateRecord();
        }
      }
    });
  };
  const toggleOpenModal = (locationId) => {
    setLocationIdToDelete(locationId);
    toggleModal();
  };
  const confirmDeleteLocation = () => {
    if (locationIdToDelete) {
      handleRemoveLocation(locationIdToDelete);
      setLocationIdToDelete("");
      toggleModal();
    }
  };
  return employer?.officeLocations?.length === 0 ? /* @__PURE__ */ jsx13("div", { className: "mx-5 flex h-96 bg-gray-100 p-4", children: /* @__PURE__ */ jsx13("div", { className: "flex w-full justify-between rounded-lg bg-white px-6 py-5 xl:border", children: /* @__PURE__ */ jsxs11("div", { className: "flex w-full flex-col items-center justify-center gap-4", children: [
    /* @__PURE__ */ jsx13("h1", { className: "text-center text-2xl font-semibold", children: "You haven't set an organization location" }),
    /* @__PURE__ */ jsx13(Button4, { color: "primary", onClick: toggleCreateLocationStatus, children: "Add new Location" })
  ] }) }) }) : /* @__PURE__ */ jsx13("div", { className: "mx-5 flex bg-gray-100 p-4", children: /* @__PURE__ */ jsx13("div", { className: "flex w-full justify-between rounded-lg bg-white px-6 py-5 xl:border", children: /* @__PURE__ */ jsxs11("div", { className: "flex w-full flex-col gap-4", children: [
    /* @__PURE__ */ jsx13("div", { className: "flex w-full justify-end", children: /* @__PURE__ */ jsx13(Button4, { color: "primary", onClick: toggleCreateLocationStatus, children: "Add new Location" }) }),
    /* @__PURE__ */ jsx13(
      EmployerLocationsRemoveDialog,
      {
        showDialog: openModal,
        onCancel: toggleModal,
        onConfirm: confirmDeleteLocation
      }
    ),
    employer?.officeLocations?.map((location2) => /* @__PURE__ */ jsxs11(
      "div",
      {
        className: "flex w-full flex-col items-center justify-between gap-4 border border-gray-300 p-4 lg:flex-row",
        children: [
          /* @__PURE__ */ jsx13("h3", { className: "text-center text-xl font-semibold", children: location2?.name }),
          /* @__PURE__ */ jsxs11("div", { className: "flex gap-4", children: [
            /* @__PURE__ */ jsx13(
              Button4,
              {
                color: "primary",
                onClick: () => setLocationDetails({
                  open: true,
                  locationId: location2?.id,
                  employerOfficeLocationId: location2?.employerOfficeLocationId
                }),
                children: "Edit"
              }
            ),
            /* @__PURE__ */ jsx13(
              Button4,
              {
                color: "danger",
                onClick: () => toggleOpenModal(location2.employerOfficeLocationId),
                disabled: isRemoving,
                children: "Delete"
              }
            )
          ] })
        ]
      },
      location2?.id
    ))
  ] }) }) });
};
var EmployerLocations = ({ routeId }) => {
  const { query, employerId } = useRouteData2(routeId);
  const { employer } = query;
  const [isEditing, toggleIsEditing] = useToggle2();
  const [createLocationStatus, toggleCreateLocationStatus] = useToggle2();
  const [locationDetails, setLocationDetails] = useState5({
    open: false,
    locationId: "",
    employerOfficeLocationId: ""
  });
  const [createLocation, isCreating] = useEmployerLocationCreate();
  const [updateLocation, isUpdating] = useEmployerLocationUpdate();
  const renderLocationComponent = (createLocationStatus2, locationDetails2) => {
    switch (true) {
      case (createLocationStatus2 && !locationDetails2.open):
        return /* @__PURE__ */ jsx13(
          EmployerLocationDetailsEditor,
          {
            onCancel: toggleCreateLocationStatus,
            employerId,
            create: createLocation,
            isCreating,
            locationDetails: locationDetails2,
            setLocationDetails
          }
        );
      case (!createLocationStatus2 && locationDetails2.open):
        return /* @__PURE__ */ jsx13(
          EmployerLocationDetails,
          {
            onCancel: () => setLocationDetails({
              open: false,
              locationId: "",
              employerOfficeLocationId: ""
            }),
            isEditing,
            isUpdating,
            updateLocation,
            toggleIsEditing,
            employerId,
            locationDetails: locationDetails2,
            setLocationDetails
          }
        );
      default:
        return /* @__PURE__ */ jsx13(
          RenderLocationList,
          {
            employer,
            toggleCreateLocationStatus,
            setLocationDetails
          }
        );
    }
  };
  return /* @__PURE__ */ jsx13(Suspense5, { fallback: /* @__PURE__ */ jsx13(EdSkeleton5, {}), children: /* @__PURE__ */ jsx13("div", { className: "mt-5 flex flex-col xl:container", children: /* @__PURE__ */ jsxs11("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx13("h1", { className: "text-md mb-3 grow px-10 font-bold text-gray-600 sm:text-2xl", children: "Organization Locations" }),
    renderLocationComponent(createLocationStatus, locationDetails)
  ] }) }) });
};
var createEmployerLocationsRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-employer-locations`;
  return [
    {
      path: "*",
      id: routeId,
      element: /* @__PURE__ */ jsx13(EmployerLocations, { routeId }),
      errorElement: /* @__PURE__ */ jsx13(ErrorContainer2, {}),
      loader: ({ params }) => {
        return loader2(environment, params, context);
      }
    }
  ];
};

// src/components/accounts/__generated__/EmployerSearchContainerQuery.graphql.ts
var node39 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v22 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    v1
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerSearchContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "EmployerSearchBox_employers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerSearchContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v22,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v22,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerSearchBox_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "5cfaec9406de250112b28edfdf1a3b64",
      "id": null,
      "metadata": {},
      "name": "EmployerSearchContainerQuery",
      "operationKind": "query",
      "text": "query EmployerSearchContainerQuery(\n  $where: EmployerFilter!\n) {\n  ...EmployerSearchBox_employers_3FC4Qo\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployerSearchBox_employers_3FC4Qo on Query {\n  list: accountsEmployers(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        employerId\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node39.hash = "423f217fe8cf043cfed2817918efc4a2";
var EmployerSearchContainerQuery_graphql_default = node39;

// src/components/accounts/EmployerSearchContainer.tsx
import { useCallback as useCallback7, useState as useState6 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery4 } from "react-relay";
import { jsx as jsx14 } from "react/jsx-runtime";
var graphqlQuery2 = EmployerSearchContainerQuery_graphql_default;
var EmployerSearchContainer = ({
  defaultValue,
  onSearchCompleted
}) => {
  const [selectedResult, setSelectedResult] = useState6();
  const onSetSelected = useCallback7(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [selectedResult]
  );
  const where = { isDeleted: { eq: false } };
  const query = useLazyLoadQuery4(
    graphqlQuery2,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx14(
    EmployerSearchBox,
    {
      onSelected: onSetSelected,
      employers: query,
      defaultValue
    }
  );
};

// src/components/accounts/__generated__/EmployerRow_account.graphql.ts
var node40 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerRow_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webSite",
      "storageKey": null
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node40.hash = "5f7da24cd711531c3e98cfcd9f64b367";
var EmployerRow_account_graphql_default = node40;

// src/components/accounts/EmployerRow.tsx
import { useFragment as useFragment6 } from "react-relay";
import { jsx as jsx15, jsxs as jsxs12 } from "react/jsx-runtime";
var fragment2 = EmployerRow_account_graphql_default;
var EmployerRow = ({
  employer,
  callback
}) => {
  const data = useFragment6(fragment2, employer);
  return /* @__PURE__ */ jsxs12("div", { className: "row", onClick: callback, children: [
    /* @__PURE__ */ jsx15("div", { className: "item", children: data.name }),
    /* @__PURE__ */ jsx15("div", { className: "item", children: data.slug }),
    /* @__PURE__ */ jsx15("div", { className: "item", children: data.webSite })
  ] });
};

// src/components/accounts/__generated__/EmployersListContainerQuery.graphql.ts
var node41 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v22 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployersListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "EmployersListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v22,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v22,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployersList_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "d0733d71be189557cd626c7b4f25b2a7",
      "id": null,
      "metadata": {},
      "name": "EmployersListContainerQuery",
      "operationKind": "query",
      "text": "query EmployersListContainerQuery(\n  $where: EmployerFilter!\n  $order: [EmployerSortInput!]\n) {\n  ...EmployersListContainer_list\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployersListContainer_list on Query {\n  list: accountsEmployers(first: 25, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerId\n        updatedAt\n        createdAt\n        code\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node41.hash = "06e99c1fe69ada41b97b0963f72f6a2e";
var EmployersListContainerQuery_graphql_default = node41;

// src/components/accounts/__generated__/EmployersListPaginationQuery.graphql.ts
var node42 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v22 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v22,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v22
          ],
          "kind": "FragmentSpread",
          "name": "EmployersListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployersListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v32,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployersList_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "eee08e9514cdf8a220b0e34bcb15f1b6",
      "id": null,
      "metadata": {},
      "name": "EmployersListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployersListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $order: [EmployerSortInput!]\n  $where: EmployerFilter\n) {\n  ...EmployersListContainer_list_2HEEH6\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployersListContainer_list_2HEEH6 on Query {\n  list: accountsEmployers(first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerId\n        updatedAt\n        createdAt\n        code\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node42.hash = "a5b1f5acab6871c8faad31fdfa0c154c";
var EmployersListPaginationQuery_graphql_default = node42;

// src/components/accounts/__generated__/EmployersListContainer_list.graphql.ts
var node43 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployersListPaginationQuery_graphql_default
      }
    },
    "name": "EmployersListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountsEmployersConnection",
        "kind": "LinkedField",
        "name": "__EmployersList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Employer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "webSite",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerRow_account"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node43.hash = "a5b1f5acab6871c8faad31fdfa0c154c";
var EmployersListContainer_list_graphql_default = node43;

// src/components/accounts/__generated__/EmployersListContainerSearchQuery.graphql.ts
var node44 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v22 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    v1
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersListContainerSearchQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "EmployersListContainer_query"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployersListContainerSearchQuery",
      "selections": [
        {
          "alias": null,
          "args": v22,
          "concreteType": "AccountEmployerUsersConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Employer",
                      "kind": "LinkedField",
                      "name": "employer",
                      "plural": false,
                      "selections": [
                        v32,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v22,
          "filters": [
            "where"
          ],
          "handle": "connection",
          "key": "EmployersListContainer__accountEmployerUsers",
          "kind": "LinkedHandle",
          "name": "accountEmployerUsers"
        }
      ]
    },
    "params": {
      "cacheID": "e510984e1dce192070f8d5e6c710a8e5",
      "id": null,
      "metadata": {},
      "name": "EmployersListContainerSearchQuery",
      "operationKind": "query",
      "text": "query EmployersListContainerSearchQuery(\n  $where: AccountsEmployerUserFilter!\n) {\n  ...EmployersListContainer_query_3FC4Qo\n}\n\nfragment EmployersListContainer_query_3FC4Qo on Query {\n  accountEmployerUsers(first: 25, where: $where) {\n    totalCount\n    edges {\n      node {\n        employer {\n          id\n          code\n          name\n          employerId\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node44.hash = "ff96c7de2c8892de509e7a6744c85c68";
var EmployersListContainerSearchQuery_graphql_default = node44;

// src/components/accounts/__generated__/EmployersListContainer_accountEmployerUsers.graphql.ts
var node45 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersListContainer_accountEmployerUsers",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "EmployersListContainer_query"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployersListContainer_accountEmployerUsers",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountEmployerUsersConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Employer",
                      "kind": "LinkedField",
                      "name": "employer",
                      "plural": false,
                      "selections": [
                        v22,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v22,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "where"
          ],
          "handle": "connection",
          "key": "EmployersListContainer__accountEmployerUsers",
          "kind": "LinkedHandle",
          "name": "accountEmployerUsers"
        }
      ]
    },
    "params": {
      "cacheID": "a616d3c307abbdd3387068ea6da663b1",
      "id": null,
      "metadata": {},
      "name": "EmployersListContainer_accountEmployerUsers",
      "operationKind": "query",
      "text": "query EmployersListContainer_accountEmployerUsers(\n  $after: String\n  $first: Int = 25\n  $where: AccountsEmployerUserFilter\n) {\n  ...EmployersListContainer_query_3sueo6\n}\n\nfragment EmployersListContainer_query_3sueo6 on Query {\n  accountEmployerUsers(first: $first, after: $after, where: $where) {\n    totalCount\n    edges {\n      node {\n        employer {\n          id\n          code\n          name\n          employerId\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node45.hash = "9cd645fb58ded3b1bc3ccb4127fe4de6";
var EmployersListContainer_accountEmployerUsers_graphql_default = node45;

// src/components/accounts/__generated__/EmployersListContainer_query.graphql.ts
var node46 = /* @__PURE__ */ function() {
  var v0 = [
    "accountEmployerUsers"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployersListContainer_accountEmployerUsers_graphql_default
      }
    },
    "name": "EmployersListContainer_query",
    "selections": [
      {
        "alias": "accountEmployerUsers",
        "args": [
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountEmployerUsersConnection",
        "kind": "LinkedField",
        "name": "__EmployersListContainer__accountEmployerUsers_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountEmployerUsersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsEmployerUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employer",
                    "kind": "LinkedField",
                    "name": "employer",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node46.hash = "9cd645fb58ded3b1bc3ccb4127fe4de6";
var EmployersListContainer_query_graphql_default = node46;

// src/components/accounts/EmployersListContainer.tsx
import {
  Suspense as Suspense6,
  useCallback as useCallback8,
  useEffect as useEffect3,
  useMemo as useMemo2,
  useState as useState7,
  useTransition
} from "react";
import {
  usePaginationFragment as usePaginationFragment2,
  usePreloadedQuery as usePreloadedQuery3,
  useRefetchableFragment
} from "react-relay";
import { formatDistanceToNow, parseISO } from "date-fns";
import {
  DebouncedInput,
  DefaultListLayoutItemHeader,
  DefaultListLayoutSectionElement,
  ListLayout,
  SelectMenu as SelectMenu2,
  Spinner as Spinner2,
  classNames as classNames14
} from "shared-ui";
import { isNotNullOrUndefined, useQueryPreloader } from "shared-lib";
import { jsx as jsx16, jsxs as jsxs13 } from "react/jsx-runtime";
var queryDef5 = EmployersListContainerQuery_graphql_default;
var fragmentDef6 = EmployersListContainer_list_graphql_default;
var employerQueryDef = EmployersListContainerSearchQuery_graphql_default;
var userSearchFragmentDef = EmployersListContainer_query_graphql_default;
function createLinkTo(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var EmployerList = ({ queryRef }) => {
  const query = usePreloadedQuery3(queryDef5, queryRef);
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment2(fragmentDef6, query);
  const onLoadNext = useCallback8(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).filter(isNotNullOrUndefined).map((e4) => e4.node).map((ft) => {
    const name = `${ft.name}`;
    return {
      key: ft.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx16("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs13("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx16("div", { className: "text-md font-medium uppercase", children: ft.name }),
        /* @__PURE__ */ jsx16("div", { className: "text-md text-blue-700", children: ft.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs13("div", { className: "pt-2 text-sm", children: [
        "Updated ",
        formatDistanceToNow(parseISO(ft.updatedAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: ft.code
      },
      element: /* @__PURE__ */ jsx16(DefaultListLayoutSectionElement, { children: /* @__PURE__ */ jsx16("div", { className: "grid", children: /* @__PURE__ */ jsx16("div", { children: ft.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx16(
    ListLayout,
    {
      sections,
      itemHeader: (s4) => /* @__PURE__ */ jsx16(
        DefaultListLayoutItemHeader,
        {
          title: "Employers",
          to: createLinkTo,
          section: s4
        }
      ),
      loadMore: onLoadNext,
      isLoading: false
    }
  );
};
var EmployersListContainer = () => {
  const order = useMemo2(() => [{ name: "ASC" }], []);
  const [queryRef, loadQuery8] = useQueryPreloader(
    queryDef5,
    { where: { and: [{ isDeleted: { eq: false } }] }, order }
  );
  const [employerQueryRef] = useQueryPreloader(queryDef5, {
    where: { and: [{ isDeleted: { eq: false } }] }
  });
  const [loading, startTransition2] = useTransition();
  const onSearch = useCallback8(
    (search) => {
      startTransition2(() => {
        loadQuery8({
          where: {
            and: [
              { isDeleted: { eq: false } },
              { name: { startsWith: search } }
            ]
          },
          order
        });
      });
    },
    [loadQuery8, order]
  );
  const onSearchEmployer = useCallback8(
    (employerIds) => {
      startTransition2(() => {
        loadQuery8({
          where: {
            and: [{ isDeleted: { eq: false } }, { id: { in: employerIds } }]
          },
          order
        });
      });
    },
    [loadQuery8, order]
  );
  const [selected, setSeleted] = useState7({
    id: "name",
    name: "By company name"
  });
  if (!queryRef) {
    return /* @__PURE__ */ jsx16("div", { children: "Loading" });
  }
  return /* @__PURE__ */ jsxs13("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx16("div", { className: "flex items-center justify-between space-x-4 border-b bg-white", children: /* @__PURE__ */ jsxs13("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx16("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsxs13("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsxs13("div", { className: "flex w-64 grow", children: [
          selected.id == "name" && /* @__PURE__ */ jsx16("div", { className: classNames14(loading && "animate-pulse"), children: /* @__PURE__ */ jsx16(
            DebouncedInput,
            {
              placeholder: "Company name",
              onValueChanged: (filter) => onSearch(filter?.trim()),
              value: void 0
            },
            "filter"
          ) }),
          employerQueryRef && /* @__PURE__ */ jsx16(Suspense6, { children: selected.id == "email" && /* @__PURE__ */ jsx16(
            SearchList,
            {
              queryRef: employerQueryRef,
              onSearchEmployers: onSearchEmployer
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx16(
          SelectMenu2,
          {
            items: [
              { id: "name", name: "By company name" },
              { id: "email", name: "By user email" }
            ],
            onChange: setSeleted,
            value: selected
          }
        ),
        loading && /* @__PURE__ */ jsx16(Spinner2, {})
      ] })
    ] }) }),
    /* @__PURE__ */ jsx16("div", { className: "flex-1", children: /* @__PURE__ */ jsx16(EmployerList, { queryRef }) })
  ] });
};
var SearchList = ({
  queryRef,
  onSearchEmployers
}) => {
  const query = usePreloadedQuery3(
    employerQueryDef,
    queryRef
  );
  const [loading, startTransition2] = useTransition();
  const [data, refetch] = useRefetchableFragment(userSearchFragmentDef, query);
  const onSearch = useCallback8(
    (contains) => {
      startTransition2(() => {
        refetch({
          where: {
            emailAddress: { contains }
          }
        });
      });
    },
    [refetch]
  );
  useEffect3(() => {
    startTransition2(() => {
      onSearchEmployers(
        data?.accountEmployerUsers?.edges?.map(
          (e4) => e4.node.employer.employerId
        ) || []
      );
    });
  }, [data?.accountEmployerUsers?.edges, onSearchEmployers]);
  return /* @__PURE__ */ jsx16("div", { className: classNames14(loading && "animate-pulse"), children: /* @__PURE__ */ jsx16(
    DebouncedInput,
    {
      placeholder: "User email",
      onValueChanged: (filter) => onSearch(filter?.trim()),
      value: void 0
    },
    "filter"
  ) });
};

// src/components/user-groups/EmployerUserGroupsRoute.tsx
import { Outlet } from "react-router-dom";
import { ErrorContainer as ErrorContainer4 } from "shared-ui";
import { OutletRoute } from "app-core";

// src/components/user-groups/__generated__/EmployerUserGroupsListLayoutQuery.graphql.ts
var node47 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v32 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v4 = {
    "alias": "employer",
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "employerCode"
      }
    ],
    "concreteType": "Employer",
    "kind": "LinkedField",
    "name": "accountsEmployerByCode",
    "plural": false,
    "selections": [
      v1,
      v22,
      v32
    ],
    "storageKey": null
  }, v5 = {
    "kind": "Variable",
    "name": "employerCode",
    "variableName": "employerCode"
  }, v6 = [
    v5,
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "updatedAt": "DESC"
      }
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupsListLayoutQuery",
      "selections": [
        v4,
        {
          "args": [
            v5
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupsList_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupsListLayoutQuery",
      "selections": [
        v4,
        {
          "alias": "groups",
          "args": v6,
          "concreteType": "AccountEmployerUserGroupsByEmployerCodeConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroupsByEmployerCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsByEmployerCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    v22,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PermissionSet",
                      "kind": "LinkedField",
                      "name": "permissionSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResourcePermissions",
                          "kind": "LinkedField",
                          "name": "permissions",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "actions",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resource",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v32
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v6,
          "filters": [],
          "handle": "connection",
          "key": "EmployerUserGroupsList_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroupsByEmployerCode"
        }
      ]
    },
    "params": {
      "cacheID": "095e8f0f35839a19a4d3a91c0d04c48b",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupsListLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupsListLayoutQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n  }\n  ...EmployerUserGroupsList_groups_4pmpJH\n}\n\nfragment EmployerUserGroupView_group on AccountsEmployerUserGroup {\n  id\n  code\n  name\n  employerId\n  isDefault\n  isAdminGroup\n  description\n  permissionSet {\n    permissions {\n      actions\n      resource\n    }\n  }\n}\n\nfragment EmployerUserGroupsList_groups_4pmpJH on Query {\n  groups: accountEmployerUserGroupsByEmployerCode(employerCode: $employerCode, first: 25, order: {updatedAt: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        name\n        employerId\n        isDefault\n        isAdminGroup\n        description\n        updatedAt\n        ...EmployerUserGroupView_group\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node47.hash = "8b19442829597595db81189b5c4f86fb";
var EmployerUserGroupsListLayoutQuery_graphql_default = node47;

// src/components/user-groups/EmployerUserGroupsListLayout.tsx
import { Suspense as Suspense7 } from "react";
import {
  loadQuery as loadQuery3,
  usePreloadedQuery as usePreloadedQuery4
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData3 } from "react-router-dom";
import { EdSkeleton as EdSkeleton6, MynPageTitle } from "shared-ui";
import { resolveEmployerCode } from "app-core";

// src/components/user-groups/__generated__/EmployerUserGroupsListPaginationQuery.graphql.ts
var node48 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "updatedAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v22 = {
    "kind": "Variable",
    "name": "employerCode",
    "variableName": "employerCode"
  }, v32 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v4 = [
    v1,
    v22,
    v32,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupsListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v22,
            v32,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            }
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupsList_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupsListPaginationQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v4,
          "concreteType": "AccountEmployerUserGroupsByEmployerCodeConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroupsByEmployerCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsByEmployerCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PermissionSet",
                      "kind": "LinkedField",
                      "name": "permissionSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResourcePermissions",
                          "kind": "LinkedField",
                          "name": "permissions",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "actions",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resource",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "EmployerUserGroupsList_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroupsByEmployerCode"
        }
      ]
    },
    "params": {
      "cacheID": "2ca999bee71f38080ebb832355314287",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupsListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupsListPaginationQuery(\n  $after: String\n  $employerCode: Long!\n  $first: Int = 25\n  $sort: [AccountsEmployerUserGroupSort!] = {updatedAt: DESC}\n) {\n  ...EmployerUserGroupsList_groups_47mpHu\n}\n\nfragment EmployerUserGroupView_group on AccountsEmployerUserGroup {\n  id\n  code\n  name\n  employerId\n  isDefault\n  isAdminGroup\n  description\n  permissionSet {\n    permissions {\n      actions\n      resource\n    }\n  }\n}\n\nfragment EmployerUserGroupsList_groups_47mpHu on Query {\n  groups: accountEmployerUserGroupsByEmployerCode(employerCode: $employerCode, first: $first, after: $after, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        name\n        employerId\n        isDefault\n        isAdminGroup\n        description\n        updatedAt\n        ...EmployerUserGroupView_group\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node48.hash = "62587f5e33b87a145689ef10e5cbafd9";
var EmployerUserGroupsListPaginationQuery_graphql_default = node48;

// src/components/user-groups/__generated__/EmployerUserGroupsList_groups.graphql.ts
var node49 = /* @__PURE__ */ function() {
  var v0 = [
    "groups"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "employerCode"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "updatedAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerUserGroupsListPaginationQuery_graphql_default
      }
    },
    "name": "EmployerUserGroupsList_groups",
    "selections": [
      {
        "alias": "groups",
        "args": null,
        "concreteType": "AccountEmployerUserGroupsByEmployerCodeConnection",
        "kind": "LinkedField",
        "name": "__EmployerUserGroupsList_groups_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountEmployerUserGroupsByEmployerCodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsEmployerUserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDefault",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAdminGroup",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerUserGroupView_group"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node49.hash = "62587f5e33b87a145689ef10e5cbafd9";
var EmployerUserGroupsList_groups_graphql_default = node49;

// src/components/user-groups/EmployerUserGroupsList.tsx
import {
  isValidElement,
  useCallback as useCallback9
} from "react";
import { usePaginationFragment as usePaginationFragment3 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow2, parseISO as parseISO2 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined2 } from "shared-lib";
import { EdButtonLink, ListLayout as ListLayout2 } from "shared-ui";

// src/components/user-groups/__generated__/EmployerUserGroupView_group.graphql.ts
var node50 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserGroupView_group",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdminGroup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PermissionSet",
      "kind": "LinkedField",
      "name": "permissionSet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResourcePermissions",
          "kind": "LinkedField",
          "name": "permissions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resource",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUserGroup",
  "abstractKey": null
};
node50.hash = "d50fb91ce3135e045c6c3595f8f31ce6";
var EmployerUserGroupView_group_graphql_default = node50;

// src/components/user-groups/EmployerUserGroupView.tsx
import { useFragment as useFragment7 } from "react-relay";
import { jsx as jsx17 } from "react/jsx-runtime";
var fragmentDef7 = EmployerUserGroupView_group_graphql_default;
var EmployerUserGroupView = ({
  fragmentRef
}) => {
  const data = useFragment7(
    fragmentDef7,
    fragmentRef
  );
  const title = `${data.name}`;
  return /* @__PURE__ */ jsx17("div", { children: /* @__PURE__ */ jsx17("div", { className: "grid", children: /* @__PURE__ */ jsx17("div", { children: title }) }) });
};

// src/components/user-groups/EmployerUserGroupsList.tsx
import { jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var defaultSort = {
  updatedAt: "DESC"
};
var fragmentDef8 = EmployerUserGroupsList_groups_graphql_default;
var SectionElement = ({ children }) => {
  return /* @__PURE__ */ jsx18("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var ItemHeader = ({ section }) => {
  const code = section.context.code;
  const titleIsElement = isValidElement(section.itemTitle);
  return /* @__PURE__ */ jsxs14("div", { children: [
    /* @__PURE__ */ jsx18("div", { children: /* @__PURE__ */ jsx18("h1", { children: "User" }) }),
    titleIsElement ? section.itemTitle : /* @__PURE__ */ jsx18("div", { className: "font-InterMedium text-info-gray-800 text-3xl font-bold tracking-tight", children: section.itemTitle }),
    /* @__PURE__ */ jsx18("div", { className: "flex items-center space-x-2 sm:justify-end", children: /* @__PURE__ */ jsx18(EdButtonLink, { name: "View", to: `../../../view/${code}` }) })
  ] });
};
function EmployerUserGroupFilters(props) {
  return /* @__PURE__ */ jsx18("div", { children: /* @__PURE__ */ jsx18("h3", { children: "Filters" }) });
}
var EmployerUserGroupListLayout = ({
  fragmentRef
}) => {
  const { data, loadNext, refetch, isLoadingNext } = usePaginationFragment3(fragmentDef8, fragmentRef);
  const { groups } = data;
  const sections = (groups?.edges || []).filter(isNotNullOrUndefined2).map(({ node: group }) => {
    const title = `${group.name}`;
    return {
      key: group.code.toString() + "/list",
      mobileLink: `../${group.code}`,
      itemTitle: title,
      listTitle: /* @__PURE__ */ jsx18("div", { className: "flex w-full grow justify-between gap-2", children: /* @__PURE__ */ jsx18("div", { className: "text-sm font-medium uppercase", children: title }) }),
      description: /* @__PURE__ */ jsxs14("div", { className: "text-xs", children: [
        "Updated",
        " ",
        formatDistanceToNow2(parseISO2(group.updatedAt), {
          addSuffix: true
        })
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: group.code
      },
      element: /* @__PURE__ */ jsx18(SectionElement, { children: /* @__PURE__ */ jsx18(EmployerUserGroupView, { fragmentRef: group }) })
    };
  });
  const onChanged = useCallback9(
    (val) => {
      refetch({
        sort: [{ [val.sortField]: val.sortDir }]
        // where: {
        //   name: {
        //     contains: val.filterValue || '',
        //   },
        // },
      });
    },
    [refetch]
  );
  const loadMore = useCallback9(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(15);
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx18(
    ListLayout2,
    {
      title: "User Groups",
      sections,
      itemHeader: (s4) => /* @__PURE__ */ jsx18(ItemHeader, { section: s4 }),
      loadMore,
      isLoading: isLoadingNext,
      children: /* @__PURE__ */ jsx18(ListLayout2.Filters, { children: /* @__PURE__ */ jsx18(EmployerUserGroupFilters, { sort: defaultSort, onChanged }) })
    }
  );
};

// src/components/user-groups/EmployerUserGroupsListLayout.tsx
import { jsx as jsx19, jsxs as jsxs15 } from "react/jsx-runtime";
var queryDef6 = EmployerUserGroupsListLayoutQuery_graphql_default;
async function loader3(environment, params, context) {
  const employerCode = resolveEmployerCode(params, context);
  const queryRef = loadQuery3(
    environment,
    queryDef6,
    {
      employerCode
    }
  );
  return {
    employerCode,
    queryRef
  };
}
function useEmployerUserGroupsRouteData(routeId) {
  const { queryRef } = useRouteLoaderData3(routeId);
  const query = usePreloadedQuery4(
    queryDef6,
    queryRef
  );
  return {
    query
  };
}
var EmployerUserGroupsListLayout = ({
  routeId
}) => {
  const { query } = useEmployerUserGroupsRouteData(routeId);
  return /* @__PURE__ */ jsxs15(Suspense7, { fallback: /* @__PURE__ */ jsx19(EdSkeleton6, {}), children: [
    /* @__PURE__ */ jsx19(MynPageTitle, { title: "Employer User Groups" }),
    /* @__PURE__ */ jsx19(EmployerUserGroupListLayout, { fragmentRef: query })
  ] });
};

// src/components/user-groups/EmployerUserGroupRoute.tsx
import { Navigate } from "react-router-dom";
import { ErrorContainer as ErrorContainer3 } from "shared-ui";

// src/components/user-groups/__generated__/EmployerUserGroupLayoutQuery.graphql.ts
var node51 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "groupId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDefault",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAdminGroup",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "concreteType": "PermissionSet",
    "kind": "LinkedField",
    "name": "permissionSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResourcePermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resource",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v11 = [
    v5,
    v9
  ], v12 = {
    "alias": null,
    "args": null,
    "concreteType": "Authorizable",
    "kind": "LinkedField",
    "name": "authorizableSets",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthorizableResource",
        "kind": "LinkedField",
        "name": "resource",
        "plural": false,
        "selections": v11,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthorizableCategory",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          v5,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          v9
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthorizableAction",
        "kind": "LinkedField",
        "name": "actions",
        "plural": true,
        "selections": v11,
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v13 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupLayoutQuery",
      "selections": [
        {
          "alias": "userGroup",
          "args": v1,
          "concreteType": "AccountsEmployerUserGroup",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroupByCode",
          "plural": false,
          "selections": [
            v22,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v12,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserGroupDetailsEditor_userGroup"
            },
            v13
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupLayoutQuery",
      "selections": [
        {
          "alias": "userGroup",
          "args": v1,
          "concreteType": "AccountsEmployerUserGroup",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroupByCode",
          "plural": false,
          "selections": [
            v22,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v12,
            v13
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "41886244d8ee9d130fcd2bacbc06b9b4",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupLayoutQuery(\n  $code: Int!\n) {\n  userGroup: accountEmployerUserGroupByCode(code: $code) {\n    id\n    groupId\n    code\n    name\n    employerId\n    isDefault\n    isAdminGroup\n    description\n    permissionSet {\n      permissions {\n        actions\n        resource\n      }\n    }\n    authorizableSets {\n      resource {\n        name\n        description\n      }\n      category {\n        name\n        label\n        description\n      }\n      actions {\n        name\n        description\n      }\n    }\n    ...EmployerUserGroupDetailsEditor_userGroup\n  }\n}\n\nfragment EmployerUserGroupDetailsEditor_userGroup on AccountsEmployerUserGroup {\n  id\n  groupId\n  code\n  name\n  employerId\n  isDefault\n  isAdminGroup\n  description\n  permissionSet {\n    permissions {\n      actions\n      resource\n    }\n  }\n}\n"
    }
  };
}();
node51.hash = "ce1fffdc44b1f25133b4433d48f3957b";
var EmployerUserGroupLayoutQuery_graphql_default = node51;

// src/components/user-groups/EmployerUserGroupLayout.tsx
import { Suspense as Suspense10 } from "react";
import {
  loadQuery as loadQuery4,
  usePreloadedQuery as usePreloadedQuery5
} from "react-relay";
import { Link, useRouteLoaderData as useRouteLoaderData4 } from "react-router-dom";
import { EdSkeleton as EdSkeleton9 } from "shared-ui";

// src/components/user-groups/EmployerUserGroupEditor.tsx
import { useCallback as useCallback13, useMemo as useMemo3, useState as useState8 } from "react";
import { MynPageTitle as MynPageTitle2, Suspense as Suspense9 } from "shared-ui";
import { useToggle as useToggle3 } from "shared-lib";
import { Button as Button6, classNames as classNames15, EdSkeleton as EdSkeleton8, Size as Size3 } from "shared-ui";
import {
  createAuthorizableGroups,
  createAuthorizables,
  createPermissionKeyableSet
} from "app-core";

// src/components/user-groups/__generated__/EmployerUserGroupDetailsEditor_userGroup.graphql.ts
var node52 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserGroupDetailsEditor_userGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdminGroup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PermissionSet",
      "kind": "LinkedField",
      "name": "permissionSet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResourcePermissions",
          "kind": "LinkedField",
          "name": "permissions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resource",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUserGroup",
  "abstractKey": null
};
node52.hash = "437305cf9be911e9e9f379e047b34326";
var EmployerUserGroupDetailsEditor_userGroup_graphql_default = node52;

// src/components/user-groups/EmployerUserGroupDetailsEditor.tsx
import { useCallback as useCallback11 } from "react";
import { useFragment as useFragment8 } from "react-relay";
import { createClientMutationId as createClientMutationId6 } from "shared-lib";

// src/components/user-groups/EmployerUserGroupForm.tsx
import { useCallback as useCallback10 } from "react";
import { useForm as useForm5 } from "react-hook-form";
import { zodResolver as zodResolver5 } from "@hookform/resolvers/zod";
import * as zod5 from "zod";
import {
  Button as Button5,
  ButtonList as ButtonList2,
  CheckboxInput,
  FormInput as FormInput3,
  FormTextAreaInput as FormTextAreaInput2,
  Size as Size2
} from "shared-ui";
import { jsx as jsx20, jsxs as jsxs16 } from "react/jsx-runtime";
var FormSchema = zod5.object({
  name: zod5.string(),
  description: zod5.string(),
  isAdminGroup: zod5.boolean(),
  isDefault: zod5.boolean()
});
var EmployerUserGroupForm = ({
  isBusy,
  group,
  onUpdated,
  onCancelled
}) => {
  const defaultValues = {
    name: group.name || "",
    description: group.description || "",
    isAdminGroup: group.isAdminGroup || false,
    isDefault: group.isDefault || false
  };
  const { register, handleSubmit, formState, control } = useForm5({
    // There is a bug in yup which causes it to compare the type boolean with the string 'true', so we're checking any to avoid this
    resolver: zodResolver5(FormSchema),
    defaultValues
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((data) => onSave(isValid, data));
  const onSave = useCallback10(
    (isValid2, form) => {
      if (!form.name) {
        return;
      }
      onUpdated(form);
    },
    [onUpdated]
  );
  return /* @__PURE__ */ jsxs16("form", { onSubmit, className: "w-1/2", children: [
    /* @__PURE__ */ jsxs16("div", { className: "mt-4", children: [
      /* @__PURE__ */ jsx20("label", { children: "Name *" }),
      /* @__PURE__ */ jsx20(
        FormInput3,
        {
          className: "mt-1",
          type: "text",
          placeholder: " Name ",
          name: "name",
          required: true,
          register
        }
      ),
      errors.name && /* @__PURE__ */ jsx20("p", { children: errors.name.message })
    ] }),
    /* @__PURE__ */ jsx20("div", { className: "mt-4", children: /* @__PURE__ */ jsx20(
      FormTextAreaInput2,
      {
        rows: 10,
        className: "mt-1",
        placeholder: " Description ",
        name: "description",
        required: false,
        register
      }
    ) }),
    /* @__PURE__ */ jsxs16("div", { className: "mt-4", children: [
      /* @__PURE__ */ jsx20(
        CheckboxInput,
        {
          label: /* @__PURE__ */ jsx20("span", { children: "Is Default" }),
          name: "isDefault",
          defaultChecked: defaultValues.isDefault,
          control,
          disabled: false
        }
      ),
      errors.isDefault && /* @__PURE__ */ jsx20("p", { children: errors.isDefault.message })
    ] }),
    /* @__PURE__ */ jsxs16("div", { className: "mt-4", children: [
      /* @__PURE__ */ jsx20(
        CheckboxInput,
        {
          label: /* @__PURE__ */ jsx20("span", { children: "Is Admin" }),
          name: "isAdminGroup",
          defaultChecked: defaultValues.isAdminGroup,
          control,
          disabled: false
        }
      ),
      errors.isAdminGroup && /* @__PURE__ */ jsx20("p", { children: errors.isAdminGroup.message })
    ] }),
    /* @__PURE__ */ jsx20("div", { className: "mt-5 flex", children: /* @__PURE__ */ jsxs16(ButtonList2, { children: [
      /* @__PURE__ */ jsx20("div", { children: /* @__PURE__ */ jsx20(
        Button5,
        {
          className: "flex-1",
          disabled: !isValid || isBusy,
          color: "primary",
          size: Size2.xl,
          type: "submit",
          children: "Update"
        }
      ) }),
      /* @__PURE__ */ jsx20("div", { children: /* @__PURE__ */ jsx20(
        Button5,
        {
          className: "flex-1",
          disabled: isBusy,
          onClick: onCancelled,
          color: "gray",
          size: Size2.xl,
          children: "Cancel"
        }
      ) })
    ] }) })
  ] });
};

// src/components/user-groups/EmployerUserGroupDetailsEditor.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var fragmentDef9 = EmployerUserGroupDetailsEditor_userGroup_graphql_default;
var EmployerUserGroupDetailsEditor = ({
  fragmentRef,
  onUpdated,
  onCancelled
}) => {
  const data = useFragment8(
    fragmentDef9,
    fragmentRef
  );
  const userGroup = {
    groupId: data.groupId,
    name: data.name,
    description: data.description,
    isAdminGroup: data.isAdminGroup || false,
    isDefault: data.isDefault || false,
    permissions: data.permissionSet.permissions.map((p4) => ({
      resource: p4.resource,
      actions: p4.actions
    }))
  };
  const [updateGroup, isUpdatingGroup] = useEmployerUserGroupUpdate();
  const onUpdateGroupDetails = useCallback11(
    async (form) => {
      if (!userGroup.name) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId6(),
        employerUserGroupId: userGroup.groupId,
        permissions: userGroup.permissions,
        name: form.name,
        description: form.description,
        isAdmin: form.isAdminGroup,
        isDefault: form.isDefault
      };
      await updateGroup({ input });
      onUpdated();
    },
    [updateGroup]
  );
  return /* @__PURE__ */ jsx21(
    EmployerUserGroupForm,
    {
      group: userGroup,
      isBusy: isUpdatingGroup,
      onUpdated: onUpdateGroupDetails,
      onCancelled
    }
  );
};

// src/components/user-groups/EmployerUserGroupPermissionsEditor.tsx
import { useCallback as useCallback12 } from "react";
import { Suspense as Suspense8 } from "shared-ui";
import { createClientMutationId as createClientMutationId7 } from "shared-lib";
import { EdSkeleton as EdSkeleton7 } from "shared-ui";
import { AuthorizableGroupEditor } from "app-core";
import { jsx as jsx22 } from "react/jsx-runtime";
var EmployerUserGroupPermissionsEditor = ({
  groups,
  selectedCategoryLabel
}) => {
  const [updateGroup, isUpdatingGroup] = useEmployerUserGroupUpdate();
  const onUpdateGroup = useCallback12(
    async (group) => {
      if (!group) {
        return;
      }
      const allPermissions = groups.filter((g3) => g3.id !== group.id).flatMap((g3) => g3.permissions).map((p4) => ({
        resource: p4.resource,
        actions: p4.actions.filter((as) => as.checked).map((as) => as.name)
      }));
      const groupPermissions = group.permissions.map((p4) => ({
        resource: p4.resource,
        actions: p4.actions.filter((as) => as.checked).map((as) => as.name)
      }));
      const input = {
        clientMutationId: createClientMutationId7(),
        permissions: [...allPermissions, ...groupPermissions],
        employerUserGroupId: group.groupId,
        name: group.name,
        description: group.description,
        isAdmin: group.isAdminGroup,
        isDefault: group.isDefault
      };
      await updateGroup({ input });
    },
    [updateGroup]
  );
  let activeGroups = [];
  if (selectedCategoryLabel && groups) {
    activeGroups = groups.filter((g3) => g3.category === selectedCategoryLabel);
  }
  const groupList = activeGroups.map((g3) => {
    return /* @__PURE__ */ jsx22(
      AuthorizableGroupEditor,
      {
        group: g3,
        isBusy: isUpdatingGroup,
        onUpdate: onUpdateGroup
      },
      g3.id
    );
  });
  return /* @__PURE__ */ jsx22(Suspense8, { fallback: /* @__PURE__ */ jsx22(EdSkeleton7, {}), children: groupList });
};

// src/components/user-groups/EmployerUserGroupEditor.tsx
import { jsx as jsx23, jsxs as jsxs17 } from "react/jsx-runtime";
var EmployerUserGroupEditor = ({
  routeId
}) => {
  const data = useEmployersUserGroupRouteData(routeId);
  const authorizableSets = useMemo3(() => {
    if (data.userGroup === null) {
      return [];
    }
    return createAuthorizables(data.userGroup?.authorizableSets || []);
  }, [data.userGroup]);
  const [isEditing, toggleIsEditing] = useToggle3();
  const [selectedCategoryLabel, setSelectedCategoryLabel] = useState8();
  const onSelect = useCallback13(
    (groupCategory) => {
      setSelectedCategoryLabel(groupCategory);
    },
    [setSelectedCategoryLabel]
  );
  if (data.userGroup === null || data.userGroup === void 0) {
    return /* @__PURE__ */ jsx23(EdSkeleton8, {});
  }
  const permissions = createPermissionKeyableSet(
    data.userGroup.permissionSet.permissions
  );
  const groups = createAuthorizableGroups(
    data.userGroup,
    permissions,
    authorizableSets
  );
  if (groups.length === 0) {
    return /* @__PURE__ */ jsx23("div", { children: "No Categories" });
  }
  const categoryLabels = groups.map((g3) => {
    const isSelected = selectedCategoryLabel && g3.category === selectedCategoryLabel;
    return /* @__PURE__ */ jsx23(
      "div",
      {
        className: classNames15(
          "cursor-pointer border-b p-3 hover:bg-gray-50",
          isSelected ? "font-bold" : ""
        ),
        onClick: () => onSelect(g3.category),
        children: g3.category
      },
      g3.id
    );
  });
  return /* @__PURE__ */ jsxs17(Suspense9, { fallback: /* @__PURE__ */ jsx23(EdSkeleton8, {}), children: [
    /* @__PURE__ */ jsxs17("div", { className: "m-4 flex items-start justify-between gap-2 border bg-white p-8", children: [
      /* @__PURE__ */ jsx23(MynPageTitle2, { title: "Employer User Group Details" }),
      /* @__PURE__ */ jsx23("div", { children: data.userGroup && data.userGroup.name }),
      /* @__PURE__ */ jsx23("div", { children: /* @__PURE__ */ jsx23(Button6, { color: "primary", size: Size3.md, onClick: toggleIsEditing, children: "Edit" }) })
    ] }),
    isEditing && data.userGroup ? /* @__PURE__ */ jsx23("div", { className: "m-4 flex items-start gap-2 border bg-white p-8", children: /* @__PURE__ */ jsx23(
      EmployerUserGroupDetailsEditor,
      {
        fragmentRef: data.userGroup,
        onUpdated: toggleIsEditing,
        onCancelled: toggleIsEditing
      }
    ) }) : /* @__PURE__ */ jsxs17("div", { className: "m-4 flex items-start gap-2 border bg-white p-8", children: [
      /* @__PURE__ */ jsxs17("div", { className: "sticky top-0 flex w-1/5 flex-col", children: [
        /* @__PURE__ */ jsx23("div", { className: "text-primary-800 p-3 font-medium", children: "Categories" }),
        categoryLabels
      ] }),
      /* @__PURE__ */ jsxs17("div", { className: "flex-1", children: [
        /* @__PURE__ */ jsx23("div", { className: "text-primary-800 p-3 font-medium", children: "Groups" }),
        selectedCategoryLabel && /* @__PURE__ */ jsx23(
          EmployerUserGroupPermissionsEditor,
          {
            groups,
            selectedCategoryLabel
          }
        )
      ] })
    ] })
  ] });
};

// src/components/user-groups/EmployerUserGroupLayout.tsx
import { jsx as jsx24, jsxs as jsxs18 } from "react/jsx-runtime";
var queryDef7 = EmployerUserGroupLayoutQuery_graphql_default;
async function loader4(environment, params, context) {
  const employerUserGroupCode = params.employerUserGroupCode;
  const code = Number(employerUserGroupCode);
  const queryRef = loadQuery4(
    environment,
    queryDef7,
    {
      code
    }
  );
  return {
    queryRef
  };
}
function useEmployersUserGroupRouteData(routeId) {
  const { queryRef } = useRouteLoaderData4(routeId);
  return usePreloadedQuery5(queryDef7, queryRef);
}
var EmployersUserGroupLayout = ({
  routeId
}) => {
  return /* @__PURE__ */ jsx24(Suspense10, { fallback: /* @__PURE__ */ jsx24(EdSkeleton9, {}), children: /* @__PURE__ */ jsxs18("div", { className: "flex-1", children: [
    /* @__PURE__ */ jsx24("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx24(Link, { to: "../../", children: "User Groups" }) }),
    /* @__PURE__ */ jsx24(EmployerUserGroupEditor, { routeId })
  ] }) });
};

// src/components/user-groups/EmployerUserGroupRoute.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var createEmployersUserGroupRoutes = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-employer-user`;
  return [
    {
      path: "*",
      id: routeId,
      element: /* @__PURE__ */ jsx25(EmployersUserGroupLayout, { routeId }),
      errorElement: /* @__PURE__ */ jsx25(ErrorContainer3, {}),
      loader: ({ params }) => {
        return loader4(environment, params, context);
      },
      children: [
        {
          path: "details",
          id: `${routeId}-details`,
          element: /* @__PURE__ */ jsx25(EmployerUserGroupEditor, { routeId }),
          errorElement: /* @__PURE__ */ jsx25(ErrorContainer3, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx25(Navigate, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/components/user-groups/EmployerUserGroupsHome.tsx
import { Link as Link2 } from "react-router-dom";
import { Button as Button7, EdSkeleton as EdSkeleton10, Suspense as Suspense11 } from "shared-ui";
import { jsx as jsx26 } from "react/jsx-runtime";
function EmployerUserGroupsHome() {
  return /* @__PURE__ */ jsx26(Suspense11, { fallback: /* @__PURE__ */ jsx26(EdSkeleton10, {}), children: /* @__PURE__ */ jsx26("div", { className: "flex flex-col gap-2 sm:m-8", children: /* @__PURE__ */ jsx26(Link2, { to: "create", children: /* @__PURE__ */ jsx26(Button7, { color: "primary", children: "Create new user group" }) }) }) });
}

// src/components/user-groups/EmployerUserGroupCreate.tsx
import { useCallback as useCallback14, useState as useState9 } from "react";
import { Link as Link3, useNavigate } from "react-router-dom";
import { ConnectionHandler } from "react-relay";
import { MynPageTitle as MynPageTitle3, Suspense as Suspense12 } from "shared-ui";
import { Button as Button8, ButtonList as ButtonList3, EdSkeleton as EdSkeleton11, Input } from "shared-ui";
import { createClientMutationId as createClientMutationId8 } from "shared-lib";
import { jsx as jsx27, jsxs as jsxs19 } from "react/jsx-runtime";
var EmployerUserGroupCreate = ({ userGroupsRouteId }) => {
  const data = useEmployerUserGroupsRouteData(userGroupsRouteId);
  const { query } = data;
  const navigate = useNavigate();
  const [createGroup, isCreatingGroup] = useEmployerUserGroupCreate();
  const [name, setName] = useState9(null);
  const connectionId = ConnectionHandler.getConnectionID(
    "root",
    "EmployerUserGroupsList_groups"
  );
  const onCreate = useCallback14(async () => {
    if (!name || !query.employer) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId8(),
      name,
      isDefault: false,
      employerId: query.employer.employerId
    };
    const response = await createGroup({ connections: [connectionId], input });
    if (response.data.employerUserGroup) {
      navigate(`../${response.data.employerUserGroup.node.code}`);
    }
  }, [createGroup, navigate]);
  const onCancel = useCallback14(() => {
    navigate(`../`);
  }, [navigate]);
  return /* @__PURE__ */ jsxs19(Suspense12, { fallback: /* @__PURE__ */ jsx27(EdSkeleton11, {}), children: [
    /* @__PURE__ */ jsx27(MynPageTitle3, { title: "Employer Create User Group" }),
    /* @__PURE__ */ jsxs19("div", { className: "flex w-full flex-col gap-2 sm:m-8", children: [
      /* @__PURE__ */ jsx27(Link3, { to: "../", children: /* @__PURE__ */ jsx27(Button8, { className: "bg-black text-white", children: "Back" }) }),
      /* @__PURE__ */ jsxs19("div", { className: "mt-5 flex flex-col gap-5 border bg-white p-4 md:w-2/3 md:p-8", children: [
        /* @__PURE__ */ jsx27("h1", { className: "border-b p-2 text-2xl", children: "Add a new group" }),
        /* @__PURE__ */ jsx27("div", { children: /* @__PURE__ */ jsx27(
          Input,
          {
            value: name ?? "",
            placeholder: "Group name",
            onValueChange: (n3) => setName(n3),
            required: true
          }
        ) }),
        /* @__PURE__ */ jsx27("div", { children: /* @__PURE__ */ jsxs19(ButtonList3, { children: [
          /* @__PURE__ */ jsx27(
            Button8,
            {
              color: `primary`,
              onClick: onCreate,
              disabled: isCreatingGroup || !name,
              children: "Create"
            }
          ),
          /* @__PURE__ */ jsx27(
            Button8,
            {
              color: "gray",
              onClick: onCancel,
              disabled: isCreatingGroup,
              children: "Cancel"
            }
          )
        ] }) })
      ] })
    ] })
  ] });
};

// src/components/user-groups/EmployerUserGroupsRoute.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
var employerUserGroupRoutes = (userGroupsRouteId, routeId, environment, context) => [
  {
    path: "*",
    element: /* @__PURE__ */ jsx28(EmployerUserGroupsHome, {})
  },
  {
    path: "create/*",
    element: /* @__PURE__ */ jsx28(EmployerUserGroupCreate, { userGroupsRouteId })
  },
  {
    path: ":employerUserGroupCode/*",
    element: /* @__PURE__ */ jsx28(OutletRoute, {}),
    children: createEmployersUserGroupRoutes(routeId, environment, context)
  }
];
var createEmployerUserGroupsRoutes = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-employer-groups`;
  return [
    {
      path: "list/*",
      id: routeId,
      element: /* @__PURE__ */ jsx28(EmployerUserGroupsListLayout, { routeId }),
      errorElement: /* @__PURE__ */ jsx28(ErrorContainer4, {}),
      loader: ({ params }) => {
        return loader3(environment, params, context);
      },
      children: employerUserGroupRoutes(routeId, routeId + "list", environment, context)
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx28(Outlet, {}),
      children: employerUserGroupRoutes(routeId, routeId, environment, context)
    }
  ];
};

// src/components/user-groups/__generated__/EmployerUserGroupSearchBoxInputQuery.graphql.ts
var node53 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupSearchBoxInputQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupSearchBox_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupSearchBoxInputQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v1,
          "concreteType": "AccountEmployerUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "groupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerUserGroupSearchBox_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "cedd6fde17e6a38ef8e760bf085c9f9a",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupSearchBoxInputQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupSearchBoxInputQuery(\n  $employerId: UUID!\n) {\n  ...EmployerUserGroupSearchBox_groups_4aLTpM\n}\n\nfragment EmployerUserGroupSearchBox_groups_4aLTpM on Query {\n  groups: accountEmployerUserGroups(first: 10, order: [{name: ASC}], where: {employerId: {eq: $employerId}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        groupId\n        name\n        description\n        isAdminGroup\n        isDefault\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node53.hash = "61a70fbe472b490f4997cc680a1d19fc";
var EmployerUserGroupSearchBoxInputQuery_graphql_default = node53;

// src/components/user-groups/EmployerUserGroupSearchBoxInput.tsx
import { Controller as Controller2 } from "react-hook-form";
import { useLazyLoadQuery as useLazyLoadQuery5 } from "react-relay";

// src/components/user-groups/__generated__/EmployerUserGroupSearchBoxPaginationQuery.graphql.ts
var node54 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v22 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v22,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupSearchBoxPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            },
            v22
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupSearchBox_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupSearchBoxPaginationQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v32,
          "concreteType": "AccountEmployerUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "groupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerUserGroupSearchBox_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "5998ac67b602db095c74deae9dce52a5",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupSearchBoxPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupSearchBoxPaginationQuery(\n  $after: String\n  $employerId: UUID\n  $first: Int = 10\n) {\n  ...EmployerUserGroupSearchBox_groups_2553ZF\n}\n\nfragment EmployerUserGroupSearchBox_groups_2553ZF on Query {\n  groups: accountEmployerUserGroups(first: $first, after: $after, order: [{name: ASC}], where: {employerId: {eq: $employerId}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        groupId\n        name\n        description\n        isAdminGroup\n        isDefault\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node54.hash = "8469155d851bd9ba65bcc33931e839cd";
var EmployerUserGroupSearchBoxPaginationQuery_graphql_default = node54;

// src/components/user-groups/__generated__/EmployerUserGroupSearchBox_groups.graphql.ts
var node55 = /* @__PURE__ */ function() {
  var v0 = [
    "groups"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "employerId"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerUserGroupSearchBoxPaginationQuery_graphql_default
      }
    },
    "name": "EmployerUserGroupSearchBox_groups",
    "selections": [
      {
        "alias": "groups",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "eq",
                    "variableName": "employerId"
                  }
                ],
                "kind": "ObjectValue",
                "name": "employerId"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          }
        ],
        "concreteType": "AccountEmployerUserGroupsConnection",
        "kind": "LinkedField",
        "name": "__EmployerUserGroupSearchBox_groups_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountEmployerUserGroupsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsEmployerUserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "groupId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAdminGroup",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDefault",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node55.hash = "8469155d851bd9ba65bcc33931e839cd";
var EmployerUserGroupSearchBox_groups_graphql_default = node55;

// src/components/user-groups/EmployerUserGroupSearchBox.tsx
import {
  useCallback as useCallback15,
  useEffect as useEffect4,
  useMemo as useMemo4,
  useState as useState10
} from "react";
import { usePaginationFragment as usePaginationFragment4 } from "react-relay";
import { debounce as debounce4 } from "lodash-es";
import { CheckIcon as CheckIcon2, ChevronUpDownIcon as ChevronUpDownIcon2 } from "@heroicons/react/24/solid";
import { Combobox as Combobox2 } from "@headlessui/react";
import { classNames as classNames16 } from "shared-ui";
import { Fragment as Fragment6, jsx as jsx29, jsxs as jsxs20 } from "react/jsx-runtime";
var fragment3 = EmployerUserGroupSearchBox_groups_graphql_default;
var EmployerUserGroupSearchBox = ({
  onSelected,
  fragmentRef,
  defaultValue,
  disabled,
  showLabel
}) => {
  const [selected, setSelected] = useState10(defaultValue ?? null);
  const [searchTerm, setSearchTerm] = useState10("");
  const onQueryChangeHandler = useMemo4(
    () => debounce4((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect4(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback15(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [selected]
  );
  const { data, refetch } = usePaginationFragment4(fragment3, fragmentRef);
  const { groups } = data;
  const rows = (groups?.edges ?? []).map((edge) => edge.node);
  return /* @__PURE__ */ jsxs20(
    Combobox2,
    {
      as: "div",
      value: selected,
      onChange: onSetSelected,
      disabled,
      children: [
        showLabel && /* @__PURE__ */ jsx29(Combobox2.Label, { className: "text-primary-700 mb-2 block px-1 text-sm font-medium", children: "User Groups" }),
        /* @__PURE__ */ jsxs20("div", { className: "relative", children: [
          /* @__PURE__ */ jsx29(
            Combobox2.Input,
            {
              className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
              onChange: (event) => onQueryChangeHandler(event.target.value),
              displayValue: (result) => {
                if (result) {
                  return result.name;
                }
                return "";
              },
              autoComplete: "off",
              "aria-label": "User group search box"
            }
          ),
          /* @__PURE__ */ jsx29(
            Combobox2.Button,
            {
              className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
              "aria-label": "User group search box select",
              children: /* @__PURE__ */ jsx29(
                ChevronUpDownIcon2,
                {
                  className: "h-5 w-5 text-gray-600",
                  "aria-hidden": "true"
                }
              )
            }
          ),
          rows.length > 0 && /* @__PURE__ */ jsx29(Combobox2.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx29(
            Combobox2.Option,
            {
              value: result,
              className: ({ active }) => classNames16(
                "relative cursor-default select-none py-2 pl-3 pr-9",
                active ? "bg-info-600 text-white" : "text-gray-900"
              ),
              children: ({ active, selected: selected2 }) => /* @__PURE__ */ jsxs20(Fragment6, { children: [
                /* @__PURE__ */ jsx29("div", { className: "flex", children: /* @__PURE__ */ jsx29(
                  "span",
                  {
                    className: classNames16(
                      "truncate",
                      selected2 ? "font-semibold" : ""
                    ),
                    children: result.name
                  }
                ) }),
                selected2 && /* @__PURE__ */ jsx29(
                  "span",
                  {
                    className: classNames16(
                      "absolute inset-y-0 right-0 flex items-center pr-4",
                      active ? "bg-info-600 text-white" : "text-info-600"
                    ),
                    children: /* @__PURE__ */ jsx29(CheckIcon2, { className: "h-5 w-5", "aria-hidden": "true" })
                  }
                )
              ] })
            },
            result.id
          )) })
        ] })
      ]
    }
  );
};

// src/components/user-groups/EmployerUserGroupSearchBoxInput.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var graphqlQuery3 = EmployerUserGroupSearchBoxInputQuery_graphql_default;
var EmployerUserGroupSearchBoxInput = ({
  employerId,
  name,
  control,
  defaultValue
}) => {
  const query = useLazyLoadQuery5(
    graphqlQuery3,
    { employerId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx30(
    Controller2,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange } }) => /* @__PURE__ */ jsx30(
        EmployerUserGroupSearchBox,
        {
          onSelected: (result) => {
            onControllerChange(result.groupId);
          },
          fragmentRef: query,
          defaultValue
        }
      )
    }
  );
};

// src/components/users/EmployerUsersRoute.tsx
import { Outlet as Outlet2 } from "react-router-dom";
import { ErrorContainer as ErrorContainer6 } from "shared-ui";
import { OutletRoute as OutletRoute2 } from "app-core";

// src/components/users/__generated__/EmployerUsersListLoaderQuery.graphql.ts
var node56 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = [
    {
      "alias": "employer",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "employerCode"
        }
      ],
      "concreteType": "Employer",
      "kind": "LinkedField",
      "name": "accountsEmployerByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUsersListLoaderQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUsersListLoaderQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "ed47167c3cb93216041ef2ac5b436af8",
      "id": null,
      "metadata": {},
      "name": "EmployerUsersListLoaderQuery",
      "operationKind": "query",
      "text": "query EmployerUsersListLoaderQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    entityId\n    name\n    code\n  }\n}\n"
    }
  };
}();
node56.hash = "1a17e8c30ceb059a9ac40de62886d60f";
var EmployerUsersListLoaderQuery_graphql_default = node56;

// src/components/users/EmployerUsersListLoader.tsx
import { Suspense as Suspense14 } from "react";
import {
  loadQuery as loadQuery5,
  usePreloadedQuery as usePreloadedQuery7
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData5 } from "react-router-dom";
import { EdSkeleton as EdSkeleton13, MynPageTitle as MynPageTitle4 } from "shared-ui";
import { resolveEmployerCode as resolveEmployerCode2 } from "app-core";

// src/components/users/__generated__/EmployerUsersListLayoutQuery.graphql.ts
var node57 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userGroupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "employerCode",
    "variableName": "employerCode"
  }, v22 = {
    "kind": "Variable",
    "name": "userGroupId",
    "variableName": "userGroupId"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "updatedAt": "DESC"
      }
    },
    v22,
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUsersListLayoutQuery",
      "selections": [
        {
          "args": [
            v1,
            v22,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUsersList_users"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUsersListLayoutQuery",
      "selections": [
        {
          "alias": "users",
          "args": v4,
          "concreteType": "AccountEmployerUsersByEmployerCodeConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUsersByEmployerCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUsersByEmployerCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "users",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "EmployerUsersList_users",
          "kind": "LinkedHandle",
          "name": "accountEmployerUsersByEmployerCode"
        }
      ]
    },
    "params": {
      "cacheID": "57c457c6f6e6d368b0136fd71c04ba99",
      "id": null,
      "metadata": {},
      "name": "EmployerUsersListLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerUsersListLayoutQuery(\n  $employerCode: Long!\n  $userGroupId: UUID\n  $where: AccountsEmployerUserFilter\n) {\n  ...EmployerUsersList_users_1pPHZP\n}\n\nfragment EmployerUserView_user on AccountsEmployerUser {\n  id\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  createdAt\n  updatedAt\n}\n\nfragment EmployerUsersList_users_1pPHZP on Query {\n  users: accountEmployerUsersByEmployerCode(employerCode: $employerCode, userGroupId: $userGroupId, first: 25, order: {updatedAt: DESC}, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n        ...EmployerUserView_user\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node57.hash = "237ca3a67ec2b53f69a10823fd7a364f";
var EmployerUsersListLayoutQuery_graphql_default = node57;

// src/components/users/EmployerUsersListLayout.tsx
import { startTransition, Suspense as Suspense13, useCallback as useCallback18, useState as useState12 } from "react";
import { Button as Button9, DebouncedInput as DebouncedInput2, EdLink, EdSkeleton as EdSkeleton12, Size as Size4 } from "shared-ui";

// src/components/user-groups/__generated__/EmployerUserGroupSearchContainerQuery.graphql.ts
var node58 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupSearchContainerQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupSearchBox_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupSearchContainerQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v1,
          "concreteType": "AccountEmployerUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "groupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerUserGroupSearchBox_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "b9044526c65515ba1eb672a910d1ff8d",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupSearchContainerQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupSearchContainerQuery(\n  $employerId: UUID!\n) {\n  ...EmployerUserGroupSearchBox_groups_4aLTpM\n}\n\nfragment EmployerUserGroupSearchBox_groups_4aLTpM on Query {\n  groups: accountEmployerUserGroups(first: 10, order: [{name: ASC}], where: {employerId: {eq: $employerId}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        groupId\n        name\n        description\n        isAdminGroup\n        isDefault\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node58.hash = "be92056a4e81b25f95c39b25abef551a";
var EmployerUserGroupSearchContainerQuery_graphql_default = node58;

// src/components/user-groups/EmployerUserGroupSearchContainer.tsx
import { useCallback as useCallback16, useState as useState11 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery6 } from "react-relay";
import { jsx as jsx31 } from "react/jsx-runtime";
var graphqlQuery4 = EmployerUserGroupSearchContainerQuery_graphql_default;
var EmployerUserGroupSearchContainer = ({
  disabled,
  employerId,
  onSearchCompleted,
  showLabel,
  defaultValue
}) => {
  const [selectedResult, setSelectedResult] = useState11(defaultValue);
  const onSetSelected = useCallback16(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [onSearchCompleted, selectedResult]
  );
  const query = useLazyLoadQuery6(
    graphqlQuery4,
    { employerId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx31(
    EmployerUserGroupSearchBox,
    {
      onSelected: onSetSelected,
      fragmentRef: query,
      showLabel,
      defaultValue: selectedResult
    }
  );
};

// src/components/users/__generated__/EmployerUsersListPaginationQuery.graphql.ts
var node59 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "updatedAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userGroupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v22 = {
    "kind": "Variable",
    "name": "employerCode",
    "variableName": "employerCode"
  }, v32 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v4 = {
    "kind": "Variable",
    "name": "userGroupId",
    "variableName": "userGroupId"
  }, v5 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v6 = [
    v1,
    v22,
    v32,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    v4,
    v5
  ], v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUsersListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v22,
            v32,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            v4,
            v5
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUsersList_users"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUsersListPaginationQuery",
      "selections": [
        {
          "alias": "users",
          "args": v6,
          "concreteType": "AccountEmployerUsersByEmployerCodeConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUsersByEmployerCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUsersByEmployerCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "users",
          "args": v6,
          "filters": [],
          "handle": "connection",
          "key": "EmployerUsersList_users",
          "kind": "LinkedHandle",
          "name": "accountEmployerUsersByEmployerCode"
        }
      ]
    },
    "params": {
      "cacheID": "85482acdc92c2be9e602b5047de7e57a",
      "id": null,
      "metadata": {},
      "name": "EmployerUsersListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerUsersListPaginationQuery(\n  $after: String\n  $employerCode: Long!\n  $first: Int = 25\n  $sort: [AccountsEmployerUserSort!] = {updatedAt: DESC}\n  $userGroupId: UUID\n  $where: AccountsEmployerUserFilter\n) {\n  ...EmployerUsersList_users_1tExRl\n}\n\nfragment EmployerUserView_user on AccountsEmployerUser {\n  id\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  createdAt\n  updatedAt\n}\n\nfragment EmployerUsersList_users_1tExRl on Query {\n  users: accountEmployerUsersByEmployerCode(employerCode: $employerCode, userGroupId: $userGroupId, first: $first, after: $after, order: $sort, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n        ...EmployerUserView_user\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node59.hash = "0ab207abb2b6524f7efb49062ef64369";
var EmployerUsersListPaginationQuery_graphql_default = node59;

// src/components/users/__generated__/EmployerUsersList_users.graphql.ts
var node60 = /* @__PURE__ */ function() {
  var v0 = [
    "users"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "employerCode"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "updatedAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userGroupId"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerUsersListPaginationQuery_graphql_default
      }
    },
    "name": "EmployerUsersList_users",
    "selections": [
      {
        "alias": "users",
        "args": null,
        "concreteType": "AccountEmployerUsersByEmployerCodeConnection",
        "kind": "LinkedField",
        "name": "__EmployerUsersList_users_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountEmployerUsersByEmployerCodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsEmployerUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountsEmployerUserGroup",
                    "kind": "LinkedField",
                    "name": "userGroups",
                    "plural": true,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAdminGroup",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDefault",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerUserView_user"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node60.hash = "0ab207abb2b6524f7efb49062ef64369";
var EmployerUsersList_users_graphql_default = node60;

// src/components/users/EmployerUsersList.tsx
import {
  isValidElement as isValidElement2,
  useCallback as useCallback17
} from "react";
import {
  usePaginationFragment as usePaginationFragment5,
  usePreloadedQuery as usePreloadedQuery6
} from "react-relay";
import { formatDistanceToNow as formatDistanceToNow3, parseISO as parseISO3 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined3 } from "shared-lib";
import { EdButtonLink as EdButtonLink2, ListLayout as ListLayout3 } from "shared-ui";

// src/components/users/__generated__/EmployerUserView_user.graphql.ts
var node61 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserView_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUser",
  "abstractKey": null
};
node61.hash = "8202d9684178842ac836c25f126959f1";
var EmployerUserView_user_graphql_default = node61;

// src/components/users/EmployerUserView.tsx
import { useFragment as useFragment9 } from "react-relay";
import { jsx as jsx32 } from "react/jsx-runtime";
var fragmentDef10 = EmployerUserView_user_graphql_default;
var EmployerUserView = ({ fragmentRef }) => {
  const data = useFragment9(fragmentDef10, fragmentRef);
  const title = `${data.firstName} ${data.lastName}`;
  return /* @__PURE__ */ jsx32("div", { children: /* @__PURE__ */ jsx32("div", { className: "grid", children: /* @__PURE__ */ jsx32("div", { children: title }) }) });
};

// src/components/users/EmployerUsersList.tsx
import { jsx as jsx33, jsxs as jsxs21 } from "react/jsx-runtime";
var fragmentDef11 = EmployerUsersList_users_graphql_default;
var SectionElement2 = ({ children }) => {
  return /* @__PURE__ */ jsx33("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var ItemHeader2 = ({ section }) => {
  const code = section.context.code;
  const titleIsElement = isValidElement2(section.itemTitle);
  return /* @__PURE__ */ jsxs21("div", { children: [
    /* @__PURE__ */ jsx33("div", { children: /* @__PURE__ */ jsx33("h1", { children: "User" }) }),
    titleIsElement ? section.itemTitle : /* @__PURE__ */ jsx33("div", { className: "font-InterMedium text-info-gray-800 text-3xl font-bold tracking-tight", children: section.itemTitle }),
    /* @__PURE__ */ jsx33("div", { className: "flex items-center space-x-2 sm:justify-end", children: /* @__PURE__ */ jsx33(EdButtonLink2, { name: "View", to: `../../../view/${code}` }) })
  ] });
};
var EmployerUserList = ({ queryRef }) => {
  const query = usePreloadedQuery6(
    EmployerUsersListQueryDef,
    queryRef
  );
  const { data, loadNext, isLoadingNext } = usePaginationFragment5(fragmentDef11, query);
  const { users } = data;
  const sections = (users?.edges || []).filter(isNotNullOrUndefined3).map(({ node: user }) => {
    const title = `${user.firstName} ${user.lastName}`;
    return {
      key: user.code.toString(),
      mobileLink: `../${user.code}`,
      itemTitle: title,
      listTitle: /* @__PURE__ */ jsx33("div", { className: "flex w-full grow justify-between gap-2", children: /* @__PURE__ */ jsx33("div", { className: "text-sm font-medium uppercase", children: title }) }),
      description: /* @__PURE__ */ jsxs21("div", { className: "text-xs", children: [
        "Updated",
        " ",
        formatDistanceToNow3(parseISO3(user.updatedAt), {
          addSuffix: true
        })
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: user.code
      },
      element: /* @__PURE__ */ jsx33(SectionElement2, { children: /* @__PURE__ */ jsx33(EmployerUserView, { fragmentRef: user }) })
    };
  });
  const loadMore = useCallback17(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(15);
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx33(
    ListLayout3,
    {
      sections,
      itemHeader: (s4) => /* @__PURE__ */ jsx33(ItemHeader2, { section: s4 }),
      loadMore,
      isLoading: isLoadingNext,
      showFilters: false
    }
  );
};

// src/components/users/EmployerUsersListLayout.tsx
import { useQueryPreloader as useQueryPreloader2 } from "shared-lib";
import { jsx as jsx34, jsxs as jsxs22 } from "react/jsx-runtime";
var EmployerUsersListQueryDef = EmployerUsersListLayoutQuery_graphql_default;
var SearchSection = ({ term, onSearch, group, onGroupChange, employerId }) => /* @__PURE__ */ jsxs22("div", { className: "flex items-center gap-2", children: [
  /* @__PURE__ */ jsxs22("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx34("div", { className: "text-sm font-medium text-gray-900 lg:flex", children: "Search" }),
    /* @__PURE__ */ jsx34(
      DebouncedInput2,
      {
        value: term ?? "",
        placeholder: "Search by name, email",
        onValueChanged: (value) => onSearch(value.trim())
      }
    )
  ] }),
  /* @__PURE__ */ jsxs22("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx34("div", { className: "text-sm font-medium text-gray-900 lg:flex", children: "Group" }),
    /* @__PURE__ */ jsx34(
      EmployerUserGroupSearchContainer,
      {
        defaultValue: group ?? void 0,
        employerId,
        onSearchCompleted: (group2) => onGroupChange(group2)
      }
    )
  ] })
] });
var EmployerUsersListLayout = ({
  employerCode,
  employerId
}) => {
  const [term, setTerm] = useState12("");
  const [group, setGroup] = useState12();
  let where = {};
  const onSearch = useCallback18(
    (searchTerm) => {
      const parts = searchTerm?.split(/\s+/);
      const firstPart = parts?.[0];
      const secondPart = parts?.slice(1)?.join(" ");
      setTerm(searchTerm);
      where = {
        ...where,
        or: [
          {
            firstName: { startsWith: firstPart },
            and: [{ lastName: { startsWith: secondPart } }]
          },
          {
            lastName: { startsWith: firstPart },
            and: [{ firstName: { startsWith: secondPart } }]
          },
          {
            firstName: { startsWith: searchTerm }
          },
          {
            lastName: { startsWith: searchTerm }
          },
          { emailAddress: { startsWith: searchTerm } }
        ]
      };
      startTransition(() => {
        loadQuery8(
          {
            employerCode,
            where,
            userGroupId: group?.groupId
          },
          { fetchPolicy: "network-only" }
        );
      });
    },
    [term, group, employerCode]
  );
  const onGroupChange = useCallback18(
    (group2) => {
      setGroup(group2);
      onReload(group2.groupId);
    },
    [group, employerCode]
  );
  let parameters = {
    employerCode,
    where
  };
  if (group) {
    parameters = {
      ...parameters,
      userGroupId: group.groupId
    };
  }
  const [queryReference, loadQuery8] = useQueryPreloader2(
    EmployerUsersListQueryDef,
    parameters
  );
  const onReload = useCallback18(
    (groupId) => {
      startTransition(() => {
        loadQuery8(
          {
            employerCode,
            where,
            userGroupId: groupId
          },
          { fetchPolicy: "network-only" }
        );
      });
    },
    [loadQuery8]
  );
  if (!queryReference) {
    return /* @__PURE__ */ jsx34("div", { className: "m-8", children: /* @__PURE__ */ jsx34(EdSkeleton12, {}) });
  }
  return /* @__PURE__ */ jsxs22("div", { children: [
    /* @__PURE__ */ jsxs22("div", { className: "hidden items-center justify-between gap-4 border-b bg-white px-2 py-2 md:px-4 lg:flex lg:px-8", children: [
      /* @__PURE__ */ jsx34("h1", { className: "py-2 text-2xl font-medium text-gray-700", children: "Users List" }),
      /* @__PURE__ */ jsx34(
        SearchSection,
        {
          term,
          onSearch,
          group,
          onGroupChange,
          employerId
        }
      ),
      /* @__PURE__ */ jsx34("div", { className: "hidden items-center justify-center lg:flex", children: /* @__PURE__ */ jsx34(EdLink, { name: "add-new-user-desktop", href: "./create", children: /* @__PURE__ */ jsx34(Button9, { "aria-label": "Add new user", size: Size4.lg, color: "green", children: "New\xA0User" }) }) })
    ] }),
    /* @__PURE__ */ jsxs22("div", { className: "flex w-full flex-col items-center justify-between gap-4 border-b bg-white px-2 py-2 md:px-4 lg:hidden lg:px-8", children: [
      /* @__PURE__ */ jsxs22("div", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ jsx34("h1", { className: "py-2 text-2xl font-medium text-gray-700", children: "Users List" }),
        /* @__PURE__ */ jsx34("div", { className: "items-center justify-center lg:flex", children: /* @__PURE__ */ jsx34(EdLink, { name: "add-new-user-mobile", href: "./create", children: /* @__PURE__ */ jsx34(
          Button9,
          {
            "aria-label": "add new user mobile",
            size: Size4.lg,
            color: "green",
            children: "New\xA0User"
          }
        ) }) })
      ] }),
      /* @__PURE__ */ jsx34(
        SearchSection,
        {
          term,
          onSearch,
          group,
          onGroupChange,
          employerId
        }
      )
    ] }),
    /* @__PURE__ */ jsx34(Suspense13, { fallback: /* @__PURE__ */ jsx34(EdSkeleton12, {}), children: /* @__PURE__ */ jsx34(EmployerUserList, { queryRef: queryReference }) })
  ] });
};

// src/components/users/EmployerUsersListLoader.tsx
import { jsx as jsx35, jsxs as jsxs23 } from "react/jsx-runtime";
async function loader5(environment, params, context) {
  const employerCode = resolveEmployerCode2(params, context);
  const queryRef = loadQuery5(
    environment,
    useEmployerUsersListLoaderRouteData.query,
    {
      employerCode
    }
  );
  return {
    employerCode,
    queryRef
  };
}
function useEmployerUsersListLoaderRouteData(routeId) {
  const { queryRef } = useRouteLoaderData5(routeId);
  const query = usePreloadedQuery7(
    useEmployerUsersListLoaderRouteData.query,
    queryRef
  );
  return {
    query
  };
}
useEmployerUsersListLoaderRouteData.query = EmployerUsersListLoaderQuery_graphql_default;
var EmployerUsersListLoader = ({
  routeId
}) => {
  const { query } = useEmployerUsersListLoaderRouteData(routeId);
  const { employer } = query;
  if (!employer) {
    return /* @__PURE__ */ jsx35(EdSkeleton13, {});
  }
  return /* @__PURE__ */ jsx35("div", { className: "flex-1", children: /* @__PURE__ */ jsxs23(Suspense14, { fallback: /* @__PURE__ */ jsx35(EdSkeleton13, {}), children: [
    /* @__PURE__ */ jsx35(MynPageTitle4, { title: "Employer Users" }),
    /* @__PURE__ */ jsx35(
      EmployerUsersListLayout,
      {
        employerCode: employer.code,
        employerId: employer.entityId
      }
    )
  ] }) });
};

// src/components/users/EmployerUserRoute.tsx
import { Navigate as Navigate2 } from "react-router-dom";
import { ErrorContainer as ErrorContainer5 } from "shared-ui";

// src/components/users/__generated__/EmployerUserLayoutQuery.graphql.ts
var node62 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDeleted",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserLayoutQuery",
      "selections": [
        {
          "alias": "user",
          "args": v1,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserByCode",
          "plural": false,
          "selections": [
            v22,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserDetailsEditor_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserGroupsEditor_user"
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserLayoutQuery",
      "selections": [
        {
          "alias": "user",
          "args": v1,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserByCode",
          "plural": false,
          "selections": [
            v22,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployerUserGroup",
              "kind": "LinkedField",
              "name": "userGroups",
              "plural": true,
              "selections": [
                v22,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAdminGroup",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDefault",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "groupId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6cc6338168966353cb265fc62fd94c12",
      "id": null,
      "metadata": {},
      "name": "EmployerUserLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerUserLayoutQuery(\n  $code: Long!\n) {\n  user: accountEmployerUserByCode(code: $code) {\n    id\n    accountId\n    firstName\n    lastName\n    emailAddress\n    updatedAt\n    isDeleted\n    ...EmployerUserDetailsEditor_user\n    ...EmployerUserGroupsEditor_user\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n\nfragment EmployerUserGroupsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  updatedAt\n  userGroups {\n    id\n    groupId\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node62.hash = "215e08205f279f5a6885bdf57723c747";
var EmployerUserLayoutQuery_graphql_default = node62;

// src/components/users/EmployerUserLayout.tsx
import { Suspense as Suspense18 } from "react";
import {
  loadQuery as loadQuery6,
  usePreloadedQuery as usePreloadedQuery8
} from "react-relay";
import { Link as Link4, useRouteLoaderData as useRouteLoaderData6 } from "react-router-dom";
import { EdSkeleton as EdSkeleton17 } from "shared-ui";

// src/components/users/EmployerUserDetails.tsx
import { Suspense as Suspense17 } from "react";
import { useToggle as useToggle5 } from "shared-lib";
import { EdSkeleton as EdSkeleton16 } from "shared-ui";

// src/components/users/EmployerUserDetailsView.tsx
import { PencilIcon as PencilIcon2 } from "@heroicons/react/24/outline";
import { timeAgo } from "shared-lib";
import { MynPageTitle as MynPageTitle5 } from "shared-ui";
import { jsx as jsx36, jsxs as jsxs24 } from "react/jsx-runtime";
var EmployerUserDetailsView = ({ user, onEdit }) => {
  return /* @__PURE__ */ jsxs24("div", { className: "flex justify-between border bg-white p-8", children: [
    /* @__PURE__ */ jsx36(MynPageTitle5, { title: "Employer User Details" }),
    /* @__PURE__ */ jsxs24("div", { children: [
      user.isDeleted && /* @__PURE__ */ jsx36("div", { className: "mb-4 border bg-gray-100 px-8 py-4", children: /* @__PURE__ */ jsx36("div", { className: "text-danger-500 text-xl font-bold", children: "Disabled" }) }),
      /* @__PURE__ */ jsxs24("div", { className: "flex items-start gap-2", children: [
        /* @__PURE__ */ jsx36("div", { children: user.firstName }),
        /* @__PURE__ */ jsx36("div", { children: user.lastName })
      ] }),
      /* @__PURE__ */ jsx36("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx36("div", { children: user.emailAddress }) }),
      /* @__PURE__ */ jsx36("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsxs24("div", { children: [
        "Updated: ",
        timeAgo(user.updatedAt)
      ] }) })
    ] }),
    /* @__PURE__ */ jsx36("div", { children: /* @__PURE__ */ jsx36(
      "div",
      {
        "aria-label": "Edit User",
        className: "text-primary-400 flex cursor-pointer pb-5 pl-5",
        onClick: onEdit,
        children: /* @__PURE__ */ jsx36(PencilIcon2, { className: "h-6 w-6" })
      }
    ) })
  ] });
};

// src/components/users/__generated__/EmployerUserDetailsEditor_user.graphql.ts
var node63 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployerUserDetailsEditor_user",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailAddress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isTest",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDeleted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "AccountsEmployerUser",
    "abstractKey": null
  };
}();
node63.hash = "9702149c9b64b2fc8e0ca76efecc768e";
var EmployerUserDetailsEditor_user_graphql_default = node63;

// src/components/users/EmployerUserDetailsEditor.tsx
import { useCallback as useCallback19 } from "react";
import { useFragment as useFragment10 } from "react-relay";
import { useForm as useForm6 } from "react-hook-form";
import { zodResolver as zodResolver6 } from "@hookform/resolvers/zod";
import * as zod6 from "zod";
import { Suspense as Suspense15 } from "shared-ui";
import { createClientMutationId as createClientMutationId9 } from "shared-lib";
import {
  Button as Button10,
  ButtonList as ButtonList4,
  CheckboxInput as CheckboxInput2,
  EdSkeleton as EdSkeleton14,
  FormInput as FormInput4,
  Size as Size5
} from "shared-ui";
import { jsx as jsx37, jsxs as jsxs25 } from "react/jsx-runtime";
var fragmentDef12 = EmployerUserDetailsEditor_user_graphql_default;
var FormSchema2 = zod6.object({
  firstName: zod6.string().min(1),
  lastName: zod6.string().min(1),
  isTest: zod6.boolean().optional()
});
var EmployerUserDetailsEditor = ({
  fragmentRef,
  onCancel,
  onDone,
  onEnabled,
  onDisabled
}) => {
  const data = useFragment10(
    fragmentDef12,
    fragmentRef
  );
  const [update, isUpdating] = useEmployerUserUpdate();
  const [enable, isEnabling] = useEmployerUserEnable();
  const [disable, isDisabling] = useEmployerUserDisable();
  const defaultValues = {
    firstName: data.firstName || "",
    lastName: data.lastName || "",
    isTest: data.isTest
  };
  const { register, handleSubmit, formState, control } = useForm6({
    // There is a bug in yup which causes it to compare the type boolean with the string 'true', so we're checking any to avoid this
    resolver: zodResolver6(FormSchema2),
    defaultValues
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((form) => onSave(isValid, form));
  const onSave = useCallback19(
    async (isValid2, form) => {
      if (!form.firstName || !form.lastName) {
        return;
      }
      const input = {
        userId: data.accountId,
        firstName: form.firstName,
        lastName: form.lastName,
        isTestUser: form.isTest,
        clientMutationId: createClientMutationId9()
      };
      const response = await update({ input });
      if (response.data.employerUser) {
        onDone();
      }
    },
    [update, data.accountId, onDone]
  );
  const onEnable = useCallback19(async () => {
    const input = {
      userId: data.accountId,
      clientMutationId: createClientMutationId9()
    };
    const response = await enable({ input });
    if (response.data?.employerUser) {
      onEnabled();
    }
  }, [enable, data.accountId, onEnabled]);
  const onDisable = useCallback19(async () => {
    const input = {
      userId: data.accountId,
      clientMutationId: createClientMutationId9()
    };
    const response = await disable({ input });
    if (response.data?.employerUser) {
      onDisabled();
    }
  }, [disable, data.accountId, onDisabled]);
  if (data === null) {
    return /* @__PURE__ */ jsx37(EdSkeleton14, {});
  }
  return /* @__PURE__ */ jsx37(Suspense15, { fallback: /* @__PURE__ */ jsx37(EdSkeleton14, {}), children: /* @__PURE__ */ jsx37("div", { className: "border bg-white p-8", children: /* @__PURE__ */ jsxs25("form", { onSubmit, children: [
    /* @__PURE__ */ jsxs25("div", { className: "mt-4", children: [
      /* @__PURE__ */ jsx37("label", { children: "First Name *" }),
      /* @__PURE__ */ jsx37(
        FormInput4,
        {
          "aria-label": "first name",
          className: "mt-1",
          type: "text",
          placeholder: " First Name ",
          name: "firstName",
          required: true,
          register
        }
      ),
      errors.firstName && /* @__PURE__ */ jsx37("p", { children: errors.firstName.message })
    ] }),
    /* @__PURE__ */ jsxs25("div", { className: "mt-4", children: [
      /* @__PURE__ */ jsx37("label", { children: "Last Name *" }),
      /* @__PURE__ */ jsx37(
        FormInput4,
        {
          "aria-label": "last name",
          className: "mt-1",
          type: "text",
          placeholder: " Last Name ",
          name: "lastName",
          required: true,
          register
        }
      ),
      errors.lastName && /* @__PURE__ */ jsx37("p", { children: errors.lastName.message })
    ] }),
    /* @__PURE__ */ jsxs25("div", { className: "mt-4", children: [
      /* @__PURE__ */ jsx37(
        CheckboxInput2,
        {
          label: /* @__PURE__ */ jsx37("span", { children: "Is Test" }),
          name: "isTest",
          defaultChecked: defaultValues.isTest,
          control,
          disabled: false
        }
      ),
      errors.isTest && /* @__PURE__ */ jsx37("p", { children: errors.isTest.message })
    ] }),
    /* @__PURE__ */ jsxs25("div", { className: "mt-4 flex items-center justify-between", children: [
      data.isDeleted ? /* @__PURE__ */ jsx37("div", { children: /* @__PURE__ */ jsx37(
        Button10,
        {
          "aria-label": "enable user",
          color: "danger",
          size: Size5.xl,
          disabled: isEnabling,
          confirmMessage: "Are you sure ?",
          onClick: onEnable,
          children: "Enable User"
        }
      ) }) : /* @__PURE__ */ jsx37("div", { children: /* @__PURE__ */ jsx37(
        Button10,
        {
          "aria-label": "disable user",
          color: "danger",
          size: Size5.xl,
          disabled: isDisabling,
          confirmMessage: "Are you sure ?",
          onClick: onDisable,
          children: "Disable User"
        }
      ) }),
      /* @__PURE__ */ jsxs25(ButtonList4, { children: [
        /* @__PURE__ */ jsx37("div", { children: /* @__PURE__ */ jsx37(
          Button10,
          {
            "aria-label": "submit contact detail form",
            type: "submit",
            color: "primary",
            size: Size5.md,
            disabled: isUpdating || !isValid,
            children: "Save"
          }
        ) }),
        /* @__PURE__ */ jsx37("div", { children: /* @__PURE__ */ jsx37(
          Button10,
          {
            "aria-label": "cancel contact detail",
            color: "gray",
            size: Size5.md,
            disabled: isUpdating,
            onClick: onCancel,
            children: "Cancel"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsx37("div", { className: "mt-4 flex items-center justify-end border-t p-4" })
  ] }) }) });
};

// src/components/users/__generated__/EmployerUserGroupsEditor_user.graphql.ts
var node64 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployerUserGroupsEditor_user",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "groupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "AccountsEmployerUser",
    "abstractKey": null
  };
}();
node64.hash = "7855dfa800c7eac4d5c446d5c006bd45";
var EmployerUserGroupsEditor_user_graphql_default = node64;

// src/components/users/EmployerUserGroupsEditor.tsx
import { useCallback as useCallback20, useState as useState13 } from "react";
import { useFragment as useFragment11 } from "react-relay";
import { Suspense as Suspense16 } from "shared-ui";
import { createClientMutationId as createClientMutationId10, useToggle as useToggle4 } from "shared-lib";
import { Button as Button11, ButtonList as ButtonList5, EdSkeleton as EdSkeleton15, Size as Size6 } from "shared-ui";
import { jsx as jsx38, jsxs as jsxs26 } from "react/jsx-runtime";
var fragmentDef13 = EmployerUserGroupsEditor_user_graphql_default;
var EmployerUserGroupsEditor = ({ fragmentRef }) => {
  const data = useFragment11(
    fragmentDef13,
    fragmentRef
  );
  const [isJoiningGroup, toggleIsJoiningGroup] = useToggle4();
  const [join, isJoining] = useEmployerUserJoinGroup();
  const [leave, isLeaving] = useEmployerUserLeaveGroup();
  const [group, setGroup] = useState13(
    null
  );
  const onJoin = useCallback20(
    async (group2) => {
      const input = {
        userId: data.accountId,
        userGroupId: group2.groupId,
        clientMutationId: createClientMutationId10()
      };
      await join({ input });
      setGroup(null);
      toggleIsJoiningGroup();
    },
    [join]
  );
  const onLeave = useCallback20(
    async (group2) => {
      const input = {
        userId: data.accountId,
        userGroupId: group2.groupId,
        clientMutationId: createClientMutationId10()
      };
      await leave({ input });
    },
    [leave]
  );
  if (data === null) {
    return /* @__PURE__ */ jsx38(EdSkeleton15, {});
  }
  const groupsRows = data.userGroups.map((g3) => {
    return /* @__PURE__ */ jsxs26(
      "div",
      {
        className: "flex cursor-pointer items-center justify-between border-b p-2 hover:bg-gray-50",
        children: [
          /* @__PURE__ */ jsx38("div", { children: g3.name }),
          /* @__PURE__ */ jsx38("div", { children: /* @__PURE__ */ jsx38(Button11, { color: "warning", size: Size6.sm, onClick: () => onLeave(g3), children: "remove" }) })
        ]
      },
      g3.groupId
    );
  });
  if (data === null) {
    return /* @__PURE__ */ jsx38(EdSkeleton15, {});
  }
  return /* @__PURE__ */ jsx38(Suspense16, { fallback: /* @__PURE__ */ jsx38(EdSkeleton15, {}), children: isJoiningGroup ? /* @__PURE__ */ jsx38("div", { className: "flex", children: /* @__PURE__ */ jsxs26("div", { className: "flex w-1/2 flex-col gap-4 border bg-white p-4", children: [
    /* @__PURE__ */ jsx38("div", { className: "flex", children: /* @__PURE__ */ jsx38("div", { className: "text-primary-500 font-medium", children: "Select a User Group below" }) }),
    /* @__PURE__ */ jsx38("div", { className: "", children: /* @__PURE__ */ jsx38(
      EmployerUserGroupSearchContainer,
      {
        disabled: isJoining || isLeaving,
        employerId: data.employerId,
        onSearchCompleted: setGroup,
        showLabel: true
      }
    ) }),
    /* @__PURE__ */ jsxs26(ButtonList5, { children: [
      /* @__PURE__ */ jsx38("div", { children: /* @__PURE__ */ jsx38(
        Button11,
        {
          "aria-label": "Add user to group form",
          color: "primary",
          disabled: isJoining || isLeaving || !group,
          size: Size6.lg,
          onClick: () => group && onJoin(group),
          children: "Save"
        }
      ) }),
      /* @__PURE__ */ jsx38("div", { children: /* @__PURE__ */ jsx38(
        Button11,
        {
          "aria-label": "Cancel user to group form",
          color: "gray",
          disabled: isJoining || isLeaving,
          size: Size6.lg,
          onClick: toggleIsJoiningGroup,
          children: "Cancel"
        }
      ) })
    ] })
  ] }) }) : /* @__PURE__ */ jsxs26("div", { className: "flex flex-col gap-3", children: [
    data.userGroups.length > 0 && /* @__PURE__ */ jsxs26("div", { className: "flex flex-col gap-3 border bg-white p-4", children: [
      /* @__PURE__ */ jsx38("h1", { className: "font-regular px-2 text-gray-600", children: "User Groups" }),
      groupsRows
    ] }),
    /* @__PURE__ */ jsx38("div", { className: "flex justify-end", children: /* @__PURE__ */ jsx38("div", { children: /* @__PURE__ */ jsx38(
      Button11,
      {
        "aria-label": "Add user to group",
        color: "primary",
        size: Size6.lg,
        onClick: toggleIsJoiningGroup,
        children: "Add to Group"
      }
    ) }) })
  ] }) });
};

// src/components/users/EmployerUserDetails.tsx
import { jsx as jsx39, jsxs as jsxs27 } from "react/jsx-runtime";
var EmployerUserDetails = ({
  userRouteId
}) => {
  const { user } = useEmployerUserRouteData(userRouteId);
  const [isEditing, toggleIsEditing] = useToggle5();
  if (user === null || user === void 0) {
    return /* @__PURE__ */ jsx39(EdSkeleton16, {});
  }
  let details = /* @__PURE__ */ jsx39("div", {});
  if (user) {
    details = isEditing ? /* @__PURE__ */ jsx39(
      EmployerUserDetailsEditor,
      {
        fragmentRef: user,
        onCancel: toggleIsEditing,
        onDone: toggleIsEditing,
        onEnabled: toggleIsEditing,
        onDisabled: toggleIsEditing
      }
    ) : /* @__PURE__ */ jsx39(EmployerUserDetailsView, { user, onEdit: toggleIsEditing });
  }
  return /* @__PURE__ */ jsxs27(Suspense17, { fallback: /* @__PURE__ */ jsx39(EdSkeleton16, {}), children: [
    /* @__PURE__ */ jsx39("div", { className: "mb-4", children: details }),
    /* @__PURE__ */ jsx39("div", { children: user && /* @__PURE__ */ jsx39(EmployerUserGroupsEditor, { fragmentRef: user }) })
  ] });
};

// src/components/users/EmployerUserLayout.tsx
import { jsx as jsx40, jsxs as jsxs28 } from "react/jsx-runtime";
var queryDef8 = EmployerUserLayoutQuery_graphql_default;
async function loader6(environment, params) {
  const employerUserCode = params.employerUserCode;
  const code = Number(employerUserCode);
  const queryRef = loadQuery6(environment, queryDef8, {
    code
  });
  return {
    queryRef
  };
}
function useEmployerUserRouteData(routeId) {
  const { queryRef } = useRouteLoaderData6(routeId);
  return usePreloadedQuery8(queryDef8, queryRef);
}
var EmployerUserLayout = ({
  userRouteId
}) => {
  return /* @__PURE__ */ jsx40(Suspense18, { fallback: /* @__PURE__ */ jsx40(EdSkeleton17, {}), children: /* @__PURE__ */ jsxs28("div", { className: "flex-1", children: [
    /* @__PURE__ */ jsx40("div", { className: "border-b bg-white p-4 lg:hidden", children: /* @__PURE__ */ jsx40(
      Link4,
      {
        className: "text-primary-500 text-md underline underline-offset-4",
        to: "../../list",
        children: "Users"
      }
    ) }),
    /* @__PURE__ */ jsx40("div", { className: "sm:m-4", children: /* @__PURE__ */ jsx40(EmployerUserDetails, { userRouteId }) })
  ] }) });
};

// src/components/users/EmployerUserRoute.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var createEmployersUserRoutes = (listRouteId, suffix, environment, context) => {
  const routeId = `${listRouteId}-employer-user-${suffix}`;
  return [
    {
      path: "*",
      id: routeId,
      element: /* @__PURE__ */ jsx41(EmployerUserLayout, { userRouteId: routeId }),
      errorElement: /* @__PURE__ */ jsx41(ErrorContainer5, {}),
      loader: ({ params }) => {
        return loader6(environment, params);
      },
      children: [
        {
          path: "details",
          id: `${routeId}-details`,
          element: /* @__PURE__ */ jsx41(EmployerUserDetails, { userRouteId: routeId }),
          errorElement: /* @__PURE__ */ jsx41(ErrorContainer5, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx41(Navigate2, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/components/users/EmployerUserCreate.tsx
import { useCallback as useCallback21, useState as useState14 } from "react";
import { Link as Link5, useNavigate as useNavigate2 } from "react-router-dom";
import { useForm as useForm7 } from "react-hook-form";
import { zodResolver as zodResolver7 } from "@hookform/resolvers/zod";
import * as zod7 from "zod";
import { RadioGroup } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { MynPageTitle as MynPageTitle6, Suspense as Suspense19 } from "shared-ui";
import { createClientMutationId as createClientMutationId11 } from "shared-lib";
import {
  Button as Button12,
  ButtonList as ButtonList6,
  CheckboxInput as CheckboxInput3,
  EdSkeleton as EdSkeleton18,
  Error as Error3,
  FormInput as FormInput5,
  Size as Size7,
  classNames as classNames17
} from "shared-ui";
import {
  IdentityUserSearchBoxContainer
} from "app-core";
import { Fragment as Fragment7, jsx as jsx42, jsxs as jsxs29 } from "react/jsx-runtime";
var formSchema5 = zod7.object({
  firstName: zod7.string().nonempty(),
  lastName: zod7.string().nonempty(),
  groupId: zod7.string().optional().nullable(),
  email: zod7.string().optional(),
  isTest: zod7.boolean().optional()
});
var EmployerUserCreate = ({
  listRouteId,
  canSearchIdentities
}) => {
  const [mutationErrors, setMutationErrors] = useState14([]);
  const { query } = useEmployerUsersListLoaderRouteData(listRouteId);
  const { employer } = query;
  const navigate = useNavigate2();
  const [isCreatingIdentity, setIsCreatingIdentity] = useState14(true);
  const [create, isCreating] = useEmployerUserCreate();
  const [selectedIdentity, setSelectedIdentity] = useState14();
  const onSearchCompleted = useCallback21(
    (result) => {
      setSelectedIdentity(result);
    },
    [setSelectedIdentity]
  );
  const onCancel = useCallback21(() => {
    navigate("../");
  }, []);
  const defaultValues = {
    firstName: "",
    lastName: "",
    email: "",
    groupId: null,
    isTest: false
  };
  const { register, handleSubmit, formState, control } = useForm7({
    // There is a bug in yup which causes it to compare the type boolean with the string 'true', so we're checking any to avoid this
    resolver: zodResolver7(formSchema5),
    defaultValues
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((data) => onSave(isValid, data));
  const onSave = useCallback21(
    async (isValid2, form) => {
      if (!isCreatingIdentity && !selectedIdentity) {
        return;
      }
      if (isCreatingIdentity && !form.email) {
        return;
      }
      if (!employer || !form.firstName || !form.lastName || !form.groupId) {
        return;
      }
      let identityUserContext;
      let email;
      if (isCreatingIdentity) {
        identityUserContext = {
          create: true
        };
        email = form.email;
      } else {
        identityUserContext = {
          identityId: selectedIdentity.identityUserId
        };
        email = selectedIdentity.email;
      }
      const input = {
        employerId: employer.entityId,
        firstName: form.firstName,
        lastName: form.lastName,
        email,
        groupId: form.groupId,
        isTestUser: form.isTest || false,
        clientMutationId: createClientMutationId11(),
        identityUserContext
      };
      const result = await create({ input });
      if (result.data.employerUser === null || result.data.employerUser?.node === null) {
        setMutationErrors(result.data.userErrors);
        return;
      }
      navigate(`../${result.data.employerUser?.node.code}`);
    },
    [create]
  );
  if (employer === null || employer === void 0) {
    return /* @__PURE__ */ jsx42(EdSkeleton18, {});
  }
  return /* @__PURE__ */ jsxs29(Suspense19, { fallback: /* @__PURE__ */ jsx42(EdSkeleton18, {}), children: [
    /* @__PURE__ */ jsx42(MynPageTitle6, { title: "Create Employer User" }),
    /* @__PURE__ */ jsxs29("div", { className: "flex flex-1 flex-col", children: [
      /* @__PURE__ */ jsx42("div", { className: "border bg-white p-2 lg:hidden", children: /* @__PURE__ */ jsx42(Link5, { to: "../", children: "Users" }) }),
      /* @__PURE__ */ jsx42("div", { className: "flex justify-center", children: /* @__PURE__ */ jsxs29("form", { onSubmit, className: "m-4 w-1/2 border bg-white p-4", children: [
        /* @__PURE__ */ jsxs29("div", { className: "mt-4", children: [
          /* @__PURE__ */ jsx42("label", { children: "First Name *" }),
          /* @__PURE__ */ jsx42(
            FormInput5,
            {
              "aria-label": "First Name",
              className: "mt-1",
              type: "text",
              placeholder: " First Name ",
              name: "firstName",
              required: true,
              register
            }
          ),
          errors.firstName && /* @__PURE__ */ jsx42("p", { children: errors.firstName.message })
        ] }),
        /* @__PURE__ */ jsxs29("div", { className: "mt-4", children: [
          /* @__PURE__ */ jsx42("label", { children: "Last Name *" }),
          /* @__PURE__ */ jsx42(
            FormInput5,
            {
              "aria-label": "Last Name",
              className: "mt-1",
              type: "text",
              placeholder: " Last Name ",
              name: "lastName",
              required: true,
              register
            }
          ),
          errors.lastName && /* @__PURE__ */ jsx42("p", { children: errors.lastName.message })
        ] }),
        canSearchIdentities && /* @__PURE__ */ jsx42("div", { className: "mt-4", children: /* @__PURE__ */ jsx42(
          ToggleSwitch,
          {
            label: "Identity",
            onChanged: setIsCreatingIdentity,
            defaultChecked: true,
            yesLabel: "Yes",
            yesDescription: "Create a new login for this user",
            noLabel: "No",
            noDescription: "Search for an existing login for this user"
          }
        ) }),
        isCreatingIdentity ? /* @__PURE__ */ jsxs29("div", { className: "mt-4", children: [
          /* @__PURE__ */ jsx42("label", { children: "Email *" }),
          /* @__PURE__ */ jsx42(
            FormInput5,
            {
              "aria-label": "Email",
              className: "mt-1",
              type: "text",
              placeholder: " Email ",
              name: "email",
              required: true,
              register
            }
          ),
          errors.email && /* @__PURE__ */ jsx42("p", { children: errors.email.message })
        ] }) : /* @__PURE__ */ jsxs29("div", { className: "mt-4", children: [
          /* @__PURE__ */ jsx42("div", { className: "mb-2", children: "Search for Login *" }),
          /* @__PURE__ */ jsx42(
            IdentityUserSearchBoxContainer,
            {
              onSearchCompleted
            }
          )
        ] }),
        /* @__PURE__ */ jsxs29("div", { className: "mt-4", children: [
          /* @__PURE__ */ jsx42(
            CheckboxInput3,
            {
              label: /* @__PURE__ */ jsx42("span", { children: "Is Test" }),
              name: "isTest",
              defaultChecked: defaultValues.isTest,
              control,
              disabled: false
            }
          ),
          errors.isTest && /* @__PURE__ */ jsx42("p", { children: errors.isTest.message })
        ] }),
        /* @__PURE__ */ jsxs29("div", { className: "mt-4", children: [
          /* @__PURE__ */ jsx42(
            EmployerUserGroupSearchBoxInput,
            {
              employerId: employer.entityId,
              control,
              defaultValue: null,
              name: "groupId"
            }
          ),
          errors.groupId && /* @__PURE__ */ jsx42("p", { children: errors.groupId.message })
        ] }),
        /* @__PURE__ */ jsx42(Error3, { children: /* @__PURE__ */ jsx42("div", { className: "flex flex-col", children: mutationErrors.map((error) => /* @__PURE__ */ jsx42("div", { children: error.message }, error.message)) }) }),
        /* @__PURE__ */ jsx42("div", { className: "mt-4", children: /* @__PURE__ */ jsxs29(ButtonList6, { children: [
          /* @__PURE__ */ jsx42("div", { children: /* @__PURE__ */ jsx42(
            Button12,
            {
              "aria-label": "Submit create user form",
              type: "submit",
              color: "primary",
              size: Size7.md,
              disabled: isCreating,
              children: "Save"
            }
          ) }),
          /* @__PURE__ */ jsx42("div", { children: /* @__PURE__ */ jsx42(
            Button12,
            {
              "aria-label": "Cancel create user",
              color: "gray",
              size: Size7.md,
              disabled: isCreating,
              onClick: onCancel,
              children: "Cancel"
            }
          ) })
        ] }) })
      ] }) })
    ] })
  ] });
};
var ToggleSwitch = ({
  label,
  onChanged,
  defaultChecked,
  yesLabel,
  yesDescription,
  noLabel,
  noDescription
}) => {
  const [isOn, setIsOn] = useState14(defaultChecked);
  const onToggle = useCallback21(
    (value) => {
      setIsOn(value);
      onChanged(value);
    },
    [setIsOn, onChanged]
  );
  return /* @__PURE__ */ jsxs29(RadioGroup, { value: isOn, onChange: onToggle, children: [
    /* @__PURE__ */ jsx42(
      RadioGroup.Label,
      {
        "aria-hidden": "true",
        className: "text-base leading-6 text-gray-900",
        children: label
      }
    ),
    /* @__PURE__ */ jsxs29("div", { className: "mt-2 flex items-center space-x-3", children: [
      /* @__PURE__ */ jsx42(
        RadioGroup.Option,
        {
          value: true,
          className: ({ active }) => classNames17(
            active ? "border-primary-600 ring-primary-600 ring-2" : "border-gray-300",
            "relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none"
          ),
          children: ({ active, checked }) => /* @__PURE__ */ jsxs29(Fragment7, { children: [
            /* @__PURE__ */ jsxs29("span", { className: "flex flex-col", children: [
              /* @__PURE__ */ jsx42(
                RadioGroup.Label,
                {
                  as: "span",
                  className: "block text-sm font-medium text-gray-900",
                  children: yesLabel
                }
              ),
              /* @__PURE__ */ jsx42(
                RadioGroup.Description,
                {
                  as: "span",
                  className: "mt-1 flex items-center text-sm text-gray-500",
                  children: yesDescription
                }
              )
            ] }),
            /* @__PURE__ */ jsx42(
              CheckCircleIcon,
              {
                className: classNames17(
                  !checked ? "invisible" : "",
                  "text-primary-600 h-5 w-5"
                ),
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ jsx42(
              "span",
              {
                className: classNames17(
                  active ? "border" : "border-2",
                  checked ? "border-primary-600" : "border-transparent",
                  "pointer-events-none absolute -inset-px rounded-lg"
                ),
                "aria-hidden": "true"
              }
            )
          ] })
        },
        "yes"
      ),
      /* @__PURE__ */ jsx42(
        RadioGroup.Option,
        {
          value: false,
          className: ({ active }) => classNames17(
            active ? "border-primary-600 ring-primary-600 ring-2" : "border-gray-300",
            "relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none"
          ),
          children: ({ active, checked }) => /* @__PURE__ */ jsxs29(Fragment7, { children: [
            /* @__PURE__ */ jsxs29("span", { className: "flex flex-col", children: [
              /* @__PURE__ */ jsx42(
                RadioGroup.Label,
                {
                  as: "span",
                  className: "block text-sm font-medium text-gray-900",
                  children: noLabel
                }
              ),
              /* @__PURE__ */ jsx42(
                RadioGroup.Description,
                {
                  as: "span",
                  className: "mt-1 flex items-center text-sm text-gray-500",
                  children: noDescription
                }
              )
            ] }),
            /* @__PURE__ */ jsx42(
              CheckCircleIcon,
              {
                className: classNames17(
                  !checked ? "invisible" : "",
                  "text-primary-600 h-5 w-5"
                ),
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ jsx42(
              "span",
              {
                className: classNames17(
                  active ? "border" : "border-2",
                  checked ? "border-primary-600" : "border-transparent",
                  "pointer-events-none absolute -inset-px rounded-lg"
                ),
                "aria-hidden": "true"
              }
            )
          ] })
        },
        "no"
      )
    ] })
  ] });
};

// src/components/users/EmployerUsersRoute.tsx
import { Fragment as Fragment8, jsx as jsx43 } from "react/jsx-runtime";
var employerUserRoutes = (listRouteId, suffix, environment, context) => [
  {
    path: "*",
    element: /* @__PURE__ */ jsx43(Fragment8, {})
  },
  {
    path: "create/*",
    element: /* @__PURE__ */ jsx43(EmployerUserCreate, { canSearchIdentities: false, listRouteId })
  },
  {
    path: ":employerUserCode/*",
    element: /* @__PURE__ */ jsx43(OutletRoute2, {}),
    children: createEmployersUserRoutes(listRouteId, suffix, environment, context)
  }
];
var createEmployersUsersRoutes = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-employer-users-list`;
  return [
    {
      path: "list/*",
      id: routeId,
      element: /* @__PURE__ */ jsx43(EmployerUsersListLoader, { routeId }),
      errorElement: /* @__PURE__ */ jsx43(ErrorContainer6, {}),
      loader: ({ params }) => {
        return loader5(environment, params, context);
      },
      children: employerUserRoutes(routeId, "list", environment, context)
    },
    {
      path: "*",
      element: /* @__PURE__ */ jsx43(Outlet2, {}),
      children: employerUserRoutes(routeId, "root", environment, context)
    }
  ];
};

// src/components/users/__generated__/EmployerUserEmailEditor_user.graphql.ts
var node65 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserEmailEditor_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUser",
  "abstractKey": null
};
node65.hash = "e4f7d6a87c1fe31eed39a0e9a8b9376c";
var EmployerUserEmailEditor_user_graphql_default = node65;

// src/components/users/EmployerUserEmailEditor.tsx
import { useCallback as useCallback22 } from "react";
import { useFragment as useFragment12 } from "react-relay";
import { useForm as useForm8 } from "react-hook-form";
import { zodResolver as zodResolver8 } from "@hookform/resolvers/zod";
import * as zod8 from "zod";
import { Suspense as Suspense20 } from "shared-ui";
import { createClientMutationId as createClientMutationId12 } from "shared-lib";
import { Button as Button13, ButtonList as ButtonList7, EdSkeleton as EdSkeleton19, FormInput as FormInput6, Size as Size8 } from "shared-ui";
import { jsx as jsx44, jsxs as jsxs30 } from "react/jsx-runtime";
var fragmentDef14 = EmployerUserEmailEditor_user_graphql_default;
var FormSchema3 = zod8.object({
  email: zod8.string().optional()
});
var EmployerUserEmailEditor = ({
  fragmentRef,
  onCancel,
  onDone
}) => {
  const data = useFragment12(
    fragmentDef14,
    fragmentRef
  );
  const [update, isUpdating] = useEmployerUserEmailUpdate();
  const defaultValues = {
    email: data.emailAddress || ""
  };
  const { register, handleSubmit, formState, control } = useForm8({
    // There is a bug in yup which causes it to compare the type boolean with the string 'true', so we're checking any to avoid this
    resolver: zodResolver8(FormSchema3),
    defaultValues
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((form) => onSave(form));
  const onSave = useCallback22(
    async (form) => {
      if (!form.email) {
        return;
      }
      const input = {
        employerUserId: data.accountId,
        email: form.email,
        clientMutationId: createClientMutationId12()
      };
      const response = await update({ input });
      if (response.data.employerUser) {
        onDone();
      }
    },
    [update, data.accountId, onDone]
  );
  if (data === null) {
    return /* @__PURE__ */ jsx44(EdSkeleton19, {});
  }
  return /* @__PURE__ */ jsx44(Suspense20, { fallback: /* @__PURE__ */ jsx44(EdSkeleton19, {}), children: /* @__PURE__ */ jsx44("div", { className: "border bg-white p-8", children: /* @__PURE__ */ jsxs30("form", { onSubmit, children: [
    /* @__PURE__ */ jsxs30("div", { className: "mt-4", children: [
      /* @__PURE__ */ jsx44("label", { children: "Email *" }),
      /* @__PURE__ */ jsx44(
        FormInput6,
        {
          "aria-label": "email input",
          className: "mt-1",
          type: "text",
          placeholder: " Email ",
          name: "email",
          required: true,
          register
        }
      ),
      errors.email && /* @__PURE__ */ jsx44("p", { children: errors.email.message })
    ] }),
    /* @__PURE__ */ jsx44("div", { className: "mt-4", children: /* @__PURE__ */ jsxs30(ButtonList7, { children: [
      /* @__PURE__ */ jsx44("div", { children: /* @__PURE__ */ jsx44(
        Button13,
        {
          "aria-label": "submit email edit form",
          type: "submit",
          color: "primary",
          size: Size8.md,
          disabled: isUpdating || !isValid,
          children: "Save"
        }
      ) }),
      /* @__PURE__ */ jsx44("div", { children: /* @__PURE__ */ jsx44(
        Button13,
        {
          "aria-label": "cancel button",
          color: "gray",
          size: Size8.md,
          disabled: isUpdating,
          onClick: onCancel,
          children: "Cancel"
        }
      ) })
    ] }) })
  ] }) }) });
};

// src/components/users/__generated__/EmployerUserGroupsViewer_user.graphql.ts
var node66 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployerUserGroupsViewer_user",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "groupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "AccountsEmployerUser",
    "abstractKey": null
  };
}();
node66.hash = "73810f0a92d6391550953c46b2c28743";
var EmployerUserGroupsViewer_user_graphql_default = node66;

// src/components/users/EmployerUserGroupsViewer.tsx
import { Suspense as Suspense21 } from "react";
import { useFragment as useFragment13 } from "react-relay";
import { EdSkeleton as EdSkeleton20 } from "shared-ui";
import { jsx as jsx45 } from "react/jsx-runtime";
var fragmentDef15 = EmployerUserGroupsViewer_user_graphql_default;
var EmployerUserGroupsViewer = ({ fragmentRef }) => {
  const data = useFragment13(
    fragmentDef15,
    fragmentRef
  );
  if (data === null) {
    return /* @__PURE__ */ jsx45(EdSkeleton20, {});
  }
  const groupsRows = data.userGroups.map((g3) => {
    return /* @__PURE__ */ jsx45(
      "div",
      {
        className: "flex cursor-pointer items-center justify-between border-b p-2 hover:bg-gray-50",
        children: /* @__PURE__ */ jsx45("div", { children: g3.name })
      },
      g3.groupId
    );
  });
  if (data === null) {
    return /* @__PURE__ */ jsx45(EdSkeleton20, {});
  }
  return /* @__PURE__ */ jsx45(Suspense21, { fallback: /* @__PURE__ */ jsx45(EdSkeleton20, {}), children: /* @__PURE__ */ jsx45("div", { className: "flex flex-col gap-3 border bg-white p-4", children: groupsRows }) });
};

// src/components/users/__generated__/EmployerUserPasswordEditor_user.graphql.ts
var node67 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserPasswordEditor_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUser",
  "abstractKey": null
};
node67.hash = "baa9f1333017d3b42c2e488fb82c2b92";
var EmployerUserPasswordEditor_user_graphql_default = node67;

// src/components/users/EmployerUserPasswordEditor.tsx
import { useCallback as useCallback23 } from "react";
import { useFragment as useFragment14 } from "react-relay";
import { useForm as useForm9 } from "react-hook-form";
import { zodResolver as zodResolver9 } from "@hookform/resolvers/zod";
import * as zod9 from "zod";
import { Suspense as Suspense22 } from "shared-ui";
import { createClientMutationId as createClientMutationId13 } from "shared-lib";
import {
  Button as Button14,
  ButtonList as ButtonList8,
  EdSkeleton as EdSkeleton21,
  FormErrorCodes as FormErrorCodes2,
  FormInput as FormInput7,
  Size as Size9
} from "shared-ui";
import { jsx as jsx46, jsxs as jsxs31 } from "react/jsx-runtime";
var fragmentDef16 = EmployerUserPasswordEditor_user_graphql_default;
var FormSchema4 = zod9.object({
  newPassword: zod9.string().min(8),
  originalPassword: zod9.string().min(8)
});
var EmployerUserPasswordEditor = ({
  fragmentRef,
  onCancel,
  onDone
}) => {
  const data = useFragment14(
    fragmentDef16,
    fragmentRef
  );
  const [update, isUpdating] = useEmployerUserPasswordUpdate();
  const defaultValues = {
    newPassword: "",
    originalPassword: ""
  };
  const { register, handleSubmit, formState, control } = useForm9({
    // There is a bug in yup which causes it to compare the type boolean with the string 'true', so we're checking any to avoid this
    resolver: zodResolver9(FormSchema4),
    defaultValues
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((f4) => {
    return onSave(isValid, f4);
  });
  const onSave = useCallback23(
    async (isValid2, form) => {
      if (isValid2 && !form.newPassword || !form.originalPassword) {
        return;
      }
      const input = {
        employerUserId: data.accountId,
        newPassword: form.newPassword,
        originalPassword: form.originalPassword,
        clientMutationId: createClientMutationId13()
      };
      const response = await update({ input });
      if (response.data.employerUser) {
        onDone();
      }
    },
    [update, data.accountId, onDone]
  );
  if (data === null) {
    return /* @__PURE__ */ jsx46(EdSkeleton21, {});
  }
  return /* @__PURE__ */ jsx46(Suspense22, { fallback: /* @__PURE__ */ jsx46(EdSkeleton21, {}), children: /* @__PURE__ */ jsxs31("div", { className: "border bg-white p-8", children: [
    /* @__PURE__ */ jsx46(FormErrorCodes2, {}),
    /* @__PURE__ */ jsxs31("form", { onSubmit, children: [
      /* @__PURE__ */ jsxs31("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx46("label", { children: "Current Password *" }),
        /* @__PURE__ */ jsx46(
          FormInput7,
          {
            className: "mt-1",
            type: "password",
            name: "originalPassword",
            required: true,
            register
          }
        ),
        errors.originalPassword && /* @__PURE__ */ jsx46("p", { children: errors.originalPassword.message })
      ] }),
      /* @__PURE__ */ jsxs31("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx46("label", { children: "New Password *" }),
        /* @__PURE__ */ jsx46(
          FormInput7,
          {
            className: "mt-1",
            type: "password",
            name: "newPassword",
            required: true,
            register
          }
        ),
        errors.newPassword && /* @__PURE__ */ jsx46("p", { children: errors.newPassword.message })
      ] }),
      /* @__PURE__ */ jsx46("div", { className: "mt-4", children: /* @__PURE__ */ jsxs31(ButtonList8, { children: [
        /* @__PURE__ */ jsx46("div", { children: /* @__PURE__ */ jsx46(
          Button14,
          {
            type: "submit",
            color: "primary",
            size: Size9.md,
            disabled: isUpdating || !isValid,
            children: "Save"
          }
        ) }),
        /* @__PURE__ */ jsx46("div", { children: /* @__PURE__ */ jsx46(
          Button14,
          {
            color: "gray",
            size: Size9.md,
            disabled: isUpdating,
            onClick: onCancel,
            children: "Cancel"
          }
        ) })
      ] }) })
    ] })
  ] }) });
};

// src/components/users/EmployerUsersHome.tsx
import { Suspense as Suspense23 } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { EdButtonLink as EdButtonLink3, EdSkeleton as EdSkeleton22, MynPageTitle as MynPageTitle7 } from "shared-ui";
import { jsx as jsx47, jsxs as jsxs32 } from "react/jsx-runtime";
var EmployerUsersHome = () => {
  return /* @__PURE__ */ jsxs32(Suspense23, { fallback: /* @__PURE__ */ jsx47(EdSkeleton22, {}), children: [
    /* @__PURE__ */ jsx47(MynPageTitle7, { title: "Employer Users" }),
    /* @__PURE__ */ jsx47("div", { className: "flex flex-col items-center justify-start gap-2 p-4 sm:m-8", children: /* @__PURE__ */ jsx47("div", { children: /* @__PURE__ */ jsx47(
      EdButtonLink3,
      {
        label: "Create User",
        to: "../create",
        name: "create",
        icon: PlusIcon
      }
    ) }) })
  ] });
};

// src/components/users/EmployerUserSearchBoxInput.tsx
import { Controller as Controller3 } from "react-hook-form";

// src/components/users/EmployerUserSearchBox.tsx
import {
  Suspense as Suspense24,
  useCallback as useCallback24,
  useEffect as useEffect5,
  useMemo as useMemo5,
  useState as useState15
} from "react";
import { debounce as debounce5 } from "lodash-es";
import { ChevronUpDownIcon as ChevronUpDownIcon3 } from "@heroicons/react/24/solid";
import { Combobox as Combobox4 } from "@headlessui/react";

// src/components/users/__generated__/EmployerUserSearchOptionsQuery.graphql.ts
var node68 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v22 = [
    {
      "alias": "users",
      "args": [
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        },
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "AccountEmployerUsersConnection",
      "kind": "LinkedField",
      "name": "accountEmployerUsers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountEmployerUsersEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployerUser",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserSearchOptionsQuery",
      "selections": v22,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "EmployerUserSearchOptionsQuery",
      "selections": v22
    },
    "params": {
      "cacheID": "baeddc8c2af430ac2eb779c3248b6411",
      "id": null,
      "metadata": {},
      "name": "EmployerUserSearchOptionsQuery",
      "operationKind": "query",
      "text": "query EmployerUserSearchOptionsQuery(\n  $where: AccountsEmployerUserFilter!\n  $order: [AccountsEmployerUserSort!]\n) {\n  users: accountEmployerUsers(where: $where, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        accountId\n        firstName\n        lastName\n        emailAddress\n      }\n    }\n  }\n}\n"
    }
  };
}();
node68.hash = "76259e4a20a580feb62801928db69e34";
var EmployerUserSearchOptionsQuery_graphql_default = node68;

// src/components/users/EmployerUserSearchOptions.tsx
import { useLazyLoadQuery as useLazyLoadQuery7 } from "react-relay";
import { Combobox as Combobox3 } from "@headlessui/react";
import { CheckIcon as CheckIcon3 } from "@heroicons/react/24/solid";
import { isNotNull } from "shared-lib";
import { classNames as classNames18 } from "shared-ui";
import { Fragment as Fragment9, jsx as jsx48, jsxs as jsxs33 } from "react/jsx-runtime";
var queryDef9 = EmployerUserSearchOptionsQuery_graphql_default;
var EmployerUserSearchOptions = ({
  employerId,
  term,
  onNoResults
}) => {
  let where = {
    or: [
      { firstName: { startsWith: term } },
      { lastName: { startsWith: term } },
      { emailAddress: { startsWith: term } }
    ]
  };
  if (employerId) {
    where = {
      ...where,
      employerId: { eq: employerId }
    };
  }
  const query = useLazyLoadQuery7(
    queryDef9,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { users } = query;
  const rows = (users?.edges ?? []).map((e4) => e4.node).filter(isNotNull);
  if (term && rows && rows.length === 0) {
    onNoResults();
  }
  return /* @__PURE__ */ jsx48(Combobox3.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx48(
    Combobox3.Option,
    {
      value: result,
      className: ({ active }) => classNames18(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs33(Fragment9, { children: [
        /* @__PURE__ */ jsx48("div", { className: "flex", children: /* @__PURE__ */ jsx48(
          "span",
          {
            className: classNames18(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: `${result.firstName} ${result.lastName} - ${result.emailAddress}`
          }
        ) }),
        selected && /* @__PURE__ */ jsx48(
          "span",
          {
            className: classNames18(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx48(CheckIcon3, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.accountId
  )) });
};

// src/components/users/EmployerUserSearchBox.tsx
import { jsx as jsx49, jsxs as jsxs34 } from "react/jsx-runtime";
var compareResults = (a4, b3) => a4?.id === b3?.id;
var EmployerUserSearchBox = ({
  employerId,
  name,
  onSelected,
  onNoResults,
  value,
  disabled
}) => {
  const [selected, setSelected] = useState15(value);
  const [searchTerm, setSearchTerm] = useState15("");
  const onQueryChangeHandler = useMemo5(
    () => debounce5((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect5(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback24(
    (result) => {
      setSelected(result);
      onSelected(result);
    },
    [onSelected]
  );
  return /* @__PURE__ */ jsx49(Suspense24, { fallback: /* @__PURE__ */ jsx49("div", { children: "Searching...." }), children: /* @__PURE__ */ jsx49(
    Combobox4,
    {
      as: "div",
      name,
      className: "w-full",
      value: selected,
      onChange: onSetSelected,
      disabled,
      by: compareResults,
      children: /* @__PURE__ */ jsxs34("div", { className: "relative mt-2", children: [
        /* @__PURE__ */ jsx49(
          Combobox4.Input,
          {
            className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
            onChange: (event) => onQueryChangeHandler(event.target.value),
            displayValue: (result) => {
              if (!result) {
                return "";
              }
              return `${result.firstName} ${result.lastName} - ${result.emailAddress}`;
            },
            autoComplete: "off"
          }
        ),
        /* @__PURE__ */ jsx49(Combobox4.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx49(
          ChevronUpDownIcon3,
          {
            className: "h-5 w-5 text-gray-600",
            "aria-hidden": "true"
          }
        ) }),
        /* @__PURE__ */ jsx49(Suspense24, { fallback: "Searching...", children: searchTerm && /* @__PURE__ */ jsx49(
          EmployerUserSearchOptions,
          {
            employerId,
            term: searchTerm,
            onNoResults: () => {
              if (onNoResults) {
                onNoResults(searchTerm);
              }
            }
          }
        ) })
      ] })
    }
  ) });
};

// src/components/users/EmployerUserSearchBoxInput.tsx
import { jsx as jsx50 } from "react/jsx-runtime";
var EmployerUserSearchBoxInput = ({
  employerId,
  name,
  control,
  onSelected
}) => {
  return /* @__PURE__ */ jsx50("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsx50(
    Controller3,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange, value } }) => {
        return /* @__PURE__ */ jsx50(
          EmployerUserSearchBox,
          {
            employerId,
            name,
            onSelected: (result) => {
              onControllerChange(result);
              if (onSelected) {
                onSelected(result);
              }
            },
            value: value ?? null
          }
        );
      }
    }
  ) });
};

// src/components/users/EmployerUserSearchContainer.tsx
import { useCallback as useCallback25, useState as useState16 } from "react";
import { jsx as jsx51 } from "react/jsx-runtime";
var EmployerUserSearchContainer = ({
  employerId,
  name,
  onSearchCompleted,
  value,
  disabled
}) => {
  const [selectedResult, setSelectedResult] = useState16();
  const onSetSelected = useCallback25(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [selectedResult]
  );
  return /* @__PURE__ */ jsx51(
    EmployerUserSearchBox,
    {
      employerId,
      name: name || "accounts-employer-user-search",
      onSelected: onSetSelected,
      value,
      disabled
    }
  );
};

// src/components/users/__generated__/EmployerUserImpersonateRouteQuery.graphql.ts
var node69 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerUserCode"
    }
  ], v1 = [
    {
      "alias": "user",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "employerUserCode"
        }
      ],
      "concreteType": "AccountsEmployerUser",
      "kind": "LinkedField",
      "name": "accountEmployerUserByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserImpersonateRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserImpersonateRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "c1cad739cebc3bb466c6399caa622708",
      "id": null,
      "metadata": {},
      "name": "EmployerUserImpersonateRouteQuery",
      "operationKind": "query",
      "text": "query EmployerUserImpersonateRouteQuery(\n  $employerUserCode: Long!\n) {\n  user: accountEmployerUserByCode(code: $employerUserCode) {\n    id\n    accountId\n    code\n    firstName\n    lastName\n    emailAddress\n  }\n}\n"
    }
  };
}();
node69.hash = "e800e428291bf1a82a30b372795f849d";
var EmployerUserImpersonateRouteQuery_graphql_default = node69;

// src/components/users/EmployerUserImpersonate.tsx
import { useCallback as useCallback26, useState as useState17 } from "react";
import { Link as Link6 } from "react-router-dom";
import { loadQuery as loadQuery7 } from "react-relay";
import { useCopyToClipboard } from "react-use";
import { useRouteData as useRouteData3 } from "shared-lib";
import { Button as Button15, MynPageTitle as MynPageTitle8 } from "shared-ui";
import { ElevateAccountTypes, useImpersonateUser } from "app-core";
import { jsx as jsx52, jsxs as jsxs35 } from "react/jsx-runtime";
var queryDef10 = EmployerUserImpersonateRouteQuery_graphql_default;
async function loader7(environment, params) {
  const code = params.employerUserCode;
  const employerUserCode = parseInt(code);
  return loadQuery7(environment, queryDef10, {
    employerUserCode
  });
}
var EmployerUserImpersonate = ({
  routeId
}) => {
  const query = useRouteData3(
    queryDef10,
    routeId
  );
  const { user } = query;
  const [state, copyToClipboard2] = useCopyToClipboard();
  const [impersonation, isImpersonating] = useImpersonateUser();
  const [impersonationLink, setImpersonationLink] = useState17();
  const onCreateImpersonationToken = useCallback26(async () => {
    if (user === null || user === void 0) {
      return;
    }
    setImpersonationLink(null);
    const token = await impersonation(
      user.accountId,
      ElevateAccountTypes.Employer
    );
    if (!token) {
      return;
    }
    const config = {
      token,
      accountId: user.accountId
    };
    const data = encodeURIComponent(JSON.stringify(config));
    const host = `${window.location.protocol}//${window.location.host}`;
    const path = `${host}/portal/employers/nav?action=impersonate&data=${data}`;
    setImpersonationLink(path);
  }, [impersonation, user, setImpersonationLink]);
  if (!user) {
    return /* @__PURE__ */ jsx52("div", { className: "m-8 max-w-4xl border bg-white p-4", children: /* @__PURE__ */ jsx52("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx52("h1", { children: "Could Not Load User" }) }) });
  }
  return /* @__PURE__ */ jsxs35("div", { className: "m-8 max-w-4xl border bg-white p-4", children: [
    /* @__PURE__ */ jsx52(MynPageTitle8, { title: "Impersonate Employer User" }),
    /* @__PURE__ */ jsxs35("div", { className: "flex flex-col", children: [
      state && state.error ? /* @__PURE__ */ jsxs35("div", { className: "flex flex-col gap-3", children: [
        /* @__PURE__ */ jsx52("div", { className: "text-failure-500 text-md p-3 font-medium", children: "Could not copy, please copy manually from below" }),
        /* @__PURE__ */ jsx52("div", { className: "text-primary-800 p-3 text-lg font-bold", children: /* @__PURE__ */ jsxs35("p", { children: [
          "Please note: you ",
          /* @__PURE__ */ jsx52("strong", { children: "must be logged in" }),
          " as admin need to use this link"
        ] }) }),
        /* @__PURE__ */ jsx52("div", { className: "text-info-500 text-md p-3 font-medium", children: impersonationLink })
      ] }) : null,
      state && state.value ? /* @__PURE__ */ jsxs35("div", { className: "flex flex-col gap-3", children: [
        /* @__PURE__ */ jsx52("div", { className: "text-md p-3 font-medium text-green-500", children: "Copied!" }),
        /* @__PURE__ */ jsx52("div", { className: "text-primary-800 p-3 text-lg font-bold", children: /* @__PURE__ */ jsxs35("p", { children: [
          "Please note: you ",
          /* @__PURE__ */ jsx52("strong", { children: "must be logged in" }),
          " as admin need to use this link"
        ] }) })
      ] }) : null,
      impersonationLink ? /* @__PURE__ */ jsxs35("div", { className: "flex items-center space-x-3 p-3", children: [
        /* @__PURE__ */ jsx52(
          "a",
          {
            className: "bg-primary-800 text-md rounded-lg border px-2.5 py-1 font-medium text-white",
            href: impersonationLink,
            target: user.code.toString(),
            children: "Impersonate"
          }
        ),
        /* @__PURE__ */ jsx52(
          Button15,
          {
            color: "primary",
            clicked: () => copyToClipboard2(impersonationLink),
            children: "Copy Link To Clipboard"
          }
        )
      ] }) : null,
      /* @__PURE__ */ jsx52("div", { className: "p-3", children: impersonationLink ? /* @__PURE__ */ jsx52(
        Button15,
        {
          color: "secondary",
          disabled: isImpersonating,
          clicked: onCreateImpersonationToken,
          children: "Create New Impersonation Link"
        }
      ) : /* @__PURE__ */ jsx52(
        Button15,
        {
          color: "primary",
          disabled: isImpersonating || !!impersonationLink,
          clicked: onCreateImpersonationToken,
          children: "Create Impersonation Link"
        }
      ) })
    ] })
  ] });
};
var createRoute = (routePrefix, environment) => {
  const routeId = `${routePrefix}-impersonate`;
  return {
    id: routeId,
    path: "impersonate",
    element: /* @__PURE__ */ jsx52(EmployerUserImpersonate, { routeId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx52(Link6, { to: "users", children: "Users" })
    },
    loader: ({ params }) => {
      return loader7(environment, params);
    }
  };
};
export {
  EmployerCreateContainer,
  EmployerEmailConfigurationForm,
  EmployerRow,
  EmployerSearchBox,
  EmployerSearchBoxInput,
  EmployerSearchContainer,
  EmployerUserCreate,
  EmployerUserDetails,
  EmployerUserDetailsEditor,
  EmployerUserDetailsView,
  EmployerUserEmailEditor,
  EmployerUserGroupSearchBoxInput,
  EmployerUserGroupsEditor,
  EmployerUserGroupsViewer,
  EmployerUserLayout,
  EmployerUserPasswordEditor,
  EmployerUserSearchBoxInput,
  EmployerUserSearchContainer,
  EmployerUsersHome,
  EmployerUsersListLoader,
  EmployersListContainer,
  UseEmployerLocationRemove,
  UseEmployerLogoUploadGraphQL,
  createEmployerDetailsRoute,
  createEmployerLocationsRoute,
  createEmployerUserGroupsRoutes,
  createEmployersUsersRoutes,
  createRoute as createImpersonateRoute,
  loader6 as employerUserLoader,
  loader5 as employerUsersLoader,
  useEmployerActivate,
  useEmployerApprove,
  useEmployerChangeCanonicalCompany,
  useEmployerCreate,
  useEmployerDeactivate,
  useEmployerEmailsSendingAddressChange,
  useEmployerLocationCreate,
  useEmployerLocationUpdate,
  useEmployerLogoUpload,
  useEmployerNameUpdateMutation,
  useEmployerSetIsTestAccount,
  useEmployerSetPhoneNumberVisibility,
  useEmployerUpdateDetails,
  useEmployerUserCreate,
  useEmployerUserDisable,
  useEmployerUserEmailUpdate,
  useEmployerUserEnable,
  useEmployerUserGroupCreate,
  useEmployerUserGroupUpdate,
  useEmployerUserJoinGroup,
  useEmployerUserLeaveGroup,
  useEmployerUserPasswordUpdate,
  useEmployerUserUpdate
};
/*! Bundled license information:

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)

@uppy/utils/lib/Translator.js:
  (**
   * Takes a string with placeholder variables like `%{smart_count} file selected`
   * and replaces it with values from options `{smart_count: 5}`
   *
   * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
   * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
   *
   * @param phrase that needs interpolation, with placeholders
   * @param options with values that will be used to replace placeholders
   *)
*/
//# sourceMappingURL=index.mjs.map